// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../css/bootstrap.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../css/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../css/slicktheme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../css/animation.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/slick-arrow-left-small.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/slick-arrow-right-small.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**************************************
    Default Styles
***************************************/
/*-- Variables --*/
:root {
  --color-primary: #345085;
  --color-primary-rgba: rgb(52, 80, 133);
  --color-primary-alt: #345085;
  --color-primary-light: #345085;
  --color-primary-lightest: #345085;
  --color-secondary: #6E8ECB;
  --color-tertiary: #343944;
  --color-tertiary-alt: #343944;
  --color-pink: #0d4083;
  --color-light-green: #07c1fa;
  --color-primary-darker: #011827;
  --color-tertiary-darker: #150b40;
  --color-secondary-darker: #190301;
  --color-light-green-darker: #001f27;
  --color-pink-darker: #2f011d;
  --color-heading: #ffffff;
  --color-body: #acacac;
  --color-dark: #060606;
  --color-darker: rgba(6, 6, 6, 0.7);
  --color-darkest: rgba(0, 0, 0, 0.3);
  --color-black: #000000;
  --color-blacker: rgba(15, 15, 17, 0);
  --color-blackest: #0f0f11;
  --color-border: hsla(0, 0%, 100%, 0.1);
  --color-lessdark: #1e1e1e;
  --color-gray: #65676B;
  --color-midgray: #878787;
  --color-light: #E4E6EA;
  --color-lighter: #CED0D4;
  --color-lightest: #F0F2F5;
  --color-white: #ffffff;
  --color-success: #3EB75E;
  --color-danger: #FF0003;
  --color-warning: #FF8F3C;
  --color-info: #1BA2DB;
  --color-facebook: #3B5997;
  --color-twitter: #1BA1F2;
  --color-youtube: #ED4141;
  --color-linkedin: #0077B5;
  --color-pinterest: #E60022;
  --color-instagram: #C231A1;
  --color-vimeo: #00ADEF;
  --color-twitch: #6441A3;
  --color-discord: #7289da;
  --color-extra01: #666666;
  --color-extra02: #606770;
  --color-extra03: #FBFBFD;
  --color-extra04: #1A1A1A;
  --color-extra05: #242424;
  --border-width: 2px;
  --radius-small: 6px;
  --radius: 10px;
  --radius-big: 16px;
  --p-light: 300;
  --p-regular: 400;
  --p-medium: 500;
  --p-semi-bold: 600;
  --p-bold: 700;
  --p-extra-bold: 800;
  --p-black: 900;
  --shadow-primary: 0 0 20px 5px rgba(251,83,67, 0.20);
  --shadow-light: 1px 1px 6px rgba(0, 0, 0, 0.25);
  --shadow-lighter: 4px 4px 20px 20px rgba(0, 0, 0, 0.01);
  --transition: 0.3s;
  --transition-transform: transform .65s cubic-bezier(.23,1,.32,1);
  --font-primary: "Inter", sans-serif;
  --secondary-font: "Inter", sans-serif;
  --font-awesome: "Font Awesome 5 Pro";
  --font-size-b1: 18px;
  --font-size-b2: 16px;
  --font-size-b3: 14px;
  --font-size-b4: 12px;
  --line-height-b1: 1.67;
  --line-height-b2: 1.7;
  --line-height-b3: 1.6;
  --line-height-b4: 1.3;
  --h1: 56px;
  --h2: 44px;
  --h3: 36px;
  --h4: 24px;
  --h5: 18px;
  --h6: 16px;
}

/**
 * Reset Styels
 */
* {
  box-sizing: border-box;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
video {
  display: inline-block;
}

audio:not([controls]) {
  display: none;
  height: 0;
}

[hidden] {
  display: none;
}

a {
  color: var(--color-heading);
  text-decoration: none;
  outline: none;
}

a:hover,
a:focus,
a:active {
  text-decoration: none;
  outline: none;
  color: var(--color-primary);
}

a:focus {
  outline: none;
}

address {
  margin: 0 0 24px;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

mark {
  background: var(--color-primary);
  color: #ffffff;
}

code,
kbd,
pre,
samp {
  font-size: var(--font-size-b3);
  hyphens: none;
  color: var(--color-primary);
}

kbd,
ins {
  color: #ffffff;
}

pre,
pre.wp-block-code {
  font-family: "Courier 10 Pitch", Courier, monospace !important;
  font-size: 15px !important;
  margin: 40px 0 !important;
  overflow: auto;
  padding: 20px !important;
  white-space: pre !important;
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  color: var(--color-body) !important;
  background: var(--color-light);
  border-radius: 4px;
}

small {
  font-size: smaller;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

dl {
  margin-top: 0;
  margin-bottom: 10px;
}

dd {
  margin: 0 15px 15px;
}

dt {
  font-weight: bold;
  color: var(--color-heading);
}

menu,
ol,
ul {
  margin: 16px 0;
  padding: 0 0 0 40px;
}

nav ul,
nav ol {
  list-style: none;
  list-style-image: none;
}

li > ul,
li > ol {
  margin: 0;
}

ol ul {
  margin-bottom: 0;
}

img {
  -ms-interpolation-mode: bicubic;
  border: 0;
  vertical-align: middle;
  max-width: 100%;
  height: auto;
}

@media (max-width: 600px) {
  .logo-dark {
    height: auto;
    max-height: 29px !important;
    max-width: none;
  }
  .logo-light {
    height: auto;
    max-height: 29px !important;
    max-width: none;
  }
}
svg:not(:root) {
  overflow: hidden;
}

figure {
  margin: 0;
}

form {
  margin: 0;
}

fieldset {
  border: 1px solid var(--color-border);
  margin: 0 2px;
  min-width: inherit;
  padding: 0.35em 0.625em 0.75em;
}

legend {
  border: 0;
  padding: 0;
  white-space: normal;
}

button,
input,
select,
textarea {
  font-size: 100%;
  margin: 0;
  max-width: 100%;
  vertical-align: baseline;
}

button,
input {
  line-height: normal;
}

button,
html input[type=button],
input[type=reset],
input[type=submit] {
  appearance: button;
  cursor: pointer;
}

button[disabled],
input[disabled] {
  cursor: default;
}

input[type=checkbox],
input[type=radio] {
  padding: 0;
}

input[type=search] {
  appearance: textfield;
  appearance: textfield;
  padding-right: 2px;
  width: 270px;
}

input[type=search]::-webkit-search-decoration {
  appearance: none;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

textarea {
  overflow: auto;
  vertical-align: top;
}

caption,
th,
td {
  font-weight: normal;
}

table thead th {
  font-weight: 700;
}

td,
.wp-block-calendar tfoot td {
  border: 1px solid var(--color-border);
  padding: 7px 10px;
}

del {
  color: #333;
}

ins {
  background: rgba(56, 88, 246, 0.6);
  text-decoration: none;
  padding: 0 5px;
}

hr {
  background-size: 4px 4px;
  border: 0;
  height: 1px;
  margin: 0 0 24px;
  opacity: 0.25;
}

table a,
table a:link,
table a:visited {
  text-decoration: underline;
}

dt {
  font-weight: bold;
  margin-bottom: 10px;
}

dd {
  margin: 0 15px 15px;
}

caption {
  caption-side: top;
}

kbd {
  background: var(--heading-color);
}

dfn,
cite,
em {
  font-style: italic;
}

/* BlockQuote  */
blockquote,
q {
  hyphens: none;
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

blockquote {
  font-size: var(--font-size-b1);
  font-style: italic;
  font-weight: var(--p-light);
  margin: 24px 40px;
}

blockquote blockquote {
  margin-right: 0;
}

blockquote cite,
blockquote small {
  font-size: var(--font-size-b3);
  font-weight: normal;
}

blockquote strong,
blockquote b {
  font-weight: 700;
}

/**
 * Typography
 */
* {
  box-sizing: border-box;
}

html {
  overflow: hidden;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  font-size: 10px;
}

body {
  overflow: hidden;
  font-size: var(--font-size-b2);
  line-height: var(--line-height-b2);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--font-primary);
  color: var(--color-body);
  font-weight: var(--p-regular);
  background-color: var(--color-dark);
  margin: 0;
  padding: 0;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
address,
p,
pre,
blockquote,
menu,
ol,
ul,
table,
hr {
  margin: 0;
  margin-bottom: 20px;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  word-break: break-word;
  font-family: var(--secondary-font);
  line-height: 1.4074;
  color: var(--color-heading);
}

h1,
.h1 {
  font-size: var(--h1);
  line-height: 1.19;
}

h2,
.h2 {
  font-size: var(--h2);
  line-height: 1.23;
}

h3,
.h3 {
  font-size: var(--h3);
  line-height: 1.4;
}

h4,
.h4 {
  font-size: var(--h4);
  line-height: 1.25;
}

h5,
.h5 {
  font-size: var(--h5);
  line-height: 1.24;
}

h6,
.h6 {
  font-size: var(--h6);
  line-height: 1.25;
}

h1 a,
h2 a,
h3 a,
h4 a,
h5 a,
h6 a,
.h1 a,
.h2 a,
.h3 a,
.h4 a,
.h5 a,
.h6 a {
  color: inherit;
  transition: 0.5s;
}

a {
  color: var(--color-body);
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  h1,
  .h1 {
    font-size: 38px;
  }
  h2,
  .h2 {
    font-size: 32px;
  }
  h3,
  .h3 {
    font-size: 28px;
  }
  h4,
  .h4 {
    font-size: 24px;
  }
  h5,
  .h5 {
    font-size: 18px;
  }
}
@media only screen and (max-width: 767px) {
  h1,
  .h1 {
    font-size: 34px;
  }
  h2,
  .h2 {
    font-size: 28px;
  }
  h3,
  .h3 {
    font-size: 24px;
  }
  h4,
  .h4 {
    font-size: 20px;
  }
  h5,
  .h5 {
    font-size: 16px;
  }
}
h1,
.h1,
h2,
.h2,
h3,
.h3 {
  font-weight: var(--p-bold);
}

h4,
.h4,
h5,
.h5 {
  font-weight: var(--p-bold);
}

h6,
.h6 {
  font-weight: var(--p-medium);
}

p {
  font-size: var(--font-size-b2);
  line-height: var(--line-height-b2);
  font-weight: var(--p-regular);
  color: var(--color-body);
  margin: 0 0 30px;
}
@media only screen and (max-width: 767px) {
  p {
    margin: 0 0 20px;
    font-size: var(--font-size-b2);
    line-height: var(--line-height-b2);
  }
}
p.has-large-font-size {
  line-height: 1.5;
  font-size: 36px;
}
p.has-medium-font-size {
  font-size: 24px;
  line-height: 36px;
}
p.has-small-font-size {
  font-size: 13px;
}
p.has-very-light-gray-color {
  color: var(--color-white);
}
p.has-background {
  padding: 20px 30px;
}
p.b1 {
  font-size: var(--font-size-b1);
  line-height: var(--line-height-b1);
}
p.b2 {
  font-size: var(--font-size-b2);
  line-height: var(--line-height-b2);
}
p.b3 {
  font-size: var(--font-size-b3);
  line-height: var(--line-height-b3);
}
p.b4 {
  font-size: var(--font-size-b4);
  line-height: var(--line-height-b4);
}

.b1 {
  font-size: var(--font-size-b1);
  line-height: var(--line-height-b1);
}

.b2 {
  font-size: var(--font-size-b2);
  line-height: var(--line-height-b2);
}

.b3 {
  font-size: var(--font-size-b3);
  line-height: var(--line-height-b3);
}

.b4 {
  font-size: var(--font-size-b4);
  line-height: var(--line-height-b4);
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0 0 40px;
  width: 100%;
}

table a,
table a:link,
table a:visited {
  text-decoration: none;
}

cite,
.wp-block-pullquote cite,
.wp-block-pullquote.is-style-solid-color blockquote cite,
.wp-block-quote cite {
  color: var(--color-heading);
}

var {
  font-family: "Courier 10 Pitch", Courier, monospace;
}

/*---------------------------
	List Style 
---------------------------*/
ul,
ol {
  padding-left: 18px;
}

ul {
  list-style: square;
  margin-bottom: 30px;
  padding-left: 20px;
}
ul.liststyle.bullet li {
  font-size: 18px;
  line-height: 30px;
  color: var(--color-body);
  position: relative;
  padding-left: 30px;
}
@media only screen and (max-width: 767px) {
  ul.liststyle.bullet li {
    padding-left: 19px;
  }
}
ul.liststyle.bullet li::before {
  position: absolute;
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background: var(--color-body);
  left: 0;
  top: 10px;
}
ul.liststyle.bullet li + li {
  margin-top: 8px;
}
ul li {
  font-size: var(--font-size-b1);
  line-height: var(--line-height-b1);
  margin-top: 10px;
  margin-bottom: 10px;
  color: var(--color-body);
  font-weight: 400;
}
ul li a {
  text-decoration: none;
  color: var(--color-body);
}
ul li a:hover {
  color: var(--color-primary);
}
ul ul {
  margin-bottom: 0;
}

ol {
  margin-bottom: 30px;
}
ol li {
  font-size: var(--font-size-b1);
  line-height: var(--line-height-b1);
  color: var(--color-gray);
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: 400;
}
ol li a {
  color: var(--heading-color);
  text-decoration: none;
}
ol li a:hover {
  color: var(--color-primary);
}
ol ul {
  padding-left: 30px;
}

hr {
  display: block;
  height: 0;
  margin: 15px 0 15px;
  border-top: 1px solid var(--color-border);
}

kbd {
  background: var(--color-primary);
}

/*=====================
All Extend Here
=======================*/
.color-primary {
  color: var(--color-primary) !important;
}

.color-primary-light {
  color: var(--color-primary-light) !important;
}

.color-primary-alt {
  color: var(--color-primary-alt) !important;
}

.color-secondary {
  color: var(--color-secondary) !important;
}

.color-tertiary {
  color: var(--color-tertiary) !important;
}

.color-tertiary-alt {
  color: var(--color-tertiary-alt) !important;
}

.color-light-green {
  color: var(--color-light-green) !important;
}

.color-pink {
  color: var(--color-pink) !important;
}

.color-primary-darker {
  color: var(--color-primary-darker) !important;
}

.color-secondary-darker {
  color: var(--color-secondary-darker) !important;
}

.color-light-green-darker {
  color: var(--color-light-green-darker) !important;
}

.color-pink-darker {
  color: var(--color-pink-darker) !important;
}

.color-heading {
  color: var(--color-heading) !important;
}

.color-body {
  color: var(--color-body) !important;
}

.color-dark {
  color: var(--color-dark) !important;
}

.color-darker {
  color: var(--color-darker) !important;
}

.color-darkest {
  color: var(--color-darkest) !important;
}

.color-black {
  color: var(--color-black) !important;
}

.color-blacker {
  color: var(--color-blacker) !important;
}

.color-blackest {
  color: var(--color-blackest) !important;
}

.color-border {
  color: var(--color-border) !important;
}

.color-gray {
  color: var(--color-gray) !important;
}

.color-midgray {
  color: var(--color-midgray) !important;
}

.color-light {
  color: var(--color-light) !important;
}

.color-lighter {
  color: var(--color-lighter) !important;
}

.color-lightest {
  color: var(--color-lightest) !important;
}

.color-white {
  color: var(--color-white) !important;
}

[data-overlay]:before {
  background: var(--color-primary);
}

/* Radius */
.filter-button-default li button, .rwt-card .inner .thumbnail .rwt-overlay, .rwt-card .inner .thumbnail .card-image img, .rwt-card .inner .thumbnail .card-image a, .radius-small {
  border-radius: var(--radius-small);
}

.radius, .post-scale {
  border-radius: var(--radius);
}

.radius-big {
  border-radius: var(--radius-big);
}

/* Font Weight */
.w-300 {
  font-weight: 300 !important;
}

.w-400 {
  font-weight: 400 !important;
}

.w-500 {
  font-weight: 500 !important;
}

.w-600 {
  font-weight: 600 !important;
}

.w-700 {
  font-weight: 700 !important;
}

.w-800 {
  font-weight: 800 !important;
}

.w-900 {
  font-weight: 900 !important;
}

/* Shadows */
.shadow-primary {
  box-shadow: var(--shadow-primary);
}

.shadow-light {
  box-shadow: var(--shadow-light);
}

.shadow-lighter {
  box-shadow: var(--shadow-lighter);
}

/*=============== Style Css =============*/
.rn-meta-list, .advance-pricing .pricing-right .plan-offer-list, .breadcrumb-inner ul.page-list {
  padding: 0;
  margin: 0;
  list-style: none;
}

.tagcloud a,
.wp-block-tag-cloud a, .rbt-single-widget.widget_recent_comments ul li span, .rbt-single-widget.widget_recent_entries ul li span, .rbt-single-widget.widget_archive ul li span, .rbt-single-widget.widget_categories ul li span, .rbt-single-widget.widget_meta ul li span, .rbt-single-widget.widget_pages ul li span, .rbt-single-widget.widget_nav_menu ul li span, .rbt-single-widget.widget_recent_comments ul li a, .rbt-single-widget.widget_recent_entries ul li a, .rbt-single-widget.widget_archive ul li a, .rbt-single-widget.widget_categories ul li a, .rbt-single-widget.widget_meta ul li a, .rbt-single-widget.widget_pages ul li a, .rbt-single-widget.widget_nav_menu ul li a, .rn-address .inner p a, .rn-slick-dot .slick-dots li button::after, .filter-button-default li button, .rwt-card .inner .content .title a, .rwt-card .inner .thumbnail .card-image img, .rwt-card, .card-box.card-style-1 .inner .content .title a, .service.service__style--2 .content p, .service.service__style--2 .content .title a, .service.service__style--2 .content .title, .service.gallery-style .content p, .service.gallery-style .content .title a, .service.gallery-style .content .title, .service.service__style--1 .content p, .service.service__style--1 .content .title a, .service.service__style--1 .content .title, .service.service__style--1 .icon, .mainmenu-nav .mainmenu li.has-droupdown .submenu li a, .form-group textarea, .form-group input, #scrollUp, ul li a, ol li a {
  transition: var(--transition);
}

.bg_image, .bgImagePosition {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

/*----------------------
    Animation Css  
-----------------------*/
.post-scale {
  overflow: hidden;
}
.post-scale img {
  transition: 0.5s;
}
.post-scale:hover img {
  transform: scale(1.1);
}

@keyframes customOne {
  from {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  to {
    transform: scale(1);
  }
}
@keyframes customTwo {
  0% {
    transform: translate(0px, 0px);
  }
  50% {
    transform: translate(100px, 0px);
  }
  100% {
    transform: translate(50px, 50px);
  }
}
.customOne {
  animation: customOne 2s infinite;
}

/* ------------------------
    Custom Animation 01 
----------------------------*/
@keyframes headerSlideDown {
  0% {
    margin-top: -100px;
  }
  to {
    margin-top: 0;
  }
}
/*------------------------
	slidefadeinup
--------------------------*/
@keyframes slideFadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 20%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.slideFadeInUp {
  animation-name: slideFadeInUp;
}

/* -----------------------------------
    Custom Animation For All Page
---------------------------------------*/
@keyframes moveVertical {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/*--------------------------------
Scroll Down Button Animation  
----------------------------------*/
@keyframes scrollDown {
  0% {
    opacity: 0;
  }
  10% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(10px);
    opacity: 0;
  }
}
/*==============================
 *  Utilities
=================================*/
/* 
font-family: 'Inter', sans-serif;
*/
.row {
  margin-right: -15px;
  margin-left: -15px;
}

.row > [class*=col] {
  padding-left: 15px;
  padding-right: 15px;
}

@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}

.clearfix:after {
  clear: both;
}

.fix {
  overflow: hidden;
}

.slick-initialized .slick-slide {
  margin-bottom: -10px;
}

/*===============================
    Background Color 
=================================*/
.bg-color-primary {
  background: var(--color-primary);
}

.bg-color-secondary {
  background: var(--color-secondary);
}

.bg-color-tertiary {
  background: var(--color-tertiary);
}

.bg-color-grey {
  background: #F0F2F5;
}

.bg-color-white {
  background: #FFFFFF;
}

.bg-color-black {
  background: #1A1A1A;
}

.bg-color-extra03 {
  background: var(--color-extra03);
}

.bg-color-lessdark {
  background: var(--color-lessdark);
}

.bg-color-color-primary {
  background: var(--color-primary);
}

.bg-color-2 {
  -webkit-backdrop-filter: saturate(180%) blur(8px);
          backdrop-filter: saturate(180%) blur(8px);
  background-color: var(--color-darker);
  background-image: linear-gradient(180deg, var(--color-black), transparent);
}

/*===========================
    Background Image 
=============================*/
.bg_image_fixed {
  background-attachment: fixed !important;
}

/* Height and width */
.fullscreen {
  min-height: 100vh;
  width: 100%;
}

/*===================
Custom Row
======================*/
.row--0 {
  margin-left: 0px;
  margin-right: 0px;
}
.row--0 > [class*=col] {
  padding-left: 0px;
  padding-right: 0px;
}

.row--5 {
  margin-left: -5px;
  margin-right: -5px;
}
.row--5 > [class*=col] {
  padding-left: 5px;
  padding-right: 5px;
}

.row--10 {
  margin-left: -10px;
  margin-right: -10px;
}
.row--10 > [class*=col] {
  padding-left: 10px;
  padding-right: 10px;
}

.row--15 {
  margin-left: -15px;
  margin-right: -15px;
}
.row--15 > [class*=col] {
  padding-left: 15px;
  padding-right: 15px;
}

.row--20 {
  margin-left: -20px;
  margin-right: -20px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--20 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--20 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--20 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--20 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--20 > [class*=col], .row--20 > [class*=col-] {
  padding-left: 20px;
  padding-right: 20px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--20 > [class*=col], .row--20 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--20 > [class*=col], .row--20 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--20 > [class*=col], .row--20 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--20 > [class*=col], .row--20 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.row--25 {
  margin-left: -25px;
  margin-right: -25px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--25 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--25 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--25 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--25 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--25 > [class*=col], .row--25 > [class*=col-] {
  padding-left: 25px;
  padding-right: 25px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--25 > [class*=col], .row--25 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--25 > [class*=col], .row--25 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--25 > [class*=col], .row--25 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--25 > [class*=col], .row--25 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.row--30 {
  margin-left: -30px;
  margin-right: -30px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--30 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--30 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--30 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--30 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--30 > [class*=col], .row--30 > [class*=col-] {
  padding-left: 30px;
  padding-right: 30px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--30 > [class*=col], .row--30 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--30 > [class*=col], .row--30 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--30 > [class*=col], .row--30 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--30 > [class*=col], .row--30 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.row--45 {
  margin-left: -45px;
  margin-right: -45px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--45 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--45 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--45 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--45 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--45 > [class*=col], .row--45 > [class*=col-] {
  padding-left: 45px;
  padding-right: 45px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--45 > [class*=col], .row--45 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--45 > [class*=col], .row--45 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--45 > [class*=col], .row--45 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--45 > [class*=col], .row--45 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.row--40 {
  margin-left: -40px;
  margin-right: -40px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--40 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--40 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--40 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--40 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--40 > [class*=col], .row--40 > [class*=col-] {
  padding-left: 40px;
  padding-right: 40px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--40 > [class*=col], .row--40 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--40 > [class*=col], .row--40 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--40 > [class*=col], .row--40 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--40 > [class*=col], .row--40 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.row--60 {
  margin-left: -60px;
  margin-right: -60px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--60 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--60 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--60 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media only screen and (max-width: 767px) {
  .row--60 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
.row--60 > [class*=col], .row--60 > [class*=col-] {
  padding-left: 60px;
  padding-right: 60px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .row--60 > [class*=col], .row--60 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .row--60 > [class*=col], .row--60 > [class*=col-] {
    padding-left: 15px;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .row--60 > [class*=col], .row--60 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 767px) {
  .row--60 > [class*=col], .row--60 > [class*=col-] {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

/*===========================
    Input Placeholder
=============================*/
input:-moz-placeholder,
textarea:-moz-placeholder {
  opacity: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  opacity: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
}

input::-moz-placeholder,
textarea::-moz-placeholder {
  opacity: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
}

input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  opacity: 1;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
}

/*=============================
	Overlay styles 
==============================*/
[data-overlay],
[data-black-overlay],
[data-white-overlay] {
  position: relative;
}

[data-overlay] > div,
[data-overlay] > *,
[data-black-overlay] > div,
[data-black-overlay] > *,
[data-white-overlay] > div,
[data-white-overlay] > * {
  position: relative;
  z-index: 2;
}

[data-overlay]:before,
[data-black-overlay]:before,
[data-white-overlay]:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 2;
}

[data-black-overlay]:before {
  background-color: #000000;
}

[data-white-overlay]:before {
  background-color: #ffffff;
}

[data-overlay="1"]:before,
[data-black-overlay="1"]:before,
[data-white-overlay="1"]:before {
  opacity: 0.1;
}

[data-overlay="2"]:before,
[data-black-overlay="2"]:before,
[data-white-overlay="2"]:before {
  opacity: 0.2;
}

[data-overlay="3"]:before,
[data-black-overlay="3"]:before,
[data-white-overlay="3"]:before {
  opacity: 0.3;
}

[data-overlay="4"]:before,
[data-black-overlay="4"]:before,
[data-white-overlay="4"]:before {
  opacity: 0.4;
}

[data-overlay="5"]:before,
[data-black-overlay="5"]:before,
[data-white-overlay="5"]:before {
  opacity: 0.5;
}

[data-overlay="6"]:before,
[data-black-overlay="6"]:before,
[data-white-overlay="6"]:before {
  opacity: 0.6;
}

[data-overlay="7"]:before,
[data-black-overlay="7"]:before,
[data-white-overlay="7"]:before {
  opacity: 0.7;
}

[data-overlay="8"]:before,
[data-black-overlay="8"]:before,
[data-white-overlay="8"]:before {
  opacity: 0.8;
}

[data-overlay="9"]:before,
[data-black-overlay="9"]:before,
[data-white-overlay="9"]:before {
  opacity: 0.9;
}

[data-overlay="10"]:before,
[data-black-overlay="10"]:before,
[data-white-overlay="10"]:before {
  opacity: 1;
}

/*------------------------------
    Scroll Up 
--------------------------------*/
#scrollUp {
  width: 70px;
  height: 80px;
  right: 100px;
  bottom: 60px;
  text-align: center;
  z-index: 9811 !important;
  text-decoration: none;
  background: #fff;
  line-height: 80px;
  color: #757589;
  font-size: 15px;
  font-weight: 400;
  display: inline-block;
  background: #ffffff;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  #scrollUp {
    right: 20px;
    bottom: 40px;
  }
}
@media only screen and (max-width: 767px) {
  #scrollUp {
    right: 20px;
    bottom: 40px;
  }
}
#scrollUp::before {
  width: 100%;
  height: 100%;
  left: 0;
  bottom: 0;
  background: rgba(0, 2, 72, 0.1);
  content: "";
  position: absolute;
  z-index: -1;
  transform-style: preserve-3d;
  transform: rotateY(-10deg);
  filter: blur(50px);
}
#scrollUp::after {
  background: #ffffff;
  position: absolute;
  content: "";
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  transform-style: preserve-3d;
  transform: rotateY(-10deg);
}
@media only screen and (max-width: 767px) {
  #scrollUp {
    right: 20px;
    bottom: 30px;
    width: 50px;
    height: 60px;
    line-height: 60px;
  }
}
#scrollUp span.text {
  position: relative;
  display: inline-block;
  margin-top: 7px;
}
@media only screen and (max-width: 767px) {
  #scrollUp span.text {
    margin-top: 3px;
  }
}
#scrollUp span.text::after {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 5px 7px 5px;
  border-color: transparent transparent var(--color-primary) transparent;
  position: absolute;
  content: "";
  left: 50%;
  top: 21%;
  transform: translateX(-50%);
}
#scrollUp:hover span.text {
  color: var(--color-primary);
}

/*--------------------
    Contact Form 
----------------------*/
.form-message {
  margin-bottom: 0;
  text-align: center;
}
.form-message.error {
  margin-top: 20px;
  color: #f80707;
}
.form-message.success {
  margin-top: 20px;
  color: #0d8d2d;
}

/*=========================
    Section Separation 
==========================*/
.slick-dotted.slick-slider {
  margin-bottom: 0 !important;
}

.mt_dec--30 {
  margin-top: -30px;
}

.mt_dec--20 {
  margin-top: -20px;
}

.ptb--120-mine {
  padding: 60px 0 !important;
}

.rn-section-gap {
  padding: 120px 0 !important;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-section-gap {
    padding: 80px 0 !important;
  }
}
@media only screen and (max-width: 767px) {
  .rn-section-gap {
    padding: 60px 0 !important;
  }
}

.rn-section-gap-inside {
  padding: 20px 0 !important;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-section-gap-inside {
    padding: 80px 0 !important;
  }
}
@media only screen and (max-width: 767px) {
  .rn-section-gap-inside {
    padding: 60px 0 !important;
  }
}

.rn-section-gapBottom {
  padding-bottom: 120px !important;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-section-gapBottom {
    padding-bottom: 80px !important;
  }
}
@media only screen and (max-width: 767px) {
  .rn-section-gapBottom {
    padding-bottom: 60px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .pb--165,
  .pb--85 {
    padding-bottom: 80px !important;
  }
}
@media only screen and (max-width: 767px) {
  .pb--165,
  .pb--85 {
    padding-bottom: 60px !important;
  }
}

.rn-section-gapTop {
  padding-top: 120px !important;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-section-gapTop {
    padding-top: 80px !important;
  }
}
@media only screen and (max-width: 767px) {
  .rn-section-gapTop {
    padding-top: 60px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ptb--120 {
    padding: 80px 0 !important;
  }
}
@media only screen and (max-width: 767px) {
  .ptb--120 {
    padding: 60px 0 !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .pb--165,
  .pb--120,
  .pb--85,
  .pb--165 {
    padding-bottom: 80px !important;
  }
}
@media only screen and (max-width: 767px) {
  .pb--165,
  .pb--120,
  .pb--85,
  .pb--165 {
    padding-bottom: 60px !important;
  }
}

@media only screen and (max-width: 767px) {
  .pb--70 {
    padding-bottom: 60px !important;
  }
}

.pl--0 {
  padding-left: 0 !important;
}

.pr--0 {
  padding-right: 0 !important;
}

.pt--0 {
  padding-top: 0 !important;
}

.pb--0 {
  padding-bottom: 0 !important;
}

.mr--0 {
  margin-right: 0 !important;
}

.ml--0 {
  margin-left: 0 !important;
}

.mt--0 {
  margin-top: 0 !important;
}

.mb--0 {
  margin-bottom: 0 !important;
}

.pt--260 {
  padding-top: 260px !important;
}

.pt--250 {
  padding-top: 250px !important;
}

.pb--240 {
  padding-bottom: 240px !important;
}

.pb--220 {
  padding-bottom: 220px !important;
}

.plr--270 {
  padding: 0 270px !important;
}

.plr--300 {
  padding: 0 300px !important;
}

.plr--340 {
  padding: 0 340px !important;
}

.ptb--300 {
  padding: 300px 0 !important;
}

.ptb--340 {
  padding: 340px 0 !important;
}

.ptb--450 {
  padding: 450px 0 !important;
}

.plr_dec--15 {
  margin: 0 -15px !important;
}

.pt--300 {
  padding-top: 300px !important;
}

.ptb--5 {
  padding: 5px 0 !important;
}

.plr--5 {
  padding: 0 5px !important;
}

.pt--5 {
  padding-top: 5px !important;
}

.pb--5 {
  padding-bottom: 5px !important;
}

.pl--5 {
  padding-left: 5px !important;
}

.pr--5 {
  padding-right: 5px !important;
}

.mt--5 {
  margin-top: 5px !important;
}

.mb--5 {
  margin-bottom: 5px !important;
}

.mr--5 {
  margin-right: 5px !important;
}

.ml--5 {
  margin-left: 5px !important;
}

.ptb--10 {
  padding: 10px 0 !important;
}

.plr--10 {
  padding: 0 10px !important;
}

.pt--10 {
  padding-top: 10px !important;
}

.pb--10 {
  padding-bottom: 10px !important;
}

.pl--10 {
  padding-left: 10px !important;
}

.pr--10 {
  padding-right: 10px !important;
}

.mt--10 {
  margin-top: 10px !important;
}

.mb--10 {
  margin-bottom: 10px !important;
}

.mr--10 {
  margin-right: 10px !important;
}

.ml--10 {
  margin-left: 10px !important;
}

.ptb--15 {
  padding: 15px 0 !important;
}

.plr--15 {
  padding: 0 15px !important;
}

.pt--15 {
  padding-top: 15px !important;
}

.pb--15 {
  padding-bottom: 15px !important;
}

.pl--15 {
  padding-left: 15px !important;
}

.pr--15 {
  padding-right: 15px !important;
}

.mt--15 {
  margin-top: 15px !important;
}

.mb--15 {
  margin-bottom: 15px !important;
}

.mr--15 {
  margin-right: 15px !important;
}

.ml--15 {
  margin-left: 15px !important;
}

.ptb--20 {
  padding: 20px 0 !important;
}

.plr--20 {
  padding: 0 20px !important;
}

.pt--20 {
  padding-top: 20px !important;
}

.pb--20 {
  padding-bottom: 20px !important;
}

.pl--20 {
  padding-left: 20px !important;
}

.pr--20 {
  padding-right: 20px !important;
}

.mt--20 {
  margin-top: 20px !important;
}

.mb--20 {
  margin-bottom: 20px !important;
}

.mr--20 {
  margin-right: 20px !important;
}

.ml--20 {
  margin-left: 20px !important;
}

.ptb--25 {
  padding: 25px 0 !important;
}

.plr--25 {
  padding: 0 25px !important;
}

.pt--25 {
  padding-top: 25px !important;
}

.pb--25 {
  padding-bottom: 25px !important;
}

.pl--25 {
  padding-left: 25px !important;
}

.pr--25 {
  padding-right: 25px !important;
}

.mt--25 {
  margin-top: 25px !important;
}

.mb--25 {
  margin-bottom: 25px !important;
}

.mr--25 {
  margin-right: 25px !important;
}

.ml--25 {
  margin-left: 25px !important;
}

.ptb--30 {
  padding: 30px 0 !important;
}

.plr--30 {
  padding: 0 30px !important;
}

.pt--30 {
  padding-top: 30px !important;
}

.pb--30 {
  padding-bottom: 30px !important;
}

.pl--30 {
  padding-left: 30px !important;
}

.pr--30 {
  padding-right: 30px !important;
}

.mt--30 {
  margin-top: 30px !important;
}

.mb--30 {
  margin-bottom: 30px !important;
}

.mr--30 {
  margin-right: 30px !important;
}

.ml--30 {
  margin-left: 30px !important;
}

.ptb--35 {
  padding: 35px 0 !important;
}

.plr--35 {
  padding: 0 35px !important;
}

.pt--35 {
  padding-top: 35px !important;
}

.pb--35 {
  padding-bottom: 35px !important;
}

.pl--35 {
  padding-left: 35px !important;
}

.pr--35 {
  padding-right: 35px !important;
}

.mt--35 {
  margin-top: 35px !important;
}

.mb--35 {
  margin-bottom: 35px !important;
}

.mr--35 {
  margin-right: 35px !important;
}

.ml--35 {
  margin-left: 35px !important;
}

.ptb--40 {
  padding: 40px 0 !important;
}

.plr--40 {
  padding: 0 40px !important;
}

.pt--40 {
  padding-top: 40px !important;
}

.pb--40 {
  padding-bottom: 40px !important;
}

.pl--40 {
  padding-left: 40px !important;
}

.pr--40 {
  padding-right: 40px !important;
}

.mt--40 {
  margin-top: 40px !important;
}

.mb--40 {
  margin-bottom: 40px !important;
}

.mr--40 {
  margin-right: 40px !important;
}

.ml--40 {
  margin-left: 40px !important;
}

.ptb--45 {
  padding: 45px 0 !important;
}

.plr--45 {
  padding: 0 45px !important;
}

.pt--45 {
  padding-top: 45px !important;
}

.pb--45 {
  padding-bottom: 45px !important;
}

.pl--45 {
  padding-left: 45px !important;
}

.pr--45 {
  padding-right: 45px !important;
}

.mt--45 {
  margin-top: 45px !important;
}

.mb--45 {
  margin-bottom: 45px !important;
}

.mr--45 {
  margin-right: 45px !important;
}

.ml--45 {
  margin-left: 45px !important;
}

.ptb--50 {
  padding: 50px 0 !important;
}

.plr--50 {
  padding: 0 50px !important;
}

.pt--50 {
  padding-top: 50px !important;
}

.pb--50 {
  padding-bottom: 50px !important;
}

.pl--50 {
  padding-left: 50px !important;
}

.pr--50 {
  padding-right: 50px !important;
}

.mt--50 {
  margin-top: 50px !important;
}

.mb--50 {
  margin-bottom: 50px !important;
}

.mr--50 {
  margin-right: 50px !important;
}

.ml--50 {
  margin-left: 50px !important;
}

.ptb--55 {
  padding: 55px 0 !important;
}

.plr--55 {
  padding: 0 55px !important;
}

.pt--55 {
  padding-top: 55px !important;
}

.pb--55 {
  padding-bottom: 55px !important;
}

.pl--55 {
  padding-left: 55px !important;
}

.pr--55 {
  padding-right: 55px !important;
}

.mt--55 {
  margin-top: 55px !important;
}

.mb--55 {
  margin-bottom: 55px !important;
}

.mr--55 {
  margin-right: 55px !important;
}

.ml--55 {
  margin-left: 55px !important;
}

.ptb--60 {
  padding: 60px 0 !important;
}

.plr--60 {
  padding: 0 60px !important;
}

.pt--60 {
  padding-top: 60px !important;
}

.pb--60 {
  padding-bottom: 60px !important;
}

.pl--60 {
  padding-left: 60px !important;
}

.pr--60 {
  padding-right: 60px !important;
}

.mt--60 {
  margin-top: 60px !important;
}

.mb--60 {
  margin-bottom: 60px !important;
}

.mr--60 {
  margin-right: 60px !important;
}

.ml--60 {
  margin-left: 60px !important;
}

.ptb--65 {
  padding: 65px 0 !important;
}

.plr--65 {
  padding: 0 65px !important;
}

.pt--65 {
  padding-top: 65px !important;
}

.pb--65 {
  padding-bottom: 65px !important;
}

.pl--65 {
  padding-left: 65px !important;
}

.pr--65 {
  padding-right: 65px !important;
}

.mt--65 {
  margin-top: 65px !important;
}

.mb--65 {
  margin-bottom: 65px !important;
}

.mr--65 {
  margin-right: 65px !important;
}

.ml--65 {
  margin-left: 65px !important;
}

.ptb--70 {
  padding: 70px 0 !important;
}

.plr--70 {
  padding: 0 70px !important;
}

.pt--70 {
  padding-top: 70px !important;
}

.pb--70 {
  padding-bottom: 70px !important;
}

.pl--70 {
  padding-left: 70px !important;
}

.pr--70 {
  padding-right: 70px !important;
}

.mt--70 {
  margin-top: 70px !important;
}

.mb--70 {
  margin-bottom: 70px !important;
}

.mr--70 {
  margin-right: 70px !important;
}

.ml--70 {
  margin-left: 70px !important;
}

.ptb--75 {
  padding: 75px 0 !important;
}

.plr--75 {
  padding: 0 75px !important;
}

.pt--75 {
  padding-top: 75px !important;
}

.pb--75 {
  padding-bottom: 75px !important;
}

.pl--75 {
  padding-left: 75px !important;
}

.pr--75 {
  padding-right: 75px !important;
}

.mt--75 {
  margin-top: 75px !important;
}

.mb--75 {
  margin-bottom: 75px !important;
}

.mr--75 {
  margin-right: 75px !important;
}

.ml--75 {
  margin-left: 75px !important;
}

.ptb--80 {
  padding: 80px 0 !important;
}

.plr--80 {
  padding: 0 80px !important;
}

.pt--80 {
  padding-top: 80px !important;
}

.pb--80 {
  padding-bottom: 80px !important;
}

.pl--80 {
  padding-left: 80px !important;
}

.pr--80 {
  padding-right: 80px !important;
}

.mt--80 {
  margin-top: 80px !important;
}

.mb--80 {
  margin-bottom: 80px !important;
}

.mr--80 {
  margin-right: 80px !important;
}

.ml--80 {
  margin-left: 80px !important;
}

.ptb--85 {
  padding: 85px 0 !important;
}

.plr--85 {
  padding: 0 85px !important;
}

.pt--85 {
  padding-top: 85px !important;
}

.pb--85 {
  padding-bottom: 85px !important;
}

.pl--85 {
  padding-left: 85px !important;
}

.pr--85 {
  padding-right: 85px !important;
}

.mt--85 {
  margin-top: 85px !important;
}

.mb--85 {
  margin-bottom: 85px !important;
}

.mr--85 {
  margin-right: 85px !important;
}

.ml--85 {
  margin-left: 85px !important;
}

.ptb--90 {
  padding: 90px 0 !important;
}

.plr--90 {
  padding: 0 90px !important;
}

.pt--90 {
  padding-top: 90px !important;
}

.pb--90 {
  padding-bottom: 90px !important;
}

.pl--90 {
  padding-left: 90px !important;
}

.pr--90 {
  padding-right: 90px !important;
}

.mt--90 {
  margin-top: 90px !important;
}

.mb--90 {
  margin-bottom: 90px !important;
}

.mr--90 {
  margin-right: 90px !important;
}

.ml--90 {
  margin-left: 90px !important;
}

.ptb--95 {
  padding: 95px 0 !important;
}

.plr--95 {
  padding: 0 95px !important;
}

.pt--95 {
  padding-top: 95px !important;
}

.pb--95 {
  padding-bottom: 95px !important;
}

.pl--95 {
  padding-left: 95px !important;
}

.pr--95 {
  padding-right: 95px !important;
}

.mt--95 {
  margin-top: 95px !important;
}

.mb--95 {
  margin-bottom: 95px !important;
}

.mr--95 {
  margin-right: 95px !important;
}

.ml--95 {
  margin-left: 95px !important;
}

.ptb--100 {
  padding: 100px 0 !important;
}

.plr--100 {
  padding: 0 100px !important;
}

.pt--100 {
  padding-top: 100px !important;
}

.pb--100 {
  padding-bottom: 100px !important;
}

.pl--100 {
  padding-left: 100px !important;
}

.pr--100 {
  padding-right: 100px !important;
}

.mt--100 {
  margin-top: 100px !important;
}

.mb--100 {
  margin-bottom: 100px !important;
}

.mr--100 {
  margin-right: 100px !important;
}

.ml--100 {
  margin-left: 100px !important;
}

.ptb--105 {
  padding: 105px 0 !important;
}

.plr--105 {
  padding: 0 105px !important;
}

.pt--105 {
  padding-top: 105px !important;
}

.pb--105 {
  padding-bottom: 105px !important;
}

.pl--105 {
  padding-left: 105px !important;
}

.pr--105 {
  padding-right: 105px !important;
}

.mt--105 {
  margin-top: 105px !important;
}

.mb--105 {
  margin-bottom: 105px !important;
}

.mr--105 {
  margin-right: 105px !important;
}

.ml--105 {
  margin-left: 105px !important;
}

.ptb--110 {
  padding: 110px 0 !important;
}

.plr--110 {
  padding: 0 110px !important;
}

.pt--110 {
  padding-top: 110px !important;
}

.pb--110 {
  padding-bottom: 110px !important;
}

.pl--110 {
  padding-left: 110px !important;
}

.pr--110 {
  padding-right: 110px !important;
}

.mt--110 {
  margin-top: 110px !important;
}

.mb--110 {
  margin-bottom: 110px !important;
}

.mr--110 {
  margin-right: 110px !important;
}

.ml--110 {
  margin-left: 110px !important;
}

.ptb--115 {
  padding: 115px 0 !important;
}

.plr--115 {
  padding: 0 115px !important;
}

.pt--115 {
  padding-top: 115px !important;
}

.pb--115 {
  padding-bottom: 115px !important;
}

.pl--115 {
  padding-left: 115px !important;
}

.pr--115 {
  padding-right: 115px !important;
}

.mt--115 {
  margin-top: 115px !important;
}

.mb--115 {
  margin-bottom: 115px !important;
}

.mr--115 {
  margin-right: 115px !important;
}

.ml--115 {
  margin-left: 115px !important;
}

.ptb--120 {
  padding: 120px 0 !important;
}

.plr--120 {
  padding: 0 120px !important;
}

.pt--120 {
  padding-top: 120px !important;
}

.pb--120 {
  padding-bottom: 120px !important;
}

.pl--120 {
  padding-left: 120px !important;
}

.pr--120 {
  padding-right: 120px !important;
}

.mt--120 {
  margin-top: 120px !important;
}

.mb--120 {
  margin-bottom: 120px !important;
}

.mr--120 {
  margin-right: 120px !important;
}

.ml--120 {
  margin-left: 120px !important;
}

.ptb--125 {
  padding: 125px 0 !important;
}

.plr--125 {
  padding: 0 125px !important;
}

.pt--125 {
  padding-top: 125px !important;
}

.pb--125 {
  padding-bottom: 125px !important;
}

.pl--125 {
  padding-left: 125px !important;
}

.pr--125 {
  padding-right: 125px !important;
}

.mt--125 {
  margin-top: 125px !important;
}

.mb--125 {
  margin-bottom: 125px !important;
}

.mr--125 {
  margin-right: 125px !important;
}

.ml--125 {
  margin-left: 125px !important;
}

.ptb--130 {
  padding: 130px 0 !important;
}

.plr--130 {
  padding: 0 130px !important;
}

.pt--130 {
  padding-top: 130px !important;
}

.pb--130 {
  padding-bottom: 130px !important;
}

.pl--130 {
  padding-left: 130px !important;
}

.pr--130 {
  padding-right: 130px !important;
}

.mt--130 {
  margin-top: 130px !important;
}

.mb--130 {
  margin-bottom: 130px !important;
}

.mr--130 {
  margin-right: 130px !important;
}

.ml--130 {
  margin-left: 130px !important;
}

.ptb--135 {
  padding: 135px 0 !important;
}

.plr--135 {
  padding: 0 135px !important;
}

.pt--135 {
  padding-top: 135px !important;
}

.pb--135 {
  padding-bottom: 135px !important;
}

.pl--135 {
  padding-left: 135px !important;
}

.pr--135 {
  padding-right: 135px !important;
}

.mt--135 {
  margin-top: 135px !important;
}

.mb--135 {
  margin-bottom: 135px !important;
}

.mr--135 {
  margin-right: 135px !important;
}

.ml--135 {
  margin-left: 135px !important;
}

.ptb--140 {
  padding: 140px 0 !important;
}

.plr--140 {
  padding: 0 140px !important;
}

.pt--140 {
  padding-top: 140px !important;
}

.pb--140 {
  padding-bottom: 140px !important;
}

.pl--140 {
  padding-left: 140px !important;
}

.pr--140 {
  padding-right: 140px !important;
}

.mt--140 {
  margin-top: 140px !important;
}

.mb--140 {
  margin-bottom: 140px !important;
}

.mr--140 {
  margin-right: 140px !important;
}

.ml--140 {
  margin-left: 140px !important;
}

.ptb--145 {
  padding: 145px 0 !important;
}

.plr--145 {
  padding: 0 145px !important;
}

.pt--145 {
  padding-top: 145px !important;
}

.pb--145 {
  padding-bottom: 145px !important;
}

.pl--145 {
  padding-left: 145px !important;
}

.pr--145 {
  padding-right: 145px !important;
}

.mt--145 {
  margin-top: 145px !important;
}

.mb--145 {
  margin-bottom: 145px !important;
}

.mr--145 {
  margin-right: 145px !important;
}

.ml--145 {
  margin-left: 145px !important;
}

.ptb--150 {
  padding: 150px 0 !important;
}

.plr--150 {
  padding: 0 150px !important;
}

.pt--150 {
  padding-top: 150px !important;
}

.pb--150 {
  padding-bottom: 150px !important;
}

.pl--150 {
  padding-left: 150px !important;
}

.pr--150 {
  padding-right: 150px !important;
}

.mt--150 {
  margin-top: 150px !important;
}

.mb--150 {
  margin-bottom: 150px !important;
}

.mr--150 {
  margin-right: 150px !important;
}

.ml--150 {
  margin-left: 150px !important;
}

.ptb--155 {
  padding: 155px 0 !important;
}

.plr--155 {
  padding: 0 155px !important;
}

.pt--155 {
  padding-top: 155px !important;
}

.pb--155 {
  padding-bottom: 155px !important;
}

.pl--155 {
  padding-left: 155px !important;
}

.pr--155 {
  padding-right: 155px !important;
}

.mt--155 {
  margin-top: 155px !important;
}

.mb--155 {
  margin-bottom: 155px !important;
}

.mr--155 {
  margin-right: 155px !important;
}

.ml--155 {
  margin-left: 155px !important;
}

.ptb--160 {
  padding: 160px 0 !important;
}

.plr--160 {
  padding: 0 160px !important;
}

.pt--160 {
  padding-top: 160px !important;
}

.pb--160 {
  padding-bottom: 160px !important;
}

.pl--160 {
  padding-left: 160px !important;
}

.pr--160 {
  padding-right: 160px !important;
}

.mt--160 {
  margin-top: 160px !important;
}

.mb--160 {
  margin-bottom: 160px !important;
}

.mr--160 {
  margin-right: 160px !important;
}

.ml--160 {
  margin-left: 160px !important;
}

.ptb--165 {
  padding: 165px 0 !important;
}

.plr--165 {
  padding: 0 165px !important;
}

.pt--165 {
  padding-top: 165px !important;
}

.pb--165 {
  padding-bottom: 165px !important;
}

.pl--165 {
  padding-left: 165px !important;
}

.pr--165 {
  padding-right: 165px !important;
}

.mt--165 {
  margin-top: 165px !important;
}

.mb--165 {
  margin-bottom: 165px !important;
}

.mr--165 {
  margin-right: 165px !important;
}

.ml--165 {
  margin-left: 165px !important;
}

.ptb--170 {
  padding: 170px 0 !important;
}

.plr--170 {
  padding: 0 170px !important;
}

.pt--170 {
  padding-top: 170px !important;
}

.pb--170 {
  padding-bottom: 170px !important;
}

.pl--170 {
  padding-left: 170px !important;
}

.pr--170 {
  padding-right: 170px !important;
}

.mt--170 {
  margin-top: 170px !important;
}

.mb--170 {
  margin-bottom: 170px !important;
}

.mr--170 {
  margin-right: 170px !important;
}

.ml--170 {
  margin-left: 170px !important;
}

.ptb--175 {
  padding: 175px 0 !important;
}

.plr--175 {
  padding: 0 175px !important;
}

.pt--175 {
  padding-top: 175px !important;
}

.pb--175 {
  padding-bottom: 175px !important;
}

.pl--175 {
  padding-left: 175px !important;
}

.pr--175 {
  padding-right: 175px !important;
}

.mt--175 {
  margin-top: 175px !important;
}

.mb--175 {
  margin-bottom: 175px !important;
}

.mr--175 {
  margin-right: 175px !important;
}

.ml--175 {
  margin-left: 175px !important;
}

.ptb--180 {
  padding: 180px 0 !important;
}

.plr--180 {
  padding: 0 180px !important;
}

.pt--180 {
  padding-top: 180px !important;
}

.pb--180 {
  padding-bottom: 180px !important;
}

.pl--180 {
  padding-left: 180px !important;
}

.pr--180 {
  padding-right: 180px !important;
}

.mt--180 {
  margin-top: 180px !important;
}

.mb--180 {
  margin-bottom: 180px !important;
}

.mr--180 {
  margin-right: 180px !important;
}

.ml--180 {
  margin-left: 180px !important;
}

.ptb--185 {
  padding: 185px 0 !important;
}

.plr--185 {
  padding: 0 185px !important;
}

.pt--185 {
  padding-top: 185px !important;
}

.pb--185 {
  padding-bottom: 185px !important;
}

.pl--185 {
  padding-left: 185px !important;
}

.pr--185 {
  padding-right: 185px !important;
}

.mt--185 {
  margin-top: 185px !important;
}

.mb--185 {
  margin-bottom: 185px !important;
}

.mr--185 {
  margin-right: 185px !important;
}

.ml--185 {
  margin-left: 185px !important;
}

.ptb--190 {
  padding: 190px 0 !important;
}

.plr--190 {
  padding: 0 190px !important;
}

.pt--190 {
  padding-top: 190px !important;
}

.pb--190 {
  padding-bottom: 190px !important;
}

.pl--190 {
  padding-left: 190px !important;
}

.pr--190 {
  padding-right: 190px !important;
}

.mt--190 {
  margin-top: 190px !important;
}

.mb--190 {
  margin-bottom: 190px !important;
}

.mr--190 {
  margin-right: 190px !important;
}

.ml--190 {
  margin-left: 190px !important;
}

.ptb--195 {
  padding: 195px 0 !important;
}

.plr--195 {
  padding: 0 195px !important;
}

.pt--195 {
  padding-top: 195px !important;
}

.pb--195 {
  padding-bottom: 195px !important;
}

.pl--195 {
  padding-left: 195px !important;
}

.pr--195 {
  padding-right: 195px !important;
}

.mt--195 {
  margin-top: 195px !important;
}

.mb--195 {
  margin-bottom: 195px !important;
}

.mr--195 {
  margin-right: 195px !important;
}

.ml--195 {
  margin-left: 195px !important;
}

.ptb--200 {
  padding: 200px 0 !important;
}

.plr--200 {
  padding: 0 200px !important;
}

.pt--200 {
  padding-top: 200px !important;
}

.pb--200 {
  padding-bottom: 200px !important;
}

.pl--200 {
  padding-left: 200px !important;
}

.pr--200 {
  padding-right: 200px !important;
}

.mt--200 {
  margin-top: 200px !important;
}

.mb--200 {
  margin-bottom: 200px !important;
}

.mr--200 {
  margin-right: 200px !important;
}

.ml--200 {
  margin-left: 200px !important;
}

@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .ptb_lp--5 {
    padding: 5px 0 !important;
  }
  .plr_lp--5 {
    padding: 0 5px !important;
  }
  .pt_lp--5 {
    padding-top: 5px !important;
  }
  .pb_lp--5 {
    padding-bottom: 5px !important;
  }
  .pl_lp--5 {
    padding-left: 5px !important;
  }
  .pr_lp--5 {
    padding-right: 5px !important;
  }
  .mt_lp--5 {
    margin-top: 5px !important;
  }
  .mb_lp--5 {
    margin-bottom: 5px !important;
  }
  .ptb_lp--10 {
    padding: 10px 0 !important;
  }
  .plr_lp--10 {
    padding: 0 10px !important;
  }
  .pt_lp--10 {
    padding-top: 10px !important;
  }
  .pb_lp--10 {
    padding-bottom: 10px !important;
  }
  .pl_lp--10 {
    padding-left: 10px !important;
  }
  .pr_lp--10 {
    padding-right: 10px !important;
  }
  .mt_lp--10 {
    margin-top: 10px !important;
  }
  .mb_lp--10 {
    margin-bottom: 10px !important;
  }
  .ptb_lp--15 {
    padding: 15px 0 !important;
  }
  .plr_lp--15 {
    padding: 0 15px !important;
  }
  .pt_lp--15 {
    padding-top: 15px !important;
  }
  .pb_lp--15 {
    padding-bottom: 15px !important;
  }
  .pl_lp--15 {
    padding-left: 15px !important;
  }
  .pr_lp--15 {
    padding-right: 15px !important;
  }
  .mt_lp--15 {
    margin-top: 15px !important;
  }
  .mb_lp--15 {
    margin-bottom: 15px !important;
  }
  .ptb_lp--20 {
    padding: 20px 0 !important;
  }
  .plr_lp--20 {
    padding: 0 20px !important;
  }
  .pt_lp--20 {
    padding-top: 20px !important;
  }
  .pb_lp--20 {
    padding-bottom: 20px !important;
  }
  .pl_lp--20 {
    padding-left: 20px !important;
  }
  .pr_lp--20 {
    padding-right: 20px !important;
  }
  .mt_lp--20 {
    margin-top: 20px !important;
  }
  .mb_lp--20 {
    margin-bottom: 20px !important;
  }
  .ptb_lp--25 {
    padding: 25px 0 !important;
  }
  .plr_lp--25 {
    padding: 0 25px !important;
  }
  .pt_lp--25 {
    padding-top: 25px !important;
  }
  .pb_lp--25 {
    padding-bottom: 25px !important;
  }
  .pl_lp--25 {
    padding-left: 25px !important;
  }
  .pr_lp--25 {
    padding-right: 25px !important;
  }
  .mt_lp--25 {
    margin-top: 25px !important;
  }
  .mb_lp--25 {
    margin-bottom: 25px !important;
  }
  .ptb_lp--30 {
    padding: 30px 0 !important;
  }
  .plr_lp--30 {
    padding: 0 30px !important;
  }
  .pt_lp--30 {
    padding-top: 30px !important;
  }
  .pb_lp--30 {
    padding-bottom: 30px !important;
  }
  .pl_lp--30 {
    padding-left: 30px !important;
  }
  .pr_lp--30 {
    padding-right: 30px !important;
  }
  .mt_lp--30 {
    margin-top: 30px !important;
  }
  .mb_lp--30 {
    margin-bottom: 30px !important;
  }
  .ptb_lp--35 {
    padding: 35px 0 !important;
  }
  .plr_lp--35 {
    padding: 0 35px !important;
  }
  .pt_lp--35 {
    padding-top: 35px !important;
  }
  .pb_lp--35 {
    padding-bottom: 35px !important;
  }
  .pl_lp--35 {
    padding-left: 35px !important;
  }
  .pr_lp--35 {
    padding-right: 35px !important;
  }
  .mt_lp--35 {
    margin-top: 35px !important;
  }
  .mb_lp--35 {
    margin-bottom: 35px !important;
  }
  .ptb_lp--40 {
    padding: 40px 0 !important;
  }
  .plr_lp--40 {
    padding: 0 40px !important;
  }
  .pt_lp--40 {
    padding-top: 40px !important;
  }
  .pb_lp--40 {
    padding-bottom: 40px !important;
  }
  .pl_lp--40 {
    padding-left: 40px !important;
  }
  .pr_lp--40 {
    padding-right: 40px !important;
  }
  .mt_lp--40 {
    margin-top: 40px !important;
  }
  .mb_lp--40 {
    margin-bottom: 40px !important;
  }
  .ptb_lp--45 {
    padding: 45px 0 !important;
  }
  .plr_lp--45 {
    padding: 0 45px !important;
  }
  .pt_lp--45 {
    padding-top: 45px !important;
  }
  .pb_lp--45 {
    padding-bottom: 45px !important;
  }
  .pl_lp--45 {
    padding-left: 45px !important;
  }
  .pr_lp--45 {
    padding-right: 45px !important;
  }
  .mt_lp--45 {
    margin-top: 45px !important;
  }
  .mb_lp--45 {
    margin-bottom: 45px !important;
  }
  .ptb_lp--50 {
    padding: 50px 0 !important;
  }
  .plr_lp--50 {
    padding: 0 50px !important;
  }
  .pt_lp--50 {
    padding-top: 50px !important;
  }
  .pb_lp--50 {
    padding-bottom: 50px !important;
  }
  .pl_lp--50 {
    padding-left: 50px !important;
  }
  .pr_lp--50 {
    padding-right: 50px !important;
  }
  .mt_lp--50 {
    margin-top: 50px !important;
  }
  .mb_lp--50 {
    margin-bottom: 50px !important;
  }
  .ptb_lp--55 {
    padding: 55px 0 !important;
  }
  .plr_lp--55 {
    padding: 0 55px !important;
  }
  .pt_lp--55 {
    padding-top: 55px !important;
  }
  .pb_lp--55 {
    padding-bottom: 55px !important;
  }
  .pl_lp--55 {
    padding-left: 55px !important;
  }
  .pr_lp--55 {
    padding-right: 55px !important;
  }
  .mt_lp--55 {
    margin-top: 55px !important;
  }
  .mb_lp--55 {
    margin-bottom: 55px !important;
  }
  .ptb_lp--60 {
    padding: 60px 0 !important;
  }
  .plr_lp--60 {
    padding: 0 60px !important;
  }
  .pt_lp--60 {
    padding-top: 60px !important;
  }
  .pb_lp--60 {
    padding-bottom: 60px !important;
  }
  .pl_lp--60 {
    padding-left: 60px !important;
  }
  .pr_lp--60 {
    padding-right: 60px !important;
  }
  .mt_lp--60 {
    margin-top: 60px !important;
  }
  .mb_lp--60 {
    margin-bottom: 60px !important;
  }
  .ptb_lp--65 {
    padding: 65px 0 !important;
  }
  .plr_lp--65 {
    padding: 0 65px !important;
  }
  .pt_lp--65 {
    padding-top: 65px !important;
  }
  .pb_lp--65 {
    padding-bottom: 65px !important;
  }
  .pl_lp--65 {
    padding-left: 65px !important;
  }
  .pr_lp--65 {
    padding-right: 65px !important;
  }
  .mt_lp--65 {
    margin-top: 65px !important;
  }
  .mb_lp--65 {
    margin-bottom: 65px !important;
  }
  .ptb_lp--70 {
    padding: 70px 0 !important;
  }
  .plr_lp--70 {
    padding: 0 70px !important;
  }
  .pt_lp--70 {
    padding-top: 70px !important;
  }
  .pb_lp--70 {
    padding-bottom: 70px !important;
  }
  .pl_lp--70 {
    padding-left: 70px !important;
  }
  .pr_lp--70 {
    padding-right: 70px !important;
  }
  .mt_lp--70 {
    margin-top: 70px !important;
  }
  .mb_lp--70 {
    margin-bottom: 70px !important;
  }
  .ptb_lp--75 {
    padding: 75px 0 !important;
  }
  .plr_lp--75 {
    padding: 0 75px !important;
  }
  .pt_lp--75 {
    padding-top: 75px !important;
  }
  .pb_lp--75 {
    padding-bottom: 75px !important;
  }
  .pl_lp--75 {
    padding-left: 75px !important;
  }
  .pr_lp--75 {
    padding-right: 75px !important;
  }
  .mt_lp--75 {
    margin-top: 75px !important;
  }
  .mb_lp--75 {
    margin-bottom: 75px !important;
  }
  .ptb_lp--80 {
    padding: 80px 0 !important;
  }
  .plr_lp--80 {
    padding: 0 80px !important;
  }
  .pt_lp--80 {
    padding-top: 80px !important;
  }
  .pb_lp--80 {
    padding-bottom: 80px !important;
  }
  .pl_lp--80 {
    padding-left: 80px !important;
  }
  .pr_lp--80 {
    padding-right: 80px !important;
  }
  .mt_lp--80 {
    margin-top: 80px !important;
  }
  .mb_lp--80 {
    margin-bottom: 80px !important;
  }
  .ptb_lp--85 {
    padding: 85px 0 !important;
  }
  .plr_lp--85 {
    padding: 0 85px !important;
  }
  .pt_lp--85 {
    padding-top: 85px !important;
  }
  .pb_lp--85 {
    padding-bottom: 85px !important;
  }
  .pl_lp--85 {
    padding-left: 85px !important;
  }
  .pr_lp--85 {
    padding-right: 85px !important;
  }
  .mt_lp--85 {
    margin-top: 85px !important;
  }
  .mb_lp--85 {
    margin-bottom: 85px !important;
  }
  .ptb_lp--90 {
    padding: 90px 0 !important;
  }
  .plr_lp--90 {
    padding: 0 90px !important;
  }
  .pt_lp--90 {
    padding-top: 90px !important;
  }
  .pb_lp--90 {
    padding-bottom: 90px !important;
  }
  .pl_lp--90 {
    padding-left: 90px !important;
  }
  .pr_lp--90 {
    padding-right: 90px !important;
  }
  .mt_lp--90 {
    margin-top: 90px !important;
  }
  .mb_lp--90 {
    margin-bottom: 90px !important;
  }
  .ptb_lp--95 {
    padding: 95px 0 !important;
  }
  .plr_lp--95 {
    padding: 0 95px !important;
  }
  .pt_lp--95 {
    padding-top: 95px !important;
  }
  .pb_lp--95 {
    padding-bottom: 95px !important;
  }
  .pl_lp--95 {
    padding-left: 95px !important;
  }
  .pr_lp--95 {
    padding-right: 95px !important;
  }
  .mt_lp--95 {
    margin-top: 95px !important;
  }
  .mb_lp--95 {
    margin-bottom: 95px !important;
  }
  .ptb_lp--100 {
    padding: 100px 0 !important;
  }
  .plr_lp--100 {
    padding: 0 100px !important;
  }
  .pt_lp--100 {
    padding-top: 100px !important;
  }
  .pb_lp--100 {
    padding-bottom: 100px !important;
  }
  .pl_lp--100 {
    padding-left: 100px !important;
  }
  .pr_lp--100 {
    padding-right: 100px !important;
  }
  .mt_lp--100 {
    margin-top: 100px !important;
  }
  .mb_lp--100 {
    margin-bottom: 100px !important;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .ptb_lg--5 {
    padding: 5px 0 !important;
  }
  .plr_lg--5 {
    padding: 0 5px !important;
  }
  .pt_lg--5 {
    padding-top: 5px !important;
  }
  .pb_lg--5 {
    padding-bottom: 5px !important;
  }
  .pl_lg--5 {
    padding-left: 5px !important;
  }
  .pr_lg--5 {
    padding-right: 5px !important;
  }
  .mt_lg--5 {
    margin-top: 5px !important;
  }
  .mb_lg--5 {
    margin-bottom: 5px !important;
  }
  .ml_lg--5 {
    margin-left: 5px !important;
  }
  .ptb_lg--10 {
    padding: 10px 0 !important;
  }
  .plr_lg--10 {
    padding: 0 10px !important;
  }
  .pt_lg--10 {
    padding-top: 10px !important;
  }
  .pb_lg--10 {
    padding-bottom: 10px !important;
  }
  .pl_lg--10 {
    padding-left: 10px !important;
  }
  .pr_lg--10 {
    padding-right: 10px !important;
  }
  .mt_lg--10 {
    margin-top: 10px !important;
  }
  .mb_lg--10 {
    margin-bottom: 10px !important;
  }
  .ml_lg--10 {
    margin-left: 10px !important;
  }
  .ptb_lg--15 {
    padding: 15px 0 !important;
  }
  .plr_lg--15 {
    padding: 0 15px !important;
  }
  .pt_lg--15 {
    padding-top: 15px !important;
  }
  .pb_lg--15 {
    padding-bottom: 15px !important;
  }
  .pl_lg--15 {
    padding-left: 15px !important;
  }
  .pr_lg--15 {
    padding-right: 15px !important;
  }
  .mt_lg--15 {
    margin-top: 15px !important;
  }
  .mb_lg--15 {
    margin-bottom: 15px !important;
  }
  .ml_lg--15 {
    margin-left: 15px !important;
  }
  .ptb_lg--20 {
    padding: 20px 0 !important;
  }
  .plr_lg--20 {
    padding: 0 20px !important;
  }
  .pt_lg--20 {
    padding-top: 20px !important;
  }
  .pb_lg--20 {
    padding-bottom: 20px !important;
  }
  .pl_lg--20 {
    padding-left: 20px !important;
  }
  .pr_lg--20 {
    padding-right: 20px !important;
  }
  .mt_lg--20 {
    margin-top: 20px !important;
  }
  .mb_lg--20 {
    margin-bottom: 20px !important;
  }
  .ml_lg--20 {
    margin-left: 20px !important;
  }
  .ptb_lg--25 {
    padding: 25px 0 !important;
  }
  .plr_lg--25 {
    padding: 0 25px !important;
  }
  .pt_lg--25 {
    padding-top: 25px !important;
  }
  .pb_lg--25 {
    padding-bottom: 25px !important;
  }
  .pl_lg--25 {
    padding-left: 25px !important;
  }
  .pr_lg--25 {
    padding-right: 25px !important;
  }
  .mt_lg--25 {
    margin-top: 25px !important;
  }
  .mb_lg--25 {
    margin-bottom: 25px !important;
  }
  .ml_lg--25 {
    margin-left: 25px !important;
  }
  .ptb_lg--30 {
    padding: 30px 0 !important;
  }
  .plr_lg--30 {
    padding: 0 30px !important;
  }
  .pt_lg--30 {
    padding-top: 30px !important;
  }
  .pb_lg--30 {
    padding-bottom: 30px !important;
  }
  .pl_lg--30 {
    padding-left: 30px !important;
  }
  .pr_lg--30 {
    padding-right: 30px !important;
  }
  .mt_lg--30 {
    margin-top: 30px !important;
  }
  .mb_lg--30 {
    margin-bottom: 30px !important;
  }
  .ml_lg--30 {
    margin-left: 30px !important;
  }
  .ptb_lg--35 {
    padding: 35px 0 !important;
  }
  .plr_lg--35 {
    padding: 0 35px !important;
  }
  .pt_lg--35 {
    padding-top: 35px !important;
  }
  .pb_lg--35 {
    padding-bottom: 35px !important;
  }
  .pl_lg--35 {
    padding-left: 35px !important;
  }
  .pr_lg--35 {
    padding-right: 35px !important;
  }
  .mt_lg--35 {
    margin-top: 35px !important;
  }
  .mb_lg--35 {
    margin-bottom: 35px !important;
  }
  .ml_lg--35 {
    margin-left: 35px !important;
  }
  .ptb_lg--40 {
    padding: 40px 0 !important;
  }
  .plr_lg--40 {
    padding: 0 40px !important;
  }
  .pt_lg--40 {
    padding-top: 40px !important;
  }
  .pb_lg--40 {
    padding-bottom: 40px !important;
  }
  .pl_lg--40 {
    padding-left: 40px !important;
  }
  .pr_lg--40 {
    padding-right: 40px !important;
  }
  .mt_lg--40 {
    margin-top: 40px !important;
  }
  .mb_lg--40 {
    margin-bottom: 40px !important;
  }
  .ml_lg--40 {
    margin-left: 40px !important;
  }
  .ptb_lg--45 {
    padding: 45px 0 !important;
  }
  .plr_lg--45 {
    padding: 0 45px !important;
  }
  .pt_lg--45 {
    padding-top: 45px !important;
  }
  .pb_lg--45 {
    padding-bottom: 45px !important;
  }
  .pl_lg--45 {
    padding-left: 45px !important;
  }
  .pr_lg--45 {
    padding-right: 45px !important;
  }
  .mt_lg--45 {
    margin-top: 45px !important;
  }
  .mb_lg--45 {
    margin-bottom: 45px !important;
  }
  .ml_lg--45 {
    margin-left: 45px !important;
  }
  .ptb_lg--50 {
    padding: 50px 0 !important;
  }
  .plr_lg--50 {
    padding: 0 50px !important;
  }
  .pt_lg--50 {
    padding-top: 50px !important;
  }
  .pb_lg--50 {
    padding-bottom: 50px !important;
  }
  .pl_lg--50 {
    padding-left: 50px !important;
  }
  .pr_lg--50 {
    padding-right: 50px !important;
  }
  .mt_lg--50 {
    margin-top: 50px !important;
  }
  .mb_lg--50 {
    margin-bottom: 50px !important;
  }
  .ml_lg--50 {
    margin-left: 50px !important;
  }
  .ptb_lg--55 {
    padding: 55px 0 !important;
  }
  .plr_lg--55 {
    padding: 0 55px !important;
  }
  .pt_lg--55 {
    padding-top: 55px !important;
  }
  .pb_lg--55 {
    padding-bottom: 55px !important;
  }
  .pl_lg--55 {
    padding-left: 55px !important;
  }
  .pr_lg--55 {
    padding-right: 55px !important;
  }
  .mt_lg--55 {
    margin-top: 55px !important;
  }
  .mb_lg--55 {
    margin-bottom: 55px !important;
  }
  .ml_lg--55 {
    margin-left: 55px !important;
  }
  .ptb_lg--60 {
    padding: 60px 0 !important;
  }
  .plr_lg--60 {
    padding: 0 60px !important;
  }
  .pt_lg--60 {
    padding-top: 60px !important;
  }
  .pb_lg--60 {
    padding-bottom: 60px !important;
  }
  .pl_lg--60 {
    padding-left: 60px !important;
  }
  .pr_lg--60 {
    padding-right: 60px !important;
  }
  .mt_lg--60 {
    margin-top: 60px !important;
  }
  .mb_lg--60 {
    margin-bottom: 60px !important;
  }
  .ml_lg--60 {
    margin-left: 60px !important;
  }
  .ptb_lg--65 {
    padding: 65px 0 !important;
  }
  .plr_lg--65 {
    padding: 0 65px !important;
  }
  .pt_lg--65 {
    padding-top: 65px !important;
  }
  .pb_lg--65 {
    padding-bottom: 65px !important;
  }
  .pl_lg--65 {
    padding-left: 65px !important;
  }
  .pr_lg--65 {
    padding-right: 65px !important;
  }
  .mt_lg--65 {
    margin-top: 65px !important;
  }
  .mb_lg--65 {
    margin-bottom: 65px !important;
  }
  .ml_lg--65 {
    margin-left: 65px !important;
  }
  .ptb_lg--70 {
    padding: 70px 0 !important;
  }
  .plr_lg--70 {
    padding: 0 70px !important;
  }
  .pt_lg--70 {
    padding-top: 70px !important;
  }
  .pb_lg--70 {
    padding-bottom: 70px !important;
  }
  .pl_lg--70 {
    padding-left: 70px !important;
  }
  .pr_lg--70 {
    padding-right: 70px !important;
  }
  .mt_lg--70 {
    margin-top: 70px !important;
  }
  .mb_lg--70 {
    margin-bottom: 70px !important;
  }
  .ml_lg--70 {
    margin-left: 70px !important;
  }
  .ptb_lg--75 {
    padding: 75px 0 !important;
  }
  .plr_lg--75 {
    padding: 0 75px !important;
  }
  .pt_lg--75 {
    padding-top: 75px !important;
  }
  .pb_lg--75 {
    padding-bottom: 75px !important;
  }
  .pl_lg--75 {
    padding-left: 75px !important;
  }
  .pr_lg--75 {
    padding-right: 75px !important;
  }
  .mt_lg--75 {
    margin-top: 75px !important;
  }
  .mb_lg--75 {
    margin-bottom: 75px !important;
  }
  .ml_lg--75 {
    margin-left: 75px !important;
  }
  .ptb_lg--80 {
    padding: 80px 0 !important;
  }
  .plr_lg--80 {
    padding: 0 80px !important;
  }
  .pt_lg--80 {
    padding-top: 80px !important;
  }
  .pb_lg--80 {
    padding-bottom: 80px !important;
  }
  .pl_lg--80 {
    padding-left: 80px !important;
  }
  .pr_lg--80 {
    padding-right: 80px !important;
  }
  .mt_lg--80 {
    margin-top: 80px !important;
  }
  .mb_lg--80 {
    margin-bottom: 80px !important;
  }
  .ml_lg--80 {
    margin-left: 80px !important;
  }
  .ptb_lg--85 {
    padding: 85px 0 !important;
  }
  .plr_lg--85 {
    padding: 0 85px !important;
  }
  .pt_lg--85 {
    padding-top: 85px !important;
  }
  .pb_lg--85 {
    padding-bottom: 85px !important;
  }
  .pl_lg--85 {
    padding-left: 85px !important;
  }
  .pr_lg--85 {
    padding-right: 85px !important;
  }
  .mt_lg--85 {
    margin-top: 85px !important;
  }
  .mb_lg--85 {
    margin-bottom: 85px !important;
  }
  .ml_lg--85 {
    margin-left: 85px !important;
  }
  .ptb_lg--90 {
    padding: 90px 0 !important;
  }
  .plr_lg--90 {
    padding: 0 90px !important;
  }
  .pt_lg--90 {
    padding-top: 90px !important;
  }
  .pb_lg--90 {
    padding-bottom: 90px !important;
  }
  .pl_lg--90 {
    padding-left: 90px !important;
  }
  .pr_lg--90 {
    padding-right: 90px !important;
  }
  .mt_lg--90 {
    margin-top: 90px !important;
  }
  .mb_lg--90 {
    margin-bottom: 90px !important;
  }
  .ml_lg--90 {
    margin-left: 90px !important;
  }
  .ptb_lg--95 {
    padding: 95px 0 !important;
  }
  .plr_lg--95 {
    padding: 0 95px !important;
  }
  .pt_lg--95 {
    padding-top: 95px !important;
  }
  .pb_lg--95 {
    padding-bottom: 95px !important;
  }
  .pl_lg--95 {
    padding-left: 95px !important;
  }
  .pr_lg--95 {
    padding-right: 95px !important;
  }
  .mt_lg--95 {
    margin-top: 95px !important;
  }
  .mb_lg--95 {
    margin-bottom: 95px !important;
  }
  .ml_lg--95 {
    margin-left: 95px !important;
  }
  .ptb_lg--100 {
    padding: 100px 0 !important;
  }
  .plr_lg--100 {
    padding: 0 100px !important;
  }
  .pt_lg--100 {
    padding-top: 100px !important;
  }
  .pb_lg--100 {
    padding-bottom: 100px !important;
  }
  .pl_lg--100 {
    padding-left: 100px !important;
  }
  .pr_lg--100 {
    padding-right: 100px !important;
  }
  .mt_lg--100 {
    margin-top: 100px !important;
  }
  .mb_lg--100 {
    margin-bottom: 100px !important;
  }
  .ml_lg--100 {
    margin-left: 100px !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ptb_md--0 {
    padding: 0 !important;
  }
  .pl_md--0 {
    padding-left: 0 !important;
  }
  .pr_md--0 {
    padding-right: 0 !important;
  }
  .pt_md--0 {
    padding-top: 0 !important;
  }
  .pb_md--0 {
    padding-bottom: 0 !important;
  }
  .mr_md--0 {
    margin-right: 0 !important;
  }
  .ml_md--0 {
    margin-left: 0 !important;
  }
  .mt_md--0 {
    margin-top: 0 !important;
  }
  .mb_md--0 {
    margin-bottom: 0 !important;
  }
  .ptb_md--250 {
    padding: 250px 0 !important;
  }
  .ptb_md--5 {
    padding: 5px 0 !important;
  }
  .plr_md--5 {
    padding: 0 5px !important;
  }
  .pt_md--5 {
    padding-top: 5px !important;
  }
  .pb_md--5 {
    padding-bottom: 5px !important;
  }
  .pl_md--5 {
    padding-left: 5px !important;
  }
  .pr_md--5 {
    padding-right: 5px !important;
  }
  .mt_md--5 {
    margin-top: 5px !important;
  }
  .mb_md--5 {
    margin-bottom: 5px !important;
  }
  .ptb_md--10 {
    padding: 10px 0 !important;
  }
  .plr_md--10 {
    padding: 0 10px !important;
  }
  .pt_md--10 {
    padding-top: 10px !important;
  }
  .pb_md--10 {
    padding-bottom: 10px !important;
  }
  .pl_md--10 {
    padding-left: 10px !important;
  }
  .pr_md--10 {
    padding-right: 10px !important;
  }
  .mt_md--10 {
    margin-top: 10px !important;
  }
  .mb_md--10 {
    margin-bottom: 10px !important;
  }
  .ptb_md--15 {
    padding: 15px 0 !important;
  }
  .plr_md--15 {
    padding: 0 15px !important;
  }
  .pt_md--15 {
    padding-top: 15px !important;
  }
  .pb_md--15 {
    padding-bottom: 15px !important;
  }
  .pl_md--15 {
    padding-left: 15px !important;
  }
  .pr_md--15 {
    padding-right: 15px !important;
  }
  .mt_md--15 {
    margin-top: 15px !important;
  }
  .mb_md--15 {
    margin-bottom: 15px !important;
  }
  .ptb_md--20 {
    padding: 20px 0 !important;
  }
  .plr_md--20 {
    padding: 0 20px !important;
  }
  .pt_md--20 {
    padding-top: 20px !important;
  }
  .pb_md--20 {
    padding-bottom: 20px !important;
  }
  .pl_md--20 {
    padding-left: 20px !important;
  }
  .pr_md--20 {
    padding-right: 20px !important;
  }
  .mt_md--20 {
    margin-top: 20px !important;
  }
  .mb_md--20 {
    margin-bottom: 20px !important;
  }
  .ptb_md--25 {
    padding: 25px 0 !important;
  }
  .plr_md--25 {
    padding: 0 25px !important;
  }
  .pt_md--25 {
    padding-top: 25px !important;
  }
  .pb_md--25 {
    padding-bottom: 25px !important;
  }
  .pl_md--25 {
    padding-left: 25px !important;
  }
  .pr_md--25 {
    padding-right: 25px !important;
  }
  .mt_md--25 {
    margin-top: 25px !important;
  }
  .mb_md--25 {
    margin-bottom: 25px !important;
  }
  .ptb_md--30 {
    padding: 30px 0 !important;
  }
  .plr_md--30 {
    padding: 0 30px !important;
  }
  .pt_md--30 {
    padding-top: 30px !important;
  }
  .pb_md--30 {
    padding-bottom: 30px !important;
  }
  .pl_md--30 {
    padding-left: 30px !important;
  }
  .pr_md--30 {
    padding-right: 30px !important;
  }
  .mt_md--30 {
    margin-top: 30px !important;
  }
  .mb_md--30 {
    margin-bottom: 30px !important;
  }
  .ptb_md--35 {
    padding: 35px 0 !important;
  }
  .plr_md--35 {
    padding: 0 35px !important;
  }
  .pt_md--35 {
    padding-top: 35px !important;
  }
  .pb_md--35 {
    padding-bottom: 35px !important;
  }
  .pl_md--35 {
    padding-left: 35px !important;
  }
  .pr_md--35 {
    padding-right: 35px !important;
  }
  .mt_md--35 {
    margin-top: 35px !important;
  }
  .mb_md--35 {
    margin-bottom: 35px !important;
  }
  .ptb_md--40 {
    padding: 40px 0 !important;
  }
  .plr_md--40 {
    padding: 0 40px !important;
  }
  .pt_md--40 {
    padding-top: 40px !important;
  }
  .pb_md--40 {
    padding-bottom: 40px !important;
  }
  .pl_md--40 {
    padding-left: 40px !important;
  }
  .pr_md--40 {
    padding-right: 40px !important;
  }
  .mt_md--40 {
    margin-top: 40px !important;
  }
  .mb_md--40 {
    margin-bottom: 40px !important;
  }
  .ptb_md--45 {
    padding: 45px 0 !important;
  }
  .plr_md--45 {
    padding: 0 45px !important;
  }
  .pt_md--45 {
    padding-top: 45px !important;
  }
  .pb_md--45 {
    padding-bottom: 45px !important;
  }
  .pl_md--45 {
    padding-left: 45px !important;
  }
  .pr_md--45 {
    padding-right: 45px !important;
  }
  .mt_md--45 {
    margin-top: 45px !important;
  }
  .mb_md--45 {
    margin-bottom: 45px !important;
  }
  .ptb_md--50 {
    padding: 50px 0 !important;
  }
  .plr_md--50 {
    padding: 0 50px !important;
  }
  .pt_md--50 {
    padding-top: 50px !important;
  }
  .pb_md--50 {
    padding-bottom: 50px !important;
  }
  .pl_md--50 {
    padding-left: 50px !important;
  }
  .pr_md--50 {
    padding-right: 50px !important;
  }
  .mt_md--50 {
    margin-top: 50px !important;
  }
  .mb_md--50 {
    margin-bottom: 50px !important;
  }
  .ptb_md--55 {
    padding: 55px 0 !important;
  }
  .plr_md--55 {
    padding: 0 55px !important;
  }
  .pt_md--55 {
    padding-top: 55px !important;
  }
  .pb_md--55 {
    padding-bottom: 55px !important;
  }
  .pl_md--55 {
    padding-left: 55px !important;
  }
  .pr_md--55 {
    padding-right: 55px !important;
  }
  .mt_md--55 {
    margin-top: 55px !important;
  }
  .mb_md--55 {
    margin-bottom: 55px !important;
  }
  .ptb_md--60 {
    padding: 60px 0 !important;
  }
  .plr_md--60 {
    padding: 0 60px !important;
  }
  .pt_md--60 {
    padding-top: 60px !important;
  }
  .pb_md--60 {
    padding-bottom: 60px !important;
  }
  .pl_md--60 {
    padding-left: 60px !important;
  }
  .pr_md--60 {
    padding-right: 60px !important;
  }
  .mt_md--60 {
    margin-top: 60px !important;
  }
  .mb_md--60 {
    margin-bottom: 60px !important;
  }
  .ptb_md--65 {
    padding: 65px 0 !important;
  }
  .plr_md--65 {
    padding: 0 65px !important;
  }
  .pt_md--65 {
    padding-top: 65px !important;
  }
  .pb_md--65 {
    padding-bottom: 65px !important;
  }
  .pl_md--65 {
    padding-left: 65px !important;
  }
  .pr_md--65 {
    padding-right: 65px !important;
  }
  .mt_md--65 {
    margin-top: 65px !important;
  }
  .mb_md--65 {
    margin-bottom: 65px !important;
  }
  .ptb_md--70 {
    padding: 70px 0 !important;
  }
  .plr_md--70 {
    padding: 0 70px !important;
  }
  .pt_md--70 {
    padding-top: 70px !important;
  }
  .pb_md--70 {
    padding-bottom: 70px !important;
  }
  .pl_md--70 {
    padding-left: 70px !important;
  }
  .pr_md--70 {
    padding-right: 70px !important;
  }
  .mt_md--70 {
    margin-top: 70px !important;
  }
  .mb_md--70 {
    margin-bottom: 70px !important;
  }
  .ptb_md--75 {
    padding: 75px 0 !important;
  }
  .plr_md--75 {
    padding: 0 75px !important;
  }
  .pt_md--75 {
    padding-top: 75px !important;
  }
  .pb_md--75 {
    padding-bottom: 75px !important;
  }
  .pl_md--75 {
    padding-left: 75px !important;
  }
  .pr_md--75 {
    padding-right: 75px !important;
  }
  .mt_md--75 {
    margin-top: 75px !important;
  }
  .mb_md--75 {
    margin-bottom: 75px !important;
  }
  .ptb_md--80 {
    padding: 80px 0 !important;
  }
  .plr_md--80 {
    padding: 0 80px !important;
  }
  .pt_md--80 {
    padding-top: 80px !important;
  }
  .pb_md--80 {
    padding-bottom: 80px !important;
  }
  .pl_md--80 {
    padding-left: 80px !important;
  }
  .pr_md--80 {
    padding-right: 80px !important;
  }
  .mt_md--80 {
    margin-top: 80px !important;
  }
  .mb_md--80 {
    margin-bottom: 80px !important;
  }
  .ptb_md--85 {
    padding: 85px 0 !important;
  }
  .plr_md--85 {
    padding: 0 85px !important;
  }
  .pt_md--85 {
    padding-top: 85px !important;
  }
  .pb_md--85 {
    padding-bottom: 85px !important;
  }
  .pl_md--85 {
    padding-left: 85px !important;
  }
  .pr_md--85 {
    padding-right: 85px !important;
  }
  .mt_md--85 {
    margin-top: 85px !important;
  }
  .mb_md--85 {
    margin-bottom: 85px !important;
  }
  .ptb_md--90 {
    padding: 90px 0 !important;
  }
  .plr_md--90 {
    padding: 0 90px !important;
  }
  .pt_md--90 {
    padding-top: 90px !important;
  }
  .pb_md--90 {
    padding-bottom: 90px !important;
  }
  .pl_md--90 {
    padding-left: 90px !important;
  }
  .pr_md--90 {
    padding-right: 90px !important;
  }
  .mt_md--90 {
    margin-top: 90px !important;
  }
  .mb_md--90 {
    margin-bottom: 90px !important;
  }
  .ptb_md--95 {
    padding: 95px 0 !important;
  }
  .plr_md--95 {
    padding: 0 95px !important;
  }
  .pt_md--95 {
    padding-top: 95px !important;
  }
  .pb_md--95 {
    padding-bottom: 95px !important;
  }
  .pl_md--95 {
    padding-left: 95px !important;
  }
  .pr_md--95 {
    padding-right: 95px !important;
  }
  .mt_md--95 {
    margin-top: 95px !important;
  }
  .mb_md--95 {
    margin-bottom: 95px !important;
  }
  .ptb_md--100 {
    padding: 100px 0 !important;
  }
  .plr_md--100 {
    padding: 0 100px !important;
  }
  .pt_md--100 {
    padding-top: 100px !important;
  }
  .pb_md--100 {
    padding-bottom: 100px !important;
  }
  .pl_md--100 {
    padding-left: 100px !important;
  }
  .pr_md--100 {
    padding-right: 100px !important;
  }
  .mt_md--100 {
    margin-top: 100px !important;
  }
  .mb_md--100 {
    margin-bottom: 100px !important;
  }
}
@media only screen and (max-width: 767px) {
  .ptb_sm--250 {
    padding: 250px 0 !important;
  }
  .ptb_sm--0 {
    padding: 0 !important;
  }
  .pl_sm--0 {
    padding-left: 0 !important;
  }
  .pr_sm--0 {
    padding-right: 0 !important;
  }
  .pt_sm--0 {
    padding-top: 0 !important;
  }
  .pb_sm--0 {
    padding-bottom: 0 !important;
  }
  .mr_sm--0 {
    margin-right: 0 !important;
  }
  .ml_sm--0 {
    margin-left: 0 !important;
  }
  .mt_sm--0 {
    margin-top: 0 !important;
  }
  .mb_sm--0 {
    margin-bottom: 0 !important;
  }
  .pt_sm--150 {
    padding-top: 150px !important;
  }
  .pb_sm--110 {
    padding-bottom: 110px !important;
  }
  .ptb_sm--5 {
    padding: 5px 0 !important;
  }
  .plr_sm--5 {
    padding: 0 5px !important;
  }
  .pt_sm--5 {
    padding-top: 5px !important;
  }
  .pb_sm--5 {
    padding-bottom: 5px !important;
  }
  .pl_sm--5 {
    padding-left: 5px !important;
  }
  .pr_sm--5 {
    padding-right: 5px !important;
  }
  .mt_sm--5 {
    margin-top: 5px !important;
  }
  .ml_sm--5 {
    margin-left: 5px !important;
  }
  .mr_sm--5 {
    margin-right: 5px !important;
  }
  .mb_sm--5 {
    margin-bottom: 5px !important;
  }
  .ptb_sm--10 {
    padding: 10px 0 !important;
  }
  .plr_sm--10 {
    padding: 0 10px !important;
  }
  .pt_sm--10 {
    padding-top: 10px !important;
  }
  .pb_sm--10 {
    padding-bottom: 10px !important;
  }
  .pl_sm--10 {
    padding-left: 10px !important;
  }
  .pr_sm--10 {
    padding-right: 10px !important;
  }
  .mt_sm--10 {
    margin-top: 10px !important;
  }
  .ml_sm--10 {
    margin-left: 10px !important;
  }
  .mr_sm--10 {
    margin-right: 10px !important;
  }
  .mb_sm--10 {
    margin-bottom: 10px !important;
  }
  .ptb_sm--15 {
    padding: 15px 0 !important;
  }
  .plr_sm--15 {
    padding: 0 15px !important;
  }
  .pt_sm--15 {
    padding-top: 15px !important;
  }
  .pb_sm--15 {
    padding-bottom: 15px !important;
  }
  .pl_sm--15 {
    padding-left: 15px !important;
  }
  .pr_sm--15 {
    padding-right: 15px !important;
  }
  .mt_sm--15 {
    margin-top: 15px !important;
  }
  .ml_sm--15 {
    margin-left: 15px !important;
  }
  .mr_sm--15 {
    margin-right: 15px !important;
  }
  .mb_sm--15 {
    margin-bottom: 15px !important;
  }
  .ptb_sm--20 {
    padding: 20px 0 !important;
  }
  .plr_sm--20 {
    padding: 0 20px !important;
  }
  .pt_sm--20 {
    padding-top: 20px !important;
  }
  .pb_sm--20 {
    padding-bottom: 20px !important;
  }
  .pl_sm--20 {
    padding-left: 20px !important;
  }
  .pr_sm--20 {
    padding-right: 20px !important;
  }
  .mt_sm--20 {
    margin-top: 20px !important;
  }
  .ml_sm--20 {
    margin-left: 20px !important;
  }
  .mr_sm--20 {
    margin-right: 20px !important;
  }
  .mb_sm--20 {
    margin-bottom: 20px !important;
  }
  .ptb_sm--25 {
    padding: 25px 0 !important;
  }
  .plr_sm--25 {
    padding: 0 25px !important;
  }
  .pt_sm--25 {
    padding-top: 25px !important;
  }
  .pb_sm--25 {
    padding-bottom: 25px !important;
  }
  .pl_sm--25 {
    padding-left: 25px !important;
  }
  .pr_sm--25 {
    padding-right: 25px !important;
  }
  .mt_sm--25 {
    margin-top: 25px !important;
  }
  .ml_sm--25 {
    margin-left: 25px !important;
  }
  .mr_sm--25 {
    margin-right: 25px !important;
  }
  .mb_sm--25 {
    margin-bottom: 25px !important;
  }
  .ptb_sm--30 {
    padding: 30px 0 !important;
  }
  .plr_sm--30 {
    padding: 0 30px !important;
  }
  .pt_sm--30 {
    padding-top: 30px !important;
  }
  .pb_sm--30 {
    padding-bottom: 30px !important;
  }
  .pl_sm--30 {
    padding-left: 30px !important;
  }
  .pr_sm--30 {
    padding-right: 30px !important;
  }
  .mt_sm--30 {
    margin-top: 30px !important;
  }
  .ml_sm--30 {
    margin-left: 30px !important;
  }
  .mr_sm--30 {
    margin-right: 30px !important;
  }
  .mb_sm--30 {
    margin-bottom: 30px !important;
  }
  .ptb_sm--35 {
    padding: 35px 0 !important;
  }
  .plr_sm--35 {
    padding: 0 35px !important;
  }
  .pt_sm--35 {
    padding-top: 35px !important;
  }
  .pb_sm--35 {
    padding-bottom: 35px !important;
  }
  .pl_sm--35 {
    padding-left: 35px !important;
  }
  .pr_sm--35 {
    padding-right: 35px !important;
  }
  .mt_sm--35 {
    margin-top: 35px !important;
  }
  .ml_sm--35 {
    margin-left: 35px !important;
  }
  .mr_sm--35 {
    margin-right: 35px !important;
  }
  .mb_sm--35 {
    margin-bottom: 35px !important;
  }
  .ptb_sm--40 {
    padding: 40px 0 !important;
  }
  .plr_sm--40 {
    padding: 0 40px !important;
  }
  .pt_sm--40 {
    padding-top: 40px !important;
  }
  .pb_sm--40 {
    padding-bottom: 40px !important;
  }
  .pl_sm--40 {
    padding-left: 40px !important;
  }
  .pr_sm--40 {
    padding-right: 40px !important;
  }
  .mt_sm--40 {
    margin-top: 40px !important;
  }
  .ml_sm--40 {
    margin-left: 40px !important;
  }
  .mr_sm--40 {
    margin-right: 40px !important;
  }
  .mb_sm--40 {
    margin-bottom: 40px !important;
  }
  .ptb_sm--45 {
    padding: 45px 0 !important;
  }
  .plr_sm--45 {
    padding: 0 45px !important;
  }
  .pt_sm--45 {
    padding-top: 45px !important;
  }
  .pb_sm--45 {
    padding-bottom: 45px !important;
  }
  .pl_sm--45 {
    padding-left: 45px !important;
  }
  .pr_sm--45 {
    padding-right: 45px !important;
  }
  .mt_sm--45 {
    margin-top: 45px !important;
  }
  .ml_sm--45 {
    margin-left: 45px !important;
  }
  .mr_sm--45 {
    margin-right: 45px !important;
  }
  .mb_sm--45 {
    margin-bottom: 45px !important;
  }
  .ptb_sm--50 {
    padding: 50px 0 !important;
  }
  .plr_sm--50 {
    padding: 0 50px !important;
  }
  .pt_sm--50 {
    padding-top: 50px !important;
  }
  .pb_sm--50 {
    padding-bottom: 50px !important;
  }
  .pl_sm--50 {
    padding-left: 50px !important;
  }
  .pr_sm--50 {
    padding-right: 50px !important;
  }
  .mt_sm--50 {
    margin-top: 50px !important;
  }
  .ml_sm--50 {
    margin-left: 50px !important;
  }
  .mr_sm--50 {
    margin-right: 50px !important;
  }
  .mb_sm--50 {
    margin-bottom: 50px !important;
  }
  .ptb_sm--55 {
    padding: 55px 0 !important;
  }
  .plr_sm--55 {
    padding: 0 55px !important;
  }
  .pt_sm--55 {
    padding-top: 55px !important;
  }
  .pb_sm--55 {
    padding-bottom: 55px !important;
  }
  .pl_sm--55 {
    padding-left: 55px !important;
  }
  .pr_sm--55 {
    padding-right: 55px !important;
  }
  .mt_sm--55 {
    margin-top: 55px !important;
  }
  .ml_sm--55 {
    margin-left: 55px !important;
  }
  .mr_sm--55 {
    margin-right: 55px !important;
  }
  .mb_sm--55 {
    margin-bottom: 55px !important;
  }
  .ptb_sm--60 {
    padding: 60px 0 !important;
  }
  .plr_sm--60 {
    padding: 0 60px !important;
  }
  .pt_sm--60 {
    padding-top: 60px !important;
  }
  .pb_sm--60 {
    padding-bottom: 60px !important;
  }
  .pl_sm--60 {
    padding-left: 60px !important;
  }
  .pr_sm--60 {
    padding-right: 60px !important;
  }
  .mt_sm--60 {
    margin-top: 60px !important;
  }
  .ml_sm--60 {
    margin-left: 60px !important;
  }
  .mr_sm--60 {
    margin-right: 60px !important;
  }
  .mb_sm--60 {
    margin-bottom: 60px !important;
  }
  .ptb_sm--65 {
    padding: 65px 0 !important;
  }
  .plr_sm--65 {
    padding: 0 65px !important;
  }
  .pt_sm--65 {
    padding-top: 65px !important;
  }
  .pb_sm--65 {
    padding-bottom: 65px !important;
  }
  .pl_sm--65 {
    padding-left: 65px !important;
  }
  .pr_sm--65 {
    padding-right: 65px !important;
  }
  .mt_sm--65 {
    margin-top: 65px !important;
  }
  .ml_sm--65 {
    margin-left: 65px !important;
  }
  .mr_sm--65 {
    margin-right: 65px !important;
  }
  .mb_sm--65 {
    margin-bottom: 65px !important;
  }
  .ptb_sm--70 {
    padding: 70px 0 !important;
  }
  .plr_sm--70 {
    padding: 0 70px !important;
  }
  .pt_sm--70 {
    padding-top: 70px !important;
  }
  .pb_sm--70 {
    padding-bottom: 70px !important;
  }
  .pl_sm--70 {
    padding-left: 70px !important;
  }
  .pr_sm--70 {
    padding-right: 70px !important;
  }
  .mt_sm--70 {
    margin-top: 70px !important;
  }
  .ml_sm--70 {
    margin-left: 70px !important;
  }
  .mr_sm--70 {
    margin-right: 70px !important;
  }
  .mb_sm--70 {
    margin-bottom: 70px !important;
  }
  .ptb_sm--75 {
    padding: 75px 0 !important;
  }
  .plr_sm--75 {
    padding: 0 75px !important;
  }
  .pt_sm--75 {
    padding-top: 75px !important;
  }
  .pb_sm--75 {
    padding-bottom: 75px !important;
  }
  .pl_sm--75 {
    padding-left: 75px !important;
  }
  .pr_sm--75 {
    padding-right: 75px !important;
  }
  .mt_sm--75 {
    margin-top: 75px !important;
  }
  .ml_sm--75 {
    margin-left: 75px !important;
  }
  .mr_sm--75 {
    margin-right: 75px !important;
  }
  .mb_sm--75 {
    margin-bottom: 75px !important;
  }
  .ptb_sm--80 {
    padding: 80px 0 !important;
  }
  .plr_sm--80 {
    padding: 0 80px !important;
  }
  .pt_sm--80 {
    padding-top: 80px !important;
  }
  .pb_sm--80 {
    padding-bottom: 80px !important;
  }
  .pl_sm--80 {
    padding-left: 80px !important;
  }
  .pr_sm--80 {
    padding-right: 80px !important;
  }
  .mt_sm--80 {
    margin-top: 80px !important;
  }
  .ml_sm--80 {
    margin-left: 80px !important;
  }
  .mr_sm--80 {
    margin-right: 80px !important;
  }
  .mb_sm--80 {
    margin-bottom: 80px !important;
  }
  .ptb_sm--85 {
    padding: 85px 0 !important;
  }
  .plr_sm--85 {
    padding: 0 85px !important;
  }
  .pt_sm--85 {
    padding-top: 85px !important;
  }
  .pb_sm--85 {
    padding-bottom: 85px !important;
  }
  .pl_sm--85 {
    padding-left: 85px !important;
  }
  .pr_sm--85 {
    padding-right: 85px !important;
  }
  .mt_sm--85 {
    margin-top: 85px !important;
  }
  .ml_sm--85 {
    margin-left: 85px !important;
  }
  .mr_sm--85 {
    margin-right: 85px !important;
  }
  .mb_sm--85 {
    margin-bottom: 85px !important;
  }
  .ptb_sm--90 {
    padding: 90px 0 !important;
  }
  .plr_sm--90 {
    padding: 0 90px !important;
  }
  .pt_sm--90 {
    padding-top: 90px !important;
  }
  .pb_sm--90 {
    padding-bottom: 90px !important;
  }
  .pl_sm--90 {
    padding-left: 90px !important;
  }
  .pr_sm--90 {
    padding-right: 90px !important;
  }
  .mt_sm--90 {
    margin-top: 90px !important;
  }
  .ml_sm--90 {
    margin-left: 90px !important;
  }
  .mr_sm--90 {
    margin-right: 90px !important;
  }
  .mb_sm--90 {
    margin-bottom: 90px !important;
  }
  .ptb_sm--95 {
    padding: 95px 0 !important;
  }
  .plr_sm--95 {
    padding: 0 95px !important;
  }
  .pt_sm--95 {
    padding-top: 95px !important;
  }
  .pb_sm--95 {
    padding-bottom: 95px !important;
  }
  .pl_sm--95 {
    padding-left: 95px !important;
  }
  .pr_sm--95 {
    padding-right: 95px !important;
  }
  .mt_sm--95 {
    margin-top: 95px !important;
  }
  .ml_sm--95 {
    margin-left: 95px !important;
  }
  .mr_sm--95 {
    margin-right: 95px !important;
  }
  .mb_sm--95 {
    margin-bottom: 95px !important;
  }
  .ptb_sm--100 {
    padding: 100px 0 !important;
  }
  .plr_sm--100 {
    padding: 0 100px !important;
  }
  .pt_sm--100 {
    padding-top: 100px !important;
  }
  .pb_sm--100 {
    padding-bottom: 100px !important;
  }
  .pl_sm--100 {
    padding-left: 100px !important;
  }
  .pr_sm--100 {
    padding-right: 100px !important;
  }
  .mt_sm--100 {
    margin-top: 100px !important;
  }
  .ml_sm--100 {
    margin-left: 100px !important;
  }
  .mr_sm--100 {
    margin-right: 100px !important;
  }
  .mb_sm--100 {
    margin-bottom: 100px !important;
  }
  .pl_sm--0 {
    padding-left: 0 !important;
  }
  .pr_sm--0 {
    padding-right: 0 !important;
  }
  .pt_sm--0 {
    padding-top: 0 !important;
  }
  .pb_sm--0 {
    padding-bottom: 0 !important;
  }
  .mr_sm--0 {
    margin-right: 0 !important;
  }
  .ml_sm--0 {
    margin-left: 0 !important;
  }
  .mt_sm--0 {
    margin-top: 0 !important;
  }
  .mb_sm--0 {
    margin-bottom: 0 !important;
  }
}
@media only screen and (max-width: 575px) {
  .ptb_mobile--5 {
    padding: 5px 0 !important;
  }
  .plr_mobile--5 {
    padding: 0 5px !important;
  }
  .pt_mobile--5 {
    padding-top: 5px !important;
  }
  .pb_mobile--5 {
    padding-bottom: 5px !important;
  }
  .pl_mobile--5 {
    padding-left: 5px !important;
  }
  .pr_mobile--5 {
    padding-right: 5px !important;
  }
  .mt_mobile--5 {
    margin-top: 5px !important;
  }
  .mb_mobile--5 {
    margin-bottom: 5px !important;
  }
  .ptb_mobile--10 {
    padding: 10px 0 !important;
  }
  .plr_mobile--10 {
    padding: 0 10px !important;
  }
  .pt_mobile--10 {
    padding-top: 10px !important;
  }
  .pb_mobile--10 {
    padding-bottom: 10px !important;
  }
  .pl_mobile--10 {
    padding-left: 10px !important;
  }
  .pr_mobile--10 {
    padding-right: 10px !important;
  }
  .mt_mobile--10 {
    margin-top: 10px !important;
  }
  .mb_mobile--10 {
    margin-bottom: 10px !important;
  }
  .ptb_mobile--15 {
    padding: 15px 0 !important;
  }
  .plr_mobile--15 {
    padding: 0 15px !important;
  }
  .pt_mobile--15 {
    padding-top: 15px !important;
  }
  .pb_mobile--15 {
    padding-bottom: 15px !important;
  }
  .pl_mobile--15 {
    padding-left: 15px !important;
  }
  .pr_mobile--15 {
    padding-right: 15px !important;
  }
  .mt_mobile--15 {
    margin-top: 15px !important;
  }
  .mb_mobile--15 {
    margin-bottom: 15px !important;
  }
  .ptb_mobile--20 {
    padding: 20px 0 !important;
  }
  .plr_mobile--20 {
    padding: 0 20px !important;
  }
  .pt_mobile--20 {
    padding-top: 20px !important;
  }
  .pb_mobile--20 {
    padding-bottom: 20px !important;
  }
  .pl_mobile--20 {
    padding-left: 20px !important;
  }
  .pr_mobile--20 {
    padding-right: 20px !important;
  }
  .mt_mobile--20 {
    margin-top: 20px !important;
  }
  .mb_mobile--20 {
    margin-bottom: 20px !important;
  }
  .ptb_mobile--25 {
    padding: 25px 0 !important;
  }
  .plr_mobile--25 {
    padding: 0 25px !important;
  }
  .pt_mobile--25 {
    padding-top: 25px !important;
  }
  .pb_mobile--25 {
    padding-bottom: 25px !important;
  }
  .pl_mobile--25 {
    padding-left: 25px !important;
  }
  .pr_mobile--25 {
    padding-right: 25px !important;
  }
  .mt_mobile--25 {
    margin-top: 25px !important;
  }
  .mb_mobile--25 {
    margin-bottom: 25px !important;
  }
  .ptb_mobile--30 {
    padding: 30px 0 !important;
  }
  .plr_mobile--30 {
    padding: 0 30px !important;
  }
  .pt_mobile--30 {
    padding-top: 30px !important;
  }
  .pb_mobile--30 {
    padding-bottom: 30px !important;
  }
  .pl_mobile--30 {
    padding-left: 30px !important;
  }
  .pr_mobile--30 {
    padding-right: 30px !important;
  }
  .mt_mobile--30 {
    margin-top: 30px !important;
  }
  .mb_mobile--30 {
    margin-bottom: 30px !important;
  }
  .ptb_mobile--35 {
    padding: 35px 0 !important;
  }
  .plr_mobile--35 {
    padding: 0 35px !important;
  }
  .pt_mobile--35 {
    padding-top: 35px !important;
  }
  .pb_mobile--35 {
    padding-bottom: 35px !important;
  }
  .pl_mobile--35 {
    padding-left: 35px !important;
  }
  .pr_mobile--35 {
    padding-right: 35px !important;
  }
  .mt_mobile--35 {
    margin-top: 35px !important;
  }
  .mb_mobile--35 {
    margin-bottom: 35px !important;
  }
  .ptb_mobile--40 {
    padding: 40px 0 !important;
  }
  .plr_mobile--40 {
    padding: 0 40px !important;
  }
  .pt_mobile--40 {
    padding-top: 40px !important;
  }
  .pb_mobile--40 {
    padding-bottom: 40px !important;
  }
  .pl_mobile--40 {
    padding-left: 40px !important;
  }
  .pr_mobile--40 {
    padding-right: 40px !important;
  }
  .mt_mobile--40 {
    margin-top: 40px !important;
  }
  .mb_mobile--40 {
    margin-bottom: 40px !important;
  }
  .ptb_mobile--45 {
    padding: 45px 0 !important;
  }
  .plr_mobile--45 {
    padding: 0 45px !important;
  }
  .pt_mobile--45 {
    padding-top: 45px !important;
  }
  .pb_mobile--45 {
    padding-bottom: 45px !important;
  }
  .pl_mobile--45 {
    padding-left: 45px !important;
  }
  .pr_mobile--45 {
    padding-right: 45px !important;
  }
  .mt_mobile--45 {
    margin-top: 45px !important;
  }
  .mb_mobile--45 {
    margin-bottom: 45px !important;
  }
  .ptb_mobile--50 {
    padding: 50px 0 !important;
  }
  .plr_mobile--50 {
    padding: 0 50px !important;
  }
  .pt_mobile--50 {
    padding-top: 50px !important;
  }
  .pb_mobile--50 {
    padding-bottom: 50px !important;
  }
  .pl_mobile--50 {
    padding-left: 50px !important;
  }
  .pr_mobile--50 {
    padding-right: 50px !important;
  }
  .mt_mobile--50 {
    margin-top: 50px !important;
  }
  .mb_mobile--50 {
    margin-bottom: 50px !important;
  }
  .ptb_mobile--55 {
    padding: 55px 0 !important;
  }
  .plr_mobile--55 {
    padding: 0 55px !important;
  }
  .pt_mobile--55 {
    padding-top: 55px !important;
  }
  .pb_mobile--55 {
    padding-bottom: 55px !important;
  }
  .pl_mobile--55 {
    padding-left: 55px !important;
  }
  .pr_mobile--55 {
    padding-right: 55px !important;
  }
  .mt_mobile--55 {
    margin-top: 55px !important;
  }
  .mb_mobile--55 {
    margin-bottom: 55px !important;
  }
  .ptb_mobile--60 {
    padding: 60px 0 !important;
  }
  .plr_mobile--60 {
    padding: 0 60px !important;
  }
  .pt_mobile--60 {
    padding-top: 60px !important;
  }
  .pb_mobile--60 {
    padding-bottom: 60px !important;
  }
  .pl_mobile--60 {
    padding-left: 60px !important;
  }
  .pr_mobile--60 {
    padding-right: 60px !important;
  }
  .mt_mobile--60 {
    margin-top: 60px !important;
  }
  .mb_mobile--60 {
    margin-bottom: 60px !important;
  }
  .ptb_mobile--65 {
    padding: 65px 0 !important;
  }
  .plr_mobile--65 {
    padding: 0 65px !important;
  }
  .pt_mobile--65 {
    padding-top: 65px !important;
  }
  .pb_mobile--65 {
    padding-bottom: 65px !important;
  }
  .pl_mobile--65 {
    padding-left: 65px !important;
  }
  .pr_mobile--65 {
    padding-right: 65px !important;
  }
  .mt_mobile--65 {
    margin-top: 65px !important;
  }
  .mb_mobile--65 {
    margin-bottom: 65px !important;
  }
  .ptb_mobile--70 {
    padding: 70px 0 !important;
  }
  .plr_mobile--70 {
    padding: 0 70px !important;
  }
  .pt_mobile--70 {
    padding-top: 70px !important;
  }
  .pb_mobile--70 {
    padding-bottom: 70px !important;
  }
  .pl_mobile--70 {
    padding-left: 70px !important;
  }
  .pr_mobile--70 {
    padding-right: 70px !important;
  }
  .mt_mobile--70 {
    margin-top: 70px !important;
  }
  .mb_mobile--70 {
    margin-bottom: 70px !important;
  }
  .ptb_mobile--75 {
    padding: 75px 0 !important;
  }
  .plr_mobile--75 {
    padding: 0 75px !important;
  }
  .pt_mobile--75 {
    padding-top: 75px !important;
  }
  .pb_mobile--75 {
    padding-bottom: 75px !important;
  }
  .pl_mobile--75 {
    padding-left: 75px !important;
  }
  .pr_mobile--75 {
    padding-right: 75px !important;
  }
  .mt_mobile--75 {
    margin-top: 75px !important;
  }
  .mb_mobile--75 {
    margin-bottom: 75px !important;
  }
  .ptb_mobile--80 {
    padding: 80px 0 !important;
  }
  .plr_mobile--80 {
    padding: 0 80px !important;
  }
  .pt_mobile--80 {
    padding-top: 80px !important;
  }
  .pb_mobile--80 {
    padding-bottom: 80px !important;
  }
  .pl_mobile--80 {
    padding-left: 80px !important;
  }
  .pr_mobile--80 {
    padding-right: 80px !important;
  }
  .mt_mobile--80 {
    margin-top: 80px !important;
  }
  .mb_mobile--80 {
    margin-bottom: 80px !important;
  }
  .ptb_mobile--85 {
    padding: 85px 0 !important;
  }
  .plr_mobile--85 {
    padding: 0 85px !important;
  }
  .pt_mobile--85 {
    padding-top: 85px !important;
  }
  .pb_mobile--85 {
    padding-bottom: 85px !important;
  }
  .pl_mobile--85 {
    padding-left: 85px !important;
  }
  .pr_mobile--85 {
    padding-right: 85px !important;
  }
  .mt_mobile--85 {
    margin-top: 85px !important;
  }
  .mb_mobile--85 {
    margin-bottom: 85px !important;
  }
  .ptb_mobile--90 {
    padding: 90px 0 !important;
  }
  .plr_mobile--90 {
    padding: 0 90px !important;
  }
  .pt_mobile--90 {
    padding-top: 90px !important;
  }
  .pb_mobile--90 {
    padding-bottom: 90px !important;
  }
  .pl_mobile--90 {
    padding-left: 90px !important;
  }
  .pr_mobile--90 {
    padding-right: 90px !important;
  }
  .mt_mobile--90 {
    margin-top: 90px !important;
  }
  .mb_mobile--90 {
    margin-bottom: 90px !important;
  }
  .ptb_mobile--95 {
    padding: 95px 0 !important;
  }
  .plr_mobile--95 {
    padding: 0 95px !important;
  }
  .pt_mobile--95 {
    padding-top: 95px !important;
  }
  .pb_mobile--95 {
    padding-bottom: 95px !important;
  }
  .pl_mobile--95 {
    padding-left: 95px !important;
  }
  .pr_mobile--95 {
    padding-right: 95px !important;
  }
  .mt_mobile--95 {
    margin-top: 95px !important;
  }
  .mb_mobile--95 {
    margin-bottom: 95px !important;
  }
  .ptb_mobile--100 {
    padding: 100px 0 !important;
  }
  .plr_mobile--100 {
    padding: 0 100px !important;
  }
  .pt_mobile--100 {
    padding-top: 100px !important;
  }
  .pb_mobile--100 {
    padding-bottom: 100px !important;
  }
  .pl_mobile--100 {
    padding-left: 100px !important;
  }
  .pr_mobile--100 {
    padding-right: 100px !important;
  }
  .mt_mobile--100 {
    margin-top: 100px !important;
  }
  .mb_mobile--100 {
    margin-bottom: 100px !important;
  }
}
.slick-gutter-5 {
  margin-left: -5px !important;
  margin-right: -5px !important;
}
.slick-gutter-5 .slick-slide {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.slick-gutter-10 {
  margin-left: -10px !important;
  margin-right: -10px !important;
}
.slick-gutter-10 .slick-slide {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.slick-gutter-15 {
  margin-left: -15px !important;
  margin-right: -15px !important;
}
.slick-gutter-15 .slick-slide {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.slick-gutter-20 {
  margin-left: -20px !important;
  margin-right: -20px !important;
}
.slick-gutter-20 .slick-slide {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.slick-gutter-25 {
  margin-left: -25px !important;
  margin-right: -25px !important;
}
.slick-gutter-25 .slick-slide {
  padding-left: 25px !important;
  padding-right: 25px !important;
}

.slick-gutter-30 {
  margin-left: -30px !important;
  margin-right: -30px !important;
}
.slick-gutter-30 .slick-slide {
  padding-left: 30px !important;
  padding-right: 30px !important;
}

.slick-gutter-35 {
  margin-left: -35px !important;
  margin-right: -35px !important;
}
.slick-gutter-35 .slick-slide {
  padding-left: 35px !important;
  padding-right: 35px !important;
}

.slick-gutter-40 {
  margin-left: -40px !important;
  margin-right: -40px !important;
}
.slick-gutter-40 .slick-slide {
  padding-left: 40px !important;
  padding-right: 40px !important;
}

.slick-gutter-45 {
  margin-left: -45px !important;
  margin-right: -45px !important;
}
.slick-gutter-45 .slick-slide {
  padding-left: 45px !important;
  padding-right: 45px !important;
}

.slick-gutter-50 {
  margin-left: -50px !important;
  margin-right: -50px !important;
}
.slick-gutter-50 .slick-slide {
  padding-left: 50px !important;
  padding-right: 50px !important;
}

.slick-gutter-55 {
  margin-left: -55px !important;
  margin-right: -55px !important;
}
.slick-gutter-55 .slick-slide {
  padding-left: 55px !important;
  padding-right: 55px !important;
}

.slick-gutter-60 {
  margin-left: -60px !important;
  margin-right: -60px !important;
}
.slick-gutter-60 .slick-slide {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

.slick-gutter-65 {
  margin-left: -65px !important;
  margin-right: -65px !important;
}
.slick-gutter-65 .slick-slide {
  padding-left: 65px !important;
  padding-right: 65px !important;
}

.slick-gutter-70 {
  margin-left: -70px !important;
  margin-right: -70px !important;
}
.slick-gutter-70 .slick-slide {
  padding-left: 70px !important;
  padding-right: 70px !important;
}

.slick-gutter-75 {
  margin-left: -75px !important;
  margin-right: -75px !important;
}
.slick-gutter-75 .slick-slide {
  padding-left: 75px !important;
  padding-right: 75px !important;
}

.slick-gutter-80 {
  margin-left: -80px !important;
  margin-right: -80px !important;
}
.slick-gutter-80 .slick-slide {
  padding-left: 80px !important;
  padding-right: 80px !important;
}

.slick-gutter-85 {
  margin-left: -85px !important;
  margin-right: -85px !important;
}
.slick-gutter-85 .slick-slide {
  padding-left: 85px !important;
  padding-right: 85px !important;
}

.slick-gutter-90 {
  margin-left: -90px !important;
  margin-right: -90px !important;
}
.slick-gutter-90 .slick-slide {
  padding-left: 90px !important;
  padding-right: 90px !important;
}

.slick-gutter-95 {
  margin-left: -95px !important;
  margin-right: -95px !important;
}
.slick-gutter-95 .slick-slide {
  padding-left: 95px !important;
  padding-right: 95px !important;
}

.slick-gutter-100 {
  margin-left: -100px !important;
  margin-right: -100px !important;
}
.slick-gutter-100 .slick-slide {
  padding-left: 100px !important;
  padding-right: 100px !important;
}

/*======================== 
    Common Style Css
==========================*/
/* Theme Gradient */
.theme-gradient, .counter-style-1 .count-number {
  background: -webkit-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98%/200% 100%;
  background: linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98%/200% 100%;
  text-transform: capitalize;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bg-theme-gradient {
  background-color: transparent;
  background-image: linear-gradient(90deg, var(--color-primary-lightest) 10%, var(--color-primary-alt) 50%, var(--color-tertiary-alt) 90%);
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .theme-gradient, .counter-style-1 .count-number {
    color: var(--color-secondary);
    background: none !important;
  }
}
/* Heading Font  */
.h1 {
  font-size: var(--h1) !important;
}

.h2 {
  font-size: var(--h2) !important;
}

.h3 {
  font-size: var(--h3) !important;
}

.h4 {
  font-size: var(--h4) !important;
}

.h5 {
  font-size: var(--h5) !important;
}

.h6 {
  font-size: var(--h6) !important;
}

/* Text Color  */
.bg-primary-color {
  background: var(--color-primary);
}

.bg-secondary-color {
  background: var(--color-secondary);
}

.bg-tertiary-color {
  background-color: var(--color-tertiary);
}

.bg-color-primary {
  background-color: var(--color-primary) !important;
}

.bg-color-primary-light {
  background-color: var(--color-primary-light) !important;
}

.bg-color-primary-alt {
  background-color: var(--color-primary-alt) !important;
}

.bg-color-secondary {
  background-color: var(--color-secondary) !important;
}

.bg-color-tertiary {
  background-color: var(--color-tertiary) !important;
}

.bg-color-tertiary-alt {
  background-color: var(--color-tertiary-alt) !important;
}

.bg-color-light-green {
  background-color: var(--color-light-green) !important;
}

.bg-color-pink {
  background-color: var(--color-pink) !important;
}

.bg-color-primary-darker {
  background-color: var(--color-primary-darker) !important;
}

.bg-color-secondary-darker {
  background-color: var(--color-secondary-darker) !important;
}

.bg-color-light-green-darker {
  background-color: var(--color-light-green-darker) !important;
}

.bg-color-pink-darker {
  background-color: var(--color-pink-darker) !important;
}

.bg-color-heading {
  background-color: var(--color-heading) !important;
}

.bg-color-body {
  background-color: var(--color-body) !important;
}

.bg-color-dark {
  background-color: var(--color-dark) !important;
}

.bg-color-darker {
  background-color: var(--color-darker) !important;
}

.bg-color-darkest {
  background-color: var(--color-darkest) !important;
}

.bg-color-black {
  background-color: var(--color-black) !important;
}

.bg-color-blacker {
  background-color: var(--color-blacker) !important;
}

.bg-color-blackest {
  background-color: var(--color-blackest) !important;
}

.bg-color-border {
  background-color: var(--color-border) !important;
}

.bg-color-gray {
  background-color: var(--color-gray) !important;
}

.bg-color-midgray {
  background-color: var(--color-midgray) !important;
}

.bg-color-light {
  background-color: var(--color-light) !important;
}

.bg-color-lighter {
  background-color: var(--color-lighter) !important;
}

.bg-color-lightest {
  background-color: var(--color-lightest) !important;
}

.bg-color-white {
  background-color: var(--color-white) !important;
}

/* Radius */
/* Font Weight */
/* Shadows */
/* Others  */
.liststyle {
  padding: 0;
  margin: 0;
  list-style: none;
}

.transition-transform {
  transition: var(--transition-transform);
}

.list-icon {
  list-style: none;
  padding: 0;
  margin: 0;
}
.list-icon li {
  display: flex;
  align-items: center;
  margin: 15px 0;
}
@media only screen and (max-width: 767px) {
  .list-icon li {
    font-size: 16px;
  }
}
.list-icon li .icon {
  width: 30px;
  background-color: var(--color-blackest);
  height: 30px;
  border-radius: 100%;
  display: inline-block;
  position: relative;
  margin-right: 9px;
  min-width: 30px;
  min-height: 30px;
}
.list-icon li .icon svg {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rn-sub-badge {
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 18px;
  font-size: 16px;
  border-radius: 4px;
  margin-bottom: 12px;
  display: inline-block;
  padding: 7px 14px;
  background-color: var(--color-blackest);
  box-shadow: var(--shadow-lighter);
}

/* ========= Forms Styles ========= */
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

input,
select,
textarea {
  width: 100%;
  transition: 0.3s;
}

input {
  height: 40px;
  padding: 0 15px;
}

select {
  transition: 0.3s;
  height: 60px;
  line-height: 28px;
  padding: 10px 20px;
  outline: none;
  color: var(--color-body);
  appearance: none;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius);
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  padding-right: 30px;
}

input[type=text],
input[type=password],
input[type=email],
input[type=number],
input[type=tel],
textarea {
  font-size: 16px;
  font-weight: 400;
  height: auto;
  line-height: 28px;
  background: transparent;
  box-shadow: none;
  padding: 0 15px;
  outline: none;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius);
  color: var(--color-body);
  /* -- Placeholder -- */
}
input[type=text]::placeholder,
input[type=password]::placeholder,
input[type=email]::placeholder,
input[type=number]::placeholder,
input[type=tel]::placeholder,
textarea::placeholder {
  color: var(--body-color);
  /* Firefox */
  opacity: 1;
}
input[type=text]:-ms-input-placeholder,
input[type=password]:-ms-input-placeholder,
input[type=email]:-ms-input-placeholder,
input[type=number]:-ms-input-placeholder,
input[type=tel]:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--body-color);
  opacity: 1;
}
input[type=text]::-ms-input-placeholder,
input[type=password]::-ms-input-placeholder,
input[type=email]::-ms-input-placeholder,
input[type=number]::-ms-input-placeholder,
input[type=tel]::-ms-input-placeholder,
textarea::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--body-color);
  opacity: 1;
}
input[type=text].p-holder__active, .input-active input[type=text], input[type=text].input-active,
input[type=password].p-holder__active,
.input-active input[type=password],
input[type=password].input-active,
input[type=email].p-holder__active,
.input-active input[type=email],
input[type=email].input-active,
input[type=number].p-holder__active,
.input-active input[type=number],
input[type=number].input-active,
input[type=tel].p-holder__active,
.input-active input[type=tel],
input[type=tel].input-active,
textarea.p-holder__active,
textarea.input-active {
  border-color: var(--color-primary);
  /* -- Placeholder -- */
}
input[type=text].p-holder__active::placeholder, .input-active input[type=text]::placeholder, input[type=text].input-active::placeholder,
input[type=password].p-holder__active::placeholder,
.input-active input[type=password]::placeholder,
input[type=password].input-active::placeholder,
input[type=email].p-holder__active::placeholder,
.input-active input[type=email]::placeholder,
input[type=email].input-active::placeholder,
input[type=number].p-holder__active::placeholder,
.input-active input[type=number]::placeholder,
input[type=number].input-active::placeholder,
input[type=tel].p-holder__active::placeholder,
.input-active input[type=tel]::placeholder,
input[type=tel].input-active::placeholder,
textarea.p-holder__active::placeholder,
textarea.input-active::placeholder {
  color: var(--color-primary);
  /* Firefox */
  opacity: 1;
}
input[type=text].p-holder__active:-ms-input-placeholder, .input-active input[type=text]:-ms-input-placeholder, input[type=text].input-active:-ms-input-placeholder,
input[type=password].p-holder__active:-ms-input-placeholder,
.input-active input[type=password]:-ms-input-placeholder,
input[type=password].input-active:-ms-input-placeholder,
input[type=email].p-holder__active:-ms-input-placeholder,
.input-active input[type=email]:-ms-input-placeholder,
input[type=email].input-active:-ms-input-placeholder,
input[type=number].p-holder__active:-ms-input-placeholder,
.input-active input[type=number]:-ms-input-placeholder,
input[type=number].input-active:-ms-input-placeholder,
input[type=tel].p-holder__active:-ms-input-placeholder,
.input-active input[type=tel]:-ms-input-placeholder,
input[type=tel].input-active:-ms-input-placeholder,
textarea.p-holder__active:-ms-input-placeholder,
textarea.input-active:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--color-primary);
}
input[type=text].p-holder__active::-ms-input-placeholder, .input-active input[type=text]::-ms-input-placeholder, input[type=text].input-active::-ms-input-placeholder,
input[type=password].p-holder__active::-ms-input-placeholder,
.input-active input[type=password]::-ms-input-placeholder,
input[type=password].input-active::-ms-input-placeholder,
input[type=email].p-holder__active::-ms-input-placeholder,
.input-active input[type=email]::-ms-input-placeholder,
input[type=email].input-active::-ms-input-placeholder,
input[type=number].p-holder__active::-ms-input-placeholder,
.input-active input[type=number]::-ms-input-placeholder,
input[type=number].input-active::-ms-input-placeholder,
input[type=tel].p-holder__active::-ms-input-placeholder,
.input-active input[type=tel]::-ms-input-placeholder,
input[type=tel].input-active::-ms-input-placeholder,
textarea.p-holder__active::-ms-input-placeholder,
textarea.input-active::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--color-primary);
}
input[type=text].p-holder__error, .input-error input[type=text], input[type=text].input-error,
input[type=password].p-holder__error,
.input-error input[type=password],
input[type=password].input-error,
input[type=email].p-holder__error,
.input-error input[type=email],
input[type=email].input-error,
input[type=number].p-holder__error,
.input-error input[type=number],
input[type=number].input-error,
input[type=tel].p-holder__error,
.input-error input[type=tel],
input[type=tel].input-error,
textarea.p-holder__error,
textarea.input-error {
  border-color: #f4282d;
  /* -- Placeholder -- */
}
input[type=text].p-holder__error::placeholder, .input-error input[type=text]::placeholder, input[type=text].input-error::placeholder,
input[type=password].p-holder__error::placeholder,
.input-error input[type=password]::placeholder,
input[type=password].input-error::placeholder,
input[type=email].p-holder__error::placeholder,
.input-error input[type=email]::placeholder,
input[type=email].input-error::placeholder,
input[type=number].p-holder__error::placeholder,
.input-error input[type=number]::placeholder,
input[type=number].input-error::placeholder,
input[type=tel].p-holder__error::placeholder,
.input-error input[type=tel]::placeholder,
input[type=tel].input-error::placeholder,
textarea.p-holder__error::placeholder,
textarea.input-error::placeholder {
  color: #f4282d;
  /* Firefox */
  opacity: 1;
}
input[type=text].p-holder__error:-ms-input-placeholder, .input-error input[type=text]:-ms-input-placeholder, input[type=text].input-error:-ms-input-placeholder,
input[type=password].p-holder__error:-ms-input-placeholder,
.input-error input[type=password]:-ms-input-placeholder,
input[type=password].input-error:-ms-input-placeholder,
input[type=email].p-holder__error:-ms-input-placeholder,
.input-error input[type=email]:-ms-input-placeholder,
input[type=email].input-error:-ms-input-placeholder,
input[type=number].p-holder__error:-ms-input-placeholder,
.input-error input[type=number]:-ms-input-placeholder,
input[type=number].input-error:-ms-input-placeholder,
input[type=tel].p-holder__error:-ms-input-placeholder,
.input-error input[type=tel]:-ms-input-placeholder,
input[type=tel].input-error:-ms-input-placeholder,
textarea.p-holder__error:-ms-input-placeholder,
textarea.input-error:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #f4282d;
}
input[type=text].p-holder__error::-ms-input-placeholder, .input-error input[type=text]::-ms-input-placeholder, input[type=text].input-error::-ms-input-placeholder,
input[type=password].p-holder__error::-ms-input-placeholder,
.input-error input[type=password]::-ms-input-placeholder,
input[type=password].input-error::-ms-input-placeholder,
input[type=email].p-holder__error::-ms-input-placeholder,
.input-error input[type=email]::-ms-input-placeholder,
input[type=email].input-error::-ms-input-placeholder,
input[type=number].p-holder__error::-ms-input-placeholder,
.input-error input[type=number]::-ms-input-placeholder,
input[type=number].input-error::-ms-input-placeholder,
input[type=tel].p-holder__error::-ms-input-placeholder,
.input-error input[type=tel]::-ms-input-placeholder,
input[type=tel].input-error::-ms-input-placeholder,
textarea.p-holder__error::-ms-input-placeholder,
textarea.input-error::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #f4282d;
}
input[type=text].p-holder__error:focus, .input-error input[type=text]:focus, input[type=text].input-error:focus,
input[type=password].p-holder__error:focus,
.input-error input[type=password]:focus,
input[type=password].input-error:focus,
input[type=email].p-holder__error:focus,
.input-error input[type=email]:focus,
input[type=email].input-error:focus,
input[type=number].p-holder__error:focus,
.input-error input[type=number]:focus,
input[type=number].input-error:focus,
input[type=tel].p-holder__error:focus,
.input-error input[type=tel]:focus,
input[type=tel].input-error:focus,
textarea.p-holder__error:focus,
textarea.input-error:focus {
  border-color: #f4282d;
}
input[type=text]:focus,
input[type=password]:focus,
input[type=email]:focus,
input[type=number]:focus,
input[type=tel]:focus,
textarea:focus {
  border-color: var(--color-primary);
}

input[type=checkbox],
input[type=radio] {
  opacity: 0;
  position: absolute;
}
input[type=checkbox] ~ label,
input[type=radio] ~ label {
  position: relative;
  font-size: 15px;
  line-height: 25px;
  color: var(--body-color);
  font-weight: 400;
  padding-left: 20px;
  cursor: pointer;
  margin-bottom: 0;
}
input[type=checkbox] ~ label::before,
input[type=radio] ~ label::before {
  content: " ";
  position: absolute;
  top: 6px;
  left: 0;
  width: 14px;
  height: 14px;
  background-color: #fff;
  border: var(--border-width) solid rgba(24, 152, 165, 0.2);
  border-radius: 2px;
  transition: all 0.3s;
}
input[type=checkbox] ~ label::after,
input[type=radio] ~ label::after {
  content: " ";
  position: absolute;
  top: 9px;
  left: 2px;
  width: 10px;
  height: 5px;
  background-color: transparent;
  border-bottom: var(--border-width) solid #fff;
  border-left: var(--border-width) solid #fff;
  border-radius: 2px;
  transform: rotate(-45deg);
  opacity: 0;
  transition: all 0.3s;
}
input[type=checkbox]:checked ~ label::before,
input[type=radio]:checked ~ label::before {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}
input[type=checkbox]:checked ~ label::after,
input[type=radio]:checked ~ label::after {
  opacity: 1;
}

input[type=radio] ~ label::before {
  border-radius: 50%;
}
input[type=radio] ~ label::after {
  width: 8px;
  height: 8px;
  left: 3px;
  background: #fff;
  border-radius: 50%;
}

.form-group {
  margin-bottom: 20px;
}
.form-group input {
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius);
  height: 50px;
  font-size: 16px;
  padding: 0 15px;
}
.form-group input:focus {
  border-color: var(--color-primary);
}
.form-group textarea {
  min-height: 193px;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius);
  resize: none;
  padding: 15px;
  font-size: 16px;
}
.form-group textarea:focus {
  border-color: var(--color-primary);
}

input[type=submit] {
  width: auto;
  font-size: 16px;
  letter-spacing: 2px;
  padding: 15px 20px;
  border-radius: 6px;
  display: block;
  font-weight: 500;
  transition: 0.3s;
  border: var(--border-width) solid var(--color-primary);
  background: var(--color-primary);
  color: #ffffff;
  height: 60px;
  margin-top: 30px;
}
input[type=submit]:hover {
  color: #ffffff;
  box-shadow: 0 10px 15px 0 rgba(249, 0, 77, 0.1);
  transform: translateY(-5px);
}

.contact-form--1 form input::-webkit-input-placeholder,
.contact-form--1 form textarea::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: var(--color-body) !important;
}

.contact-form--1 form input::-moz-placeholder,
.contact-form--1 form textarea::-moz-placeholder {
  /* Firefox 19+ */
  color: var(--color-body) !important;
}

.contact-form--1 form input:-ms-input-placeholder,
.contact-form--1 form textarea:-ms-input-placeholder {
  /* IE 10+ */
  color: var(--color-body) !important;
}

.contact-form--1 form input:-moz-placeholder,
.contact-form--1 form textarea:-moz-placeholder {
  /* Firefox 18- */
  color: var(--color-body) !important;
}

/* Theme Bg Color  */
.rn-gradient-circle {
  position: fixed;
  left: -250px;
  top: 250px;
  right: auto;
  bottom: auto;
  z-index: -1;
  width: 500px;
  height: 500px;
  border-radius: 1000px;
  opacity: 0.25;
  filter: blur(100px);
}
.rn-gradient-circle.theme-pink {
  left: auto;
  top: -250px;
  right: -250px;
  bottom: auto;
  background-image: linear-gradient(45deg, var(--color-secondary), var(--color-tertiary));
}

.theme-shape {
  position: relative;
  z-index: 2;
  overflow: hidden;
}
.theme-shape::before {
  position: absolute;
  left: -250px;
  top: 250px;
  right: auto;
  bottom: auto;
  z-index: -1;
  width: 500px;
  height: 500px;
  border-radius: 1000px;
  background-image: linear-gradient(45deg, var(--color-primary), var(--color-light-green));
  opacity: 0.2;
  filter: blur(100px);
  content: "";
}
.theme-shape::after {
  position: absolute;
  z-index: -1;
  width: 500px;
  height: 500px;
  border-radius: 1000px;
  opacity: 0.2;
  filter: blur(100px);
  content: "";
  left: auto;
  top: -250px;
  right: -250px;
  bottom: auto;
  background-image: linear-gradient(45deg, var(--color-secondary), var(--color-tertiary));
}

.link-hover a {
  display: inline-block;
  position: relative;
}
.link-hover a::after {
  position: absolute;
  content: "";
  left: auto;
  bottom: 0;
  background: currentColor;
  width: 0;
  height: 2px;
  transition: 0.3s;
  right: 0;
}
.link-hover a:hover::after {
  width: 100%;
  left: 0;
  right: auto;
}

/*--------------------------
    Header Styles  
 --------------------------*/
.logo-dark {
  display: none;
}

.header-default {
  max-width: 100%;
  border-bottom: 1px solid var(--color-border);
  background-color: var(--color-darker);
  color: #fff;
  font-size: 12px;
  z-index: 99;
  position: relative;
  height: 106px;
  display: flex;
  align-items: center;
}
.header-default .logo a {
  display: flex;
  height: 80px;
  line-height: 80px;
  align-items: center;
}
.header-default .logo a img {
  max-height: 40px;
}
.header-default .header-right {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.header-default.header-relative {
  position: relative;
}
.header-default .header-right {
  display: flex;
  justify-content: flex-end;
}
.header-default .header-right .header-btn {
  margin-left: 25px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .header-default .header-right .header-btn {
    margin-left: 0;
  }
}
@media only screen and (max-width: 767px) {
  .header-default .header-right .header-btn {
    margin-left: 0;
  }
}
@media only screen and (max-width: 767px) {
  .header-default a.btn-default,
  .header-default button.btn-default {
    height: 33px;
    line-height: 30px;
    padding: 0 9px;
    font-size: 12px;
  }
}
@media only screen and (max-width: 767px) {
  .header-default a.btn-default.btn-small,
  .header-default button.btn-default.btn-small {
    height: 33px;
    line-height: 30px;
    padding: 0 9px;
    font-size: 12px;
  }
}
.header-default.header-transparent {
  position: absolute;
  left: 0;
  right: 0;
  width: auto;
  background: transparent !important;
  -webkit-backdrop-filter: inherit;
          backdrop-filter: inherit;
}

.header-transparent-with-topbar {
  position: absolute;
  left: 0;
  right: 0;
  width: auto;
  z-index: 99;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .header-transparent-with-topbar {
    position: relative;
  }
}
@media only screen and (max-width: 767px) {
  .header-transparent-with-topbar {
    position: relative;
  }
}
.header-transparent-with-topbar .header-top-bar {
  background-color: transparent;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .header-transparent-with-topbar .header-top-bar {
    background-color: var(--color-darker);
  }
}
@media only screen and (max-width: 767px) {
  .header-transparent-with-topbar .header-top-bar {
    background-color: var(--color-darker);
  }
}
.header-transparent-with-topbar .header-default {
  background-color: transparent;
  background-image: none;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .header-transparent-with-topbar .header-default {
    background-color: var(--color-darker);
  }
}
@media only screen and (max-width: 767px) {
  .header-transparent-with-topbar .header-default {
    background-color: var(--color-darker);
  }
}

.hamberger-button {
  background: var(--color-blackest);
  border: 0 none;
  color: var(--color-white);
  width: 40px;
  height: 40px;
  font-size: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  cursor: pointer;
}
.hamberger-button svg {
  position: relative;
  z-index: 2;
  stroke-width: 2px;
  stroke: #fff;
}

.header-left-align .mainmenu-nav {
  margin-left: 30px;
}

.rn-header.sticky {
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--color-dark) !important;
  width: 100%;
  height: 100px;
  animation: headerSticky 0.95s ease forwards;
  z-index: 9;
}

@keyframes headerSticky {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}
/*--------------------------
    Navigation Styles 
----------------------------*/
.active {
  color: var(--color-primary) !important;
}

.activeInside {
  color: var(--color-primary) !important;
  pointer-events: none;
  cursor: default;
}

.mainmenu-nav .mainmenu {
  display: flex;
  margin: 0;
  padding: 0;
}
.mainmenu-nav .mainmenu > li > a {
  color: var(--color-body);
  font-size: 18px;
  font-weight: 500;
  padding: 0 17px;
  display: block;
  height: 80px;
  line-height: 80px;
  transition: 0.3s;
  cursor: pointer;
}
.mainmenu-nav .mainmenu > li > a:hover {
  color: var(--color-primary);
}
.mainmenu-nav .mainmenu li {
  margin-top: 0;
  margin-bottom: 0;
  position: relative;
}
.mainmenu-nav .mainmenu li.has-droupdown .submenu {
  min-width: 240px;
  height: auto;
  position: absolute;
  top: 90%;
  left: 0;
  z-index: 90;
  opacity: 0;
  visibility: hidden;
  text-align: left;
  padding: 12px 0;
  transition: 0.3s;
  border-radius: 0 0 10px 10px;
  background-color: var(--color-blackest);
  box-shadow: var(--shadow-lighter);
}
.mainmenu-nav .mainmenu li.has-droupdown .submenu li a {
  font-weight: 500;
  padding: 5px 20px;
  font-size: 14px;
  display: block;
  color: var(--color-body);
  margin: 0 10px;
  border-radius: 3px;
}
.mainmenu-nav .mainmenu li.has-droupdown .submenu li a:hover {
  color: var(--color-primary);
  background: var(--color-darker);
}
.mainmenu-nav .mainmenu li.has-droupdown:hover .submenu {
  opacity: 1;
  visibility: visible;
  top: 100%;
}
.mainmenu-nav .mainmenu li.with-megamenu {
  position: static;
}
.mainmenu-nav .mainmenu li.with-megamenu .rn-megamenu {
  position: absolute;
  transition: 0.3s;
  top: 90%;
  width: 100%;
  left: 0;
  right: 0;
  padding: 0 15px;
  visibility: hidden;
  opacity: 0;
}
.mainmenu-nav .mainmenu li.with-megamenu .rn-megamenu .wrapper {
  border-radius: 0 0 10px 10px;
  background-color: var(--color-blackest);
  box-shadow: var(--shadow-lighter);
}
.mainmenu-nav .mainmenu li.with-megamenu .rn-megamenu .wrapper .mega-menu-item {
  padding: 22px 10px;
  border-right: 1px solid var(--color-extra04);
  height: 100%;
}
.mainmenu-nav .mainmenu li.with-megamenu .rn-megamenu .wrapper .mega-menu-item li a {
  font-weight: 500;
  padding: 5px 14px;
  font-size: 15px;
  display: block;
  color: var(--color-body);
  margin: 0 10px;
  border-radius: 4px;
  transition: 0.3s;
  display: flex;
  align-items: center;
}
.mainmenu-nav .mainmenu li.with-megamenu .rn-megamenu .wrapper .mega-menu-item li a .rn-badge-card {
  margin-left: 10px;
}
.mainmenu-nav .mainmenu li.with-megamenu .rn-megamenu .wrapper .mega-menu-item li a:hover {
  color: var(--color-primary);
  background: var(--color-darker);
}
.mainmenu-nav .mainmenu li.with-megamenu .single-mega-item:last-child .mega-menu-item {
  border-right: 0 none;
}
.mainmenu-nav .mainmenu li.with-megamenu:hover .rn-megamenu {
  opacity: 1;
  visibility: visible;
  top: 100%;
}

/*------------------------------
    Popup Menu Styles  
--------------------------------*/
.popup-mobile-menu {
  z-index: 9999;
  position: fixed;
  content: "";
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.5s ease-out;
}
.popup-mobile-menu .inner {
  width: 320px;
  z-index: 999;
  position: absolute;
  background-color: var(--color-blackest);
  height: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  opacity: 0;
  left: -150px;
  transition: all 0.5s ease-out;
}
.popup-mobile-menu .inner .header-top {
  display: flex;
  border-bottom: 1px solid var(--color-border);
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
}
.popup-mobile-menu .inner .header-top .logo a img {
  max-height: 45px;
}
.popup-mobile-menu .inner .header-top .close-menu .close-button {
  background: var(--color-darker);
  border: 0 none;
  color: var(--color-white);
  width: 40px;
  height: 40px;
  font-size: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  cursor: pointer;
}
.popup-mobile-menu .inner .header-top .close-menu .close-button svg {
  position: relative;
  z-index: 2;
  stroke-width: 2px;
  stroke: #fff;
}
.popup-mobile-menu.active {
  visibility: visible;
  opacity: 1;
}
.popup-mobile-menu.active .inner {
  opacity: 1;
  left: 0;
  overflow-y: auto;
}
.popup-mobile-menu .mainmenu {
  list-style: none;
  padding: 0;
  margin: 0;
  padding: 15px 20px;
}
.popup-mobile-menu .mainmenu li {
  margin: 0;
}
.popup-mobile-menu .mainmenu li a {
  padding: 8px 0;
  display: block;
  font-size: 18px;
  font-weight: 500;
}
.popup-mobile-menu .mainmenu li + li {
  border-top: 1px solid var(--color-border);
}
.popup-mobile-menu .mainmenu .has-droupdown .submenu {
  height: 0;
  transition: all 0.3s;
  opacity: 0;
  visibility: hidden;
  padding: 0;
  max-width: 100%;
  list-style: none;
  padding-left: 14px;
}
.popup-mobile-menu .mainmenu .has-droupdown .submenu li a {
  font-size: 15px;
}
.popup-mobile-menu .mainmenu .has-droupdown .submenu.active {
  height: 100%;
  opacity: 1;
  visibility: visible;
  padding-bottom: 12px;
}
.popup-mobile-menu .mainmenu .rn-megamenu {
  height: 0;
  transition: all 0.3s;
  opacity: 0;
  visibility: hidden;
  padding: 0;
  max-width: 100%;
  list-style: none;
  padding-left: 14px;
}
.popup-mobile-menu .mainmenu .rn-megamenu.active {
  height: 100%;
  opacity: 1;
  visibility: visible;
  padding-bottom: 12px;
}
.popup-mobile-menu .mainmenu .mega-menu-item {
  list-style: none;
  padding: 0;
  margin: 0;
  padding-left: 0;
}
.popup-mobile-menu .mainmenu .mega-menu-item li a {
  font-size: 15px;
}
.popup-mobile-menu .mainmenu .mega-menu-item li:last-child {
  border-bottom: 1px solid var(--color-border);
}
.popup-mobile-menu .mainmenu .single-mega-item:last-child .mega-menu-item li:last-child {
  border-bottom-color: transparent;
}

/*--------------------------
    Header Top Styles  
-----------------------------*/
.header-top-news {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  width: auto;
  z-index: 99;
  transition: 0.4s;
}
.header-top-news.deactive {
  display: none;
}
.header-top-news .inner {
  display: flex;
  justify-content: center;
  padding: 8px 0;
  align-items: center;
  position: relative;
}
@media only screen and (max-width: 767px) {
  .header-top-news .inner {
    display: block;
    text-align: center;
    padding: 15px 0;
  }
}
.header-top-news .inner .content .news-text {
  display: inline-block;
  margin-left: 15px;
  color: var(--color-body);
  font-size: 14px;
}
@media only screen and (max-width: 575px) {
  .header-top-news .inner .content .news-text {
    margin-left: 0;
    margin-top: 10px;
    display: block;
  }
}
.header-top-news .inner .right-button {
  margin-left: 30px;
}
@media only screen and (max-width: 767px) {
  .header-top-news .inner .right-button {
    margin-left: 0;
  }
}
.header-top-news .icon-close {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
}
@media only screen and (max-width: 767px) {
  .header-top-news .icon-close {
    right: 10px;
    top: 13px;
    transform: none;
  }
}
.header-top-news .close-button {
  background: transparent;
  color: #fff;
  border: 2px solid var(--color-border);
  width: 35px;
  display: inline-block;
  height: 35px;
  border-radius: 100%;
  padding: 0;
  margin: 0;
  line-height: 31px;
  transition: 0.3s;
}
.header-top-news .close-button:hover {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: #fff;
}

/*----------------------------
    Header Top Bar  
----------------------------*/
.header-top-bar {
  padding: 10px 0;
  border-bottom: 1px solid var(--color-border);
  background-color: var(--color-darker);
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .header-top-bar .header-left {
    text-align: center;
  }
}
@media only screen and (max-width: 767px) {
  .header-top-bar .header-left {
    text-align: center;
  }
}
.header-top-bar .header-left p {
  margin-bottom: 0;
}
.header-top-bar .header-left p a {
  transition: 0.3s;
}
.header-top-bar .header-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .header-top-bar .header-right {
    justify-content: center;
    margin-top: 6px;
  }
}
@media only screen and (max-width: 767px) {
  .header-top-bar .header-right {
    justify-content: center;
    margin-top: 6px;
  }
}
.header-top-bar .header-right .address-content {
  display: flex;
  align-items: center;
  margin: 0 -10px;
}
.header-top-bar .header-right .address-content p {
  margin-bottom: 0;
  padding: 0 10px;
  font-size: 14px;
  position: relative;
}
@media only screen and (max-width: 575px) {
  .header-top-bar .header-right .address-content p {
    padding: 0 8px;
  }
}
.header-top-bar .header-right .address-content p + p::before {
  position: absolute;
  content: "";
  height: 20px;
  width: 2px;
  background: var(--color-border);
  top: 50%;
  transform: translateY(-50%);
  left: -1px;
}
.header-top-bar .header-right .address-content p a {
  transition: 0.3s;
}
.header-top-bar .header-right .address-content p svg {
  margin-right: 8px;
  font-size: 16px;
}
.header-top-bar .social-default.icon-naked li {
  margin: 1px;
}
.header-top-bar .social-default.icon-naked li a {
  color: var(--color-body);
  font-size: 15px;
  line-height: 26px;
}
.header-top-bar .social-icon-wrapper {
  position: relative;
  margin-left: 10px;
  padding-left: 10px;
}
@media only screen and (max-width: 575px) {
  .header-top-bar .social-icon-wrapper {
    margin-left: 0;
    padding-left: 0;
    flex-basis: 100%;
  }
}
.header-top-bar .social-icon-wrapper::before {
  position: absolute;
  content: "";
  height: 20px;
  width: 2px;
  background: var(--color-border);
  top: 50%;
  transform: translateY(-50%);
  left: -1px;
}
@media only screen and (max-width: 575px) {
  .header-top-bar .social-icon-wrapper::before {
    display: none;
  }
}

.section-title .subtitle {
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 18px;
  font-size: 16px;
  border-radius: 4px;
  margin-bottom: 12px;
  display: inline-block;
  padding: 7px 14px;
  background-color: var(--color-blackest);
  box-shadow: var(--shadow-lighter);
}
.section-title .subtitle.radius-rounded {
  border-radius: 100px;
}
@media only screen and (max-width: 767px) {
  .section-title .description br {
    display: none;
  }
}
.section-title p:empty {
  display: none;
}

.section-title-2 .title {
  color: var(--color-body);
  display: block;
  border-bottom: 1px solid var(--color-border);
  padding-bottom: 19px;
  opacity: 0.6;
}

/* Button Styles  */
.button-group {
  margin: -10px;
}
.button-group a,
.button-group button {
  margin: 10px;
}

a.btn-default,
button.btn-default {
  padding: 0 28px;
  border-style: solid;
  border-width: 2px;
  border-color: transparent;
  border-radius: 8px;
  background-color: transparent;
  background: linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 95%/200% 100%;
  transition-duration: 300ms;
  color: var(--color-white);
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  text-decoration: none;
  text-shadow: var(--shadow-light);
  display: inline-block;
  height: 50px;
  line-height: 47px;
  letter-spacing: 0.5px;
  width: auto;
}
a.btn-default.btn-icon .icon,
button.btn-default.btn-icon .icon {
  position: relative;
  top: -1px;
  padding-left: 4px;
}
a.btn-default.btn-icon .icon svg,
button.btn-default.btn-icon .icon svg {
  width: 20px;
  height: 20px;
}
a.btn-default:hover,
button.btn-default:hover {
  box-shadow: var(--shadow-primary);
  filter: brightness(125%);
  color: var(--color-white);
  text-decoration: none;
}
a.btn-default.btn-small,
button.btn-default.btn-small {
  height: 40px;
  line-height: 36px;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 500;
}
a.btn-default.btn-medium,
button.btn-default.btn-medium {
  height: 65px;
  line-height: 63px;
  padding: 0 40px;
}
@media only screen and (max-width: 767px) {
  a.btn-default.btn-medium,
  button.btn-default.btn-medium {
    padding: 0 30px;
  }
}
a.btn-default.btn-large,
button.btn-default.btn-large {
  height: 60px;
  line-height: 56px;
  padding: 0 37px;
  font-size: 17px;
}
@media only screen and (max-width: 767px) {
  a.btn-default.btn-large,
  button.btn-default.btn-large {
    padding: 0 30px;
  }
}
a.btn-default.btn-extra-large,
button.btn-default.btn-extra-large {
  height: 90px;
  line-height: 90px;
  padding: 0 70px;
  font-size: 20px;
}
@media only screen and (max-width: 767px) {
  a.btn-default.btn-extra-large,
  button.btn-default.btn-extra-large {
    padding: 0 44px;
  }
}
a.btn-default.btn-border,
button.btn-default.btn-border {
  background-image: inherit;
  border-color: var(--color-border);
  border-width: 2px;
  border-style: solid;
}
a.btn-default.btn-border:hover,
button.btn-default.btn-border:hover {
  background-color: var(--color-secondary);
  border-color: var(--color-secondary);
}
a.btn-default.text-underline,
button.btn-default.text-underline {
  background-image: inherit;
  border-color: var(--color-white);
}
a.btn-default.text-underline span,
button.btn-default.text-underline span {
  position: relative;
  display: inline-block;
  line-height: 30px;
}
a.btn-default.text-underline span::after,
button.btn-default.text-underline span::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  height: 1px;
  background-color: currentColor;
  transition: background-color 0.25s ease-in-out, width 0.36s cubic-bezier(0.51, 0.5, 0.07, 0.99);
  backface-visibility: hidden;
  width: 0px;
  bottom: 3px;
}
a.btn-default.text-underline:hover,
button.btn-default.text-underline:hover {
  box-shadow: none;
}
a.btn-default.text-underline:hover span::after,
button.btn-default.text-underline:hover span::after {
  width: 100%;
}
a.btn-default.round,
button.btn-default.round {
  border-radius: 100px;
}
a.btn-default.square,
button.btn-default.square {
  border-radius: 0;
}
a.btn-default.rounded-player,
button.btn-default.rounded-player {
  border-radius: 100%;
  width: 100px;
  height: 100px;
  padding: 0;
  line-height: 100px;
  font-size: 30px;
  display: inline-block;
}
@media only screen and (max-width: 767px) {
  a.btn-default.rounded-player,
  button.btn-default.rounded-player {
    width: 70px;
    height: 70px;
    line-height: 70px;
  }
}
a.btn-default.rounded-player span svg,
button.btn-default.rounded-player span svg {
  position: relative;
  top: -5px;
  left: 2px;
}
a.btn-default.rounded-player.border,
button.btn-default.rounded-player.border {
  background-image: inherit;
  border-color: var(--color-white);
}
a.btn-default.rounded-player.sm-size,
button.btn-default.rounded-player.sm-size {
  width: 70px;
  height: 70px;
  line-height: 70px;
}

.btn-read-more span {
  position: relative;
  color: var(--color-heading);
  display: inline-block;
  line-height: 35px;
  transition: 0.3s;
}
.btn-read-more span::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  background-color: var(--color-border);
  transition: 0.3s;
  width: 100%;
  bottom: 3px;
}
.btn-read-more span::before {
  position: absolute;
  content: "";
  left: auto;
  bottom: 2px;
  background: var(--color-primary);
  width: 0;
  height: 2px;
  transition: 0.3s;
  right: 0;
}
.btn-read-more:hover span {
  color: var(--color-primary);
}
.btn-read-more:hover span::before {
  width: 100%;
  left: 0;
  right: auto;
}

.rn-badge {
  display: inline-block;
  background-color: var(--color-primary);
  padding: 0 16px;
  height: 30px;
  line-height: 30px;
  border-radius: 100px;
  color: #fff;
  font-size: 12px;
  letter-spacing: 0.5px;
}

.rn-badge-card {
  background-color: transparent;
  background: transparent;
  padding: 1px 10px;
  border-radius: 100px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
  position: relative;
  z-index: 2;
  letter-spacing: 0.5px;
}
.rn-badge-card::before {
  background: linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 95%/200% 100%;
  content: "";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  z-index: -1;
  border-radius: 100px;
  opacity: 0.5;
}

.btn.disabled,
.btn:disabled,
fieldset:disabled .btn {
  border: 0 none;
  color: #fff;
}

/*====================
    Breadcrump Area 
======================*/
.breadcarumb-style-1 {
  border-bottom: 1px solid var(--color-border);
}

.breadcrumb-inner {
  text-align: center;
}
@media md-layout {
  .breadcrumb-inner .title br {
    display: none;
  }
}
@media sm-layout {
  .breadcrumb-inner .title br {
    display: none;
  }
}
.breadcrumb-inner ul.page-list {
  margin-top: 16px;
}
.breadcrumb-inner ul.page-list li {
  display: inline-block;
  color: var(--color-body);
  padding: 0 12px;
  position: relative;
  font-size: 20px;
  margin: 0;
}
.breadcrumb-inner ul.page-list li::after {
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  background-color: var(--color-body);
  width: 5px;
  height: 5px;
  border-radius: 100%;
  opacity: 0.5;
  right: -3px;
}
.breadcrumb-inner ul.page-list li a {
  color: var(--color-body);
  transition: 0.5s;
}
.breadcrumb-inner ul.page-list li a:hover {
  color: var(--color-primary);
}
.breadcrumb-inner ul.page-list li.rn-breadcrumb-item {
  font-weight: 500;
}
.breadcrumb-inner ul.page-list li.rn-breadcrumb-item.active {
  color: var(--color-primary);
  font-weight: 500;
}
.breadcrumb-inner ul.page-list li.rn-breadcrumb-item.active::after {
  display: none;
}

/*--------------------------
    Accordion Styles  
---------------------------*/
.rn-accordion-style .card {
  background: var(--color-lessdark);
  border: 0;
  border-radius: var(--radius) !important;
}
.rn-accordion-style .card .card-header {
  background-color: transparent;
  border-bottom: 0 none;
  box-shadow: none;
  padding: 20px 30px;
  margin-bottom: 0;
}
.rn-accordion-style .card .card-header button {
  color: var(--color-heading);
  font-size: 18px;
  outline: none;
  text-decoration: none;
  box-shadow: none;
  width: 100%;
  text-align: left;
  padding: 0;
}
.rn-accordion-style .card .card-body {
  padding-top: 0;
  font-size: var(--font-size-b2);
  line-height: var(--line-height-b2);
  font-weight: var(--p-regular);
  color: var(--color-body);
  padding: 30px 20px;
  border-top: 1px solid var(--color-border);
}
.rn-accordion-style .card + .card {
  margin-top: 20px;
}
.rn-accordion-style.rn-accordion-02 .card {
  background: transparent !important;
  border-radius: 0 !important;
}
.rn-accordion-style.rn-accordion-02 .card .card-header {
  border-bottom: 2px solid var(--color-border);
  padding: 0px 20px 10px 0;
}
.rn-accordion-style.rn-accordion-02 .card .card-body {
  padding: 15px 20px 10px 0;
  border: 0;
}
.rn-accordion-style.rn-accordion-03 .card {
  background: transparent !important;
  border-radius: 0 !important;
}
.rn-accordion-style.rn-accordion-03 .card .card-header {
  border: 2px solid var(--color-border);
  padding: 15px 20px;
  border-radius: var(--radius) !important;
}
.rn-accordion-style.rn-accordion-03 .card .card-body {
  padding: 15px 20px 10px 0;
  border: 0;
}
.rn-accordion-style.rn-accordion-04 .card {
  border: 2px solid var(--color-border);
  background: transparent !important;
  border-radius: var(--radius) !important;
}
.rn-accordion-style.rn-accordion-04 .card .card-header {
  padding: 15px 20px;
  border-radius: var(--radius) !important;
}
.rn-accordion-style.rn-accordion-04 .card .card-body {
  border: 0;
  border-top: 2px solid var(--color-border);
}

/*--------------------
    Service Styles  
----------------------*/
.service.service__style--1 {
  padding: 50px 35px;
  padding-bottom: 55px;
  transition: transform 0.65s cubic-bezier(0.05, 0.2, 0.1, 1), box-shadow 0.65s cubic-bezier(0.05, 0.2, 0.1, 1);
  position: relative;
  z-index: 2;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .service.service__style--1 {
    padding: 30px 28px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service.service__style--1 {
    padding: 30px 25px;
  }
}
@media only screen and (max-width: 767px) {
  .service.service__style--1 {
    padding: 30px 14px;
  }
}
.service.service__style--1 .icon {
  font-size: 45px;
  font-weight: 400;
  margin-bottom: 23px;
  color: var(--color-primary);
  text-align: center;
  border-radius: 100%;
  display: flex;
  justify-content: center;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service.service__style--1 .icon {
    margin-bottom: 11px;
  }
}
.service.service__style--1 .icon svg {
  stroke-width: 1 !important;
}
.service.service__style--1 .content .title {
  margin-bottom: 19px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service.service__style--1 .content .title {
    margin-bottom: 8px;
  }
}
.service.service__style--1 .content .title a {
  color: inherit;
}
.service.service__style--1 .content .title a:hover {
  color: var(--color-primary);
}
.service.service__style--1:hover {
  transform: translateY(-5px);
}
.service.service__style--1.rbt-border {
  border: 1px solid var(--color-border);
}
.service.service__style--1.text-start {
  padding: 50px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .service.service__style--1.text-start {
    padding: 40px 30px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .service.service__style--1.text-start {
    padding: 40px 30px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service.service__style--1.text-start {
    padding: 40px 30px;
  }
}
@media only screen and (max-width: 767px) {
  .service.service__style--1.text-start {
    padding: 30px 20px;
  }
}
.service.service__style--1.text-start .icon {
  justify-content: left;
}
.service.service__style--1.icon-circle-style {
  background-color: transparent;
  box-shadow: none;
  padding: 0px 35px;
  margin-top: 25px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service.service__style--1.icon-circle-style {
    padding: 0px 10px;
  }
}
@media only screen and (max-width: 767px) {
  .service.service__style--1.icon-circle-style {
    padding: 0px 10px;
  }
}
.service.service__style--1.icon-circle-style .icon {
  font-size: 39px;
  color: var(--color-primary);
  display: flex;
  justify-content: center;
  width: 90px;
  height: 90px;
  margin: 0 auto;
  margin-bottom: 23px;
  background-color: var(--color-primary-darker);
  line-height: 90px;
  align-items: center;
}
.service.service__style--1.with-working-process {
  position: relative;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .service.service__style--1.with-working-process {
    padding: 20px 0;
  }
}
.service.service__style--1.with-working-process .icon {
  width: 180px;
  height: 180px;
  line-height: 180px;
  font-size: 60px;
  position: relative;
}
.service.service__style--1.with-working-process .line {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 1px;
  width: 100%;
  left: 100%;
  background-color: var(--color-border);
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service.service__style--1.with-working-process .line {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .service.service__style--1.with-working-process .line {
    display: none;
  }
}
.service.service__style--1.with-working-process:hover {
  transform: none;
}
.service.gallery-style {
  padding: 40px 30px;
  background: var(--color-blackest);
  border-radius: 24px;
  box-shadow: 0px 1px 1px rgba(255, 255, 255, 0.1);
  margin-top: 30px;
}
.service.gallery-style .content .image img {
  border-radius: 5px;
}
.service.gallery-style .content .title {
  margin-bottom: 19px;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 10px;
}
.service.gallery-style .content .title a {
  color: inherit;
}
.service.gallery-style .content .title a:hover {
  color: var(--color-primary);
}
.service.gallery-style .content p {
  color: var(--color-body);
  margin-bottom: 20px;
}
.service.service__style--2 {
  padding: 50px 35px;
  padding-bottom: 55px;
  transition: transform 0.65s cubic-bezier(0.05, 0.2, 0.1, 1), box-shadow 0.65s cubic-bezier(0.05, 0.2, 0.1, 1);
  position: relative;
  z-index: 2;
  border-radius: 10px;
  margin-top: 30px;
}
@media only screen and (min-width: 1200px) and (max-width: 1599px) {
  .service.service__style--2 {
    padding: 10px 28px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .service.service__style--2 {
    padding: 10px 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .service.service__style--2 {
    padding: 10px 25px;
  }
}
@media only screen and (max-width: 767px) {
  .service.service__style--2 {
    padding: 0px 18px;
  }
}
.service.service__style--2 .image {
  margin-bottom: 23px;
}
.service.service__style--2 .image img {
  max-height: 220px;
}
.service.service__style--2 .content .title a {
  color: inherit;
}
.service.service__style--2 .content .title a:hover {
  color: var(--color-primary);
}
.service.service__style--2 .content p {
  padding: 0 5%;
}
.service.service__style--2:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 39px rgba(255, 101, 80, 0.1);
}

.service-wrapper > [class*=col]:nth-child(1) .service.service__style--1 .icon {
  color: var(--color-primary);
  color: white;
}
.service-wrapper > [class*=col]:nth-child(2) .service.service__style--1 .icon {
  color: var(--color-primary);
  color: white;
}
.service-wrapper > [class*=col]:nth-child(3) .service.service__style--1 .icon {
  color: var(--color-primary);
  color: white;
}
.service-wrapper > [class*=col]:nth-child(4) .service.service__style--1 .icon {
  color: var(--color-primary);
  color: white;
}
.service-wrapper > [class*=col]:nth-child(1) .service.service__style--1.icon-circle-style .icon {
  background-color: #1e3b71;
}
.service-wrapper > [class*=col]:nth-child(2) .service.service__style--1.icon-circle-style .icon {
  background-color: #1e3b71;
}
.service-wrapper > [class*=col]:nth-child(3) .service.service__style--1.icon-circle-style .icon {
  background-color: #1e3b71;
}
.service-wrapper > [class*=col]:nth-child(4) .service.service__style--1.icon-circle-style .icon {
  background-color: #1e3b71;
}
.service-wrapper > [class*=col]:last-child .with-working-process .line {
  display: none;
}

/*
 Card Styles  
*/
.card-box.card-style-1 {
  box-shadow: var(--shadow-lighter);
  background-color: var(--color-blackest);
  padding: 20px;
  border-radius: 5px;
  margin-top: 30px;
}
.card-box.card-style-1 .inner .image img {
  border-radius: 5px;
}
.card-box.card-style-1 .inner .content {
  padding-top: 20px;
}
.card-box.card-style-1 .inner .content .title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 14px;
}
.card-box.card-style-1 .inner .content .title a {
  color: inherit;
}
.card-box.card-style-1 .inner .content .title a:hover {
  color: var(--color-primary);
}
.card-box.card-style-1 .inner .content .description {
  margin-bottom: 0;
}
.card-box.card-style-1 .inner .content .btn-default {
  margin-top: 20px;
}

/*-----------------------
    Progress Bar 
-----------------------*/
.single-progress + .single-progress {
  margin-top: 40px;
}

.progress {
  height: 6px;
  overflow: hidden;
  background-color: var(--color-blackest);
  border-radius: 10px;
}
.progress .progress-bar {
  border-radius: 10px;
  width: 0;
  height: 100%;
  background-color: var(--color-black);
  transition: width 0.5s ease;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
}
.progress-info .title {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 0;
  color: var(--color-body);
  letter-spacing: 0.5px;
}
.progress-info span.progress-number {
  font-size: 14px;
  color: var(--color-body);
}

.no-radius .progress {
  border-radius: 0;
}
.no-radius .progress .progress-bar {
  border-radius: 0;
}

.large-size .progress {
  height: 20px;
}

/*--------------------
    Rwt Circle 
---------------------*/
.rwt-circle .circle-info {
  padding-top: 20px;
}
.rwt-circle .circle-info .title {
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 4px;
}
.rwt-circle .circle-info .subtitle {
  font-style: italic;
  margin-bottom: 0;
  font-size: 14px;
  letter-spacing: 0.5px;
}

/* Counter Style One  */
.counter-style-1 .count-number {
  font-size: 90px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .counter-style-1 .count-number {
    font-size: 60px;
    margin-bottom: -5px;
    display: block;
  }
}
@media only screen and (max-width: 767px) {
  .counter-style-1 .count-number {
    font-size: 60px;
    margin-bottom: -5px;
    display: block;
  }
}
.counter-style-1 .title {
  font-size: 20px;
  line-height: 1.3em;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 0;
}

.counter-style-2 {
  margin-top: 30px;
}
@media only screen and (max-width: 575px) {
  .counter-style-2 {
    text-align: center !important;
  }
}
.counter-style-2 .count-number {
  font-size: 44px;
  background-color: var(--color-blackest);
  display: inline-block;
  min-width: 150px;
  height: 150px;
  border-radius: 100%;
  text-align: center;
  line-height: 150px;
  margin-bottom: 20px;
  padding: 0 20px;
  font-weight: 500;
  color: var(--color-white);
}
.counter-style-2 .title {
  font-size: 20px;
  line-height: 1.3em;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 10px;
}
.counter-style-2 .description {
  line-height: 1.8;
  padding-right: 16%;
  margin: 0;
}
@media only screen and (max-width: 575px) {
  .counter-style-2 .description {
    padding-right: 0;
  }
}
.counter-style-2.color-variation .count-number {
  background-color: var(--color-primary-darker);
  color: var(--color-primary);
}
.counter-style-2.border-style .count-number {
  background-color: transparent;
  border: 2px solid var(--color-border);
}
.counter-style-2.text-center .description {
  padding: 0 10%;
}

[class*=col]:nth-child(2) .counter-style-2.color-variation .count-number {
  background-color: var(--color-secondary-darker);
  color: var(--color-secondary);
}

[class*=col]:nth-child(3) .counter-style-2.color-variation .count-number {
  background-color: var(--color-light-green-darker);
  color: var(--color-light-green);
}

/*------------------------------
    Counterup Style Four  
-------------------------------*/
.counter-style-4 {
  text-align: left;
  margin-top: 30px;
}
.counter-style-4 .counter-title {
  margin-top: 8px;
  font-weight: 400;
  font-size: 24px;
}
.counter-style-4 .count-number {
  font-size: 35px;
  line-height: 1.2;
  font-weight: 700;
  color: var(--color-primary);
  display: inline-block;
  position: relative;
}
.counter-style-4 .count-number::after {
  content: "+";
}
.counter-style-4 .count-number span {
  display: inline-block;
}

/*---------------------
    Portfolio Styles  
-----------------------*/
.rwt-card {
  overflow: hidden;
}
.rwt-card .inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.rwt-card .inner .thumbnail {
  position: relative;
}
.rwt-card .inner .thumbnail .card-image {
  overflow: hidden;
}
.rwt-card .inner .thumbnail .card-image a {
  display: block;
  overflow: hidden;
}
.rwt-card .inner .thumbnail .card-image img {
  overflow: hidden;
}
.rwt-card .inner .thumbnail .rwt-overlay {
  opacity: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.65s, transform 0.65s;
  transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  background: linear-gradient(0deg, var(--color-primary-rgba) 0.3184713376%, rgba(255, 255, 255, 0.36) 100%);
  color: rgba(255, 255, 255, 0);
  display: block;
}
.rwt-card .inner .content {
  padding-top: 20px;
}
.rwt-card:hover {
  transform: translateY(-4px);
}
.rwt-card:hover .inner .thumbnail .card-image img {
  transform: scale(1.05);
}

/* No Overlay  */
.no-overlay .rwt-card .inner .thumbnail .rwt-overlay {
  display: none;
}

/* Box Grid Layout  */
.filterImage {
  display: flex;
  justify-content: center;
  width: 290px;
  height: 290px;
}

.serviceCard {
  display: flex;
  justify-content: center;
}

.center {
  text-align: center !important;
}

.title2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  color: white !important;
  text-align: center;
  font-weight: bold;
  font-size: 28px;
  text-shadow: 0.02em 0.02em 0 blue, 0 0 0.5em #345085;
}

.img-fluid {
  max-width: 100%;
  height: auto;
  z-index: 0;
}

.box-grid-layout .rwt-card {
  border-radius: var(--radius-small);
  background-color: var(--color-blackest);
}
.box-grid-layout .rwt-card .inner .thumbnail .card-image {
  position: relative;
}
.box-grid-layout .rwt-card .inner .thumbnail .card-image a {
  border-radius: var(--radius-small) var(--radius-small) 0 0;
}
.box-grid-layout .rwt-card .inner .thumbnail .card-image a img {
  border-radius: var(--radius-small) var(--radius-small) 0 0;
}
.box-grid-layout .rwt-card .inner .content {
  padding: 25px;
}
.box-grid-layout .rwt-card .inner .content .title {
  color: var(--color-heading);
}

/*-----------------------------
    Filter Button Style  
-------------------------------*/
.filter-button-default {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.filter-button-default li button {
  border: 0 none;
  padding: 10px 20px;
  text-transform: capitalize;
  background: transparent;
  color: var(--color-body);
  margin: 0 5px;
}
.filter-button-default li button.current, .filter-button-default li button:hover {
  background-color: var(--color-primary);
  color: var(--color-white) !important;
}

/* Portfolio Read More Icon  */
.rwt-load-more a.btn-default.btn-icon .icon,
.rwt-load-more button.btn-default.btn-icon .icon {
  top: -1px;
  margin-left: 4px;
}
.rwt-load-more a.btn-default.btn-icon .icon svg,
.rwt-load-more button.btn-default.btn-icon .icon svg {
  width: 14px;
  height: 20px;
}

/*-----------------------
    Social Icons 
-------------------------*/
.social-default {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  list-style: none;
  justify-content: center;
  margin: -5px;
}
.social-default li {
  margin: 5px;
}
.social-default li a {
  width: 48px;
  background: var(--color-blackest);
  height: 48px;
  text-align: center;
  line-height: 46px;
  display: inline-block;
  border-radius: 100%;
  transition: 0.3s;
  color: var(--color-white);
  z-index: 2;
  position: relative;
}
.social-default li a::after {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: var(--color-primary);
  transform: scale(0.5);
  opacity: 0;
  transition: 0.3s;
  border-radius: 100%;
}
.social-default li a:hover {
  color: var(--color-white);
}
.social-default li a:hover::after {
  transform: scale(1);
  opacity: 1;
}
.social-default.color-lessdark li a {
  background-color: var(--color-lessdark);
}
.social-default.transparent-with-border li a {
  line-height: 45px;
  background: transparent;
  border: 1px solid var(--color-border);
}
.social-default.transparent-with-border li a:hover {
  border-color: transparent;
}
.social-default.transparent-with-border li a::after {
  border: 1px solid var(--color-primary);
}
.social-default.with-gradient li a::after {
  background: linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98%/200% 100%;
}
.social-default.with-bg-primary li a {
  background-color: var(--color-primary) !important;
  border: 2px solid var(--color-primary);
  transition: 0.5s;
  line-height: 44px;
  color: #fff !important;
}
.social-default.with-bg-primary li a::after {
  display: none;
}
.social-default.with-bg-primary li a:hover {
  background-color: transparent;
}
.social-default.icon-naked li a {
  background: transparent !important;
  width: 30px;
  height: 30px;
  line-height: 36px;
}
.social-default.icon-naked li a::after {
  display: none;
}
.social-default.icon-naked li a:hover {
  color: var(--color-primary) !important;
}

/*----------------------
    Team Style  
-------------------------*/
.rn-box-card,
.team-style-default {
  margin-top: 75px;
}
.rn-box-card .inner,
.team-style-default .inner {
  background: linear-gradient(180deg, var(--color-lessdark) 20%, rgba(19, 19, 19, 0.4));
  -webkit-backdrop-filter: blur(4px) opacity(0.95);
  backdrop-filter: blur(4px) opacity(0.95);
  border-radius: var(--radius-big);
}
.rn-box-card .inner .thumbnail,
.team-style-default .inner .thumbnail {
  max-width: 150px;
  max-height: 150px;
  border-radius: 100%;
  border: 6px solid var(--color-lessdark);
  top: -75px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  min-width: 150px;
  min-height: 150px;
  overflow: hidden;
}
.rn-box-card .inner .thumbnail img,
.team-style-default .inner .thumbnail img {
  border-radius: 100%;
}
.rn-box-card .inner .content,
.team-style-default .inner .content {
  text-align: center;
  padding: 20px;
  padding-top: 85px;
  padding-bottom: 35px;
}
.rn-box-card .inner .content .title,
.team-style-default .inner .content .title {
  font-size: 34px;
  line-height: 1.4;
  font-weight: 700;
  margin-bottom: 6px;
}
.rn-box-card .inner .content .subtitle,
.team-style-default .inner .content .subtitle {
  font-size: 20px;
  line-height: 1.4;
  margin-bottom: 15px;
  display: inline-block;
}
.rn-box-card .inner .content .team-form,
.team-style-default .inner .content .team-form {
  display: block;
  font-size: 14px;
  margin-bottom: 12px;
  letter-spacing: 0.6px;
  font-style: italic;
}
.rn-box-card .inner .content .team-form img,
.team-style-default .inner .content .team-form img {
  padding-right: 10px;
  max-height: 18px;
}
.rn-box-card .inner .content .description,
.team-style-default .inner .content .description {
  margin-bottom: 0;
  padding: 0 5%;
}
.rn-box-card .inner .social-icon li a,
.team-style-default .inner .social-icon li a {
  color: var(--color-body);
}
.rn-box-card.border-gradient .thumbnail,
.team-style-default.border-gradient .thumbnail {
  background: linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98%/200% 100%;
  padding: 5px;
  border: 0 none;
}
.rn-box-card.style-two,
.team-style-default.style-two {
  margin-top: 30px;
}
.rn-box-card.style-two .inner,
.team-style-default.style-two .inner {
  padding-top: 35px;
}
.rn-box-card.style-two .inner .thumbnail,
.team-style-default.style-two .inner .thumbnail {
  top: 0;
  position: static;
  left: inherit;
  transform: none;
  min-width: 150px;
  min-height: 150px;
  margin: 0 auto;
}
.rn-box-card.style-two .inner .content,
.team-style-default.style-two .inner .content {
  padding-top: 10px;
}

/*---------------------
    Team Style Two  
-----------------------*/
.team-style-two .inner .thumbnail img {
  width: 100%;
  border-radius: var(--radius);
}
.team-style-two .inner .content {
  padding-top: 20px;
}
.team-style-two .inner .content .title {
  font-size: 28px;
  line-height: 1.4;
  font-weight: 500;
  margin-bottom: 0;
}
.team-style-two .inner .content .subtitle {
  font-size: 18px;
  line-height: 1.4;
  display: inline-block;
  margin-top: 4px;
  margin-bottom: 0;
  opacity: 0;
  transform: translateX(30px);
  transition: transform 0.45s cubic-bezier(0.16, 0.32, 0.26, 0.92), opacity 0.45s ease-out;
  transition-delay: 0.15s;
}
.team-style-two .inner .content .team-form {
  display: block;
  font-size: 14px;
  letter-spacing: 0.6px;
  font-style: italic;
  margin-top: 11px;
}
.team-style-two .inner .content .team-form img {
  padding-right: 10px;
  max-height: 18px;
}
.team-style-two:hover .inner .content .subtitle {
  opacity: 1;
  transform: none;
}

/*---------------------
    Team Style Three  
-----------------------*/
.team-style-three .inner {
  position: relative;
}
.team-style-three .inner .thumbnail img {
  width: 100%;
  border-radius: var(--radius);
}
.team-style-three .inner .content {
  position: absolute;
  bottom: 0;
  padding: 20px;
  width: 100%;
  transition: all 0.3s;
  opacity: 0;
}
.team-style-three .inner .content .team-info {
  padding: 20px;
  background-color: rgba(58, 58, 58, 0.85);
  border-radius: var(--radius-small);
}
.team-style-three .inner .content .title {
  font-size: 17px;
  line-height: 25px;
  color: var(--color-heading);
  margin-bottom: 4px;
}
.team-style-three .inner .content .subtitle {
  font-size: 16px;
  line-height: 25px;
  margin-bottom: 4px;
}
.team-style-three .inner .content .team-form {
  display: block;
  font-style: italic;
  font-size: 14px;
  color: #ADADAD;
  letter-spacing: 0.5px;
}
.team-style-three:hover .inner .content {
  opacity: 1;
}

/* -----------------------
Timeline Area  
--------------------------*/
.timeline-line {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: hsla(0, 0%, 76.9%, 0.22);
}
.timeline-line::before, .timeline-line::after {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
}
.timeline-line::before {
  height: 100%;
  bottom: 0;
  background: linear-gradient(180deg, var(var(--color-blackest)), rgba(19, 19, 19, 0));
}
.timeline-line::after {
  height: 200px;
  top: 0;
  background: linear-gradient(180deg, var(var(--color-blackest)), rgba(19, 19, 19, 0));
}

.timeline-dot {
  position: absolute;
  top: 50%;
  left: 0;
}
.timeline-dot::before, .timeline-dot::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}
.timeline-dot::before {
  z-index: 1;
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 50%;
  background: linear-gradient(180deg, var(--color-primary-light), var(--color-primary));
  box-shadow: 0 0 15px rgba(82, 56, 255, 0.5);
}
.timeline-dot::after {
  border: 5px solid var(var(--color-blackest));
  background: radial-gradient(50% 50% at 50% 50%, var(--color-lessdark) 48.96%, var(--color-lessdark) 100%);
  z-index: 0;
  width: 31px;
  height: 31px;
}
.timeline-dot .time-line-circle {
  position: absolute;
  top: 50%;
  border-radius: 50%;
  left: 50%;
  width: 100px;
  height: 100px;
  background: radial-gradient(50% 50% at 50% 50%, rgba(242, 201, 76, 0) 40.62%, rgba(82, 56, 255, 0.5) 100%);
  transform: translate(-50%, -50%);
  will-change: transform;
  animation: radialanimation 2.2s cubic-bezier(0.26, 1.04, 0.54, 1) infinite;
}

/*------------------------------
    Single Timeline Styles  
-------------------------------*/
.single-timeline {
  position: relative;
  padding-left: 100px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .single-timeline {
    padding-left: 50px;
  }
}
@media only screen and (max-width: 767px) {
  .single-timeline {
    padding-left: 30px;
  }
}
.single-timeline .single-content {
  background: linear-gradient(180deg, var(--color-lessdark) 20%, rgba(19, 19, 19, 0.4));
  -webkit-backdrop-filter: blur(4px) opacity(0.95);
  backdrop-filter: blur(4px) opacity(0.95);
  border-radius: var(--radius-big);
}
.single-timeline .single-content .inner {
  padding: 50px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .single-timeline .single-content .inner {
    padding: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .single-timeline .single-content .inner {
    padding: 20px;
  }
}
.single-timeline .single-content .inner .content .date-of-timeline {
  color: var(--color-body);
  display: block;
  margin-bottom: 30px;
  letter-spacing: 0.5px;
  font-style: italic;
  font-size: 14px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .single-timeline .single-content .inner .content .date-of-timeline {
    margin-bottom: 14px;
  }
}
@media only screen and (max-width: 767px) {
  .single-timeline .single-content .inner .content .date-of-timeline {
    margin-bottom: 14px;
  }
}
.single-timeline .single-content .inner .content .title {
  margin-bottom: 0;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .single-timeline .single-content .inner .content .title {
    font-size: 32px;
  }
}
.single-timeline .single-content .inner .content .description {
  margin-top: 30px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .single-timeline .single-content .inner .content .description {
    margin-top: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .single-timeline .single-content .inner .content .description {
    margin-top: 15px;
  }
}
.single-timeline .single-content .thumbnail img {
  border-radius: var(--radius);
}
@keyframes radialanimation {
  0% {
    opacity: 1;
    transform: translate3d(-50%, -50%, 0) scale(0.1);
  }
  to {
    opacity: 0;
    transform: translate3d(-50%, -50%, 0) scale(1);
  }
}
/*----------------------------
    Timeline Style Two  
----------------------------*/
.timeline-style-two {
  position: relative;
  padding: 20px 50px 50px 50px;
  border-radius: var(--radius-big);
}

.rn-timeline-single {
  margin-top: 30px;
}
.rn-timeline-single .rn-timeline {
  text-align: center;
}
.rn-timeline-single .rn-timeline .progress-line {
  position: relative;
  border-radius: 0px;
  height: 6px;
  box-shadow: none;
  margin: 20px 0;
  width: 100%;
}
.rn-timeline-single .rn-timeline .progress-line .line-inner {
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  transition: width 0.6s ease;
  background-image: radial-gradient(circle farthest-corner at 0%, var(--color-pink) 25%, var(--color-secondary) 45%, var(--color-primary-light) 65%, var(--color-light-green) 85%);
  background-attachment: fixed;
  background-repeat: repeat-y;
  width: 100%;
  display: flex;
  height: 100%;
}
@media only screen and (max-width: 767px) {
  .rn-timeline-single .rn-timeline .progress-line .line-inner {
    display: none;
  }
}
.rn-timeline-single .rn-timeline .progress-dot {
  position: relative;
  height: 30px;
  display: block;
  width: 100%;
  margin-top: -39px;
  margin-left: -15px;
}
.rn-timeline-single .rn-timeline .progress-dot .dot-level {
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  background: linear-gradient(to right, var(--color-primary), var(--color-secondary), var(--color-primary-light));
  background-attachment: fixed;
  background-repeat: repeat-y;
  position: absolute;
  width: 28px;
  height: 28px;
  display: block;
  display: inline-block;
  text-align: center;
  border-radius: 50%;
}
.rn-timeline-single .rn-timeline .progress-dot .dot-level .dot-inner {
  width: 12px;
  height: 12px;
  border-radius: 50px;
  position: absolute;
  top: 8px;
  left: 8px;
  background-color: var(--color-darkest);
}
.rn-timeline-single:first-child .rn-timeline .progress-line {
  width: 50%;
  left: 50%;
}
.rn-timeline-single:last-child .rn-timeline .progress-line {
  width: 50%;
}
.rn-timeline-single .title {
  margin-bottom: 33px;
  font-size: 20px;
}
.rn-timeline-single .description {
  padding: 0 10%;
  margin-top: 15px;
  margin-bottom: 0;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-timeline-single .description {
    padding: 0 10px;
  }
}
@media only screen and (max-width: 767px) {
  .rn-timeline-single .description {
    padding: 0 10px;
  }
}
.rn-timeline-single.no-gradient .rn-timeline .progress-line .line-inner {
  background-image: inherit;
  background: var(--color-primary);
}
.rn-timeline-single.no-gradient .rn-timeline .progress-dot .dot-level {
  background-image: inherit;
  background: var(--color-primary);
}
.rn-timeline-single.dark-line .rn-timeline .progress-line .line-inner {
  background-image: inherit;
  background: var(--color-lessdark);
}
.rn-timeline-single.dark-line .rn-timeline .progress-dot .dot-level {
  background-image: inherit;
  background: var(--color-lessdark);
}
.rn-timeline-single.dark-line .rn-timeline .progress-dot .dot-level .dot-inner {
  background-color: var(--color-primary);
}

/*-------------------------
    Testimonial Styles  
--------------------------*/
.card-style-default.testimonial-style-one .inner .thumbnail {
  overflow: visible;
}
.card-style-default.testimonial-style-one .inner .thumbnail::after {
  position: absolute;
  content: "”";
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background: var(--color-blackest);
  right: 0;
  top: 0;
  color: #fff;
  z-index: 2;
  text-align: center;
  line-height: 58px;
  font-size: 39px;
}
.card-style-default.testimonial-style-one .inner .content .description {
  margin-bottom: 14px;
}
.card-style-default.testimonial-style-one .inner .content .title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 2px;
  letter-spacing: 0.5px;
}
.card-style-default.testimonial-style-one .inner .content .subtitle {
  font-size: 16px;
  line-height: 1.2;
  margin-bottom: 0;
  letter-spacing: 0.5px;
}
.card-style-default.testimonial-style-one.style-two .inner .thumbnail {
  position: relative;
}
.card-style-default.testimonial-style-one.style-two .inner .description {
  margin-bottom: 19px;
  margin-top: 20px;
}

/*-----------------------------
    Testimonial Style Two  
-------------------------------*/
.testimonial-style-two .content {
  position: relative;
  z-index: 2;
}
.testimonial-style-two .content::after {
  position: absolute;
  content: "“";
  left: -20px;
  color: var(--color-lessdark);
  text-align: center;
  font-size: 320px;
  opacity: 0.7;
  line-height: 50px;
  top: 52px;
  z-index: -1;
}
.testimonial-style-two .content .form {
  display: block;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
}
.testimonial-style-two .content .description {
  line-height: 1.5;
  margin-bottom: 30px;
  font-size: 32px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .testimonial-style-two .content .description {
    margin-bottom: 25px;
    font-size: 24px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .testimonial-style-two .content .description {
    font-size: 24px;
  }
}
@media only screen and (max-width: 767px) {
  .testimonial-style-two .content .description {
    font-size: 24px;
  }
}
.testimonial-style-two .content .client-info .title {
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 8px;
}
.testimonial-style-two .content .client-info .subtitle {
  font-size: 16px;
  margin-bottom: 0;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: var(--color-body);
  font-style: italic;
}
.testimonial-style-two .thumbnail {
  background: linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98%/200% 100%;
  border-radius: 100%;
  padding: 10px;
}
.testimonial-style-two .thumbnail img {
  border-radius: 100%;
}

/*--------------------------
    Slick Slider Styles   
----------------------------*/
.slick-initialized .slick-slide {
  margin-bottom: 0;
}

/*----------------------
    Slick Dots  
------------------------*/
.rn-slick-dot .slick-dots {
  bottom: -60px;
}
@media only screen and (max-width: 575px) {
  .rn-slick-dot .slick-dots {
    bottom: -50px;
  }
}
.rn-slick-dot .slick-dots li {
  width: 30px;
  margin: 0;
  opacity: 1;
  position: relative;
}
.rn-slick-dot .slick-dots li button::before {
  display: none;
}
.rn-slick-dot .slick-dots li button::after {
  background: var(--color-lessdark);
  width: 100%;
  display: block;
  content: "";
  position: absolute;
  left: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-left: 11px;
  background-color: transparent;
  box-shadow: inset 0 0 0 5px var(--color-lessdark);
}
.rn-slick-dot .slick-dots li.slick-active {
  opacity: 1;
}
.rn-slick-dot .slick-dots li.slick-active button::after {
  transform: scale(2);
  box-shadow: inset 0 0 0 1px var(--color-primary);
  background-color: transparent;
  background-color: transparent !important;
}
.rn-slick-dot.dot-light .slick-dots li button::after {
  background: #ffffff;
  box-shadow: inset 0 0 0 5px #ffffff;
}
.rn-slick-dot.dot-light .slick-dots li.slick-active {
  opacity: 1;
}
.rn-slick-dot.dot-light .slick-dots li.slick-active button::after {
  transform: scale(2);
  box-shadow: inset 0 0 0 1px var(--color-primary);
  background-color: transparent;
  background-color: transparent !important;
}

/*----------------------
    Slick Arrow  
------------------------*/
.rn-slick-arrow {
  position: relative;
}
.rn-slick-arrow button.slick-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  transition: 0.5s;
  opacity: 0;
  width: 68px;
  height: 68px;
  border: 2px solid var(--color-border);
  border-radius: 100%;
  color: var(--color-border);
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-slick-arrow button.slick-arrow {
    display: none !important;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .rn-slick-arrow button.slick-arrow {
    display: none !important;
  }
}
@media only screen and (max-width: 767px) {
  .rn-slick-arrow button.slick-arrow {
    display: none !important;
  }
}
.rn-slick-arrow button.slick-arrow:hover {
  background: var(--color-primary);
  border-color: var(--color-primary);
}
.rn-slick-arrow button.slick-arrow::before {
  line-height: 1;
  opacity: 0.4;
  position: relative;
  top: -2px;
  transition: 0.5s;
  z-index: 2;
}
.rn-slick-arrow button.slick-arrow.slick-prev {
  left: 15px;
}
.rn-slick-arrow button.slick-arrow.slick-prev::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.rn-slick-arrow button.slick-arrow.slick-prev:hover {
  left: 10px;
}
.rn-slick-arrow button.slick-arrow.slick-prev:hover::before {
  opacity: 1;
}
.rn-slick-arrow button.slick-arrow.slick-next {
  left: auto;
  right: 15px;
}
.rn-slick-arrow button.slick-arrow.slick-next::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.rn-slick-arrow button.slick-arrow.slick-next:hover {
  right: 10px;
}
.rn-slick-arrow button.slick-arrow.slick-next:hover::before {
  opacity: 1;
}
.rn-slick-arrow:hover button.slick-arrow {
  opacity: 1;
}

/* Slick Gutter Space  */
.slick-space-gutter--15 {
  margin-left: -15px;
  margin-right: -15px;
}
.slick-space-gutter--15 .slick-slide {
  padding-left: 15px;
  padding-right: 15px;
}
.slick-space-gutter--15 .testimonial-style-two {
  margin: 40px 0;
}

.slickdot--20 .slick-dots {
  bottom: -20px;
}

/*---------------------
    Tab Styles  
-----------------------*/
.rn-default-tab .tab-button {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
}
.rn-default-tab .tab-button .react-tabs__tab {
  padding: 20px 44px;
  margin: 0;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .rn-default-tab .tab-button .react-tabs__tab {
    padding: 20px 24px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-default-tab .tab-button .react-tabs__tab {
    padding: 20px 24px;
  }
}
@media only screen and (max-width: 767px) {
  .rn-default-tab .tab-button .react-tabs__tab {
    padding: 20px 24px;
  }
}
.rn-default-tab .tab-button .react-tabs__tab.react-tabs__tab--selected {
  background: var(--color-lessdark);
}
.rn-default-tab .tab-button .rn-tab-button button {
  padding: 0;
  margin: 0;
  background: transparent;
  border: 0 none;
  color: var(--color-white);
}
.rn-default-tab .rn-tab-content {
  background: var(--color-lessdark);
  padding: 40px 40px;
}
@media only screen and (max-width: 767px) {
  .rn-default-tab .rn-tab-content {
    padding: 30px;
  }
}
.rn-default-tab .rn-tab-content p:last-child {
  margin-bottom: 0;
}
.rn-default-tab.style-two .tab-button {
  margin-bottom: 30px;
}
.rn-default-tab.style-two .tab-button .react-tabs__tab {
  border-radius: var(--radius-small);
}
.rn-default-tab.style-two .rn-tab-content {
  border-radius: var(--radius-small);
}

.rn-pricing {
  margin-top: 40px;
}
.rn-pricing .pricing-table-inner {
  padding: 40px;
  position: relative;
  z-index: 2;
  border: 2px solid var(--color-border);
  border-radius: 5px;
  transition: all 0.6s cubic-bezier(0.33, 0.84, 0.31, 0.98);
  transform-style: preserve-3d;
}
.rn-pricing .pricing-table-inner::before {
  z-index: -1;
  display: inline-block;
  content: "";
  transition: all 0.6s cubic-bezier(0.33, 0.84, 0.31, 0.98);
  opacity: 0;
  border-radius: 5px;
  position: absolute;
  top: -2px;
  right: -2px;
  bottom: -2px;
  left: -2px;
  background-color: var(--color-lessdark);
}
.rn-pricing .pricing-table-inner .pricing-header {
  margin-bottom: 30px;
  padding-bottom: 30px;
  text-align: center;
  border-bottom: 2px solid var(--color-border);
}
.rn-pricing .pricing-table-inner .pricing-header .title {
  margin-bottom: 20px;
}
.rn-pricing .pricing-table-inner .pricing-header .price-wrapper {
  display: flex;
  justify-content: center;
}
.rn-pricing .pricing-table-inner .pricing-header .pricing span {
  display: block;
}
.rn-pricing .pricing-table-inner .pricing-header .pricing span.currency {
  font-size: 28px;
  position: relative;
  top: -3px;
  left: -2px;
  opacity: 0.3;
}
.rn-pricing .pricing-table-inner .pricing-header .pricing span.price {
  font-size: 77px;
  color: var(--color-white);
  line-height: 1;
  font-weight: 700;
  margin-bottom: 10px;
}
@media only screen and (max-width: 767px) {
  .rn-pricing .pricing-table-inner .pricing-header .pricing span.price {
    font-size: 54px;
  }
}
.rn-pricing .pricing-table-inner .pricing-header .pricing span.subtitle {
  font-size: 14px;
  color: var(--color-body);
}
.rn-pricing .pricing-table-inner .pricing-body {
  text-align: center;
  margin-bottom: 48px;
}
.rn-pricing .pricing-table-inner .pricing-body .list-style--1 {
  list-style: none;
  padding: 0;
  margin: 0;
}
.rn-pricing .pricing-table-inner .pricing-footer {
  text-align: center;
}
.rn-pricing.style-2 .pricing-table-inner {
  background-color: var(--color-blackest);
  border-color: transparent !important;
}
.rn-pricing.style-4 {
  margin-left: -1px;
  margin-right: -1px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-pricing.style-4 {
    margin-left: 15px;
    margin-right: 15px;
  }
}
@media only screen and (max-width: 767px) {
  .rn-pricing.style-4 {
    margin-left: 15px;
    margin-right: 15px;
  }
}
.rn-pricing.active .pricing-table-inner {
  border-color: transparent !important;
}
.rn-pricing.active .pricing-table-inner::before {
  transform: scaleY(1.12);
  opacity: 1;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-pricing.active .pricing-table-inner::before {
    transform: scaleY(1);
  }
}
@media only screen and (max-width: 767px) {
  .rn-pricing.active .pricing-table-inner::before {
    transform: scaleY(1);
  }
}
.rn-pricing.active .pricing-table-inner .pricing-header {
  border-bottom: 2px solid var(--color-border);
}
.rn-pricing.active .pricing-table-inner .pricing-header .title {
  color: var(--color-white);
}
.rn-pricing.active .pricing-table-inner .pricing-header .pricing span {
  display: block;
}
.rn-pricing.active .pricing-table-inner .pricing-header .pricing span.currency {
  color: var(--color-white);
  opacity: 1;
}
.rn-pricing.active .pricing-table-inner .pricing-header .pricing span.price {
  color: var(--color-white);
}
.rn-pricing.active .pricing-table-inner .pricing-header .pricing span.subtitle {
  color: var(--color-white);
}
.rn-pricing.active .pricing-table-inner .pricing-body ul.list-style--1 li {
  color: var(--color-white);
}
.rn-pricing.active .pricing-table-inner .pricing-body ul.list-style--1 li svg {
  color: var(--color-white);
}
.rn-pricing.active .pricing-table-inner .pricing-footer {
  text-align: center;
}
.rn-pricing.style-5 .pricing-table-inner {
  background-color: var(--color-blackest);
  border-color: transparent;
  padding: 0;
  padding-bottom: 40px;
  border: 0 none;
}
.rn-pricing.style-5 .pricing-table-inner::before {
  display: none;
}
.rn-pricing.style-5 .pricing-table-inner .pricing-header {
  margin-bottom: 30px;
  padding-bottom: 0;
  border-bottom: 0 none !important;
}
.rn-pricing.style-5 .pricing-table-inner .pricing-header .title {
  padding: 30px 40px;
  margin-bottom: 0;
  font-size: 19px;
  font-weight: 500;
  letter-spacing: 0.5px;
}
.rn-pricing.style-5 .pricing-table-inner .pricing-header .price-wrapper {
  margin-bottom: 5px;
}
.rn-pricing.style-5 .pricing-table-inner .pricing-header .pricing span.currency {
  font-size: 40px;
  position: relative;
  top: 0px;
  left: 0;
  opacity: 1;
  color: var(--color-white);
  font-weight: 700;
  line-height: 7px;
  display: flex;
  align-items: center;
}
.rn-pricing.style-5 .pricing-table-inner .pricing-header .pricing span.price {
  font-size: 50px;
  color: var(--color-white);
  line-height: 1;
  font-weight: 700;
  margin-bottom: 0;
}
.rn-pricing.style-5 .pricing-table-inner .pricing-header .pricing span.subtitle {
  color: var(--color-white);
}
.rn-pricing.style-5 .pricing-table-inner .pricing {
  background-color: var(--color-lessdark);
  padding: 30px;
}

/*--------------------------
    split Area Styles  
----------------------------*/
.slider_img {
  width: 150px !important;
  filter: brightness(0) invert(1) grayscale(100%) contrast(8);
}

.slider-container-logo {
  margin-bottom: 90px;
}

.rn-splite-style .thumbnail img {
  border-radius: 0;
  width: 100%;
}
.rn-splite-style .thumbnail.image-left-content img {
  border-radius: 0 10px 10px 0;
}
.rn-splite-style .split-inner {
  padding: 30px 115px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .rn-splite-style .split-inner {
    padding: 40px 80px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-splite-style .split-inner {
    padding: 40px 30px;
  }
}
@media only screen and (max-width: 767px) {
  .rn-splite-style .split-inner {
    padding: 40px 30px;
  }
}
.rn-splite-style .split-inner .title {
  font-size: 36px;
  line-height: 50px;
  color: var(--color-heading);
  font-weight: var(--p-bold);
}
@media only screen and (max-width: 767px) {
  .rn-splite-style .split-inner .title {
    font-size: 24px;
    line-height: 30px;
  }
}
.rn-splite-style .split-inner .split-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
  column-gap: 20px;
}
.rn-splite-style .split-inner .split-list li {
  color: white;
  display: flex;
  align-items: center;
}
.rn-splite-style .split-inner .split-list li .split-icon {
  margin-right: 20px;
}

.no-radius .rn-splite-style .thumbnail.image-left-content img {
  border-radius: 0;
}

/*--------------------------------
    Call To Action Style  
--------------------------------*/
.clltoaction-style-default {
  padding: 250px 0;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .clltoaction-style-default {
    padding: 150px 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .clltoaction-style-default {
    padding: 150px 0;
  }
}
@media only screen and (max-width: 767px) {
  .clltoaction-style-default {
    padding: 150px 0;
  }
}
.clltoaction-style-default .title {
  font-size: 52px;
  font-weight: 600;
  position: relative;
  margin-bottom: 30px;
  padding-bottom: 0;
  line-height: 1.4;
  color: var(--color-white);
}
.clltoaction-style-default .inner p {
  color: var(--color-body);
}
.clltoaction-style-default .subtitle {
  color: #fff;
  font-size: 24px;
  line-height: 1.4;
  margin: 0;
  font-weight: 400;
  letter-spacing: 0.5px;
}
.clltoaction-style-default .call-to-btn {
  margin-top: 50px;
}
.clltoaction-style-default .content.text-start .title::before {
  left: 0;
  transform: none;
}
.clltoaction-style-default .content.text-start .subtitle {
  padding: 0 16% 0 0;
}
.clltoaction-style-default.style-2 {
  padding: 130px 0;
}
.clltoaction-style-default.style-3 {
  padding: 150px 0;
}
.clltoaction-style-default.style-3 .content-wrapper {
  background-color: var(--color-lessdark);
  border-radius: var(--radius);
  padding: 50px 40px;
}
.clltoaction-style-default.style-3 .content .title {
  font-size: 32px;
  margin-bottom: 18px;
  padding-bottom: 10px;
}
.clltoaction-style-default.style-3 .content .subtitle {
  font-size: 16px;
  line-height: 1.4;
  letter-spacing: 0.5px;
}
.clltoaction-style-default.style-3 .call-to-btn {
  margin-top: 0;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .clltoaction-style-default.style-3 .call-to-btn {
    margin-top: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .clltoaction-style-default.style-3 .call-to-btn {
    margin-top: 20px;
  }
}
.clltoaction-style-default.style-4 {
  padding: 0;
}
.clltoaction-style-default.style-4 .content-wrapper {
  background-color: var(--color-lessdark);
  border-radius: var(--radius);
  padding: 70px 50px;
}
.clltoaction-style-default.style-4 .content .title {
  font-size: 47px;
  margin-bottom: 33px;
  padding-bottom: 16px;
  line-height: 1.4;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .clltoaction-style-default.style-4 .content .title {
    margin-bottom: 0px;
  }
}
@media only screen and (max-width: 767px) {
  .clltoaction-style-default.style-4 .content .title {
    font-size: 39px;
    margin-bottom: 1px;
  }
}
.clltoaction-style-default.style-4 .content .subtitle {
  font-size: 16px;
  line-height: 1.4;
  letter-spacing: 0.5px;
}
.clltoaction-style-default.style-4 .call-to-btn {
  margin-top: 0;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .clltoaction-style-default.style-4 .call-to-btn {
    margin-top: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .clltoaction-style-default.style-4 .call-to-btn {
    margin-top: 20px;
  }
}
.clltoaction-style-default.style-5 {
  padding: 0;
}
.clltoaction-style-default.style-5 .content-wrapper {
  background-color: var(--color-blackest);
  border-radius: var(--radius);
  padding: 70px 50px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .clltoaction-style-default.style-5 .content-wrapper {
    padding: 40px 20px;
  }
}
@media only screen and (max-width: 767px) {
  .clltoaction-style-default.style-5 .content-wrapper {
    padding: 40px 20px;
  }
}
.clltoaction-style-default.style-5 .content .title {
  font-size: 47px;
  margin-bottom: 20px;
  padding-bottom: 0;
  line-height: 1.4;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .clltoaction-style-default.style-5 .content .title {
    font-size: 38px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .clltoaction-style-default.style-5 .content .title {
    font-size: 34px;
  }
}
@media only screen and (max-width: 767px) {
  .clltoaction-style-default.style-5 .content .title {
    font-size: 34px;
  }
}
@media only screen and (max-width: 575px) {
  .clltoaction-style-default.style-5 .content .title {
    font-size: 26px;
  }
}
.clltoaction-style-default.style-5 .content .title::before {
  display: none;
}
.clltoaction-style-default.style-5 .content .subtitle {
  font-size: 16px;
  line-height: 1.4;
  letter-spacing: 0.5px;
}
.clltoaction-style-default.style-5 .call-to-btn {
  margin-top: 30px;
}
.clltoaction-style-default.style-6 {
  padding: 80px 0;
}
.clltoaction-style-default.style-6 .content .title {
  font-size: 36px;
  margin-bottom: 0;
  padding-bottom: 0;
  line-height: 1.4;
}
.clltoaction-style-default.style-6 .content .title::before {
  display: none;
}
.clltoaction-style-default.style-6 .call-to-btn {
  margin-top: 0;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .clltoaction-style-default.style-6 .call-to-btn {
    margin-top: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .clltoaction-style-default.style-6 .call-to-btn {
    margin-top: 20px;
  }
}
.clltoaction-style-default.style-7 {
  padding: 0;
}
.clltoaction-style-default.style-7 .content-wrapper {
  padding: 40px 0;
  border-bottom: 1px solid var(--color-border);
}
.clltoaction-style-default.style-7 .content .subtitle {
  font-size: 16px;
  color: var(--color-body);
  max-width: 450px;
  line-height: 30px;
  margin-bottom: 0;
  margin-top: 13px;
  padding: 0;
}
.clltoaction-style-default.style-7 .call-to-btn {
  margin-top: 0;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .clltoaction-style-default.style-7 .call-to-btn {
    margin-top: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .clltoaction-style-default.style-7 .call-to-btn {
    margin-top: 20px;
  }
}

.rn-call-to-action.style-8 {
  padding: 100px 0;
  background: var(--color-blackest);
}
.rn-call-to-action.style-8 .content-wrapper {
  padding: 40px 0;
  border-bottom: 1px solid var(--color-border);
}
.rn-call-to-action.style-8 .title {
  color: var(--color-white);
}
.rn-call-to-action.style-8 .content .subtitle {
  font-size: 20px;
  color: var(--color-body);
  line-height: 1.5;
  margin-bottom: 0;
}
.rn-call-to-action.style-8 .call-to-btn {
  margin-top: 0;
}

.theme-shape {
  position: relative;
  z-index: 2;
  overflow: hidden;
}
.theme-shape::before {
  position: absolute;
  left: -250px;
  top: 250px;
  right: auto;
  bottom: auto;
  z-index: -1;
  width: 500px;
  height: 500px;
  border-radius: 1000px;
  background-image: linear-gradient(45deg, var(--color-primary), var(--color-light-green));
  opacity: 0.2;
  filter: blur(100px);
  content: "";
}
.theme-shape::after {
  position: absolute;
  z-index: -1;
  width: 500px;
  height: 500px;
  border-radius: 1000px;
  opacity: 0.2;
  filter: blur(100px);
  content: "";
  left: auto;
  top: -250px;
  right: -250px;
  bottom: auto;
  background-image: linear-gradient(45deg, var(--color-secondary), var(--color-tertiary));
}

/*----------------------------
    Video Popup Styles  
------------------------------*/
.video-popup,
.rn-gallery {
  position: relative;
  display: block;
}
.video-popup .thumbnail img,
.rn-gallery .thumbnail img {
  width: 100%;
}
.video-popup .video-icon,
.rn-gallery .video-icon {
  position: absolute;
  content: "";
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 10px;
  transition: 0.4s;
}

.rn-gallery .video-icon {
  opacity: 0;
  transition: 0.4s;
  transform: translate(-50%, -50%) scale(0.5);
}
.rn-gallery:hover .video-icon {
  opacity: 1;
  margin-top: 0;
  transform: translate(-50%, -50%) scale(1);
}

.video-gallery-content {
  border-radius: 10px;
  padding-top: 300px;
  padding-bottom: 60px;
  overflow: hidden;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .video-gallery-content {
    padding-bottom: 40px;
    padding-top: 150px;
  }
}
@media only screen and (max-width: 767px) {
  .video-gallery-content {
    padding-bottom: 40px;
    padding-top: 150px;
  }
}
.video-gallery-content .overlay-content {
  padding: 0 60px;
}
@media only screen and (max-width: 767px) {
  .video-gallery-content .overlay-content {
    padding: 0 20px;
  }
}
.video-gallery-content .overlay-content .title {
  margin-top: 15px;
  margin-bottom: 0;
  font-size: 30px;
  letter-spacing: 0.5px;
  line-height: 1.4;
  color: var(--color-white);
}
@media only screen and (max-width: 767px) {
  .video-gallery-content .overlay-content .title {
    font-size: 20px;
  }
}

/*==========================
    Contact Address 
============================*/
.contact-form-1 .form-group input {
  height: 70px;
  padding: 0 20px;
}
.contact-form-1 .form-group textarea {
  padding-top: 20px;
  padding-left: 20px;
}

.contact-address-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

/*-------------------
    Address Area  
--------------------*/
.rn-address {
  margin-top: 30px;
  padding: 40px;
  border-radius: 10px;
  padding-top: 40px;
  background: var(--color-blackest);
  padding-bottom: 50px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  transition: 0.3s;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .rn-address {
    padding: 30px 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-address {
    padding: 30px 20px;
  }
}
@media only screen and (max-width: 767px) {
  .rn-address {
    padding: 30px 20px;
  }
}
.rn-address .icon {
  color: var(--color-primary);
  border-radius: 100%;
  font-size: 40px;
  display: inline-block;
  margin-bottom: 17px;
  line-height: 6px;
}
.rn-address .inner h4.title {
  font-size: 18px;
  font-weight: 700;
}
.rn-address .inner p {
  font-size: 18px;
  margin-bottom: 0;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .rn-address .inner p {
    font-size: 16px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-address .inner p {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767px) {
  .rn-address .inner p {
    font-size: 16px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .rn-address .inner p br {
    display: none;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-address .inner p br {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .rn-address .inner p br {
    display: none;
  }
}
.rn-address .inner p a {
  color: var(--color-body);
}
.rn-address .inner p a:hover {
  color: var(--color-primary);
}
.rn-address:hover {
  transform: translateY(-5px);
}

.google-map-style-1 {
  width: 100%;
  height: 550px;
  border-radius: 10px;
}
.google-map-style-1 div {
  border-radius: 10px;
}

.success-message {
  color: green;
  margin-top: 20px;
  font-size: 16px;
}

.brand-style-1 {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.brand-style-1 li {
  flex-basis: 25%;
  border-width: 1px 1px 1px 1px;
  border-style: solid;
  margin: 0px 0px -2px -2px;
  border-color: var(--color-border);
  padding: 40px 0 40px 0;
  text-align: center;
}
@media only screen and (max-width: 575px) {
  .brand-style-1 li {
    flex-basis: 33.33%;
  }
}
@media only screen and (max-width: 479px) {
  .brand-style-1 li {
    flex-basis: 50%;
  }
}
.brand-style-1 li a {
  display: block;
}
.brand-style-1 li a img {
  opacity: 0.8;
  transition: 0.3s;
}
.brand-style-1 li:hover a img {
  opacity: 1;
}

.brand-style-2 {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.brand-style-2 li {
  flex-basis: 16.666%;
  text-align: center;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .brand-style-2 li {
    flex-basis: 25%;
  }
}
@media only screen and (max-width: 767px) {
  .brand-style-2 li {
    flex-basis: 25%;
  }
}
@media only screen and (max-width: 575px) {
  .brand-style-2 li {
    flex-basis: 33.33%;
  }
}
@media only screen and (max-width: 479px) {
  .brand-style-2 li {
    flex-basis: 50%;
  }
}
.brand-style-2 li a {
  pointer-events: none;
  cursor: default;
  display: block;
}
.brand-style-2 li a img {
  opacity: 1;
  transition: 0.3s;
  width: 145px;
}
.brand-style-2 li:hover a img {
  opacity: 0.8;
}
.brand-style-2.variation-2 li {
  flex-basis: 25%;
  text-align: center;
}
@media only screen and (max-width: 767px) {
  .brand-style-2.variation-2 li {
    flex-basis: 33.33%;
  }
}
@media only screen and (max-width: 479px) {
  .brand-style-2.variation-2 li {
    flex-basis: 50%;
  }
}

/*---------------------------
    Newsletter Styles  
----------------------------*/
.border-top-bottom {
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
}

.newsletter-area .border-top-bottom {
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
}

.rn-newsletter-default .newsletter-wrapper {
  padding: 40px 0;
}
.rn-newsletter-default .newsletter-section-title .title {
  color: var(--color-body);
  margin-bottom: 7px;
}
.rn-newsletter-default .newsletter-section-title .description {
  color: var(--color-body);
  margin-bottom: 0;
}
.rn-newsletter-default .rn-newsletter {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0 -10px;
}
@media only screen and (max-width: 575px) {
  .rn-newsletter-default .rn-newsletter {
    display: block;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-newsletter-default .rn-newsletter {
    justify-content: flex-start;
  }
}
@media only screen and (max-width: 767px) {
  .rn-newsletter-default .rn-newsletter {
    justify-content: flex-start;
  }
}
.rn-newsletter-default .rn-newsletter .form-group {
  margin-bottom: 0;
  margin: 0 10px;
}
.rn-newsletter-default .rn-newsletter .form-group input {
  height: 55px;
  padding: 0 24px;
  min-width: 500px;
  background: var(--color-blackest);
  border: 0 none;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .rn-newsletter-default .rn-newsletter .form-group input {
    min-width: 400px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rn-newsletter-default .rn-newsletter .form-group input {
    min-width: 400px;
  }
}
@media only screen and (max-width: 767px) {
  .rn-newsletter-default .rn-newsletter .form-group input {
    min-width: 350px;
  }
}
@media only screen and (max-width: 575px) {
  .rn-newsletter-default .rn-newsletter .form-group input {
    min-width: 100%;
    margin-bottom: 20px;
  }
}
.rn-newsletter-default .rn-newsletter .form-group .btn-default {
  height: 55px;
}

.advance-tab-button-1 .tab-button-list {
  list-style: none;
  padding: 0;
  margin: -10px 0;
}
.advance-tab-button-1 .tab-button-list li {
  margin: 10px 0;
}
.advance-tab-button-1 .tab-button-list .tab-button {
  cursor: pointer;
  padding: 47px 27px;
  border-radius: 10px;
  position: relative;
  z-index: 2;
}
.advance-tab-button-1 .tab-button-list .tab-button::before {
  position: absolute;
  content: "";
  background: var(--color-blackest);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  transition: 0.3s;
  opacity: 0;
  transform: scale(0.9);
  z-index: -1;
  border-radius: 10px;
}
.advance-tab-button-1 .tab-button-list .tab-button:hover::before {
  opacity: 1;
  transform: scale(1);
}
.advance-tab-button-1 .tab-button-list .tab-button::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 100%;
  border-left: 20px solid var(--color-blackest);
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  margin-top: -20px;
  opacity: 0;
  transition: 0.3s;
  transform: scale(0.9);
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .advance-tab-button-1 .tab-button-list .tab-button::after {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .advance-tab-button-1 .tab-button-list .tab-button::after {
    display: none;
  }
}
.advance-tab-button-1 .tab-button-list .tab-button .title {
  color: var(--color-body);
  font-size: 20px;
  margin-bottom: 10px;
}
.advance-tab-button-1 .tab-button-list .tab-button .description {
  margin-bottom: 0;
}
.advance-tab-button-1 .tab-button-list .react-tabs__tab--selected .tab-button .title {
  color: var(--color-white);
}
.advance-tab-button-1 .tab-button-list .react-tabs__tab--selected .tab-button::before {
  opacity: 1;
  transform: scale(1);
}
.advance-tab-button-1 .tab-button-list .react-tabs__tab--selected .tab-button::after {
  opacity: 1;
  transform: scale(1);
}

.advance-tab-content-1 .thumbnail img {
  border-radius: 10px;
}

.advance-tab-button-1.right-align .tab-button-list .tab-button::after {
  transform: scale(0.9) rotate(-180deg);
  left: auto;
  right: 100%;
}

.advance-tab-button-1.right-align .tab-button-list .react-tabs__tab--selected .tab-button::after {
  transform: scale(1) rotate(-180deg);
}

.advance-tab-button-1.right-top .tab-button-list .tab-button::after {
  left: 50%;
  transform: scale(0.9) translateX(-50%) rotate(45deg);
  bottom: 94%;
  top: auto;
}

.advance-tab-button-1.right-top .tab-button-list .react-tabs__tab--selected .tab-button::after {
  opacity: 1;
  transform: scale(1) translateX(-50%) rotate(-90deg);
}

/*----------------------------
    Advance Pricing Table  
------------------------------*/
.advance-pricing {
  background: var(--color-blackest);
  border-radius: 10px;
}
.advance-pricing .pricing-left {
  height: 100%;
  background: var(--color-lessdark);
  padding: 60px 50px;
  border-radius: 10px 0 0 10px;
}
.advance-pricing .pricing-left .main-title {
  margin-bottom: 10px;
}
.advance-pricing .pricing-left .price-wrapper .price-amount {
  font-size: 60px;
  text-align: center;
  display: block;
  color: var(--color-white);
  font-weight: 700;
}
.advance-pricing .pricing-left .price-wrapper .price-amount sup {
  font-size: 16px;
  top: -34px;
}
.advance-pricing .pricing-left .btn-default {
  width: 100%;
  margin: 10px 0;
}
.advance-pricing .pricing-left .rating {
  text-align: center;
  margin-top: 5px;
}
.advance-pricing .pricing-left .rating a {
  font-weight: 700;
  color: #f1b304;
}
.advance-pricing .pricing-left .rating a svg {
  fill: #f1b304;
}
.advance-pricing .pricing-left .subtitle {
  display: block;
  color: var(--color-body);
  text-align: center;
}
.advance-pricing .pricing-right {
  padding: 60px 30px;
}
.advance-pricing .pricing-right .price-title {
  font-size: 20px;
  margin-bottom: 10px;
}
.advance-pricing .pricing-right .price-title li {
  font-size: 16px;
  margin: 8px 0;
}

/*--------------------------
    About Styles  
---------------------------*/
.about-style-4 .title {
  font-weight: 400;
  margin-bottom: 35px;
}
.about-style-4 .title strong {
  color: var(--color-primary);
}
.about-style-4 .feature-list {
  padding: 0;
  margin: 0;
  list-style: none;
}
.about-style-4 .feature-list li {
  display: flex;
}
.about-style-4 .feature-list li .icon {
  background: var(--color-primary);
  width: 30px;
  height: 30px;
  border-radius: 100%;
  color: var(--color-white);
  text-align: center;
  min-width: 30px;
}
.about-style-4 .feature-list li .title-wrapper {
  margin-left: 13px;
}
.about-style-4 .feature-list li .title-wrapper .title {
  font-size: 18px;
  margin: 0;
}
.about-style-4 .feature-list li .title-wrapper .text {
  font-size: 16px;
  margin-bottom: 20px;
  max-width: 80%;
  margin-top: 13px;
}

.about-style-5 {
  position: relative;
  z-index: 2;
}
.about-style-5 .about-wrapper {
  margin-top: -150px;
  background: var(--color-blackest);
  border-radius: 10px;
  padding: 15px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-5 .about-wrapper {
    margin-top: 80px;
    padding: 15px 15px 30px 15px;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-5 .about-wrapper {
    margin-top: 80px;
    padding: 15px 15px 30px 15px;
  }
}
.about-style-5 .about-wrapper .thumbnail img {
  border-radius: 10px;
}
.about-style-5 .about-wrapper .content .inner {
  padding: 0 40px;
}
@media only screen and (max-width: 767px) {
  .about-style-5 .about-wrapper .content .inner {
    padding: 0;
  }
}
.about-style-5 .about-wrapper .content .inner .title {
  font-size: 30px;
  margin-bottom: 13px;
}
.about-style-5 .about-wrapper .content .inner p {
  margin-bottom: 20px;
  width: 80%;
}

.contact-address {
  padding: 0;
  margin: 0;
  list-style: none;
}
.contact-address li {
  font-size: 16px;
}
.contact-address li svg {
  color: var(--color-primary);
  margin-right: 10px;
}

.about-style-6 .rbt-progress-style-1,
.about-style-6 .wrapper {
  position: relative;
  z-index: 2;
  max-width: 850px;
  margin: 0 auto;
  border-radius: 10px;
}
.about-style-6 .wrapper {
  padding: 50px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-style-6 .wrapper {
    padding: 20px;
  }
}
@media only screen and (max-width: 767px) {
  .about-style-6 .wrapper {
    padding: 20px;
  }
}
.about-style-6 .wrapper::after {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  background: var(--color-lessdark);
  width: 100%;
  height: 100%;
  z-index: -1;
  opacity: 0.6;
  border-radius: 10px;
}
.about-style-6 .thumbnail img {
  max-height: 200px;
}
.about-style-6 .subtitle {
  font-size: 18px;
  font-weight: 500;
}
.about-style-6 .maintitle {
  font-size: 30px;
  line-height: 1.3;
  margin-top: 17px;
  margin-bottom: 25px;
}

/*--------------------------
    Swicher Styles  
----------------------------*/
body.dark .dark-icon {
  display: none;
}

.dark-icon {
  display: none;
  filter: brightness(100);
}

#darkmode {
  border: 0 none;
  padding: 0;
  margin-left: 10px;
  width: 40px;
  background: var(--color-primary);
  display: flex;
  justify-content: center;
  height: 40px;
  align-items: center;
  border-radius: 100%;
}

.my_switcher {
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.my_switcher ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: auto;
  height: auto;
}
.my_switcher ul li {
  margin-top: 0;
  margin-bottom: 0;
}
.my_switcher ul li a {
  position: relative;
  text-decoration: none;
  transition: 0.4s;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}
.my_switcher ul li a img {
  width: 15px;
}
.my_switcher ul li a span {
  transform: rotate(-180deg);
  display: none;
}
.my_switcher ul li a.active {
  display: none;
}
.my_switcher ul li a.light {
  color: var(--color-white);
}
.my_switcher ul li a.dark {
  color: #18191A;
}

/*---------------------------
    Error Styles Area  
-----------------------------*/
.error-inner {
  text-align: center;
}
.error-inner h1 {
  font-size: 200px;
  line-height: 1;
  color: var(--color-primary);
  font-weight: var(--p-bold);
}
@media only screen and (max-width: 767px) {
  .error-inner h1 {
    font-size: 100px;
    line-height: 1;
  }
}
.error-inner .title {
  line-height: 45px;
  font-weight: var(--p-bold);
}
.error-inner .description {
  font-size: var(--font-size-b2);
  line-height: 28px;
  color: var(--color-body);
  font-weight: var(--p-regular);
  margin-bottom: 30px;
}
.error-inner .blog-search {
  display: inline-block;
}
.error-inner .blog-search input {
  min-width: 500px;
}
.error-inner .view-more-button {
  margin-top: 30px;
}

/**************************************
    Blog Styles
***************************************/
/*----------------------
    Blog Styles  
-----------------------*/
.rn-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--color-blackest);
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: var(--radius);
  overflow: hidden;
  transition: all 0.5s;
}
.rn-card .inner .thumbnail a img {
  width: 100%;
}
.rn-card .inner .content {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  padding: 30px;
  padding-top: 22px;
}
@media only screen and (max-width: 767px) {
  .rn-card .inner .content {
    padding: 30px 20px;
  }
}
.rn-card .inner .content .descriptiion {
  margin-bottom: 0;
  margin-bottom: 13px;
}
.rn-card .inner .content .title {
  font-size: 20px;
  line-height: 1.5;
  transition: all 0.5s;
  margin-bottom: 0;
  margin-top: 15px;
  flex-basis: 100%;
}
.rn-card.card-list-view {
  height: 100%;
}
.rn-card.card-list-view .inner {
  display: flex;
  height: 100%;
}
.rn-card.card-list-view .inner .thumbnail {
  flex-basis: 50%;
}
.rn-card.card-list-view .inner .thumbnail a {
  display: block;
  height: 100%;
}
.rn-card.card-list-view .inner .thumbnail a img {
  width: auto;
  object-fit: cover;
  height: 100%;
}
.rn-card.card-list-view .inner .content {
  flex-basis: 50%;
}
.rn-card.card-list-view .inner .content .title {
  margin-bottom: 10px;
}
.rn-card.card-list-view .inner .content .descriptiion {
  margin-bottom: 13px;
  margin-top: 12px;
}

.rn-meta-list {
  font-size: 1.4rem;
  line-height: 2.2rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.rn-meta-list li {
  margin-top: 0;
  margin-bottom: 0;
  color: var(--color-gray);
  font-size: 14px;
}
.rn-meta-list li a {
  color: var(--color-gray);
  transition: 0.5s;
}
.rn-meta-list li.separator {
  margin: 0 0.8rem;
}

.blog-search {
  position: relative;
}
.blog-search input {
  height: 60px;
  padding: 0 20px;
  color: var(--color-body);
  padding-right: 80px;
}
.blog-search .search-button {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  border: 0 none;
  background: var(--color-primary-light);
  height: 47px;
  padding: 0 20px;
  border-radius: 3px;
  text-align: center;
  font-size: 20px;
}
.blog-search .search-button svg {
  color: var(--color-white);
  font-weight: 400;
}

.rbt-single-widget {
  border-radius: 4px;
  padding: 20px 20px;
  border: 1px solid var(--color-border);
  padding-top: 0;
}
.rbt-single-widget:first-child {
  margin-top: 0 !important;
}
.rbt-single-widget input,
.rbt-single-widget select {
  border: var(--border-width) solid var(--color-border);
}
.rbt-single-widget.widget_search {
  padding: 0;
  border: 0 none;
}
.rbt-single-widget.widget_search .title {
  margin: 0;
}
.rbt-single-widget p {
  font-size: 16px;
  line-height: 28px;
  color: #717173;
}
.rbt-single-widget .title {
  line-height: 26px;
  position: relative;
  padding-bottom: 6px;
  font-size: 18px;
  font-weight: 500;
  color: var(--color-white);
  background-color: var(--color-blackest);
  margin: -1px -22px 0;
  padding: 14px 24px;
  border-radius: 4px;
}
.rbt-single-widget .title a {
  color: var(--color-primary);
}
.rbt-single-widget .title a.rsswidget img {
  height: 13px;
  margin-right: 3px;
}
.rbt-single-widget .title img {
  vertical-align: 0px;
}
.rbt-single-widget ul {
  padding-left: 0;
  margin-bottom: -10px;
  list-style: none;
  padding-right: 0;
}
.rbt-single-widget ul ul {
  margin-bottom: 0;
}
.rbt-single-widget ul li {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 28px;
  color: #717173;
}
.rbt-single-widget ul li a {
  transition: all 0.3s ease 0s;
  text-decoration: none;
  color: var(--color-heading);
  display: initial;
}
.rbt-single-widget ul li a:hover {
  color: var(--color-primary);
}
.rbt-single-widget.widget_categories ul li a {
  display: flex;
  justify-content: space-between;
}
.rbt-single-widget.widget_recent_comments ul li, .rbt-single-widget.widget_recent_entries ul li, .rbt-single-widget.widget_archive ul li, .rbt-single-widget.widget_categories ul li, .rbt-single-widget.widget_meta ul li, .rbt-single-widget.widget_pages ul li, .rbt-single-widget.widget_nav_menu ul li {
  position: relative;
  padding-top: 15px;
  padding-bottom: 15px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--color-body);
}
.rbt-single-widget.widget_recent_comments ul li a, .rbt-single-widget.widget_recent_entries ul li a, .rbt-single-widget.widget_archive ul li a, .rbt-single-widget.widget_categories ul li a, .rbt-single-widget.widget_meta ul li a, .rbt-single-widget.widget_pages ul li a, .rbt-single-widget.widget_nav_menu ul li a {
  color: var(--color-body);
}
.rbt-single-widget.widget_recent_comments ul li a:hover, .rbt-single-widget.widget_recent_entries ul li a:hover, .rbt-single-widget.widget_archive ul li a:hover, .rbt-single-widget.widget_categories ul li a:hover, .rbt-single-widget.widget_meta ul li a:hover, .rbt-single-widget.widget_pages ul li a:hover, .rbt-single-widget.widget_nav_menu ul li a:hover {
  color: var(--color-primary);
}
.rbt-single-widget.widget_recent_comments ul li span, .rbt-single-widget.widget_recent_entries ul li span, .rbt-single-widget.widget_archive ul li span, .rbt-single-widget.widget_categories ul li span, .rbt-single-widget.widget_meta ul li span, .rbt-single-widget.widget_pages ul li span, .rbt-single-widget.widget_nav_menu ul li span {
  color: var(--color-body);
}
.rbt-single-widget.widget_recent_comments ul li:hover a span, .rbt-single-widget.widget_recent_entries ul li:hover a span, .rbt-single-widget.widget_archive ul li:hover a span, .rbt-single-widget.widget_categories ul li:hover a span, .rbt-single-widget.widget_meta ul li:hover a span, .rbt-single-widget.widget_pages ul li:hover a span, .rbt-single-widget.widget_nav_menu ul li:hover a span {
  color: var(--color-primary);
}
.rbt-single-widget.widget_recent_comments ul li + li, .rbt-single-widget.widget_recent_entries ul li + li, .rbt-single-widget.widget_archive ul li + li, .rbt-single-widget.widget_categories ul li + li, .rbt-single-widget.widget_meta ul li + li, .rbt-single-widget.widget_pages ul li + li, .rbt-single-widget.widget_nav_menu ul li + li {
  border-top: 1px solid var(--color-border);
}
.rbt-single-widget.widget_recent_comments > ul > li, .rbt-single-widget.widget_recent_entries > ul > li, .rbt-single-widget.widget_archive > ul > li, .rbt-single-widget.widget_categories > ul > li, .rbt-single-widget.widget_meta > ul > li, .rbt-single-widget.widget_pages > ul > li {
  margin-top: 0;
  margin-bottom: 0;
}
.rbt-single-widget.widget_recent_comments > ul > li:first-child, .rbt-single-widget.widget_recent_entries > ul > li:first-child, .rbt-single-widget.widget_archive > ul > li:first-child, .rbt-single-widget.widget_categories > ul > li:first-child, .rbt-single-widget.widget_meta > ul > li:first-child, .rbt-single-widget.widget_pages > ul > li:first-child {
  margin-top: 0;
}
.rbt-single-widget.widget_recent_comments > ul > li:last-child, .rbt-single-widget.widget_recent_entries > ul > li:last-child, .rbt-single-widget.widget_archive > ul > li:last-child, .rbt-single-widget.widget_categories > ul > li:last-child, .rbt-single-widget.widget_meta > ul > li:last-child, .rbt-single-widget.widget_pages > ul > li:last-child {
  margin-bottom: 10px;
}
.rbt-single-widget.widget_recent_entries .inner a {
  color: var(--color-white);
  margin-bottom: 4px;
}
.rbt-single-widget.widget_recent_entries .inner span {
  color: var(--color-body);
  font-size: 14px;
  letter-spacing: 0.5px;
}

.alignwide {
  margin-left: -220px;
  margin-right: -220px;
  max-width: 1400px;
  width: auto;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .alignwide {
    margin-left: 0;
    margin-right: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .alignwide {
    margin-left: 0;
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .alignwide {
    margin-left: 0;
    margin-right: 0;
  }
}

.alignfull {
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  max-width: 100vw;
  width: 100vw;
}

.tagcloud,
.wp-block-tag-cloud {
  margin: -3px;
  padding-left: 0;
}
.tagcloud a,
.wp-block-tag-cloud a {
  background: transparent;
  display: inline-block;
  height: 40px;
  color: var(--color-body);
  font-size: 16px !important;
  line-height: 35px;
  text-decoration: none;
  margin: 3px;
  border: 2px solid var(--color-border);
  padding: 0 20px;
  border-radius: 3px;
}
.tagcloud a:hover,
.wp-block-tag-cloud a:hover {
  background: var(--color-primary);
  color: #ffffff;
  border-color: var(--color-primary);
}

/*------------------------------
    Blog Details 
----------------------------------*/
.post-page-banner .rn-meta-list {
  justify-content: center;
}
.post-page-banner .rn-meta-list li {
  color: var(--color-body);
  font-size: 20px;
  margin: 0 15px;
  margin-top: 38px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .post-page-banner .rn-meta-list li {
    font-size: 16px;
    margin-top: 8px;
  }
}
@media only screen and (max-width: 767px) {
  .post-page-banner .rn-meta-list li {
    font-size: 16px;
    margin-top: 8px;
  }
}
.post-page-banner .rn-meta-list li svg {
  margin-right: 10px;
}
.post-page-banner .rn-meta-list li a {
  color: var(--color-body);
  transition: 0.3s;
}
.post-page-banner .rn-meta-list li a:hover {
  color: var(--color-primary);
}
.post-page-banner .category-list {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  justify-content: center;
  margin: -10px;
  padding: 0;
  margin-top: 14px;
}
.post-page-banner .category-list li {
  margin: 10px;
  position: relative;
}
.post-page-banner .category-list li::after {
  position: absolute;
  content: ",";
  right: -9px;
}
.post-page-banner .category-list li:last-child::after {
  display: none;
}

.blog-details-content .category-meta {
  display: flex;
  padding: 42px 0;
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
  flex-wrap: wrap;
}
.blog-details-content .category-meta span.text {
  color: var(--color-white);
  font-size: 22px;
  display: inline-block;
  margin: 10px 0;
  margin-top: 0;
}

/**************************************
    Footer Styles
***************************************/
/*------------------------
    Banner Styles  
-------------------------*/
.slider-dot.rn-slick-dot .slick-dots {
  bottom: 60px;
}

.height-850 {
  height: 500px;
  display: flex;
  align-items: center;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .height-850 {
    height: auto;
    padding: 150px 0;
  }
}
@media only screen and (max-width: 767px) {
  .height-850 {
    height: auto;
    padding: 100px 0;
  }
}

.height-main {
  height: 700px;
  display: flex;
  align-items: center;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .height-main {
    height: auto;
    padding: 150px 0;
  }
}
@media only screen and (max-width: 767px) {
  .height-main {
    height: auto;
    padding: 100px 0;
  }
}

.height-650 {
  height: 650px;
  display: flex;
  align-items: center;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .height-650 {
    height: auto;
    padding: 150px 0;
  }
}
@media only screen and (max-width: 767px) {
  .height-650 {
    height: auto;
    padding: 100px 0;
  }
}

.height-750 {
  height: 750px;
  display: flex;
  align-items: center;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .height-750 {
    height: auto;
    padding: 150px 0;
  }
}
@media only screen and (max-width: 767px) {
  .height-750 {
    height: auto;
    padding: 100px 0;
  }
}

.height-950 {
  height: 950px;
  display: flex;
  align-items: center;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .height-950 {
    height: auto;
    padding: 150px 0;
  }
}
@media only screen and (max-width: 767px) {
  .height-950 {
    height: auto;
    padding: 150px 0;
  }
}

.display-one {
  font-size: 75px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .display-one {
    font-size: 70px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .display-one {
    font-size: 65px;
  }
}
@media only screen and (max-width: 767px) {
  .display-one {
    font-size: 50px;
  }
}
@media only screen and (max-width: 575px) {
  .display-one {
    font-size: 46px;
  }
}

.display-two {
  font-size: 85px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .display-two {
    font-size: 70px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .display-two {
    font-size: 65px;
  }
}
@media only screen and (max-width: 767px) {
  .display-two {
    font-size: 65px;
  }
}
@media only screen and (max-width: 575px) {
  .display-two {
    font-size: 46px;
  }
}

.bg-overlay {
  position: relative;
}
.bg-overlay::before {
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 1;
  top: 0;
  left: 0;
  background-color: transparent;
  background-image: linear-gradient(90deg, #060606 0%, rgba(6, 6, 6, 0) 90%);
  content: "";
}

.bg-overlay-solid {
  position: relative;
  z-index: 1;
}
.bg-overlay-solid::before {
  position: absolute;
  height: 100%;
  width: 40%;
  opacity: 1;
  top: 0;
  left: 0;
  content: "";
  background: var(--color-dark);
  z-index: -1;
}
.bg-overlay-solid::after {
  position: absolute;
  width: 500px;
  height: 500px;
  border-radius: 1000px;
  opacity: 0.5;
  filter: blur(100px);
  left: auto;
  top: -250px;
  left: -250px;
  bottom: auto;
  background-image: linear-gradient(45deg, var(--color-secondary), var(--color-tertiary));
  content: "";
  z-index: -1;
}

.frame-image {
  padding: 20px;
  position: relative;
  right: 0;
  border-radius: 10px;
  transition: var(--transition);
  height: 100%;
  background-color: var(--color-blackest);
}
.frame-image img {
  width: 100%;
}
.frame-image:hover {
  transform: translateY(-5px);
}

.slider-area .inner a.btn-default.btn-border,
.slider-area .inner button.btn-default.btn-border {
  border-color: var(--color-border);
  color: var(--color-white);
}

/*-----------------------
    Slider Style One  
-------------------------*/
.slider-style-1 .inner .subtitle {
  font-family: var(--font-primary);
  font-size: 18px;
  letter-spacing: 0.5px;
  display: block;
  margin-bottom: 18px;
  color: var(--color-body);
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-1 .inner .subtitle {
    font-size: 16px;
    margin-bottom: 10px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-1 .inner .subtitle {
    font-size: 16px;
    margin-bottom: 10px;
  }
}
@media only screen and (max-width: 575px) {
  .slider-style-1 .inner .subtitle {
    font-size: 14px;
  }
}
.slider-style-1 .inner .title {
  font-family: var(--font-primary);
  margin-bottom: 25px;
  display: inline-block;
}
.slider-style-1 .inner .title span {
  display: inline-block;
}
.slider-style-1 .inner .title span label {
  margin-bottom: 0;
}
.slider-style-1 .inner .description {
  font-family: var(--font-primary);
  padding: 0 22%;
  font-size: 25px;
  line-height: 1.7;
  margin-bottom: 40px;
  color: var(--color-body);
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .slider-style-1 .inner .description {
    padding: 0 14%;
    font-size: 22px;
    margin-bottom: 35px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-1 .inner .description {
    padding: 0 1%;
    font-size: 20px;
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-1 .inner .description {
    padding: 0 1%;
    font-size: 20px;
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 575px) {
  .slider-style-1 .inner .description {
    font-size: 18px;
    margin-bottom: 25px;
  }
}
.slider-style-1 .inner.text-start .description {
  padding: 0;
}
.slider-style-1.variation-default .inner {
  padding-top: 80px;
}
.slider-style-1.variation-2 {
  position: relative;
}
.slider-style-1.variation-2 .thumbnail img {
  transform: scale(1.1);
}

.slider-style-2 {
  padding-top: 130px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-2 {
    padding-top: 150px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-2 {
    padding-top: 150px;
  }
}
.slider-style-2 .inner .subtitle {
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 18px;
  font-size: 14px;
  border-radius: 4px;
  margin-bottom: 12px;
  display: inline-block;
  padding: 7px 14px;
  background-color: var(--color-blackest);
  box-shadow: var(--shadow-lighter);
}
.slider-style-2 .inner .title {
  font-family: var(--font-primary);
  margin-bottom: 25px;
  display: block;
  color: var(--color-white);
}
@media only screen and (max-width: 767px) {
  .slider-style-2 .inner .title.display-one {
    font-size: 40px;
  }
}
.slider-style-2 .inner .list-icon li {
  color: var(--color-body);
}
.slider-style-2.variation-2 {
  padding-top: 79px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-2.variation-2 {
    padding-top: 170px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-2.variation-2 {
    padding-top: 170px;
  }
}
.slider-style-2.variation-2 .inner .title {
  font-weight: 500;
  font-size: 75px;
  margin-top: 0;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-2.variation-2 .inner .title {
    font-size: 54px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-2.variation-2 .inner .title {
    font-size: 54px;
  }
}
@media only screen and (max-width: 575px) {
  .slider-style-2.variation-2 .inner .title {
    font-size: 40px;
  }
}
.slider-style-2.variation-2 .inner .tag-title {
  color: var(--color-secondary);
  margin: 0;
  letter-spacing: 1.5px;
  padding-left: 129px;
  position: relative;
  margin-top: 50px;
}
.slider-style-2.variation-2 .inner .tag-title::before {
  position: absolute;
  content: "";
  left: 0;
  width: 100px;
  height: 2px;
  background: var(--color-secondary);
  top: 50%;
  transform: translateY(-50%);
}
.slider-style-2.variation-3 {
  padding-top: 80px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-2.variation-3 {
    padding-top: 180px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-2.variation-3 {
    padding-top: 180px;
  }
}
.slider-style-2.variation-3 .inner .title {
  font-family: var(--font-primary);
  margin-bottom: 25px;
  display: block;
  font-size: 80px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-2.variation-3 .inner .title {
    font-size: 60px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-2.variation-3 .inner .title {
    font-size: 50px;
  }
  .slider-style-2.variation-3 .inner .title br {
    display: none;
  }
}
.slider-style-2.variation-3 .inner .description {
  font-size: 20px;
  line-height: 37px;
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .slider-style-2.variation-3 .inner .description {
    font-size: 18px;
    line-height: 30px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-3 {
    padding: 100px 0;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-3 {
    padding: 100px 0;
  }
}
.slider-style-3 .inner .title {
  font-family: var(--font-primary);
  margin-bottom: 25px;
  display: block;
  font-size: 130px;
  line-height: 1.1;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .slider-style-3 .inner .title {
    font-size: 100px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-3 .inner .title {
    font-size: 80px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-3 .inner .title {
    margin-bottom: 20px;
    font-size: 50px;
  }
}
.slider-style-3 .inner .description {
  font-size: 22px;
  line-height: 43px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-3 .inner .description {
    font-size: 20px;
    line-height: 38px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-3 .inner .description {
    font-size: 18px;
    line-height: 30px;
  }
}
.slider-style-3 .thumbnail {
  position: relative;
  z-index: 2;
}
.slider-style-3 .thumbnail::after {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: calc(100% - 130px);
  content: "";
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  background: var(--color-blackest);
  box-shadow: var(--shadow-1);
  border-radius: 6px;
}

.slider-style-4 .inner {
  padding-top: 80px;
}
@media only screen and (max-width: 767px) {
  .slider-style-4 .inner {
    padding-top: 50px;
  }
}
.slider-style-4 .inner > * {
  animation-name: fadeOutUp;
  animation-fill-mode: both;
  animation-duration: 1s;
}
.slider-style-4 .inner .title {
  font-family: var(--font-primary);
  margin-bottom: 25px;
  display: block;
  font-size: 130px;
  line-height: 1.1;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: var(--color-white);
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .slider-style-4 .inner .title {
    font-size: 100px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-4 .inner .title {
    font-size: 100px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-4 .inner .title {
    font-size: 60px;
  }
}
@media only screen and (max-width: 575px) {
  .slider-style-4 .inner .title {
    font-size: 55px;
  }
}
.slider-style-4 .inner .description {
  font-size: 22px;
  line-height: 43px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: var(--color-body);
}
@media only screen and (max-width: 767px) {
  .slider-style-4 .inner .description {
    font-size: 20px;
    line-height: 35px;
  }
}
.slider-style-4 .inner .button-group {
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.slider-style-4.variation-2 .inner .title {
  font-size: 70px;
}
@media only screen and (max-width: 767px) {
  .slider-style-4.variation-2 .inner .title {
    font-size: 42px;
  }
}
.slider-style-4.variation-2 .bg-overlay::before {
  background: #000000;
  content: "";
  opacity: 0.5;
  background-image: none;
}
.slider-style-4.variation-3 .inner .title {
  font-size: 70px;
}
.slider-style-4.variation-3 .bg-overlay::before {
  background: #000000;
  content: "";
  opacity: 0.5;
  background-image: none;
}

.slider-style-5 .inner .subtitle {
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.5px;
  position: relative;
  padding-right: 20px;
  display: inline-block;
  color: var(--color-white);
}
.slider-style-5 .inner .subtitle::after {
  position: absolute;
  content: "";
  width: 120px;
  height: 2px;
  background: var(--color-pink);
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
}
.slider-style-5 .inner .title {
  font-family: var(--font-primary);
  margin-bottom: 25px;
  display: block;
  font-size: 64px;
  line-height: 1.4;
  color: var(--color-white);
}
@media only screen and (max-width: 767px) {
  .slider-style-5 .inner .title {
    font-size: 40px;
  }
}

.slider-style-6 {
  background-color: var(--color-blackest);
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-6 {
    overflow: hidden;
    padding: 100px 0;
    padding-top: 170px;
  }
}
.slider-style-6.shape-right {
  position: relative;
  z-index: 2;
  overflow: hidden;
}
.slider-style-6.shape-right .shape-image {
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0.5;
  width: auto;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-6.shape-right .shape-image {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-6.shape-right .shape-image {
    display: none;
  }
}
.slider-style-6.shape-left {
  position: relative;
}
.slider-style-6.shape-left .inner {
  position: relative;
  z-index: 2;
}
.slider-style-6.shape-left .shape-image {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.5;
  transform: rotate(180deg);
  height: 100%;
  bottom: 0;
  width: auto;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-6.shape-left .shape-image {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-6.shape-left .shape-image {
    display: none;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-6.inheader-not-transparent {
    padding-top: 100px;
  }
}
.slider-style-6 .inner .title {
  font-family: var(--font-primary);
  margin-bottom: 25px;
  display: block;
  font-size: 80px;
  line-height: 1.1;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .slider-style-6 .inner .title {
    font-size: 62px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-6 .inner .title {
    font-size: 60px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-6 .inner .title {
    font-size: 45px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-6 .inner .title br {
    display: none;
  }
}
.slider-style-6 .inner .description {
  font-size: 22px;
  line-height: 43px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-6 .inner .description {
    font-size: 20px;
    line-height: 38px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-6 .inner .description {
    font-size: 18px;
    line-height: 30px;
  }
}
.slider-style-6 .inner a.btn-default.btn-border {
  border-color: var(--color-border);
  color: var(--color-white);
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-perosonal-portfolio.height-750 {
    padding-top: 180px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-perosonal-portfolio.height-750 {
    padding-top: 180px;
  }
}
.slider-perosonal-portfolio .inner {
  margin-top: -100px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-perosonal-portfolio .inner {
    margin-top: 0;
  }
}
@media only screen and (max-width: 767px) {
  .slider-perosonal-portfolio .inner {
    margin-top: 0;
  }
}
.slider-perosonal-portfolio .inner .title {
  font-size: 100px;
  color: var(--color-white);
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-perosonal-portfolio .inner .title {
    font-size: 58px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-perosonal-portfolio .inner .title {
    font-size: 46px;
  }
}
.slider-perosonal-portfolio .inner a.btn-default.btn-border,
.slider-perosonal-portfolio .inner button.btn-default.btn-border {
  border-color: var(--color-border);
  color: var(--color-white);
}

.slider-style-7 .inner .title {
  font-size: 100px;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .slider-style-7 .inner .title {
    font-size: 60px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-7 .inner .title {
    font-size: 50px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-7 .inner .title {
    font-size: 32px;
  }
  .slider-style-7 .inner .title br {
    display: none;
  }
}

.slider-style-8 {
  justify-content: center;
}
.slider-style-8 .inner .title {
  font-size: 100px;
  line-height: 1.1;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-8 .inner .title {
    font-size: 60px;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-8 .inner .title {
    font-size: 46px;
  }
}
.slider-style-8 .inner .description {
  font-size: 22px;
  line-height: 43px;
}
@media only screen and (max-width: 767px) {
  .slider-style-8 .inner .description {
    font-size: 20px;
    line-height: 38px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .slider-style-8 .inner .description br {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .slider-style-8 .inner .description br {
    display: none;
  }
}

.slider-style-4 .slick-active .inner > * {
  animation-name: fadeInUp;
}
.slider-style-4 .slick-active .inner .title {
  animation-delay: 0.5s;
}
.slider-style-4 .slick-active .inner .description {
  animation-delay: 1s;
}
.slider-style-4 .slick-active .inner .button-group {
  animation-delay: 1.2s;
}

/*-----------------------------
    Portfolio details  
--------------------------------*/
.rwt-portfolio-details .content-left .title {
  font-size: 38px;
  margin-bottom: 33px;
}
@media only screen and (max-width: 767px) {
  .rwt-portfolio-details .content-left .title {
    font-size: 25px;
    margin-bottom: 20px;
  }
}
.rwt-portfolio-details .content-left .single-list-wrapper {
  margin: -5px;
}
.rwt-portfolio-details .content-left .single-list-wrapper .single-list {
  margin: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}
.rwt-portfolio-details .content-left .single-list-wrapper .single-list + .single-list {
  border-top: 1px solid var(--color-border);
}
.rwt-portfolio-details .content-left .single-list-wrapper .single-list label {
  font-size: 20px;
  color: #fff;
  display: inline-block;
  padding-right: 16px;
  margin: 0;
}
.rwt-portfolio-details .content-left .single-list-wrapper .single-list span {
  font-size: 18px;
}
.rwt-portfolio-details .content-right .subtitle {
  font-size: 25px;
  letter-spacing: 0.5px;
  font-weight: 500;
}
.rwt-portfolio-details .content-right .description p {
  margin-bottom: 10px;
}

.rwt-portfolio-details .alignwide {
  margin-left: -100px;
  margin-right: -100px;
  max-width: 1400px;
  width: auto;
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .rwt-portfolio-details .alignwide {
    margin-left: 0;
    margin-right: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .rwt-portfolio-details .alignwide {
    margin-left: 0;
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .rwt-portfolio-details .alignwide {
    margin-left: 0;
    margin-right: 0;
  }
}

/*--------------------------------
    Single Demo  
-------------------------------*/
.single-demo {
  text-align: center;
  background: var(--color-lessdark);
  border-radius: 10px;
  padding: 20px;
  transition: 0.3s;
  position: relative;
}
.single-demo a {
  display: block;
}
.single-demo .thumbnail {
  position: relative;
}
.single-demo .thumbnail img {
  border-radius: 10px;
  width: 100%;
}
.single-demo .thumbnail .image-light {
  display: none;
}
.single-demo .thumbnail .label-badge {
  position: absolute;
  right: 20px;
  border-radius: 5px;
  background-color: transparent;
  background: #fff700;
  padding: 0 12px;
  color: #000;
  font-size: 14px;
  height: 29px;
  line-height: 29px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
  display: inline-block;
  width: 60px;
  bottom: 20px;
}
.single-demo .title {
  margin: 0;
  margin-top: 20px;
  font-size: 20px;
  letter-spacing: 0.5px;
  position: relative;
  display: inline-block;
}
.single-demo:hover {
  transform: translateY(-5px);
}

.react-image img {
  max-height: 150px;
}

.seeMoreButton {
  padding: 50px;
  display: flex;
  justify-content: center;
}

.service-wrapper-box {
  display: flex;
  justify-content: space-around;
}

/**************************************
    Footer Styles
***************************************/
/*-----------------------
    Footer Style Here  
------------------------*/
.logo a img {
  max-height: 55px;
}

.footer-style-default {
  border-top: 1px solid var(--color-border);
  background-color: var(--color-darkest);
  background-image: linear-gradient(0deg, var(--color-black), var(--color-blacker));
}
.footer-style-default .footer-top {
  padding: 100px 0;
  padding-bottom: 70px;
}
.footer-style-default .footer-top .rn-footer-widget .text-big {
  font-size: 21px;
  margin-top: 30px;
  padding-right: 13%;
  line-height: 1.7;
  font-weight: 500;
  color: var(--color-body);
  margin-bottom: 30px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .footer-style-default .footer-top .rn-footer-widget .text-big {
    font-size: 20px;
    padding-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .footer-style-default .footer-top .rn-footer-widget .text-big {
    font-size: 20px;
    padding-right: 0;
  }
}
.footer-style-default .footer-top .rn-footer-widget .title {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 1px;
  margin-bottom: 10px;
  color: var(--color-heading);
}
.footer-style-default .footer-top .rn-footer-widget .subtitle {
  font-weight: 400;
  color: var(--color-body);
  font-size: 16px;
  padding-right: 31%;
  line-height: 28px;
  margin-bottom: 32px;
}
@media only screen and (max-width: 767px) {
  .footer-style-default .footer-top .rn-footer-widget .subtitle {
    padding-right: 0;
  }
}
.footer-style-default .footer-top .rn-footer-widget .inner {
  margin-top: 13px;
}
.footer-style-default .footer-top .rn-footer-widget .footer-link {
  list-style: none;
  padding: 0;
}
.footer-style-default .footer-top .rn-footer-widget .footer-link li {
  margin-top: 5px;
  margin-bottom: 5px;
}
.footer-style-default .footer-top .rn-footer-widget .footer-link li a {
  font-size: 14px;
  display: inline-block;
  color: var(--color-body);
  line-height: 25px;
  transition: 0.3s;
}
.footer-style-default .footer-top .rn-footer-widget .footer-link li a:hover {
  color: var(--color-primary);
}
.footer-style-default .footer-top .rn-footer-widget .footer-link li a:hover::after {
  width: 100%;
  left: 0;
  right: auto;
}
.footer-style-default .logo a img {
  max-height: 80px;
}
.footer-style-default.variation-two {
  border-top: 0;
}
.footer-style-default.no-border {
  border-top: 0;
}

.footer-style-2 .copyright-style-one {
  background: transparent;
}

.flex {
  display: flex;
  justify-content: space-between;
}

.newsletter-form {
  display: flex;
  flex-wrap: wrap;
}
.newsletter-form input {
  flex-grow: 1;
  width: auto;
  margin-right: 10px;
  height: 50px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.5px;
}

.footer-style-default .newsletter-form .form-group input {
  border-color: var(--color-border);
}

/*--------------------------
    Copyright Area  
---------------------------*/
.rn-back-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  cursor: pointer;
  z-index: 999;
  width: 50px;
  height: 50px;
  line-height: 46px;
  border-radius: 50%;
  text-align: center;
  z-index: 999 !important;
  background-color: var(--color-blackest);
}
.rn-back-top svg {
  color: #fff;
  width: 27px;
  height: 27px;
  font-size: 14px !important;
}

.copyright-style-one {
  background: var(--color-darkest);
  padding: 20px 0;
  border-top: 1px solid var(--color-border);
}
.copyright-style-one .copyright-text {
  margin-bottom: 0;
  font-size: 14px;
}
.copyright-style-one .ft-menu {
  padding: 0;
  margin: 0 -10px;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 767px) {
  .copyright-style-one .ft-menu {
    justify-content: center;
  }
}
.copyright-style-one .ft-menu li {
  margin: 0;
  padding: 0 10px;
  position: relative;
}
.copyright-style-one .ft-menu li + li::after {
  position: absolute;
  content: "";
  height: 14px;
  width: 1px;
  background: var(--color-border);
  left: -1px;
  top: 50%;
  transform: translateY(-50%);
}
.copyright-style-one .ft-menu li a {
  font-size: 14px;
}
.copyright-style-one.variation-two {
  background: var(--color-blackest);
}
.copyright-style-one.no-border {
  border-top: 0;
}

/*-------------------------
    Darkmode Styles  
---------------------------*/
.rn-back-top svg {
  transition: 0.3s;
}

.rn-back-top:hover svg {
  color: var(--color-primary) !important;
}

body.light {
  background-color: var(--color-white);
  color: #65676b;
}
body.light .dark-icon {
  display: block;
}
body.light .light-icon {
  display: none;
}
body.light h1,
body.light h2,
body.light h3,
body.light h4,
body.light h5,
body.light h6,
body.light .h1,
body.light .h2,
body.light .h3,
body.light .h4,
body.light .h5,
body.light .h6,
body.light .social-default li a,
body.light .rbt-single-widget .title,
body.light .rbt-single-widget.widget_recent_entries .inner a,
body.light .tagcloud a,
body.light .wp-block-tag-cloud a,
body.light .rwt-portfolio-details .content-left .single-list-wrapper .single-list label,
body.light .blog-details-content .category-meta span.text,
body.light .demo-slider-area.slider-style-1 .inner .title,
body.light .rn-back-top svg,
body.light .popup-mobile-menu .inner .header-top .close-menu .close-button,
body.light .footer-style-default .footer-top .rn-footer-widget .title,
body.light .rn-call-to-action.style-8 .title,
body.light .rn-newsletter-default .newsletter-section-title .title {
  color: #181818;
}
body.light p,
body.light input[type=text],
body.light input[type=password],
body.light input[type=email],
body.light input[type=number],
body.light input[type=tel],
body.light textarea,
body.light .breadcrumb-inner ul.page-list li a,
body.light .rn-address .inner p a,
body.light .error-inner .description,
body.light .rbt-single-widget.widget_recent_comments ul li a,
body.light .rbt-single-widget.widget_recent_entries ul li a,
body.light .rbt-single-widget.widget_archive ul li a,
body.light .rbt-single-widget.widget_categories ul li a,
body.light .rbt-single-widget.widget_meta ul li a,
body.light .rbt-single-widget.widget_pages ul li a,
body.light .rbt-single-widget.widget_nav_menu ul li a,
body.light .rbt-single-widget.widget_recent_entries .inner span,
body.light .rbt-single-widget.widget_recent_comments ul li span,
body.light .rbt-single-widget.widget_recent_entries ul li span,
body.light .rbt-single-widget.widget_archive ul li span,
body.light .rbt-single-widget.widget_categories ul li span,
body.light .rbt-single-widget.widget_meta ul li span,
body.light .rbt-single-widget.widget_pages ul li span,
body.light .rbt-single-widget.widget_nav_menu ul li span,
body.light .post-page-banner .rn-meta-list li a,
body.light .post-page-banner .rn-meta-list li,
body.light .breadcrumb-inner ul.page-list li.rn-breadcrumb-item.active,
body.light .slider-style-1.bg-transparent .inner .subtitle,
body.light .slider-style-1.bg-transparent .inner .description,
body.light .popup-mobile-menu .mainmenu li a,
body.light .footer-style-default .footer-top .rn-footer-widget .footer-link li a,
body.light .footer-style-default .footer-top .rn-footer-widget .subtitle,
body.light .rn-call-to-action.style-8 .content .subtitle,
body.light .rn-newsletter-default .newsletter-section-title .description,
body.light .slider-style-5 .inner .subtitle,
body.light .slider-style-5 .inner .title {
  color: #65676b;
}
body.light .header-transparent.sticky .mainmenu-nav .mainmenu > li > a,
body.light .clltoaction-style-default.style-7 .content .subtitle,
body.light .copyright-style-one .ft-menu li a,
body.light .footer-style-default .footer-top .rn-footer-widget .text-big {
  color: #65676b;
}
body.light .form-group input,
body.light .form-group textarea,
body.light .rn-accordion-style.rn-accordion-02 .card .card-header,
body.light .mainmenu-nav .mainmenu li.with-megamenu .rn-megamenu .wrapper .mega-menu-item,
body.light .breadcarumb-style-1,
body.light .rn-accordion-style.rn-accordion-03 .card .card-header,
body.light .rn-accordion-style.rn-accordion-04 .card,
body.light .rn-pricing .pricing-table-inner,
body.light input[type=text],
body.light input[type=password],
body.light input[type=email],
body.light input[type=number],
body.light input[type=tel],
body.light textarea,
body.light .rbt-single-widget,
body.light .rbt-single-widget.widget_recent_comments ul li + li,
body.light .rbt-single-widget.widget_recent_entries ul li + li,
body.light .rbt-single-widget.widget_archive ul li + li,
body.light .rbt-single-widget.widget_categories ul li + li,
body.light .rbt-single-widget.widget_meta ul li + li,
body.light .rbt-single-widget.widget_pages ul li + li,
body.light .rbt-single-widget.widget_nav_menu ul li + li,
body.light .tagcloud a,
body.light .wp-block-tag-cloud a,
body.light .section-title-2 .title,
body.light .popup-mobile-menu .mainmenu li + li,
body.light .clltoaction-style-default.style-7 .content-wrapper,
body.light .copyright-style-one,
body.light .footer-style-default .newsletter-form .form-group input,
body.light .newsletter-area .border-top-bottom {
  border-color: rgba(0, 0, 0, 0.1411764706);
}
body.light .mainmenu-nav .mainmenu li.has-droupdown .submenu li a:hover {
  background: #d8d8d8;
}
body.light .mainmenu-nav .mainmenu li.with-megamenu .rn-megamenu .wrapper .mega-menu-item li a:hover {
  background: #d8d8d8;
  color: var(--color-primary);
}
body.light .btn-read-more span::after {
  background: rgba(0, 0, 0, 0.1411764706);
}
body.light .breadcrumb-inner ul.page-list li a:hover,
body.light .rn-address .inner p a:hover,
body.light .post-page-banner .rn-meta-list li a:hover,
body.light .header-top-bar .header-left p a:hover {
  color: var(--color-primary);
}
body.light .social-default li a:hover,
body.light .tagcloud a:hover,
body.light .wp-block-tag-cloud a:hover,
body.light .header-top-news .btn-read-more span {
  color: var(--color-white);
}
body.light .tagcloud a:hover,
body.light .wp-block-tag-cloud a:hover {
  border-color: var(--color-primary);
}
body.light a.btn-default.text-underline,
body.light button.btn-default.text-underline {
  border-color: #181818;
  color: #181818;
}
body.light .hamberger-button svg,
body.light .popup-mobile-menu .inner .header-top .close-menu .close-button svg {
  stroke: #181818;
}
body.light .single-demo .thumbnail .image-light {
  display: block;
}
body.light .single-demo .thumbnail .image-dark {
  display: none;
}
body.light .footer-style-default .social-default li a,
body.light .copyright-style-one .social-default.color-lessdark li a,
body.light .rn-newsletter-default .rn-newsletter .form-group input {
  background: #fff;
}
body.light .copyright-style-one .ft-menu li + li::after {
  background: #c5c1c1;
}
body.light .copyright-style-one .ft-menu li a:hover,
body.light .footer-style-default .footer-top .rn-footer-widget .footer-link li a:hover {
  color: var(--color-primary);
}
body.light .header-transparent-with-topbar .header-top-bar,
body.light .header-transparent-with-topbar .header-default {
  background: transparent;
}
body.light [class*=col]:nth-child(2) .counter-style-2.color-variation .count-number {
  background-color: #f9f5f5;
}
body.light [class*=col]:nth-child(3) .counter-style-2.color-variation .count-number {
  background-color: #eef2f3;
}
body.light .service-wrapper > [class*=col]:nth-child(4) .service.service__style--1.icon-circle-style .icon {
  background-color: rgba(47, 1, 29, 0.2705882353);
}
body.light .slider-style-8 .inner a.btn-default.btn-border,
body.light .slider-style-8 .inner button.btn-default.btn-border {
  border-color: #d8d8d8;
  color: #65676b;
}
body.light .slider-style-8 .inner a.btn-default.btn-border:hover,
body.light .slider-style-8 .inner button.btn-default.btn-border:hover {
  color: #fff;
}

body.light .service.service__style--1.icon-circle-style .icon {
  background-color: rgba(5, 157, 255, 0.0588235294);
  color: var(--color-primary);
}

body.light .service-wrapper > [class*=col]:nth-child(1) .service.service__style--1.icon-circle-style .icon {
  background-color: rgba(5, 157, 255, 0.0588235294);
  color: var(--color-primary);
}

body.light .service-wrapper > [class*=col]:nth-child(2) .service.service__style--1.icon-circle-style .icon {
  background-color: rgba(5, 157, 255, 0.0588235294);
  color: var(--color-primary);
}

body.light .service-wrapper > [class*=col]:nth-child(3) .service.service__style--1.icon-circle-style .icon {
  background-color: rgba(5, 157, 255, 0.0588235294);
  color: var(--color-primary);
}

body.light .service.service__style--1.icon-circle-style .iconSolutions {
  background-color: var(--color-primary);
}

body.light .service-wrapper > [class*=col]:nth-child(1) .service.service__style--1.icon-circle-style .iconSolutions {
  background-color: var(--color-primary);
}

body.light .service-wrapper > [class*=col]:nth-child(2) .service.service__style--1.icon-circle-style .iconSolutions {
  background-color: var(--color-primary);
}

body.light .service-wrapper > [class*=col]:nth-child(3) .service.service__style--1.icon-circle-style .iconSolutions {
  background-color: var(--color-primary);
}

body.light .timeline-dot::after {
  background: radial-gradient(50% 50% at 50% 50%, #f5f8fa 48.96%, #f5f8fa 100%);
}

body.light .header-top-bar {
  background-color: var(--color-white);
}

body.light .single-timeline .single-content,
body.light .rn-card,
body.light .clltoaction-style-default.style-5 .content-wrapper,
body.light .header-default,
body.light .mainmenu-nav .mainmenu li.has-droupdown .submenu,
body.light .service.gallery-style,
body.light .rn-box-card .inner,
body.light .team-style-default .inner,
body.light .rn-accordion-style .card,
body.light .section-title .subtitle,
body.light .card-box.card-style-1,
body.light .list-icon li .icon,
body.light .counter-style-2 .count-number,
body.light .rn-pricing.style-2 .pricing-table-inner,
body.light .rn-default-tab .rn-tab-content,
body.light .rn-default-tab .tab-button .react-tabs__tab.react-tabs__tab--selected,
body.light .advance-tab-button-1 .tab-button-list .tab-button::before,
body.light .advance-pricing .pricing-left,
body.light .rn-pricing.style-5 .pricing-table-inner,
body.light .about-style-5 .about-wrapper,
body.light .rn-sub-badge,
body.light .about-style-6 .wrapper::after,
body.light .box-grid-layout .rwt-card,
body.light .mainmenu-nav .mainmenu li.with-megamenu .rn-megamenu .wrapper,
body.light .social-default li a,
body.light .clltoaction-style-default.style-4 .content-wrapper,
body.light .rn-address,
body.light .rbt-single-widget .title,
body.light .frame-image,
body.light .rn-back-top,
body.light .popup-mobile-menu .inner,
body.light .rn-call-to-action.style-8,
body.light .bg-overlay-solid::before {
  background: #f5f8fa;
}

body.light .rn-header.sticky {
  background: #f5f8fa !important;
}

body.light .bg-color-blackest {
  background: #f5f8fa !important;
}

body.light .footer-style-default,
body.light .copyright-style-one {
  background: #f5f8fa;
}

body.light .slider-style-2 .list-icon li .icon {
  background: var(--color-blackest);
}

body.light .rn-pricing .pricing-table-inner::before,
body.light .rn-timeline-single.dark-line .rn-timeline .progress-dot .dot-level,
body.light .rn-timeline-single.dark-line .rn-timeline .progress-line .line-inner,
body.light .card-style-default.testimonial-style-one .inner .thumbnail::after,
body.light .advance-pricing,
body.light .rn-pricing.style-5 .pricing-table-inner .pricing,
body.light .popup-mobile-menu .inner .header-top .close-menu .close-button,
body.light .hamberger-button {
  background: #d8d8d8;
}

body.light .single-demo {
  background: #e9f8fe;
}

body.light .slider_img {
  width: 150px !important;
  filter: none !important;
}

body.light .split-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
  column-gap: 20px;
}
body.light .split-list li {
  color: var(--color-dark-alt) !important;
  display: flex;
  align-items: center;
}
body.light .split-list li .split-icon {
  margin-right: 20px;
}

body.light .rn-accordion-style .card .card-body,
body.light .brand-style-1 li {
  border-color: #d8d8d8;
}

body.light hr {
  border-top: 1px solid rgba(0, 0, 0, 0.1411764706);
}

body.light .rn-card {
  border-color: #f5f8fa;
}

body.light .rn-pricing.active .pricing-table-inner .pricing-header,
body.light .rn-pricing .pricing-table-inner .pricing-header {
  border-color: rgba(0, 0, 0, 0.0392156863);
}

body.light .advance-tab-button-1 .tab-button-list .tab-button::after {
  border-left: 20px solid #f5f8fa;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
}

body.light a.btn-default.btn-border,
body.light button.btn-default.btn-border {
  border-color: rgba(0, 0, 0, 0.1411764706);
  color: #181818;
}

body.light a.btn-default.btn-border:hover,
body.light button.btn-default.btn-border:hover {
  border-color: var(--color-secondary);
  color: #fff;
}

body.light .rn-box-card .inner .thumbnail,
body.light .team-style-default .inner .thumbnail {
  border: 6px solid var(--color-white);
}

body.light .filter-button-default li button,
body.light .testimonial-style-two .content .client-info .subtitle,
body.light .single-timeline .single-content .inner .content .date-of-timeline,
body.light .service.gallery-style .content p,
body.light .rn-box-card .inner .social-icon li a,
body.light .team-style-default .inner .social-icon li a,
body.light .rn-accordion-style .card .card-body,
body.light .mainmenu-nav .mainmenu li.has-droupdown .submenu li a,
body.light .list-icon li,
body.light ul li,
body.light .rn-pricing.active .pricing-table-inner .pricing-body ul.list-style--1 li,
body.light .rn-pricing.active .pricing-table-inner .pricing-body ul.list-style--1 li svg,
body.light .advance-tab-button-1 .tab-button-list .tab-button .title,
body.light .advance-pricing .pricing-left .subtitle,
body.light .header-top-bar .header-left p a,
body.light .header-top-bar .header-right .address-content p a,
body.light .header-top-bar .social-default.icon-naked li a,
body.light .progress-info .title,
body.light .progress-info span.progress-number,
body.light .mainmenu-nav .mainmenu li.with-megamenu .rn-megamenu .wrapper .mega-menu-item li a,
body.light .clltoaction-style-default.style-4 .content .subtitle {
  color: #65676b;
}

body.light .card-box.card-style-1 .inner .content .description {
  color: #65676b !important;
}

body.light .clltoaction-style-default.style-5 .content .subtitle,
body.light .rn-accordion-style .card .card-header button,
body.light .counter-style-2 .count-number,
body.light .rn-pricing .pricing-table-inner .pricing-header .pricing span.price,
body.light .rn-pricing.active .pricing-table-inner .pricing-header .title,
body.light .rn-pricing.active .pricing-table-inner .pricing-header .pricing span.currency,
body.light .rn-pricing.active .pricing-table-inner .pricing-header .pricing span.subtitle,
body.light .rn-pricing .pricing-table-inner .pricing-header .pricing span.subtitle,
body.light .rn-default-tab .tab-button .rn-tab-button button,
body.light .rn-pricing .pricing-table-inner .pricing-header .pricing span.currency,
body.light .card-style-default.testimonial-style-one .inner .thumbnail::after,
body.light .clltoaction-style-default.style-6 .content .title,
body.light .rn-splite-style .split-inner .title,
body.light .advance-tab-button-1 .tab-button-list .react-tabs__tab--selected .tab-button .title,
body.light .advance-pricing .pricing-left .price-wrapper .price-amount,
body.light .btn-read-more span,
body.light .section-title-2 .title,
body.light .box-grid-layout .rwt-card .inner .content .title,
body.light .clltoaction-style-default.style-5 .content .title,
body.light .clltoaction-style-default.style-4 .content .title,
body.light .hamberger-button {
  color: #181818;
}

body.light .about-style-6 .maintitle {
  color: #181818 !important;
}

body.light .slider-style-1 .inner .title {
  color: var(--color-white);
}

body.light .testimonial-style-two .content::after {
  color: #f5f8fa;
}

body.light .header-transparent .mainmenu-nav .mainmenu > li > a {
  color: var(--color-body);
}

body.light .header-top-bar .header-right .address-content p a:hover {
  color: var(--color-primary);
}

body.light .rn-pricing .pricing-table-inner .pricing-header .pricing span.currency {
  opacity: 0.8;
}

body.light .mainmenu-nav .mainmenu li.has-droupdown .submenu li a:hover,
body.light .btn-read-more:hover span {
  color: var(--color-primary);
}

body.light .CircularProgressbar .CircularProgressbar-text {
  fill: #181818 !important;
}

body.light .logo-light {
  display: none;
}

body.light .logo-dark {
  display: block;
}

body.light .slider-area.bg-transparent .inner a.btn-default.btn-border,
body.light .slider-area.bg-transparent .inner button.btn-default.btn-border {
  border-color: rgba(0, 0, 0, 0.1411764706);
  color: #181818;
}

body.light .slider-area.bg-transparent .inner a.btn-default.btn-border:hover,
body.light .slider-area.bg-transparent .inner button.btn-default.btn-border:hover {
  color: var(--color-white);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/style.scss","webpack://./src/assets/scss/default/_variables.scss","webpack://./src/assets/scss/default/_reset.scss","webpack://./src/assets/scss/default/_typography.scss","webpack://./src/assets/scss/default/_extend.scss","webpack://./src/assets/scss/default/_animations.scss","webpack://./src/assets/scss/default/_shortcode.scss","webpack://./src/assets/scss/default/_mixins.scss","webpack://./src/assets/scss/default/_spacing.scss","webpack://./src/assets/scss/default/_common.scss","webpack://./src/assets/scss/default/_forms.scss","webpack://./src/assets/scss/color/_themebg.scss","webpack://./src/assets/scss/header/_header.scss","webpack://./src/assets/scss/header/_nav.scss","webpack://./src/assets/scss/header/_mobilemenu.scss","webpack://./src/assets/scss/header/_headertop.scss","webpack://./src/assets/scss/elements/_sctiontitle.scss","webpack://./src/assets/scss/elements/_button.scss","webpack://./src/assets/scss/elements/_breadcrumb.scss","webpack://./src/assets/scss/elements/_accordion.scss","webpack://./src/assets/scss/elements/_service.scss","webpack://./src/assets/scss/elements/_card.scss","webpack://./src/assets/scss/elements/_progressbar.scss","webpack://./src/assets/scss/elements/_counter.scss","webpack://./src/assets/scss/elements/_portfolio.scss","webpack://./src/assets/scss/elements/_social.scss","webpack://./src/assets/scss/elements/_team.scss","webpack://./src/assets/scss/elements/_timeline.scss","webpack://./src/assets/scss/elements/_testimonial.scss","webpack://./src/assets/scss/elements/_slickslide.scss","webpack://./src/assets/scss/elements/_tab.scss","webpack://./src/assets/scss/elements/_pricing.scss","webpack://./src/assets/scss/elements/_split.scss","webpack://./src/assets/scss/elements/_callto-action.scss","webpack://./src/assets/scss/elements/_video.scss","webpack://./src/assets/scss/elements/_contact.scss","webpack://./src/assets/scss/elements/_brand.scss","webpack://./src/assets/scss/elements/_newsletter.scss","webpack://./src/assets/scss/elements/_advance-tab.scss","webpack://./src/assets/scss/elements/_advancepricing.scss","webpack://./src/assets/scss/elements/_about.scss","webpack://./src/assets/scss/elements/_swicher.scss","webpack://./src/assets/scss/elements/_404.scss","webpack://./src/assets/scss/blog/_blog.scss","webpack://./src/assets/scss/blog/_sidebar.scss","webpack://./src/assets/scss/blog/_blog-details.scss","webpack://./src/assets/scss/template/_banner.scss","webpack://./src/assets/scss/template/_portfoliodetails.scss","webpack://./src/assets/scss/template/_splash.scss","webpack://./src/assets/scss/template/_manpage.scss","webpack://./src/assets/scss/footer/_footer.scss","webpack://./src/assets/scss/footer/_copyright.scss","webpack://./src/assets/scss/footer/_darkmode.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;uCAAA;ACAA,kBAAA;AACA;EAEI,wBAAA;EACA,sCAAA;EACA,4BAAA;EACA,8BAAA;EACA,iCAAA;EACA,0BAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;EACA,4BAAA;EACA,+BAAA;EACA,gCAAA;EACA,iCAAA;EACA,mCAAA;EACA,4BAAA;EAGA,wBAAA;EACA,qBAAA;EAEA,qBAAA;EACA,kCAAA;EACA,mCAAA;EAEA,sBAAA;EACA,oCAAA;EACA,yBAAA;EACA,sCAAA;EAGA,yBAAA;EAMA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;EAEA,sBAAA;EAKA,wBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA;EAIA,yBAAA;EACA,wBAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EAIA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EAMA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EAIA,oDAAA;EACA,+CAAA;EACA,uDAAA;EAIA,kBAAA;EACA,gEAAA;EAGA,mCAAA;EACA,qCAAA;EACA,oCAAA;EAKA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAGA,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;ADrCJ;;AE7FA;;EAAA;AAKC;EAGG,sBAAA;AF8FJ;;AE1FA;;;;;;;;;;EAUI,cAAA;AF6FJ;;AE1FA;;;EAGI,qBAAA;AF6FJ;;AE1FA;EACI,aAAA;EACA,SAAA;AF6FJ;;AE1FA;EACI,aAAA;AF6FJ;;AEzFA;EACI,2BAAA;EACA,qBAAA;EACA,aAAA;AF4FJ;;AExFA;;;EAGC,qBAAA;EACA,aAAA;EACA,2BAAA;AF2FD;;AExFA;EACI,aAAA;AF2FJ;;AEzFA;EACI,gBAAA;AF4FJ;;AEzFA;EACI,yBAAA;AF4FJ;;AEzFA;;EAEI,iBAAA;AF4FJ;;AE1FA;EACI,gCAAA;EACA,cAAA;AF6FJ;;AE3FA;;;;EAII,8BAAA;EAIA,aAAA;EACA,2BAAA;AF8FJ;;AE5FA;;EAEI,cAAA;AF+FJ;;AEzFA;;EAEI,8DAAA;EACA,0BAAA;EACA,yBAAA;EACA,cAAA;EACA,wBAAA;EACA,2BAAA;EACA,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,8BAAA;EACA,kBAAA;AF4FJ;;AExFA;EACI,kBAAA;AF2FJ;;AExFA;;EAEI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AF2FJ;;AEzFA;EACI,WAAA;AF4FJ;;AE1FA;EACI,eAAA;AF6FJ;;AE1FA;EACI,aAAA;EACA,mBAAA;AF6FJ;;AE1FA;EACI,mBAAA;AF6FJ;;AE3FA;EACI,iBAAA;EACA,2BAAA;AF8FJ;;AE3FA;;;EAGI,cAAA;EACA,mBAAA;AF8FJ;;AE3FA;;EAEI,gBAAA;EACA,sBAAA;AF8FJ;;AE5FA;;EAEI,SAAA;AF+FJ;;AE3FI;EACI,gBAAA;AF8FR;;AE1FA;EACI,+BAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AF6FJ;;AE3FA;EACE;IACE,YAAA;IACA,2BAAA;IACA,eAAA;EF8FF;EE5FA;IACE,YAAA;IACA,2BAAA;IACA,eAAA;EF8FF;AACF;AE5FA;EACI,gBAAA;AF8FJ;;AE5FA;EACI,SAAA;AF+FJ;;AE7FA;EACI,SAAA;AFgGJ;;AE9FA;EACI,qCAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;AFiGJ;;AE/FA;EACI,SAAA;EACA,UAAA;EACA,mBAAA;AFkGJ;;AE/FA;;;;EAII,eAAA;EACA,SAAA;EACA,eAAA;EACA,wBAAA;AFkGJ;;AE/FA;;EAEI,mBAAA;AFkGJ;;AE/FA;;;;EAMI,kBAAA;EACA,eAAA;AFkGJ;;AE/FA;;EAEI,eAAA;AFkGJ;;AE/FA;;EAEI,UAAA;AFkGJ;;AE/FA;EAGI,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;AFkGJ;;AE/FA;EAEI,gBAAA;AFkGJ;;AE/FA;;EAEI,SAAA;EACA,UAAA;AFkGJ;;AEhGA;EACI,cAAA;EACA,mBAAA;AFmGJ;;AEjGA;;;EAGI,mBAAA;AFoGJ;;AElGA;EACI,gBAAA;AFqGJ;;AElGA;;EAEI,qCAAA;EACA,iBAAA;AFqGJ;;AEnGA;EACI,WAAA;AFsGJ;;AEnGA;EACI,kCAAA;EACA,qBAAA;EACA,cAAA;AFsGJ;;AEpGA;EACI,wBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AFuGJ;;AErGA;;;EAGI,0BAAA;AFwGJ;;AErGA;EACI,iBAAA;EACA,mBAAA;AFwGJ;;AErGA;EACI,mBAAA;AFwGJ;;AErGA;EACI,iBAAA;AFwGJ;;AErGA;EACI,gCAAA;AFwGJ;;AErGA;;;EAGI,kBAAA;AFwGJ;;AEpGA,gBAAA;AACA;;EAKI,aAAA;EACA,YAAA;AFuGJ;;AEpGA;;;;EAII,WAAA;EACA,aAAA;AFuGJ;;AEpGA;EACI,8BAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;AFuGJ;;AEpGA;EACI,eAAA;AFuGJ;;AEpGA;;EAEI,8BAAA;EACA,mBAAA;AFuGJ;;AEpGA;;EAEI,gBAAA;AFuGJ;;AG9cA;;EAAA;AAKA;EACC,sBAAA;AH+cD;;AG5cA;EACC,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AH+cD;;AG5cA;EACC,gBAAA;EACA,8BAAA;EACA,kCAAA;EACA,mCAAA;EACA,kCAAA;EACA,gCAAA;EACA,wBAAA;EACA,6BAAA;EACA,mCAAA;EACA,SAAA;EACG,UAAA;AH+cJ;;AG5cA;;;;;;;;;;;;;;;;;;;;;EAqBC,SAAA;EACA,mBAAA;AH+cD;;AG5cA;;;;;;;;;;;;EAYC,sBAAA;EACA,kCAAA;EACA,mBAAA;EACA,2BAAA;AH+cD;;AG5cA;;EAEC,oBAAA;EACA,iBAAA;AH+cD;;AG5cA;;EAEC,oBAAA;EACA,iBAAA;AH+cD;;AG5cA;;EAEC,oBAAA;EACA,gBAAA;AH+cD;;AG5cA;;EAEC,oBAAA;EACA,iBAAA;AH+cD;;AG5cA;;EAEC,oBAAA;EACA,iBAAA;AH+cD;;AG5cA;;EAEC,oBAAA;EACA,iBAAA;AH+cD;;AGhcC;;;;;;;;;;;;EACC,cAAA;EACA,gBAAA;AH8cF;;AG1cA;EACC,wBAAA;AH6cD;;AG3cA;EACC;;IAEC,eAAA;EH8cA;EG5cD;;IAEC,eAAA;EH8cA;EG3cD;;IAEC,eAAA;EH6cA;EG1cD;;IAEC,eAAA;EH4cA;EGzcD;;IAEC,eAAA;EH2cA;AACF;AGvcA;EACC;;IAEC,eAAA;EHycA;EGtcD;;IAEC,eAAA;EHwcA;EGrcD;;IAEC,eAAA;EHucA;EGpcD;;IAEC,eAAA;EHscA;EGncD;;IAEC,eAAA;EHqcA;AACF;AGhcA;;;;;;EAMC,0BAAA;AHkcD;;AG/bA;;;;EAIC,0BAAA;AHkcD;;AG/bA;;EAEC,4BAAA;AHkcD;;AG/bA;EACC,8BAAA;EACA,kCAAA;EACA,6BAAA;EACA,wBAAA;EACA,gBAAA;AHkcD;AGhcC;EAPD;IAQE,gBAAA;IACA,8BAAA;IACA,kCAAA;EHmcA;AACF;AGjcC;EACC,gBAAA;EACA,eAAA;AHmcF;AGhcC;EACC,eAAA;EACA,iBAAA;AHkcF;AG/bC;EACC,eAAA;AHicF;AG9bC;EACC,yBAAA;AHgcF;AG7bC;EACC,kBAAA;AH+bF;AG5bC;EACC,8BAAA;EACA,kCAAA;AH8bF;AG3bC;EACC,8BAAA;EACA,kCAAA;AH6bF;AG1bC;EACC,8BAAA;EACA,kCAAA;AH4bF;AGzbC;EACC,8BAAA;EACA,kCAAA;AH2bF;;AGrbA;EACC,8BAAA;EACA,kCAAA;AHwbD;;AGrbA;EACC,8BAAA;EACA,kCAAA;AHwbD;;AGrbA;EACC,8BAAA;EACA,kCAAA;AHwbD;;AGrbA;EACC,8BAAA;EACA,kCAAA;AHwbD;;AGpbA;EACC,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AHubD;;AGpbA;;;EAGC,qBAAA;AHubD;;AGpbA;;;;EAIC,2BAAA;AHubD;;AGnbA;EACC,mDAAA;AHsbD;;AGnbA;;4BAAA;AAGA;;EAEC,kBAAA;AHsbD;;AGnbA;EACC,kBAAA;EACA,mBAAA;EACA,kBAAA;AHsbD;AGlbG;EACC,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;AHobJ;AGlbI;EAPD;IAQE,kBAAA;EHqbH;AACF;AGnbI;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,OAAA;EACA,SAAA;AHqbL;AGlbI;EACC,eAAA;AHobL;AG9aC;EACC,8BAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;AHgbF;AG9aE;EACC,qBAAA;EACA,wBAAA;AHgbH;AG7aG;EACC,2BAAA;AH+aJ;AG1aC;EACC,gBAAA;AH4aF;;AGxaA;EACC,mBAAA;AH2aD;AG1aC;EACC,8BAAA;EACA,kCAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AH4aF;AG3aE;EACC,2BAAA;EAEA,qBAAA;AH4aH;AG3aG;EACC,2BAAA;AH6aJ;AGzaC;EACC,kBAAA;AH2aF;;AGxaA;EACI,cAAA;EACA,SAAA;EACA,mBAAA;EACA,yCAAA;AH2aJ;;AGzaA;EACI,gCAAA;AH4aJ;;AIr0BA;;wBAAA;AAGA;EACI,sCAAA;AJw0BJ;;AIr0BA;EACI,4CAAA;AJw0BJ;;AIr0BA;EACI,0CAAA;AJw0BJ;;AIr0BA;EACI,wCAAA;AJw0BJ;;AIt0BA;EACI,uCAAA;AJy0BJ;;AIv0BA;EACI,2CAAA;AJ00BJ;;AIx0BA;EACI,0CAAA;AJ20BJ;;AIz0BA;EACI,mCAAA;AJ40BJ;;AI10BA;EACI,6CAAA;AJ60BJ;;AI30BA;EACI,+CAAA;AJ80BJ;;AI50BA;EACI,iDAAA;AJ+0BJ;;AI70BA;EACI,0CAAA;AJg1BJ;;AI90BA;EACI,sCAAA;AJi1BJ;;AI/0BA;EACI,mCAAA;AJk1BJ;;AIh1BA;EACI,mCAAA;AJm1BJ;;AIj1BA;EACI,qCAAA;AJo1BJ;;AIl1BA;EACI,sCAAA;AJq1BJ;;AIn1BA;EACI,oCAAA;AJs1BJ;;AIp1BA;EACI,sCAAA;AJu1BJ;;AIr1BA;EACI,uCAAA;AJw1BJ;;AIt1BA;EACI,qCAAA;AJy1BJ;;AIv1BA;EACI,mCAAA;AJ01BJ;;AIx1BA;EACI,sCAAA;AJ21BJ;;AIz1BA;EACI,oCAAA;AJ41BJ;;AIz1BA;EACI,sCAAA;AJ41BJ;;AI11BA;EACI,uCAAA;AJ61BJ;;AI31BA;EACI,oCAAA;AJ81BJ;;AIv1BA;EACI,gCAAA;AJ01BJ;;AIxvBA,WAAA;AACA;EACI,kCAAA;AJ2vBJ;;AIxvBA;EACI,4BAAA;AJ2vBJ;;AIxvBA;EACI,gCAAA;AJ2vBJ;;AIxvBA,gBAAA;AAEA;EACI,2BAAA;AJ0vBJ;;AIxvBA;EACI,2BAAA;AJ2vBJ;;AIzvBA;EACI,2BAAA;AJ4vBJ;;AI1vBA;EACI,2BAAA;AJ6vBJ;;AI3vBA;EACI,2BAAA;AJ8vBJ;;AI5vBA;EACI,2BAAA;AJ+vBJ;;AI7vBA;EACI,2BAAA;AJgwBJ;;AI7vBA,YAAA;AAEA;EACI,iCAAA;AJ+vBJ;;AI7vBA;EACI,+BAAA;AJgwBJ;;AI9vBA;EACI,iCAAA;AJiwBJ;;AIhvBA,0CAAA;AAEA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AJkvBJ;;AI/uBA;;EACI,6BAAA;AJmvBJ;;AIhvBA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;AJmvBJ;;AKjgCA;;wBAAA;AAGA;EACI,gBAAA;ALogCJ;AKlgCI;EACI,gBAAA;ALogCR;AKjgCQ;EACI,qBAAA;ALmgCZ;;AK7/BA;EACI;IACI,mBAAA;ELggCN;EK7/BE;IACI,qBAAA;EL+/BN;EK5/BE;IACI,mBAAA;EL8/BN;AACF;AK3/BA;EACI;IACI,8BAAA;EL6/BN;EK1/BE;IACI,gCAAA;EL4/BN;EKz/BE;IACI,gCAAA;EL2/BN;AACF;AKx/BA;EACI,gCAAA;AL0/BJ;;AKp/BA;;6BAAA;AAcA;EACI;IACI,kBAAA;ELo/BN;EKj/BE;IACI,aAAA;ELm/BN;AACF;AK/+BA;;2BAAA;AAkBA;EACI;IACI,UAAA;IAEA,iCAAA;EL8+BN;EK3+BE;IACI,UAAA;IAEA,eAAA;EL6+BN;AACF;AK1+BA;EAEI,6BAAA;AL4+BJ;;AKz+BA;;wCAAA;AAWA;EACI;IACI,UAAA;IAEA,wBAAA;EL0+BN;AACF;AKl+BA;;mCAAA;AAGA;EACI;IACI,UAAA;ELo+BN;EKj+BE;IACI,wBAAA;IACA,UAAA;ELm+BN;EKh+BE;IACI,2BAAA;IACA,UAAA;ELk+BN;AACF;AM5nCA;;kCAAA;AAIA;;CAAA;AAKA;EACI,mBAAA;EACA,kBAAA;AN2nCJ;;AMxnCA;EACI,kBAAA;EACA,mBAAA;AN2nCJ;;AMxnCA;EACI;IACI,iBAAA;EN2nCN;AACF;AMxnCA;;EAEI,YAAA;EACA,cAAA;AN0nCJ;;AMxnCA;EACI,WAAA;AN2nCJ;;AMznCA;EACI,gBAAA;AN4nCJ;;AMznCA;EACI,oBAAA;AN4nCJ;;AMxnCA;;kCAAA;AChCE;EACC,gCAAA;AP8pCH;;AO/pCE;EACC,kCAAA;APkqCH;;AOnqCE;EACC,iCAAA;APsqCH;;AOvqCE;EACC,mBAAA;AP0qCH;;AO3qCE;EACC,mBAAA;AP8qCH;;AO/qCE;EACC,mBAAA;APkrCH;;AOnrCE;EACC,gCAAA;APsrCH;;AOvrCE;EACC,iCAAA;AP0rCH;;AO3rCE;EACC,gCAAA;AP8rCH;;AM9oCA;EACI,iDAAA;UAAA,yCAAA;EACA,qCAAA;EACA,0EAAA;ANipCJ;;AM9oCA;;8BAAA;AAOA;EACI,uCAAA;AN6oCJ;;AM3oCA,qBAAA;AACA;EACI,iBAAA;EACA,WAAA;AN8oCJ;;AM1oCA;;uBAAA;AAGA;EACI,gBAAA;EACA,iBAAA;AN6oCJ;AM3oCI;EACI,iBAAA;EACA,kBAAA;AN6oCR;;AMzoCA;EACI,iBAAA;EACA,kBAAA;AN4oCJ;AM1oCI;EACI,iBAAA;EACA,kBAAA;AN4oCR;;AMxoCA;EACI,kBAAA;EACA,mBAAA;AN2oCJ;AMzoCI;EACI,kBAAA;EACA,mBAAA;AN2oCR;;AMvoCA;EACI,kBAAA;EACA,mBAAA;AN0oCJ;AMxoCI;EACI,kBAAA;EACA,mBAAA;AN0oCR;;AMtoCA;EACI,kBAAA;EACA,mBAAA;ANyoCJ;AMtoCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;ENyoCN;AACF;AMvoCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;EN0oCN;AACF;AMxoCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;EN2oCN;AACF;AMzoCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;EN4oCN;AACF;AM1oCI;EAEI,kBAAA;EACA,mBAAA;AN2oCR;AMxoCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;EN2oCV;AACF;AMzoCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;EN4oCV;AACF;AM1oCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;EN6oCV;AACF;AM3oCQ;EArBJ;IAsBQ,6BAAA;IACA,8BAAA;EN8oCV;AACF;;AM1oCA;EACI,kBAAA;EACA,mBAAA;AN6oCJ;AM1oCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;EN6oCN;AACF;AM3oCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;EN8oCN;AACF;AM5oCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;EN+oCN;AACF;AM7oCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;ENgpCN;AACF;AM9oCI;EAEI,kBAAA;EACA,mBAAA;AN+oCR;AM5oCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;EN+oCV;AACF;AM7oCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;ENgpCV;AACF;AM9oCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;ENipCV;AACF;AM/oCQ;EArBJ;IAsBQ,6BAAA;IACA,8BAAA;ENkpCV;AACF;;AM7oCA;EACI,kBAAA;EACA,mBAAA;ANgpCJ;AM7oCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;ENgpCN;AACF;AM9oCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;ENipCN;AACF;AM/oCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;ENkpCN;AACF;AMhpCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;ENmpCN;AACF;AMjpCI;EAEI,kBAAA;EACA,mBAAA;ANkpCR;AM/oCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;ENkpCV;AACF;AMhpCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;ENmpCV;AACF;AMjpCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;ENopCV;AACF;AMlpCQ;EArBJ;IAsBQ,6BAAA;IACA,8BAAA;ENqpCV;AACF;;AMhpCA;EACI,kBAAA;EACA,mBAAA;ANmpCJ;AMhpCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;ENmpCN;AACF;AMjpCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;ENopCN;AACF;AMlpCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;ENqpCN;AACF;AMnpCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;ENspCN;AACF;AMppCI;EAEI,kBAAA;EACA,mBAAA;ANqpCR;AMlpCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;ENqpCV;AACF;AMnpCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;ENspCV;AACF;AMppCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;ENupCV;AACF;AMtpCQ;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;ENypCV;AACF;;AMrpCA;EACI,kBAAA;EACA,mBAAA;ANwpCJ;AMrpCI;EALJ;IAMQ,kBAAA;IACA,mBAAA;ENwpCN;AACF;AMtpCI;EAVJ;IAWQ,kBAAA;IACA,mBAAA;ENypCN;AACF;AMvpCI;EAfJ;IAgBQ,kBAAA;IACA,mBAAA;EN0pCN;AACF;AMxpCI;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;EN2pCN;AACF;AMzpCI;EAEI,kBAAA;EACA,mBAAA;AN0pCR;AMvpCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;EN0pCV;AACF;AMxpCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;EN2pCV;AACF;AMzpCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;EN4pCV;AACF;AM3pCQ;EApBJ;IAqBQ,6BAAA;IACA,8BAAA;EN8pCV;AACF;;AM1pCA;EACI,kBAAA;EACA,mBAAA;AN6pCJ;AM3pCI;EAJJ;IAKQ,kBAAA;IACA,mBAAA;EN8pCN;AACF;AM5pCI;EATJ;IAUQ,kBAAA;IACA,mBAAA;EN+pCN;AACF;AM7pCI;EAdJ;IAeQ,kBAAA;IACA,mBAAA;ENgqCN;AACF;AM9pCI;EAnBJ;IAoBQ,6BAAA;IACA,8BAAA;ENiqCN;AACF;AM/pCI;EAEI,kBAAA;EACA,mBAAA;ANgqCR;AM7pCQ;EANJ;IAOQ,kBAAA;IACA,mBAAA;ENgqCV;AACF;AM9pCQ;EAXJ;IAYQ,kBAAA;IACA,mBAAA;ENiqCV;AACF;AM/pCQ;EAhBJ;IAiBQ,6BAAA;IACA,8BAAA;ENkqCV;AACF;AMhqCQ;EArBJ;IAsBQ,6BAAA;IACA,8BAAA;ENmqCV;AACF;;AM9pCA;;8BAAA;AAGA;;EAEI,UAAA;EACA,kEAAA;ANiqCJ;;AM9pCA;;EAEI,UAAA;EACA,kEAAA;ANiqCJ;;AM9pCA;;EAEI,UAAA;EACA,kEAAA;ANiqCJ;;AM9pCA;;EAEI,UAAA;EACA,kEAAA;ANiqCJ;;AM9pCA;;+BAAA;AAIA;;;EAGI,kBAAA;ANgqCJ;;AM7pCA;;;;;;EAMI,kBAAA;EACA,UAAA;ANgqCJ;;AM7pCA;;;EAGI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;ANgqCJ;;AMzpCA;EACI,yBAAA;AN4pCJ;;AMzpCA;EACI,yBAAA;AN4pCJ;;AMxpCI;;;EAGI,YAAA;AN2pCR;;AM9pCI;;;EAGI,YAAA;ANiqCR;;AMpqCI;;;EAGI,YAAA;ANuqCR;;AM1qCI;;;EAGI,YAAA;AN6qCR;;AMhrCI;;;EAGI,YAAA;ANmrCR;;AMtrCI;;;EAGI,YAAA;ANyrCR;;AM5rCI;;;EAGI,YAAA;AN+rCR;;AMlsCI;;;EAGI,YAAA;ANqsCR;;AMxsCI;;;EAGI,YAAA;AN2sCR;;AM9sCI;;;EAGI,UAAA;ANitCR;;AM7sCA;;iCAAA;AAIA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EAEA,qBAAA;EACA,mBAAA;AN8sCJ;AM7sCI;EAhBJ;IAiBQ,WAAA;IACA,YAAA;ENgtCN;AACF;AM/sCI;EApBJ;IAqBQ,WAAA;IACA,YAAA;ENktCN;AACF;AMjtCI;EACI,WAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,0BAAA;EACA,kBAAA;ANmtCR;AMjtCI;EACI,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,0BAAA;ANmtCR;AMhtCI;EApDJ;IAqDQ,WAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;ENmtCN;AACF;AMhtCQ;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;ANktCZ;AMjtCY;EAJJ;IAKQ,eAAA;ENotCd;AACF;AMntCY;EACI,QAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,sEAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;ANqtChB;AM/sCY;EACI,2BAAA;ANitChB;;AMxsCA;;uBAAA;AAGA;EACI,gBAAA;EACA,kBAAA;AN2sCJ;AM1sCI;EACI,gBAAA;EACA,cAAA;AN4sCR;AM1sCI;EACI,gBAAA;EACA,cAAA;AN4sCR;;AQp0DA;;2BAAA;AAIA;EACI,2BAAA;ARs0DJ;;AQn0DA;EACI,iBAAA;ARs0DJ;;AQn0DA;EACI,iBAAA;ARs0DJ;;AQp0DA;EACI,0BAAA;ARu0DJ;;AQr0DA;EACI,2BAAA;ARw0DJ;AQv0DI;EAFJ;IAGQ,0BAAA;ER00DN;AACF;AQz0DI;EALJ;IAMQ,0BAAA;ER40DN;AACF;;AQ10DA;EACI,0BAAA;AR60DJ;AQ50DI;EAFJ;IAGQ,0BAAA;ER+0DN;AACF;AQ90DI;EALJ;IAMQ,0BAAA;ERi1DN;AACF;;AQ/0DA;EACI,gCAAA;ARk1DJ;AQj1DI;EAFJ;IAGQ,+BAAA;ERo1DN;AACF;AQn1DI;EALJ;IAMQ,+BAAA;ERs1DN;AACF;;AQj1DI;EAFJ;;IAGQ,+BAAA;ERs1DN;AACF;AQr1DI;EALJ;;IAMQ,+BAAA;ERy1DN;AACF;;AQt1DA;EACI,6BAAA;ARy1DJ;AQx1DI;EAFJ;IAGQ,4BAAA;ER21DN;AACF;AQ11DI;EALJ;IAMQ,4BAAA;ER61DN;AACF;;AQv1DI;EADJ;IAEQ,0BAAA;ER21DN;AACF;AQ11DI;EAJJ;IAKQ,0BAAA;ER61DN;AACF;;AQt1DI;EAJJ;;;;IAKQ,+BAAA;ER61DN;AACF;AQ51DI;EAPJ;;;;IAQQ,+BAAA;ERk2DN;AACF;;AQ91DI;EADJ;IAEQ,+BAAA;ERk2DN;AACF;;AQ/1DA;EACI,0BAAA;ARk2DJ;;AQh2DA;EACI,2BAAA;ARm2DJ;;AQj2DA;EACI,yBAAA;ARo2DJ;;AQl2DA;EACI,4BAAA;ARq2DJ;;AQn2DA;EACI,0BAAA;ARs2DJ;;AQp2DA;EACI,yBAAA;ARu2DJ;;AQr2DA;EACI,wBAAA;ARw2DJ;;AQt2DA;EACI,2BAAA;ARy2DJ;;AQt2DA;EACI,6BAAA;ARy2DJ;;AQt2DA;EACI,6BAAA;ARy2DJ;;AQt2DA;EACI,gCAAA;ARy2DJ;;AQt2DA;EACI,gCAAA;ARy2DJ;;AQt2DA;EACI,2BAAA;ARy2DJ;;AQt2DA;EACI,2BAAA;ARy2DJ;;AQt2DA;EACI,2BAAA;ARy2DJ;;AQt2DA;EACI,2BAAA;ARy2DJ;;AQt2DA;EACI,2BAAA;ARy2DJ;;AQt2DA;EACI,2BAAA;ARy2DJ;;AQt2DA;EACI,0BAAA;ARy2DJ;;AQt2DA;EACI,6BAAA;ARy2DJ;;AQr2DI;EAAkB,yBAAA;ARy2DtB;;AQx2DI;EAAkB,yBAAA;AR42DtB;;AQ32DI;EAAiB,2BAAA;AR+2DrB;;AQ92DI;EAAiB,8BAAA;ARk3DrB;;AQj3DI;EAAiB,4BAAA;ARq3DrB;;AQp3DI;EAAiB,6BAAA;ARw3DrB;;AQv3DI;EAAgB,0BAAA;AR23DpB;;AQ13DI;EAAgB,6BAAA;AR83DpB;;AQ73DI;EAAgB,4BAAA;ARi4DpB;;AQh4DI;EAAgB,2BAAA;ARo4DpB;;AQ74DI;EAAkB,0BAAA;ARi5DtB;;AQh5DI;EAAkB,0BAAA;ARo5DtB;;AQn5DI;EAAiB,4BAAA;ARu5DrB;;AQt5DI;EAAiB,+BAAA;AR05DrB;;AQz5DI;EAAiB,6BAAA;AR65DrB;;AQ55DI;EAAiB,8BAAA;ARg6DrB;;AQ/5DI;EAAgB,2BAAA;ARm6DpB;;AQl6DI;EAAgB,8BAAA;ARs6DpB;;AQr6DI;EAAgB,6BAAA;ARy6DpB;;AQx6DI;EAAgB,4BAAA;AR46DpB;;AQr7DI;EAAkB,0BAAA;ARy7DtB;;AQx7DI;EAAkB,0BAAA;AR47DtB;;AQ37DI;EAAiB,4BAAA;AR+7DrB;;AQ97DI;EAAiB,+BAAA;ARk8DrB;;AQj8DI;EAAiB,6BAAA;ARq8DrB;;AQp8DI;EAAiB,8BAAA;ARw8DrB;;AQv8DI;EAAgB,2BAAA;AR28DpB;;AQ18DI;EAAgB,8BAAA;AR88DpB;;AQ78DI;EAAgB,6BAAA;ARi9DpB;;AQh9DI;EAAgB,4BAAA;ARo9DpB;;AQ79DI;EAAkB,0BAAA;ARi+DtB;;AQh+DI;EAAkB,0BAAA;ARo+DtB;;AQn+DI;EAAiB,4BAAA;ARu+DrB;;AQt+DI;EAAiB,+BAAA;AR0+DrB;;AQz+DI;EAAiB,6BAAA;AR6+DrB;;AQ5+DI;EAAiB,8BAAA;ARg/DrB;;AQ/+DI;EAAgB,2BAAA;ARm/DpB;;AQl/DI;EAAgB,8BAAA;ARs/DpB;;AQr/DI;EAAgB,6BAAA;ARy/DpB;;AQx/DI;EAAgB,4BAAA;AR4/DpB;;AQrgEI;EAAkB,0BAAA;ARygEtB;;AQxgEI;EAAkB,0BAAA;AR4gEtB;;AQ3gEI;EAAiB,4BAAA;AR+gErB;;AQ9gEI;EAAiB,+BAAA;ARkhErB;;AQjhEI;EAAiB,6BAAA;ARqhErB;;AQphEI;EAAiB,8BAAA;ARwhErB;;AQvhEI;EAAgB,2BAAA;AR2hEpB;;AQ1hEI;EAAgB,8BAAA;AR8hEpB;;AQ7hEI;EAAgB,6BAAA;ARiiEpB;;AQhiEI;EAAgB,4BAAA;ARoiEpB;;AQ7iEI;EAAkB,0BAAA;ARijEtB;;AQhjEI;EAAkB,0BAAA;ARojEtB;;AQnjEI;EAAiB,4BAAA;ARujErB;;AQtjEI;EAAiB,+BAAA;AR0jErB;;AQzjEI;EAAiB,6BAAA;AR6jErB;;AQ5jEI;EAAiB,8BAAA;ARgkErB;;AQ/jEI;EAAgB,2BAAA;ARmkEpB;;AQlkEI;EAAgB,8BAAA;ARskEpB;;AQrkEI;EAAgB,6BAAA;ARykEpB;;AQxkEI;EAAgB,4BAAA;AR4kEpB;;AQrlEI;EAAkB,0BAAA;ARylEtB;;AQxlEI;EAAkB,0BAAA;AR4lEtB;;AQ3lEI;EAAiB,4BAAA;AR+lErB;;AQ9lEI;EAAiB,+BAAA;ARkmErB;;AQjmEI;EAAiB,6BAAA;ARqmErB;;AQpmEI;EAAiB,8BAAA;ARwmErB;;AQvmEI;EAAgB,2BAAA;AR2mEpB;;AQ1mEI;EAAgB,8BAAA;AR8mEpB;;AQ7mEI;EAAgB,6BAAA;ARinEpB;;AQhnEI;EAAgB,4BAAA;ARonEpB;;AQ7nEI;EAAkB,0BAAA;ARioEtB;;AQhoEI;EAAkB,0BAAA;ARooEtB;;AQnoEI;EAAiB,4BAAA;ARuoErB;;AQtoEI;EAAiB,+BAAA;AR0oErB;;AQzoEI;EAAiB,6BAAA;AR6oErB;;AQ5oEI;EAAiB,8BAAA;ARgpErB;;AQ/oEI;EAAgB,2BAAA;ARmpEpB;;AQlpEI;EAAgB,8BAAA;ARspEpB;;AQrpEI;EAAgB,6BAAA;ARypEpB;;AQxpEI;EAAgB,4BAAA;AR4pEpB;;AQrqEI;EAAkB,0BAAA;ARyqEtB;;AQxqEI;EAAkB,0BAAA;AR4qEtB;;AQ3qEI;EAAiB,4BAAA;AR+qErB;;AQ9qEI;EAAiB,+BAAA;ARkrErB;;AQjrEI;EAAiB,6BAAA;ARqrErB;;AQprEI;EAAiB,8BAAA;ARwrErB;;AQvrEI;EAAgB,2BAAA;AR2rEpB;;AQ1rEI;EAAgB,8BAAA;AR8rEpB;;AQ7rEI;EAAgB,6BAAA;ARisEpB;;AQhsEI;EAAgB,4BAAA;ARosEpB;;AQ7sEI;EAAkB,0BAAA;ARitEtB;;AQhtEI;EAAkB,0BAAA;ARotEtB;;AQntEI;EAAiB,4BAAA;ARutErB;;AQttEI;EAAiB,+BAAA;AR0tErB;;AQztEI;EAAiB,6BAAA;AR6tErB;;AQ5tEI;EAAiB,8BAAA;ARguErB;;AQ/tEI;EAAgB,2BAAA;ARmuEpB;;AQluEI;EAAgB,8BAAA;ARsuEpB;;AQruEI;EAAgB,6BAAA;ARyuEpB;;AQxuEI;EAAgB,4BAAA;AR4uEpB;;AQrvEI;EAAkB,0BAAA;ARyvEtB;;AQxvEI;EAAkB,0BAAA;AR4vEtB;;AQ3vEI;EAAiB,4BAAA;AR+vErB;;AQ9vEI;EAAiB,+BAAA;ARkwErB;;AQjwEI;EAAiB,6BAAA;ARqwErB;;AQpwEI;EAAiB,8BAAA;ARwwErB;;AQvwEI;EAAgB,2BAAA;AR2wEpB;;AQ1wEI;EAAgB,8BAAA;AR8wEpB;;AQ7wEI;EAAgB,6BAAA;ARixEpB;;AQhxEI;EAAgB,4BAAA;ARoxEpB;;AQ7xEI;EAAkB,0BAAA;ARiyEtB;;AQhyEI;EAAkB,0BAAA;ARoyEtB;;AQnyEI;EAAiB,4BAAA;ARuyErB;;AQtyEI;EAAiB,+BAAA;AR0yErB;;AQzyEI;EAAiB,6BAAA;AR6yErB;;AQ5yEI;EAAiB,8BAAA;ARgzErB;;AQ/yEI;EAAgB,2BAAA;ARmzEpB;;AQlzEI;EAAgB,8BAAA;ARszEpB;;AQrzEI;EAAgB,6BAAA;ARyzEpB;;AQxzEI;EAAgB,4BAAA;AR4zEpB;;AQr0EI;EAAkB,0BAAA;ARy0EtB;;AQx0EI;EAAkB,0BAAA;AR40EtB;;AQ30EI;EAAiB,4BAAA;AR+0ErB;;AQ90EI;EAAiB,+BAAA;ARk1ErB;;AQj1EI;EAAiB,6BAAA;ARq1ErB;;AQp1EI;EAAiB,8BAAA;ARw1ErB;;AQv1EI;EAAgB,2BAAA;AR21EpB;;AQ11EI;EAAgB,8BAAA;AR81EpB;;AQ71EI;EAAgB,6BAAA;ARi2EpB;;AQh2EI;EAAgB,4BAAA;ARo2EpB;;AQ72EI;EAAkB,0BAAA;ARi3EtB;;AQh3EI;EAAkB,0BAAA;ARo3EtB;;AQn3EI;EAAiB,4BAAA;ARu3ErB;;AQt3EI;EAAiB,+BAAA;AR03ErB;;AQz3EI;EAAiB,6BAAA;AR63ErB;;AQ53EI;EAAiB,8BAAA;ARg4ErB;;AQ/3EI;EAAgB,2BAAA;ARm4EpB;;AQl4EI;EAAgB,8BAAA;ARs4EpB;;AQr4EI;EAAgB,6BAAA;ARy4EpB;;AQx4EI;EAAgB,4BAAA;AR44EpB;;AQr5EI;EAAkB,0BAAA;ARy5EtB;;AQx5EI;EAAkB,0BAAA;AR45EtB;;AQ35EI;EAAiB,4BAAA;AR+5ErB;;AQ95EI;EAAiB,+BAAA;ARk6ErB;;AQj6EI;EAAiB,6BAAA;ARq6ErB;;AQp6EI;EAAiB,8BAAA;ARw6ErB;;AQv6EI;EAAgB,2BAAA;AR26EpB;;AQ16EI;EAAgB,8BAAA;AR86EpB;;AQ76EI;EAAgB,6BAAA;ARi7EpB;;AQh7EI;EAAgB,4BAAA;ARo7EpB;;AQ77EI;EAAkB,0BAAA;ARi8EtB;;AQh8EI;EAAkB,0BAAA;ARo8EtB;;AQn8EI;EAAiB,4BAAA;ARu8ErB;;AQt8EI;EAAiB,+BAAA;AR08ErB;;AQz8EI;EAAiB,6BAAA;AR68ErB;;AQ58EI;EAAiB,8BAAA;ARg9ErB;;AQ/8EI;EAAgB,2BAAA;ARm9EpB;;AQl9EI;EAAgB,8BAAA;ARs9EpB;;AQr9EI;EAAgB,6BAAA;ARy9EpB;;AQx9EI;EAAgB,4BAAA;AR49EpB;;AQr+EI;EAAkB,0BAAA;ARy+EtB;;AQx+EI;EAAkB,0BAAA;AR4+EtB;;AQ3+EI;EAAiB,4BAAA;AR++ErB;;AQ9+EI;EAAiB,+BAAA;ARk/ErB;;AQj/EI;EAAiB,6BAAA;ARq/ErB;;AQp/EI;EAAiB,8BAAA;ARw/ErB;;AQv/EI;EAAgB,2BAAA;AR2/EpB;;AQ1/EI;EAAgB,8BAAA;AR8/EpB;;AQ7/EI;EAAgB,6BAAA;ARigFpB;;AQhgFI;EAAgB,4BAAA;ARogFpB;;AQ7gFI;EAAkB,0BAAA;ARihFtB;;AQhhFI;EAAkB,0BAAA;ARohFtB;;AQnhFI;EAAiB,4BAAA;ARuhFrB;;AQthFI;EAAiB,+BAAA;AR0hFrB;;AQzhFI;EAAiB,6BAAA;AR6hFrB;;AQ5hFI;EAAiB,8BAAA;ARgiFrB;;AQ/hFI;EAAgB,2BAAA;ARmiFpB;;AQliFI;EAAgB,8BAAA;ARsiFpB;;AQriFI;EAAgB,6BAAA;ARyiFpB;;AQxiFI;EAAgB,4BAAA;AR4iFpB;;AQrjFI;EAAkB,0BAAA;ARyjFtB;;AQxjFI;EAAkB,0BAAA;AR4jFtB;;AQ3jFI;EAAiB,4BAAA;AR+jFrB;;AQ9jFI;EAAiB,+BAAA;ARkkFrB;;AQjkFI;EAAiB,6BAAA;ARqkFrB;;AQpkFI;EAAiB,8BAAA;ARwkFrB;;AQvkFI;EAAgB,2BAAA;AR2kFpB;;AQ1kFI;EAAgB,8BAAA;AR8kFpB;;AQ7kFI;EAAgB,6BAAA;ARilFpB;;AQhlFI;EAAgB,4BAAA;ARolFpB;;AQ7lFI;EAAkB,2BAAA;ARimFtB;;AQhmFI;EAAkB,2BAAA;ARomFtB;;AQnmFI;EAAiB,6BAAA;ARumFrB;;AQtmFI;EAAiB,gCAAA;AR0mFrB;;AQzmFI;EAAiB,8BAAA;AR6mFrB;;AQ5mFI;EAAiB,+BAAA;ARgnFrB;;AQ/mFI;EAAgB,4BAAA;ARmnFpB;;AQlnFI;EAAgB,+BAAA;ARsnFpB;;AQrnFI;EAAgB,8BAAA;ARynFpB;;AQxnFI;EAAgB,6BAAA;AR4nFpB;;AQroFI;EAAkB,2BAAA;ARyoFtB;;AQxoFI;EAAkB,2BAAA;AR4oFtB;;AQ3oFI;EAAiB,6BAAA;AR+oFrB;;AQ9oFI;EAAiB,gCAAA;ARkpFrB;;AQjpFI;EAAiB,8BAAA;ARqpFrB;;AQppFI;EAAiB,+BAAA;ARwpFrB;;AQvpFI;EAAgB,4BAAA;AR2pFpB;;AQ1pFI;EAAgB,+BAAA;AR8pFpB;;AQ7pFI;EAAgB,8BAAA;ARiqFpB;;AQhqFI;EAAgB,6BAAA;ARoqFpB;;AQ7qFI;EAAkB,2BAAA;ARirFtB;;AQhrFI;EAAkB,2BAAA;ARorFtB;;AQnrFI;EAAiB,6BAAA;ARurFrB;;AQtrFI;EAAiB,gCAAA;AR0rFrB;;AQzrFI;EAAiB,8BAAA;AR6rFrB;;AQ5rFI;EAAiB,+BAAA;ARgsFrB;;AQ/rFI;EAAgB,4BAAA;ARmsFpB;;AQlsFI;EAAgB,+BAAA;ARssFpB;;AQrsFI;EAAgB,8BAAA;ARysFpB;;AQxsFI;EAAgB,6BAAA;AR4sFpB;;AQrtFI;EAAkB,2BAAA;ARytFtB;;AQxtFI;EAAkB,2BAAA;AR4tFtB;;AQ3tFI;EAAiB,6BAAA;AR+tFrB;;AQ9tFI;EAAiB,gCAAA;ARkuFrB;;AQjuFI;EAAiB,8BAAA;ARquFrB;;AQpuFI;EAAiB,+BAAA;ARwuFrB;;AQvuFI;EAAgB,4BAAA;AR2uFpB;;AQ1uFI;EAAgB,+BAAA;AR8uFpB;;AQ7uFI;EAAgB,8BAAA;ARivFpB;;AQhvFI;EAAgB,6BAAA;ARovFpB;;AQ7vFI;EAAkB,2BAAA;ARiwFtB;;AQhwFI;EAAkB,2BAAA;ARowFtB;;AQnwFI;EAAiB,6BAAA;ARuwFrB;;AQtwFI;EAAiB,gCAAA;AR0wFrB;;AQzwFI;EAAiB,8BAAA;AR6wFrB;;AQ5wFI;EAAiB,+BAAA;ARgxFrB;;AQ/wFI;EAAgB,4BAAA;ARmxFpB;;AQlxFI;EAAgB,+BAAA;ARsxFpB;;AQrxFI;EAAgB,8BAAA;ARyxFpB;;AQxxFI;EAAgB,6BAAA;AR4xFpB;;AQryFI;EAAkB,2BAAA;ARyyFtB;;AQxyFI;EAAkB,2BAAA;AR4yFtB;;AQ3yFI;EAAiB,6BAAA;AR+yFrB;;AQ9yFI;EAAiB,gCAAA;ARkzFrB;;AQjzFI;EAAiB,8BAAA;ARqzFrB;;AQpzFI;EAAiB,+BAAA;ARwzFrB;;AQvzFI;EAAgB,4BAAA;AR2zFpB;;AQ1zFI;EAAgB,+BAAA;AR8zFpB;;AQ7zFI;EAAgB,8BAAA;ARi0FpB;;AQh0FI;EAAgB,6BAAA;ARo0FpB;;AQ70FI;EAAkB,2BAAA;ARi1FtB;;AQh1FI;EAAkB,2BAAA;ARo1FtB;;AQn1FI;EAAiB,6BAAA;ARu1FrB;;AQt1FI;EAAiB,gCAAA;AR01FrB;;AQz1FI;EAAiB,8BAAA;AR61FrB;;AQ51FI;EAAiB,+BAAA;ARg2FrB;;AQ/1FI;EAAgB,4BAAA;ARm2FpB;;AQl2FI;EAAgB,+BAAA;ARs2FpB;;AQr2FI;EAAgB,8BAAA;ARy2FpB;;AQx2FI;EAAgB,6BAAA;AR42FpB;;AQr3FI;EAAkB,2BAAA;ARy3FtB;;AQx3FI;EAAkB,2BAAA;AR43FtB;;AQ33FI;EAAiB,6BAAA;AR+3FrB;;AQ93FI;EAAiB,gCAAA;ARk4FrB;;AQj4FI;EAAiB,8BAAA;ARq4FrB;;AQp4FI;EAAiB,+BAAA;ARw4FrB;;AQv4FI;EAAgB,4BAAA;AR24FpB;;AQ14FI;EAAgB,+BAAA;AR84FpB;;AQ74FI;EAAgB,8BAAA;ARi5FpB;;AQh5FI;EAAgB,6BAAA;ARo5FpB;;AQ75FI;EAAkB,2BAAA;ARi6FtB;;AQh6FI;EAAkB,2BAAA;ARo6FtB;;AQn6FI;EAAiB,6BAAA;ARu6FrB;;AQt6FI;EAAiB,gCAAA;AR06FrB;;AQz6FI;EAAiB,8BAAA;AR66FrB;;AQ56FI;EAAiB,+BAAA;ARg7FrB;;AQ/6FI;EAAgB,4BAAA;ARm7FpB;;AQl7FI;EAAgB,+BAAA;ARs7FpB;;AQr7FI;EAAgB,8BAAA;ARy7FpB;;AQx7FI;EAAgB,6BAAA;AR47FpB;;AQr8FI;EAAkB,2BAAA;ARy8FtB;;AQx8FI;EAAkB,2BAAA;AR48FtB;;AQ38FI;EAAiB,6BAAA;AR+8FrB;;AQ98FI;EAAiB,gCAAA;ARk9FrB;;AQj9FI;EAAiB,8BAAA;ARq9FrB;;AQp9FI;EAAiB,+BAAA;ARw9FrB;;AQv9FI;EAAgB,4BAAA;AR29FpB;;AQ19FI;EAAgB,+BAAA;AR89FpB;;AQ79FI;EAAgB,8BAAA;ARi+FpB;;AQh+FI;EAAgB,6BAAA;ARo+FpB;;AQ7+FI;EAAkB,2BAAA;ARi/FtB;;AQh/FI;EAAkB,2BAAA;ARo/FtB;;AQn/FI;EAAiB,6BAAA;ARu/FrB;;AQt/FI;EAAiB,gCAAA;AR0/FrB;;AQz/FI;EAAiB,8BAAA;AR6/FrB;;AQ5/FI;EAAiB,+BAAA;ARggGrB;;AQ//FI;EAAgB,4BAAA;ARmgGpB;;AQlgGI;EAAgB,+BAAA;ARsgGpB;;AQrgGI;EAAgB,8BAAA;ARygGpB;;AQxgGI;EAAgB,6BAAA;AR4gGpB;;AQrhGI;EAAkB,2BAAA;ARyhGtB;;AQxhGI;EAAkB,2BAAA;AR4hGtB;;AQ3hGI;EAAiB,6BAAA;AR+hGrB;;AQ9hGI;EAAiB,gCAAA;ARkiGrB;;AQjiGI;EAAiB,8BAAA;ARqiGrB;;AQpiGI;EAAiB,+BAAA;ARwiGrB;;AQviGI;EAAgB,4BAAA;AR2iGpB;;AQ1iGI;EAAgB,+BAAA;AR8iGpB;;AQ7iGI;EAAgB,8BAAA;ARijGpB;;AQhjGI;EAAgB,6BAAA;ARojGpB;;AQ7jGI;EAAkB,2BAAA;ARikGtB;;AQhkGI;EAAkB,2BAAA;ARokGtB;;AQnkGI;EAAiB,6BAAA;ARukGrB;;AQtkGI;EAAiB,gCAAA;AR0kGrB;;AQzkGI;EAAiB,8BAAA;AR6kGrB;;AQ5kGI;EAAiB,+BAAA;ARglGrB;;AQ/kGI;EAAgB,4BAAA;ARmlGpB;;AQllGI;EAAgB,+BAAA;ARslGpB;;AQrlGI;EAAgB,8BAAA;ARylGpB;;AQxlGI;EAAgB,6BAAA;AR4lGpB;;AQrmGI;EAAkB,2BAAA;ARymGtB;;AQxmGI;EAAkB,2BAAA;AR4mGtB;;AQ3mGI;EAAiB,6BAAA;AR+mGrB;;AQ9mGI;EAAiB,gCAAA;ARknGrB;;AQjnGI;EAAiB,8BAAA;ARqnGrB;;AQpnGI;EAAiB,+BAAA;ARwnGrB;;AQvnGI;EAAgB,4BAAA;AR2nGpB;;AQ1nGI;EAAgB,+BAAA;AR8nGpB;;AQ7nGI;EAAgB,8BAAA;ARioGpB;;AQhoGI;EAAgB,6BAAA;ARooGpB;;AQ7oGI;EAAkB,2BAAA;ARipGtB;;AQhpGI;EAAkB,2BAAA;ARopGtB;;AQnpGI;EAAiB,6BAAA;ARupGrB;;AQtpGI;EAAiB,gCAAA;AR0pGrB;;AQzpGI;EAAiB,8BAAA;AR6pGrB;;AQ5pGI;EAAiB,+BAAA;ARgqGrB;;AQ/pGI;EAAgB,4BAAA;ARmqGpB;;AQlqGI;EAAgB,+BAAA;ARsqGpB;;AQrqGI;EAAgB,8BAAA;ARyqGpB;;AQxqGI;EAAgB,6BAAA;AR4qGpB;;AQrrGI;EAAkB,2BAAA;ARyrGtB;;AQxrGI;EAAkB,2BAAA;AR4rGtB;;AQ3rGI;EAAiB,6BAAA;AR+rGrB;;AQ9rGI;EAAiB,gCAAA;ARksGrB;;AQjsGI;EAAiB,8BAAA;ARqsGrB;;AQpsGI;EAAiB,+BAAA;ARwsGrB;;AQvsGI;EAAgB,4BAAA;AR2sGpB;;AQ1sGI;EAAgB,+BAAA;AR8sGpB;;AQ7sGI;EAAgB,8BAAA;ARitGpB;;AQhtGI;EAAgB,6BAAA;ARotGpB;;AQ7tGI;EAAkB,2BAAA;ARiuGtB;;AQhuGI;EAAkB,2BAAA;ARouGtB;;AQnuGI;EAAiB,6BAAA;ARuuGrB;;AQtuGI;EAAiB,gCAAA;AR0uGrB;;AQzuGI;EAAiB,8BAAA;AR6uGrB;;AQ5uGI;EAAiB,+BAAA;ARgvGrB;;AQ/uGI;EAAgB,4BAAA;ARmvGpB;;AQlvGI;EAAgB,+BAAA;ARsvGpB;;AQrvGI;EAAgB,8BAAA;ARyvGpB;;AQxvGI;EAAgB,6BAAA;AR4vGpB;;AQrwGI;EAAkB,2BAAA;ARywGtB;;AQxwGI;EAAkB,2BAAA;AR4wGtB;;AQ3wGI;EAAiB,6BAAA;AR+wGrB;;AQ9wGI;EAAiB,gCAAA;ARkxGrB;;AQjxGI;EAAiB,8BAAA;ARqxGrB;;AQpxGI;EAAiB,+BAAA;ARwxGrB;;AQvxGI;EAAgB,4BAAA;AR2xGpB;;AQ1xGI;EAAgB,+BAAA;AR8xGpB;;AQ7xGI;EAAgB,8BAAA;ARiyGpB;;AQhyGI;EAAgB,6BAAA;ARoyGpB;;AQ7yGI;EAAkB,2BAAA;ARizGtB;;AQhzGI;EAAkB,2BAAA;ARozGtB;;AQnzGI;EAAiB,6BAAA;ARuzGrB;;AQtzGI;EAAiB,gCAAA;AR0zGrB;;AQzzGI;EAAiB,8BAAA;AR6zGrB;;AQ5zGI;EAAiB,+BAAA;ARg0GrB;;AQ/zGI;EAAgB,4BAAA;ARm0GpB;;AQl0GI;EAAgB,+BAAA;ARs0GpB;;AQr0GI;EAAgB,8BAAA;ARy0GpB;;AQx0GI;EAAgB,6BAAA;AR40GpB;;AQr1GI;EAAkB,2BAAA;ARy1GtB;;AQx1GI;EAAkB,2BAAA;AR41GtB;;AQ31GI;EAAiB,6BAAA;AR+1GrB;;AQ91GI;EAAiB,gCAAA;ARk2GrB;;AQj2GI;EAAiB,8BAAA;ARq2GrB;;AQp2GI;EAAiB,+BAAA;ARw2GrB;;AQv2GI;EAAgB,4BAAA;AR22GpB;;AQ12GI;EAAgB,+BAAA;AR82GpB;;AQ72GI;EAAgB,8BAAA;ARi3GpB;;AQh3GI;EAAgB,6BAAA;ARo3GpB;;AQ73GI;EAAkB,2BAAA;ARi4GtB;;AQh4GI;EAAkB,2BAAA;ARo4GtB;;AQn4GI;EAAiB,6BAAA;ARu4GrB;;AQt4GI;EAAiB,gCAAA;AR04GrB;;AQz4GI;EAAiB,8BAAA;AR64GrB;;AQ54GI;EAAiB,+BAAA;ARg5GrB;;AQ/4GI;EAAgB,4BAAA;ARm5GpB;;AQl5GI;EAAgB,+BAAA;ARs5GpB;;AQr5GI;EAAgB,8BAAA;ARy5GpB;;AQx5GI;EAAgB,6BAAA;AR45GpB;;AQx5GA;EAEQ;IACI,yBAAA;ER05GV;EQv5GM;IACI,yBAAA;ERy5GV;EQt5GM;IACI,2BAAA;ERw5GV;EQr5GM;IACI,8BAAA;ERu5GV;EQp5GM;IACI,4BAAA;ERs5GV;EQn5GM;IACI,6BAAA;ERq5GV;EQl5GM;IACI,0BAAA;ERo5GV;EQj5GM;IACI,6BAAA;ERm5GV;EQh7GM;IACI,0BAAA;ERk7GV;EQ/6GM;IACI,0BAAA;ERi7GV;EQ96GM;IACI,4BAAA;ERg7GV;EQ76GM;IACI,+BAAA;ER+6GV;EQ56GM;IACI,6BAAA;ER86GV;EQ36GM;IACI,8BAAA;ER66GV;EQ16GM;IACI,2BAAA;ER46GV;EQz6GM;IACI,8BAAA;ER26GV;EQx8GM;IACI,0BAAA;ER08GV;EQv8GM;IACI,0BAAA;ERy8GV;EQt8GM;IACI,4BAAA;ERw8GV;EQr8GM;IACI,+BAAA;ERu8GV;EQp8GM;IACI,6BAAA;ERs8GV;EQn8GM;IACI,8BAAA;ERq8GV;EQl8GM;IACI,2BAAA;ERo8GV;EQj8GM;IACI,8BAAA;ERm8GV;EQh+GM;IACI,0BAAA;ERk+GV;EQ/9GM;IACI,0BAAA;ERi+GV;EQ99GM;IACI,4BAAA;ERg+GV;EQ79GM;IACI,+BAAA;ER+9GV;EQ59GM;IACI,6BAAA;ER89GV;EQ39GM;IACI,8BAAA;ER69GV;EQ19GM;IACI,2BAAA;ER49GV;EQz9GM;IACI,8BAAA;ER29GV;EQx/GM;IACI,0BAAA;ER0/GV;EQv/GM;IACI,0BAAA;ERy/GV;EQt/GM;IACI,4BAAA;ERw/GV;EQr/GM;IACI,+BAAA;ERu/GV;EQp/GM;IACI,6BAAA;ERs/GV;EQn/GM;IACI,8BAAA;ERq/GV;EQl/GM;IACI,2BAAA;ERo/GV;EQj/GM;IACI,8BAAA;ERm/GV;EQhhHM;IACI,0BAAA;ERkhHV;EQ/gHM;IACI,0BAAA;ERihHV;EQ9gHM;IACI,4BAAA;ERghHV;EQ7gHM;IACI,+BAAA;ER+gHV;EQ5gHM;IACI,6BAAA;ER8gHV;EQ3gHM;IACI,8BAAA;ER6gHV;EQ1gHM;IACI,2BAAA;ER4gHV;EQzgHM;IACI,8BAAA;ER2gHV;EQxiHM;IACI,0BAAA;ER0iHV;EQviHM;IACI,0BAAA;ERyiHV;EQtiHM;IACI,4BAAA;ERwiHV;EQriHM;IACI,+BAAA;ERuiHV;EQpiHM;IACI,6BAAA;ERsiHV;EQniHM;IACI,8BAAA;ERqiHV;EQliHM;IACI,2BAAA;ERoiHV;EQjiHM;IACI,8BAAA;ERmiHV;EQhkHM;IACI,0BAAA;ERkkHV;EQ/jHM;IACI,0BAAA;ERikHV;EQ9jHM;IACI,4BAAA;ERgkHV;EQ7jHM;IACI,+BAAA;ER+jHV;EQ5jHM;IACI,6BAAA;ER8jHV;EQ3jHM;IACI,8BAAA;ER6jHV;EQ1jHM;IACI,2BAAA;ER4jHV;EQzjHM;IACI,8BAAA;ER2jHV;EQxlHM;IACI,0BAAA;ER0lHV;EQvlHM;IACI,0BAAA;ERylHV;EQtlHM;IACI,4BAAA;ERwlHV;EQrlHM;IACI,+BAAA;ERulHV;EQplHM;IACI,6BAAA;ERslHV;EQnlHM;IACI,8BAAA;ERqlHV;EQllHM;IACI,2BAAA;ERolHV;EQjlHM;IACI,8BAAA;ERmlHV;EQhnHM;IACI,0BAAA;ERknHV;EQ/mHM;IACI,0BAAA;ERinHV;EQ9mHM;IACI,4BAAA;ERgnHV;EQ7mHM;IACI,+BAAA;ER+mHV;EQ5mHM;IACI,6BAAA;ER8mHV;EQ3mHM;IACI,8BAAA;ER6mHV;EQ1mHM;IACI,2BAAA;ER4mHV;EQzmHM;IACI,8BAAA;ER2mHV;EQxoHM;IACI,0BAAA;ER0oHV;EQvoHM;IACI,0BAAA;ERyoHV;EQtoHM;IACI,4BAAA;ERwoHV;EQroHM;IACI,+BAAA;ERuoHV;EQpoHM;IACI,6BAAA;ERsoHV;EQnoHM;IACI,8BAAA;ERqoHV;EQloHM;IACI,2BAAA;ERooHV;EQjoHM;IACI,8BAAA;ERmoHV;EQhqHM;IACI,0BAAA;ERkqHV;EQ/pHM;IACI,0BAAA;ERiqHV;EQ9pHM;IACI,4BAAA;ERgqHV;EQ7pHM;IACI,+BAAA;ER+pHV;EQ5pHM;IACI,6BAAA;ER8pHV;EQ3pHM;IACI,8BAAA;ER6pHV;EQ1pHM;IACI,2BAAA;ER4pHV;EQzpHM;IACI,8BAAA;ER2pHV;EQxrHM;IACI,0BAAA;ER0rHV;EQvrHM;IACI,0BAAA;ERyrHV;EQtrHM;IACI,4BAAA;ERwrHV;EQrrHM;IACI,+BAAA;ERurHV;EQprHM;IACI,6BAAA;ERsrHV;EQnrHM;IACI,8BAAA;ERqrHV;EQlrHM;IACI,2BAAA;ERorHV;EQjrHM;IACI,8BAAA;ERmrHV;EQhtHM;IACI,0BAAA;ERktHV;EQ/sHM;IACI,0BAAA;ERitHV;EQ9sHM;IACI,4BAAA;ERgtHV;EQ7sHM;IACI,+BAAA;ER+sHV;EQ5sHM;IACI,6BAAA;ER8sHV;EQ3sHM;IACI,8BAAA;ER6sHV;EQ1sHM;IACI,2BAAA;ER4sHV;EQzsHM;IACI,8BAAA;ER2sHV;EQxuHM;IACI,0BAAA;ER0uHV;EQvuHM;IACI,0BAAA;ERyuHV;EQtuHM;IACI,4BAAA;ERwuHV;EQruHM;IACI,+BAAA;ERuuHV;EQpuHM;IACI,6BAAA;ERsuHV;EQnuHM;IACI,8BAAA;ERquHV;EQluHM;IACI,2BAAA;ERouHV;EQjuHM;IACI,8BAAA;ERmuHV;EQhwHM;IACI,0BAAA;ERkwHV;EQ/vHM;IACI,0BAAA;ERiwHV;EQ9vHM;IACI,4BAAA;ERgwHV;EQ7vHM;IACI,+BAAA;ER+vHV;EQ5vHM;IACI,6BAAA;ER8vHV;EQ3vHM;IACI,8BAAA;ER6vHV;EQ1vHM;IACI,2BAAA;ER4vHV;EQzvHM;IACI,8BAAA;ER2vHV;EQxxHM;IACI,0BAAA;ER0xHV;EQvxHM;IACI,0BAAA;ERyxHV;EQtxHM;IACI,4BAAA;ERwxHV;EQrxHM;IACI,+BAAA;ERuxHV;EQpxHM;IACI,6BAAA;ERsxHV;EQnxHM;IACI,8BAAA;ERqxHV;EQlxHM;IACI,2BAAA;ERoxHV;EQjxHM;IACI,8BAAA;ERmxHV;EQhzHM;IACI,0BAAA;ERkzHV;EQ/yHM;IACI,0BAAA;ERizHV;EQ9yHM;IACI,4BAAA;ERgzHV;EQ7yHM;IACI,+BAAA;ER+yHV;EQ5yHM;IACI,6BAAA;ER8yHV;EQ3yHM;IACI,8BAAA;ER6yHV;EQ1yHM;IACI,2BAAA;ER4yHV;EQzyHM;IACI,8BAAA;ER2yHV;EQx0HM;IACI,0BAAA;ER00HV;EQv0HM;IACI,0BAAA;ERy0HV;EQt0HM;IACI,4BAAA;ERw0HV;EQr0HM;IACI,+BAAA;ERu0HV;EQp0HM;IACI,6BAAA;ERs0HV;EQn0HM;IACI,8BAAA;ERq0HV;EQl0HM;IACI,2BAAA;ERo0HV;EQj0HM;IACI,8BAAA;ERm0HV;EQh2HM;IACI,2BAAA;ERk2HV;EQ/1HM;IACI,2BAAA;ERi2HV;EQ91HM;IACI,6BAAA;ERg2HV;EQ71HM;IACI,gCAAA;ER+1HV;EQ51HM;IACI,8BAAA;ER81HV;EQ31HM;IACI,+BAAA;ER61HV;EQ11HM;IACI,4BAAA;ER41HV;EQz1HM;IACI,+BAAA;ER21HV;AACF;AQt1HA;EAEQ;IACI,yBAAA;ERu1HV;EQr1HM;IACI,yBAAA;ERu1HV;EQr1HM;IACI,2BAAA;ERu1HV;EQr1HM;IACI,8BAAA;ERu1HV;EQp1HM;IACI,4BAAA;ERs1HV;EQn1HM;IACI,6BAAA;ERq1HV;EQl1HM;IACI,0BAAA;ERo1HV;EQj1HM;IACI,6BAAA;ERm1HV;EQj1HM;IACI,2BAAA;ERm1HV;EQh3HM;IACI,0BAAA;ERk3HV;EQh3HM;IACI,0BAAA;ERk3HV;EQh3HM;IACI,4BAAA;ERk3HV;EQh3HM;IACI,+BAAA;ERk3HV;EQ/2HM;IACI,6BAAA;ERi3HV;EQ92HM;IACI,8BAAA;ERg3HV;EQ72HM;IACI,2BAAA;ER+2HV;EQ52HM;IACI,8BAAA;ER82HV;EQ52HM;IACI,4BAAA;ER82HV;EQ34HM;IACI,0BAAA;ER64HV;EQ34HM;IACI,0BAAA;ER64HV;EQ34HM;IACI,4BAAA;ER64HV;EQ34HM;IACI,+BAAA;ER64HV;EQ14HM;IACI,6BAAA;ER44HV;EQz4HM;IACI,8BAAA;ER24HV;EQx4HM;IACI,2BAAA;ER04HV;EQv4HM;IACI,8BAAA;ERy4HV;EQv4HM;IACI,4BAAA;ERy4HV;EQt6HM;IACI,0BAAA;ERw6HV;EQt6HM;IACI,0BAAA;ERw6HV;EQt6HM;IACI,4BAAA;ERw6HV;EQt6HM;IACI,+BAAA;ERw6HV;EQr6HM;IACI,6BAAA;ERu6HV;EQp6HM;IACI,8BAAA;ERs6HV;EQn6HM;IACI,2BAAA;ERq6HV;EQl6HM;IACI,8BAAA;ERo6HV;EQl6HM;IACI,4BAAA;ERo6HV;EQj8HM;IACI,0BAAA;ERm8HV;EQj8HM;IACI,0BAAA;ERm8HV;EQj8HM;IACI,4BAAA;ERm8HV;EQj8HM;IACI,+BAAA;ERm8HV;EQh8HM;IACI,6BAAA;ERk8HV;EQ/7HM;IACI,8BAAA;ERi8HV;EQ97HM;IACI,2BAAA;ERg8HV;EQ77HM;IACI,8BAAA;ER+7HV;EQ77HM;IACI,4BAAA;ER+7HV;EQ59HM;IACI,0BAAA;ER89HV;EQ59HM;IACI,0BAAA;ER89HV;EQ59HM;IACI,4BAAA;ER89HV;EQ59HM;IACI,+BAAA;ER89HV;EQ39HM;IACI,6BAAA;ER69HV;EQ19HM;IACI,8BAAA;ER49HV;EQz9HM;IACI,2BAAA;ER29HV;EQx9HM;IACI,8BAAA;ER09HV;EQx9HM;IACI,4BAAA;ER09HV;EQv/HM;IACI,0BAAA;ERy/HV;EQv/HM;IACI,0BAAA;ERy/HV;EQv/HM;IACI,4BAAA;ERy/HV;EQv/HM;IACI,+BAAA;ERy/HV;EQt/HM;IACI,6BAAA;ERw/HV;EQr/HM;IACI,8BAAA;ERu/HV;EQp/HM;IACI,2BAAA;ERs/HV;EQn/HM;IACI,8BAAA;ERq/HV;EQn/HM;IACI,4BAAA;ERq/HV;EQlhIM;IACI,0BAAA;ERohIV;EQlhIM;IACI,0BAAA;ERohIV;EQlhIM;IACI,4BAAA;ERohIV;EQlhIM;IACI,+BAAA;ERohIV;EQjhIM;IACI,6BAAA;ERmhIV;EQhhIM;IACI,8BAAA;ERkhIV;EQ/gIM;IACI,2BAAA;ERihIV;EQ9gIM;IACI,8BAAA;ERghIV;EQ9gIM;IACI,4BAAA;ERghIV;EQ7iIM;IACI,0BAAA;ER+iIV;EQ7iIM;IACI,0BAAA;ER+iIV;EQ7iIM;IACI,4BAAA;ER+iIV;EQ7iIM;IACI,+BAAA;ER+iIV;EQ5iIM;IACI,6BAAA;ER8iIV;EQ3iIM;IACI,8BAAA;ER6iIV;EQ1iIM;IACI,2BAAA;ER4iIV;EQziIM;IACI,8BAAA;ER2iIV;EQziIM;IACI,4BAAA;ER2iIV;EQxkIM;IACI,0BAAA;ER0kIV;EQxkIM;IACI,0BAAA;ER0kIV;EQxkIM;IACI,4BAAA;ER0kIV;EQxkIM;IACI,+BAAA;ER0kIV;EQvkIM;IACI,6BAAA;ERykIV;EQtkIM;IACI,8BAAA;ERwkIV;EQrkIM;IACI,2BAAA;ERukIV;EQpkIM;IACI,8BAAA;ERskIV;EQpkIM;IACI,4BAAA;ERskIV;EQnmIM;IACI,0BAAA;ERqmIV;EQnmIM;IACI,0BAAA;ERqmIV;EQnmIM;IACI,4BAAA;ERqmIV;EQnmIM;IACI,+BAAA;ERqmIV;EQlmIM;IACI,6BAAA;ERomIV;EQjmIM;IACI,8BAAA;ERmmIV;EQhmIM;IACI,2BAAA;ERkmIV;EQ/lIM;IACI,8BAAA;ERimIV;EQ/lIM;IACI,4BAAA;ERimIV;EQ9nIM;IACI,0BAAA;ERgoIV;EQ9nIM;IACI,0BAAA;ERgoIV;EQ9nIM;IACI,4BAAA;ERgoIV;EQ9nIM;IACI,+BAAA;ERgoIV;EQ7nIM;IACI,6BAAA;ER+nIV;EQ5nIM;IACI,8BAAA;ER8nIV;EQ3nIM;IACI,2BAAA;ER6nIV;EQ1nIM;IACI,8BAAA;ER4nIV;EQ1nIM;IACI,4BAAA;ER4nIV;EQzpIM;IACI,0BAAA;ER2pIV;EQzpIM;IACI,0BAAA;ER2pIV;EQzpIM;IACI,4BAAA;ER2pIV;EQzpIM;IACI,+BAAA;ER2pIV;EQxpIM;IACI,6BAAA;ER0pIV;EQvpIM;IACI,8BAAA;ERypIV;EQtpIM;IACI,2BAAA;ERwpIV;EQrpIM;IACI,8BAAA;ERupIV;EQrpIM;IACI,4BAAA;ERupIV;EQprIM;IACI,0BAAA;ERsrIV;EQprIM;IACI,0BAAA;ERsrIV;EQprIM;IACI,4BAAA;ERsrIV;EQprIM;IACI,+BAAA;ERsrIV;EQnrIM;IACI,6BAAA;ERqrIV;EQlrIM;IACI,8BAAA;ERorIV;EQjrIM;IACI,2BAAA;ERmrIV;EQhrIM;IACI,8BAAA;ERkrIV;EQhrIM;IACI,4BAAA;ERkrIV;EQ/sIM;IACI,0BAAA;ERitIV;EQ/sIM;IACI,0BAAA;ERitIV;EQ/sIM;IACI,4BAAA;ERitIV;EQ/sIM;IACI,+BAAA;ERitIV;EQ9sIM;IACI,6BAAA;ERgtIV;EQ7sIM;IACI,8BAAA;ER+sIV;EQ5sIM;IACI,2BAAA;ER8sIV;EQ3sIM;IACI,8BAAA;ER6sIV;EQ3sIM;IACI,4BAAA;ER6sIV;EQ1uIM;IACI,0BAAA;ER4uIV;EQ1uIM;IACI,0BAAA;ER4uIV;EQ1uIM;IACI,4BAAA;ER4uIV;EQ1uIM;IACI,+BAAA;ER4uIV;EQzuIM;IACI,6BAAA;ER2uIV;EQxuIM;IACI,8BAAA;ER0uIV;EQvuIM;IACI,2BAAA;ERyuIV;EQtuIM;IACI,8BAAA;ERwuIV;EQtuIM;IACI,4BAAA;ERwuIV;EQrwIM;IACI,0BAAA;ERuwIV;EQrwIM;IACI,0BAAA;ERuwIV;EQrwIM;IACI,4BAAA;ERuwIV;EQrwIM;IACI,+BAAA;ERuwIV;EQpwIM;IACI,6BAAA;ERswIV;EQnwIM;IACI,8BAAA;ERqwIV;EQlwIM;IACI,2BAAA;ERowIV;EQjwIM;IACI,8BAAA;ERmwIV;EQjwIM;IACI,4BAAA;ERmwIV;EQhyIM;IACI,0BAAA;ERkyIV;EQhyIM;IACI,0BAAA;ERkyIV;EQhyIM;IACI,4BAAA;ERkyIV;EQhyIM;IACI,+BAAA;ERkyIV;EQ/xIM;IACI,6BAAA;ERiyIV;EQ9xIM;IACI,8BAAA;ERgyIV;EQ7xIM;IACI,2BAAA;ER+xIV;EQ5xIM;IACI,8BAAA;ER8xIV;EQ5xIM;IACI,4BAAA;ER8xIV;EQ3zIM;IACI,0BAAA;ER6zIV;EQ3zIM;IACI,0BAAA;ER6zIV;EQ3zIM;IACI,4BAAA;ER6zIV;EQ3zIM;IACI,+BAAA;ER6zIV;EQ1zIM;IACI,6BAAA;ER4zIV;EQzzIM;IACI,8BAAA;ER2zIV;EQxzIM;IACI,2BAAA;ER0zIV;EQvzIM;IACI,8BAAA;ERyzIV;EQvzIM;IACI,4BAAA;ERyzIV;EQt1IM;IACI,2BAAA;ERw1IV;EQt1IM;IACI,2BAAA;ERw1IV;EQt1IM;IACI,6BAAA;ERw1IV;EQt1IM;IACI,gCAAA;ERw1IV;EQr1IM;IACI,8BAAA;ERu1IV;EQp1IM;IACI,+BAAA;ERs1IV;EQn1IM;IACI,4BAAA;ERq1IV;EQl1IM;IACI,+BAAA;ERo1IV;EQl1IM;IACI,6BAAA;ERo1IV;AACF;AQ/0IA;EAEI;IACI,qBAAA;ERg1IN;EQ90IE;IACI,0BAAA;ERg1IN;EQ90IE;IACI,2BAAA;ERg1IN;EQ90IE;IACI,yBAAA;ERg1IN;EQ90IE;IACI,4BAAA;ERg1IN;EQ90IE;IACI,0BAAA;ERg1IN;EQ90IE;IACI,yBAAA;ERg1IN;EQ90IE;IACI,wBAAA;ERg1IN;EQ90IE;IACI,2BAAA;ERg1IN;EQ90IE;IACI,2BAAA;ERg1IN;EQ50IM;IACI,yBAAA;ER80IV;EQ30IM;IACI,yBAAA;ER60IV;EQ10IM;IACI,2BAAA;ER40IV;EQz0IM;IACI,8BAAA;ER20IV;EQx0IM;IACI,4BAAA;ER00IV;EQv0IM;IACI,6BAAA;ERy0IV;EQt0IM;IACI,0BAAA;ERw0IV;EQr0IM;IACI,6BAAA;ERu0IV;EQp2IM;IACI,0BAAA;ERs2IV;EQn2IM;IACI,0BAAA;ERq2IV;EQl2IM;IACI,4BAAA;ERo2IV;EQj2IM;IACI,+BAAA;ERm2IV;EQh2IM;IACI,6BAAA;ERk2IV;EQ/1IM;IACI,8BAAA;ERi2IV;EQ91IM;IACI,2BAAA;ERg2IV;EQ71IM;IACI,8BAAA;ER+1IV;EQ53IM;IACI,0BAAA;ER83IV;EQ33IM;IACI,0BAAA;ER63IV;EQ13IM;IACI,4BAAA;ER43IV;EQz3IM;IACI,+BAAA;ER23IV;EQx3IM;IACI,6BAAA;ER03IV;EQv3IM;IACI,8BAAA;ERy3IV;EQt3IM;IACI,2BAAA;ERw3IV;EQr3IM;IACI,8BAAA;ERu3IV;EQp5IM;IACI,0BAAA;ERs5IV;EQn5IM;IACI,0BAAA;ERq5IV;EQl5IM;IACI,4BAAA;ERo5IV;EQj5IM;IACI,+BAAA;ERm5IV;EQh5IM;IACI,6BAAA;ERk5IV;EQ/4IM;IACI,8BAAA;ERi5IV;EQ94IM;IACI,2BAAA;ERg5IV;EQ74IM;IACI,8BAAA;ER+4IV;EQ56IM;IACI,0BAAA;ER86IV;EQ36IM;IACI,0BAAA;ER66IV;EQ16IM;IACI,4BAAA;ER46IV;EQz6IM;IACI,+BAAA;ER26IV;EQx6IM;IACI,6BAAA;ER06IV;EQv6IM;IACI,8BAAA;ERy6IV;EQt6IM;IACI,2BAAA;ERw6IV;EQr6IM;IACI,8BAAA;ERu6IV;EQp8IM;IACI,0BAAA;ERs8IV;EQn8IM;IACI,0BAAA;ERq8IV;EQl8IM;IACI,4BAAA;ERo8IV;EQj8IM;IACI,+BAAA;ERm8IV;EQh8IM;IACI,6BAAA;ERk8IV;EQ/7IM;IACI,8BAAA;ERi8IV;EQ97IM;IACI,2BAAA;ERg8IV;EQ77IM;IACI,8BAAA;ER+7IV;EQ59IM;IACI,0BAAA;ER89IV;EQ39IM;IACI,0BAAA;ER69IV;EQ19IM;IACI,4BAAA;ER49IV;EQz9IM;IACI,+BAAA;ER29IV;EQx9IM;IACI,6BAAA;ER09IV;EQv9IM;IACI,8BAAA;ERy9IV;EQt9IM;IACI,2BAAA;ERw9IV;EQr9IM;IACI,8BAAA;ERu9IV;EQp/IM;IACI,0BAAA;ERs/IV;EQn/IM;IACI,0BAAA;ERq/IV;EQl/IM;IACI,4BAAA;ERo/IV;EQj/IM;IACI,+BAAA;ERm/IV;EQh/IM;IACI,6BAAA;ERk/IV;EQ/+IM;IACI,8BAAA;ERi/IV;EQ9+IM;IACI,2BAAA;ERg/IV;EQ7+IM;IACI,8BAAA;ER++IV;EQ5gJM;IACI,0BAAA;ER8gJV;EQ3gJM;IACI,0BAAA;ER6gJV;EQ1gJM;IACI,4BAAA;ER4gJV;EQzgJM;IACI,+BAAA;ER2gJV;EQxgJM;IACI,6BAAA;ER0gJV;EQvgJM;IACI,8BAAA;ERygJV;EQtgJM;IACI,2BAAA;ERwgJV;EQrgJM;IACI,8BAAA;ERugJV;EQpiJM;IACI,0BAAA;ERsiJV;EQniJM;IACI,0BAAA;ERqiJV;EQliJM;IACI,4BAAA;ERoiJV;EQjiJM;IACI,+BAAA;ERmiJV;EQhiJM;IACI,6BAAA;ERkiJV;EQ/hJM;IACI,8BAAA;ERiiJV;EQ9hJM;IACI,2BAAA;ERgiJV;EQ7hJM;IACI,8BAAA;ER+hJV;EQ5jJM;IACI,0BAAA;ER8jJV;EQ3jJM;IACI,0BAAA;ER6jJV;EQ1jJM;IACI,4BAAA;ER4jJV;EQzjJM;IACI,+BAAA;ER2jJV;EQxjJM;IACI,6BAAA;ER0jJV;EQvjJM;IACI,8BAAA;ERyjJV;EQtjJM;IACI,2BAAA;ERwjJV;EQrjJM;IACI,8BAAA;ERujJV;EQplJM;IACI,0BAAA;ERslJV;EQnlJM;IACI,0BAAA;ERqlJV;EQllJM;IACI,4BAAA;ERolJV;EQjlJM;IACI,+BAAA;ERmlJV;EQhlJM;IACI,6BAAA;ERklJV;EQ/kJM;IACI,8BAAA;ERilJV;EQ9kJM;IACI,2BAAA;ERglJV;EQ7kJM;IACI,8BAAA;ER+kJV;EQ5mJM;IACI,0BAAA;ER8mJV;EQ3mJM;IACI,0BAAA;ER6mJV;EQ1mJM;IACI,4BAAA;ER4mJV;EQzmJM;IACI,+BAAA;ER2mJV;EQxmJM;IACI,6BAAA;ER0mJV;EQvmJM;IACI,8BAAA;ERymJV;EQtmJM;IACI,2BAAA;ERwmJV;EQrmJM;IACI,8BAAA;ERumJV;EQpoJM;IACI,0BAAA;ERsoJV;EQnoJM;IACI,0BAAA;ERqoJV;EQloJM;IACI,4BAAA;ERooJV;EQjoJM;IACI,+BAAA;ERmoJV;EQhoJM;IACI,6BAAA;ERkoJV;EQ/nJM;IACI,8BAAA;ERioJV;EQ9nJM;IACI,2BAAA;ERgoJV;EQ7nJM;IACI,8BAAA;ER+nJV;EQ5pJM;IACI,0BAAA;ER8pJV;EQ3pJM;IACI,0BAAA;ER6pJV;EQ1pJM;IACI,4BAAA;ER4pJV;EQzpJM;IACI,+BAAA;ER2pJV;EQxpJM;IACI,6BAAA;ER0pJV;EQvpJM;IACI,8BAAA;ERypJV;EQtpJM;IACI,2BAAA;ERwpJV;EQrpJM;IACI,8BAAA;ERupJV;EQprJM;IACI,0BAAA;ERsrJV;EQnrJM;IACI,0BAAA;ERqrJV;EQlrJM;IACI,4BAAA;ERorJV;EQjrJM;IACI,+BAAA;ERmrJV;EQhrJM;IACI,6BAAA;ERkrJV;EQ/qJM;IACI,8BAAA;ERirJV;EQ9qJM;IACI,2BAAA;ERgrJV;EQ7qJM;IACI,8BAAA;ER+qJV;EQ5sJM;IACI,0BAAA;ER8sJV;EQ3sJM;IACI,0BAAA;ER6sJV;EQ1sJM;IACI,4BAAA;ER4sJV;EQzsJM;IACI,+BAAA;ER2sJV;EQxsJM;IACI,6BAAA;ER0sJV;EQvsJM;IACI,8BAAA;ERysJV;EQtsJM;IACI,2BAAA;ERwsJV;EQrsJM;IACI,8BAAA;ERusJV;EQpuJM;IACI,0BAAA;ERsuJV;EQnuJM;IACI,0BAAA;ERquJV;EQluJM;IACI,4BAAA;ERouJV;EQjuJM;IACI,+BAAA;ERmuJV;EQhuJM;IACI,6BAAA;ERkuJV;EQ/tJM;IACI,8BAAA;ERiuJV;EQ9tJM;IACI,2BAAA;ERguJV;EQ7tJM;IACI,8BAAA;ER+tJV;EQ5vJM;IACI,0BAAA;ER8vJV;EQ3vJM;IACI,0BAAA;ER6vJV;EQ1vJM;IACI,4BAAA;ER4vJV;EQzvJM;IACI,+BAAA;ER2vJV;EQxvJM;IACI,6BAAA;ER0vJV;EQvvJM;IACI,8BAAA;ERyvJV;EQtvJM;IACI,2BAAA;ERwvJV;EQrvJM;IACI,8BAAA;ERuvJV;EQpxJM;IACI,2BAAA;ERsxJV;EQnxJM;IACI,2BAAA;ERqxJV;EQlxJM;IACI,6BAAA;ERoxJV;EQjxJM;IACI,gCAAA;ERmxJV;EQhxJM;IACI,8BAAA;ERkxJV;EQ/wJM;IACI,+BAAA;ERixJV;EQ9wJM;IACI,4BAAA;ERgxJV;EQ7wJM;IACI,+BAAA;ER+wJV;AACF;AQ1wJA;EACI;IACI,2BAAA;ER4wJN;EQ1wJE;IACI,qBAAA;ER4wJN;EQ1wJE;IACI,0BAAA;ER4wJN;EQ1wJE;IACI,2BAAA;ER4wJN;EQ1wJE;IACI,yBAAA;ER4wJN;EQ1wJE;IACI,4BAAA;ER4wJN;EQ1wJE;IACI,0BAAA;ER4wJN;EQ1wJE;IACI,yBAAA;ER4wJN;EQ1wJE;IACI,wBAAA;ER4wJN;EQ1wJE;IACI,2BAAA;ER4wJN;EQ1wJE;IACI,6BAAA;ER4wJN;EQ1wJE;IACI,gCAAA;ER4wJN;EQzwJM;IACI,yBAAA;ER2wJV;EQzwJM;IACI,yBAAA;ER2wJV;EQzwJM;IACI,2BAAA;ER2wJV;EQxwJM;IACI,8BAAA;ER0wJV;EQvwJM;IACI,4BAAA;ERywJV;EQtwJM;IACI,6BAAA;ERwwJV;EQrwJM;IACI,0BAAA;ERuwJV;EQpwJM;IACI,2BAAA;ERswJV;EQnwJM;IACI,4BAAA;ERqwJV;EQlwJM;IACI,6BAAA;ERowJV;EQvyJM;IACI,0BAAA;ERyyJV;EQvyJM;IACI,0BAAA;ERyyJV;EQvyJM;IACI,4BAAA;ERyyJV;EQtyJM;IACI,+BAAA;ERwyJV;EQryJM;IACI,6BAAA;ERuyJV;EQpyJM;IACI,8BAAA;ERsyJV;EQnyJM;IACI,2BAAA;ERqyJV;EQlyJM;IACI,4BAAA;ERoyJV;EQjyJM;IACI,6BAAA;ERmyJV;EQhyJM;IACI,8BAAA;ERkyJV;EQr0JM;IACI,0BAAA;ERu0JV;EQr0JM;IACI,0BAAA;ERu0JV;EQr0JM;IACI,4BAAA;ERu0JV;EQp0JM;IACI,+BAAA;ERs0JV;EQn0JM;IACI,6BAAA;ERq0JV;EQl0JM;IACI,8BAAA;ERo0JV;EQj0JM;IACI,2BAAA;ERm0JV;EQh0JM;IACI,4BAAA;ERk0JV;EQ/zJM;IACI,6BAAA;ERi0JV;EQ9zJM;IACI,8BAAA;ERg0JV;EQn2JM;IACI,0BAAA;ERq2JV;EQn2JM;IACI,0BAAA;ERq2JV;EQn2JM;IACI,4BAAA;ERq2JV;EQl2JM;IACI,+BAAA;ERo2JV;EQj2JM;IACI,6BAAA;ERm2JV;EQh2JM;IACI,8BAAA;ERk2JV;EQ/1JM;IACI,2BAAA;ERi2JV;EQ91JM;IACI,4BAAA;ERg2JV;EQ71JM;IACI,6BAAA;ER+1JV;EQ51JM;IACI,8BAAA;ER81JV;EQj4JM;IACI,0BAAA;ERm4JV;EQj4JM;IACI,0BAAA;ERm4JV;EQj4JM;IACI,4BAAA;ERm4JV;EQh4JM;IACI,+BAAA;ERk4JV;EQ/3JM;IACI,6BAAA;ERi4JV;EQ93JM;IACI,8BAAA;ERg4JV;EQ73JM;IACI,2BAAA;ER+3JV;EQ53JM;IACI,4BAAA;ER83JV;EQ33JM;IACI,6BAAA;ER63JV;EQ13JM;IACI,8BAAA;ER43JV;EQ/5JM;IACI,0BAAA;ERi6JV;EQ/5JM;IACI,0BAAA;ERi6JV;EQ/5JM;IACI,4BAAA;ERi6JV;EQ95JM;IACI,+BAAA;ERg6JV;EQ75JM;IACI,6BAAA;ER+5JV;EQ55JM;IACI,8BAAA;ER85JV;EQ35JM;IACI,2BAAA;ER65JV;EQ15JM;IACI,4BAAA;ER45JV;EQz5JM;IACI,6BAAA;ER25JV;EQx5JM;IACI,8BAAA;ER05JV;EQ77JM;IACI,0BAAA;ER+7JV;EQ77JM;IACI,0BAAA;ER+7JV;EQ77JM;IACI,4BAAA;ER+7JV;EQ57JM;IACI,+BAAA;ER87JV;EQ37JM;IACI,6BAAA;ER67JV;EQ17JM;IACI,8BAAA;ER47JV;EQz7JM;IACI,2BAAA;ER27JV;EQx7JM;IACI,4BAAA;ER07JV;EQv7JM;IACI,6BAAA;ERy7JV;EQt7JM;IACI,8BAAA;ERw7JV;EQ39JM;IACI,0BAAA;ER69JV;EQ39JM;IACI,0BAAA;ER69JV;EQ39JM;IACI,4BAAA;ER69JV;EQ19JM;IACI,+BAAA;ER49JV;EQz9JM;IACI,6BAAA;ER29JV;EQx9JM;IACI,8BAAA;ER09JV;EQv9JM;IACI,2BAAA;ERy9JV;EQt9JM;IACI,4BAAA;ERw9JV;EQr9JM;IACI,6BAAA;ERu9JV;EQp9JM;IACI,8BAAA;ERs9JV;EQz/JM;IACI,0BAAA;ER2/JV;EQz/JM;IACI,0BAAA;ER2/JV;EQz/JM;IACI,4BAAA;ER2/JV;EQx/JM;IACI,+BAAA;ER0/JV;EQv/JM;IACI,6BAAA;ERy/JV;EQt/JM;IACI,8BAAA;ERw/JV;EQr/JM;IACI,2BAAA;ERu/JV;EQp/JM;IACI,4BAAA;ERs/JV;EQn/JM;IACI,6BAAA;ERq/JV;EQl/JM;IACI,8BAAA;ERo/JV;EQvhKM;IACI,0BAAA;ERyhKV;EQvhKM;IACI,0BAAA;ERyhKV;EQvhKM;IACI,4BAAA;ERyhKV;EQthKM;IACI,+BAAA;ERwhKV;EQrhKM;IACI,6BAAA;ERuhKV;EQphKM;IACI,8BAAA;ERshKV;EQnhKM;IACI,2BAAA;ERqhKV;EQlhKM;IACI,4BAAA;ERohKV;EQjhKM;IACI,6BAAA;ERmhKV;EQhhKM;IACI,8BAAA;ERkhKV;EQrjKM;IACI,0BAAA;ERujKV;EQrjKM;IACI,0BAAA;ERujKV;EQrjKM;IACI,4BAAA;ERujKV;EQpjKM;IACI,+BAAA;ERsjKV;EQnjKM;IACI,6BAAA;ERqjKV;EQljKM;IACI,8BAAA;ERojKV;EQjjKM;IACI,2BAAA;ERmjKV;EQhjKM;IACI,4BAAA;ERkjKV;EQ/iKM;IACI,6BAAA;ERijKV;EQ9iKM;IACI,8BAAA;ERgjKV;EQnlKM;IACI,0BAAA;ERqlKV;EQnlKM;IACI,0BAAA;ERqlKV;EQnlKM;IACI,4BAAA;ERqlKV;EQllKM;IACI,+BAAA;ERolKV;EQjlKM;IACI,6BAAA;ERmlKV;EQhlKM;IACI,8BAAA;ERklKV;EQ/kKM;IACI,2BAAA;ERilKV;EQ9kKM;IACI,4BAAA;ERglKV;EQ7kKM;IACI,6BAAA;ER+kKV;EQ5kKM;IACI,8BAAA;ER8kKV;EQjnKM;IACI,0BAAA;ERmnKV;EQjnKM;IACI,0BAAA;ERmnKV;EQjnKM;IACI,4BAAA;ERmnKV;EQhnKM;IACI,+BAAA;ERknKV;EQ/mKM;IACI,6BAAA;ERinKV;EQ9mKM;IACI,8BAAA;ERgnKV;EQ7mKM;IACI,2BAAA;ER+mKV;EQ5mKM;IACI,4BAAA;ER8mKV;EQ3mKM;IACI,6BAAA;ER6mKV;EQ1mKM;IACI,8BAAA;ER4mKV;EQ/oKM;IACI,0BAAA;ERipKV;EQ/oKM;IACI,0BAAA;ERipKV;EQ/oKM;IACI,4BAAA;ERipKV;EQ9oKM;IACI,+BAAA;ERgpKV;EQ7oKM;IACI,6BAAA;ER+oKV;EQ5oKM;IACI,8BAAA;ER8oKV;EQ3oKM;IACI,2BAAA;ER6oKV;EQ1oKM;IACI,4BAAA;ER4oKV;EQzoKM;IACI,6BAAA;ER2oKV;EQxoKM;IACI,8BAAA;ER0oKV;EQ7qKM;IACI,0BAAA;ER+qKV;EQ7qKM;IACI,0BAAA;ER+qKV;EQ7qKM;IACI,4BAAA;ER+qKV;EQ5qKM;IACI,+BAAA;ER8qKV;EQ3qKM;IACI,6BAAA;ER6qKV;EQ1qKM;IACI,8BAAA;ER4qKV;EQzqKM;IACI,2BAAA;ER2qKV;EQxqKM;IACI,4BAAA;ER0qKV;EQvqKM;IACI,6BAAA;ERyqKV;EQtqKM;IACI,8BAAA;ERwqKV;EQ3sKM;IACI,0BAAA;ER6sKV;EQ3sKM;IACI,0BAAA;ER6sKV;EQ3sKM;IACI,4BAAA;ER6sKV;EQ1sKM;IACI,+BAAA;ER4sKV;EQzsKM;IACI,6BAAA;ER2sKV;EQxsKM;IACI,8BAAA;ER0sKV;EQvsKM;IACI,2BAAA;ERysKV;EQtsKM;IACI,4BAAA;ERwsKV;EQrsKM;IACI,6BAAA;ERusKV;EQpsKM;IACI,8BAAA;ERssKV;EQzuKM;IACI,0BAAA;ER2uKV;EQzuKM;IACI,0BAAA;ER2uKV;EQzuKM;IACI,4BAAA;ER2uKV;EQxuKM;IACI,+BAAA;ER0uKV;EQvuKM;IACI,6BAAA;ERyuKV;EQtuKM;IACI,8BAAA;ERwuKV;EQruKM;IACI,2BAAA;ERuuKV;EQpuKM;IACI,4BAAA;ERsuKV;EQnuKM;IACI,6BAAA;ERquKV;EQluKM;IACI,8BAAA;ERouKV;EQvwKM;IACI,0BAAA;ERywKV;EQvwKM;IACI,0BAAA;ERywKV;EQvwKM;IACI,4BAAA;ERywKV;EQtwKM;IACI,+BAAA;ERwwKV;EQrwKM;IACI,6BAAA;ERuwKV;EQpwKM;IACI,8BAAA;ERswKV;EQnwKM;IACI,2BAAA;ERqwKV;EQlwKM;IACI,4BAAA;ERowKV;EQjwKM;IACI,6BAAA;ERmwKV;EQhwKM;IACI,8BAAA;ERkwKV;EQryKM;IACI,0BAAA;ERuyKV;EQryKM;IACI,0BAAA;ERuyKV;EQryKM;IACI,4BAAA;ERuyKV;EQpyKM;IACI,+BAAA;ERsyKV;EQnyKM;IACI,6BAAA;ERqyKV;EQlyKM;IACI,8BAAA;ERoyKV;EQjyKM;IACI,2BAAA;ERmyKV;EQhyKM;IACI,4BAAA;ERkyKV;EQ/xKM;IACI,6BAAA;ERiyKV;EQ9xKM;IACI,8BAAA;ERgyKV;EQn0KM;IACI,2BAAA;ERq0KV;EQn0KM;IACI,2BAAA;ERq0KV;EQn0KM;IACI,6BAAA;ERq0KV;EQl0KM;IACI,gCAAA;ERo0KV;EQj0KM;IACI,8BAAA;ERm0KV;EQh0KM;IACI,+BAAA;ERk0KV;EQ/zKM;IACI,4BAAA;ERi0KV;EQ9zKM;IACI,6BAAA;ERg0KV;EQ7zKM;IACI,8BAAA;ER+zKV;EQ5zKM;IACI,+BAAA;ER8zKV;EQ1zKE;IACI,0BAAA;ER4zKN;EQ1zKE;IACI,2BAAA;ER4zKN;EQ1zKE;IACI,yBAAA;ER4zKN;EQ1zKE;IACI,4BAAA;ER4zKN;EQ1zKE;IACI,0BAAA;ER4zKN;EQ1zKE;IACI,yBAAA;ER4zKN;EQ1zKE;IACI,wBAAA;ER4zKN;EQ1zKE;IACI,2BAAA;ER4zKN;AACF;AQvzKA;EAEQ;IACI,yBAAA;ERwzKV;EQtzKM;IACI,yBAAA;ERwzKV;EQtzKM;IACI,2BAAA;ERwzKV;EQtzKM;IACI,8BAAA;ERwzKV;EQtzKM;IACI,4BAAA;ERwzKV;EQtzKM;IACI,6BAAA;ERwzKV;EQtzKM;IACI,0BAAA;ERwzKV;EQtzKM;IACI,6BAAA;ERwzKV;EQ90KM;IACI,0BAAA;ERg1KV;EQ90KM;IACI,0BAAA;ERg1KV;EQ90KM;IACI,4BAAA;ERg1KV;EQ90KM;IACI,+BAAA;ERg1KV;EQ90KM;IACI,6BAAA;ERg1KV;EQ90KM;IACI,8BAAA;ERg1KV;EQ90KM;IACI,2BAAA;ERg1KV;EQ90KM;IACI,8BAAA;ERg1KV;EQt2KM;IACI,0BAAA;ERw2KV;EQt2KM;IACI,0BAAA;ERw2KV;EQt2KM;IACI,4BAAA;ERw2KV;EQt2KM;IACI,+BAAA;ERw2KV;EQt2KM;IACI,6BAAA;ERw2KV;EQt2KM;IACI,8BAAA;ERw2KV;EQt2KM;IACI,2BAAA;ERw2KV;EQt2KM;IACI,8BAAA;ERw2KV;EQ93KM;IACI,0BAAA;ERg4KV;EQ93KM;IACI,0BAAA;ERg4KV;EQ93KM;IACI,4BAAA;ERg4KV;EQ93KM;IACI,+BAAA;ERg4KV;EQ93KM;IACI,6BAAA;ERg4KV;EQ93KM;IACI,8BAAA;ERg4KV;EQ93KM;IACI,2BAAA;ERg4KV;EQ93KM;IACI,8BAAA;ERg4KV;EQt5KM;IACI,0BAAA;ERw5KV;EQt5KM;IACI,0BAAA;ERw5KV;EQt5KM;IACI,4BAAA;ERw5KV;EQt5KM;IACI,+BAAA;ERw5KV;EQt5KM;IACI,6BAAA;ERw5KV;EQt5KM;IACI,8BAAA;ERw5KV;EQt5KM;IACI,2BAAA;ERw5KV;EQt5KM;IACI,8BAAA;ERw5KV;EQ96KM;IACI,0BAAA;ERg7KV;EQ96KM;IACI,0BAAA;ERg7KV;EQ96KM;IACI,4BAAA;ERg7KV;EQ96KM;IACI,+BAAA;ERg7KV;EQ96KM;IACI,6BAAA;ERg7KV;EQ96KM;IACI,8BAAA;ERg7KV;EQ96KM;IACI,2BAAA;ERg7KV;EQ96KM;IACI,8BAAA;ERg7KV;EQt8KM;IACI,0BAAA;ERw8KV;EQt8KM;IACI,0BAAA;ERw8KV;EQt8KM;IACI,4BAAA;ERw8KV;EQt8KM;IACI,+BAAA;ERw8KV;EQt8KM;IACI,6BAAA;ERw8KV;EQt8KM;IACI,8BAAA;ERw8KV;EQt8KM;IACI,2BAAA;ERw8KV;EQt8KM;IACI,8BAAA;ERw8KV;EQ99KM;IACI,0BAAA;ERg+KV;EQ99KM;IACI,0BAAA;ERg+KV;EQ99KM;IACI,4BAAA;ERg+KV;EQ99KM;IACI,+BAAA;ERg+KV;EQ99KM;IACI,6BAAA;ERg+KV;EQ99KM;IACI,8BAAA;ERg+KV;EQ99KM;IACI,2BAAA;ERg+KV;EQ99KM;IACI,8BAAA;ERg+KV;EQt/KM;IACI,0BAAA;ERw/KV;EQt/KM;IACI,0BAAA;ERw/KV;EQt/KM;IACI,4BAAA;ERw/KV;EQt/KM;IACI,+BAAA;ERw/KV;EQt/KM;IACI,6BAAA;ERw/KV;EQt/KM;IACI,8BAAA;ERw/KV;EQt/KM;IACI,2BAAA;ERw/KV;EQt/KM;IACI,8BAAA;ERw/KV;EQ9gLM;IACI,0BAAA;ERghLV;EQ9gLM;IACI,0BAAA;ERghLV;EQ9gLM;IACI,4BAAA;ERghLV;EQ9gLM;IACI,+BAAA;ERghLV;EQ9gLM;IACI,6BAAA;ERghLV;EQ9gLM;IACI,8BAAA;ERghLV;EQ9gLM;IACI,2BAAA;ERghLV;EQ9gLM;IACI,8BAAA;ERghLV;EQtiLM;IACI,0BAAA;ERwiLV;EQtiLM;IACI,0BAAA;ERwiLV;EQtiLM;IACI,4BAAA;ERwiLV;EQtiLM;IACI,+BAAA;ERwiLV;EQtiLM;IACI,6BAAA;ERwiLV;EQtiLM;IACI,8BAAA;ERwiLV;EQtiLM;IACI,2BAAA;ERwiLV;EQtiLM;IACI,8BAAA;ERwiLV;EQ9jLM;IACI,0BAAA;ERgkLV;EQ9jLM;IACI,0BAAA;ERgkLV;EQ9jLM;IACI,4BAAA;ERgkLV;EQ9jLM;IACI,+BAAA;ERgkLV;EQ9jLM;IACI,6BAAA;ERgkLV;EQ9jLM;IACI,8BAAA;ERgkLV;EQ9jLM;IACI,2BAAA;ERgkLV;EQ9jLM;IACI,8BAAA;ERgkLV;EQtlLM;IACI,0BAAA;ERwlLV;EQtlLM;IACI,0BAAA;ERwlLV;EQtlLM;IACI,4BAAA;ERwlLV;EQtlLM;IACI,+BAAA;ERwlLV;EQtlLM;IACI,6BAAA;ERwlLV;EQtlLM;IACI,8BAAA;ERwlLV;EQtlLM;IACI,2BAAA;ERwlLV;EQtlLM;IACI,8BAAA;ERwlLV;EQ9mLM;IACI,0BAAA;ERgnLV;EQ9mLM;IACI,0BAAA;ERgnLV;EQ9mLM;IACI,4BAAA;ERgnLV;EQ9mLM;IACI,+BAAA;ERgnLV;EQ9mLM;IACI,6BAAA;ERgnLV;EQ9mLM;IACI,8BAAA;ERgnLV;EQ9mLM;IACI,2BAAA;ERgnLV;EQ9mLM;IACI,8BAAA;ERgnLV;EQtoLM;IACI,0BAAA;ERwoLV;EQtoLM;IACI,0BAAA;ERwoLV;EQtoLM;IACI,4BAAA;ERwoLV;EQtoLM;IACI,+BAAA;ERwoLV;EQtoLM;IACI,6BAAA;ERwoLV;EQtoLM;IACI,8BAAA;ERwoLV;EQtoLM;IACI,2BAAA;ERwoLV;EQtoLM;IACI,8BAAA;ERwoLV;EQ9pLM;IACI,0BAAA;ERgqLV;EQ9pLM;IACI,0BAAA;ERgqLV;EQ9pLM;IACI,4BAAA;ERgqLV;EQ9pLM;IACI,+BAAA;ERgqLV;EQ9pLM;IACI,6BAAA;ERgqLV;EQ9pLM;IACI,8BAAA;ERgqLV;EQ9pLM;IACI,2BAAA;ERgqLV;EQ9pLM;IACI,8BAAA;ERgqLV;EQtrLM;IACI,0BAAA;ERwrLV;EQtrLM;IACI,0BAAA;ERwrLV;EQtrLM;IACI,4BAAA;ERwrLV;EQtrLM;IACI,+BAAA;ERwrLV;EQtrLM;IACI,6BAAA;ERwrLV;EQtrLM;IACI,8BAAA;ERwrLV;EQtrLM;IACI,2BAAA;ERwrLV;EQtrLM;IACI,8BAAA;ERwrLV;EQ9sLM;IACI,0BAAA;ERgtLV;EQ9sLM;IACI,0BAAA;ERgtLV;EQ9sLM;IACI,4BAAA;ERgtLV;EQ9sLM;IACI,+BAAA;ERgtLV;EQ9sLM;IACI,6BAAA;ERgtLV;EQ9sLM;IACI,8BAAA;ERgtLV;EQ9sLM;IACI,2BAAA;ERgtLV;EQ9sLM;IACI,8BAAA;ERgtLV;EQtuLM;IACI,0BAAA;ERwuLV;EQtuLM;IACI,0BAAA;ERwuLV;EQtuLM;IACI,4BAAA;ERwuLV;EQtuLM;IACI,+BAAA;ERwuLV;EQtuLM;IACI,6BAAA;ERwuLV;EQtuLM;IACI,8BAAA;ERwuLV;EQtuLM;IACI,2BAAA;ERwuLV;EQtuLM;IACI,8BAAA;ERwuLV;EQ9vLM;IACI,2BAAA;ERgwLV;EQ9vLM;IACI,2BAAA;ERgwLV;EQ9vLM;IACI,6BAAA;ERgwLV;EQ9vLM;IACI,gCAAA;ERgwLV;EQ9vLM;IACI,8BAAA;ERgwLV;EQ9vLM;IACI,+BAAA;ERgwLV;EQ9vLM;IACI,4BAAA;ERgwLV;EQ9vLM;IACI,+BAAA;ERgwLV;AACF;AQzvLI;EACI,4BAAA;EACA,6BAAA;AR2vLR;AQzvLQ;EACI,4BAAA;EACA,6BAAA;AR2vLZ;;AQjwLI;EACI,6BAAA;EACA,8BAAA;ARowLR;AQlwLQ;EACI,6BAAA;EACA,8BAAA;ARowLZ;;AQ1wLI;EACI,6BAAA;EACA,8BAAA;AR6wLR;AQ3wLQ;EACI,6BAAA;EACA,8BAAA;AR6wLZ;;AQnxLI;EACI,6BAAA;EACA,8BAAA;ARsxLR;AQpxLQ;EACI,6BAAA;EACA,8BAAA;ARsxLZ;;AQ5xLI;EACI,6BAAA;EACA,8BAAA;AR+xLR;AQ7xLQ;EACI,6BAAA;EACA,8BAAA;AR+xLZ;;AQryLI;EACI,6BAAA;EACA,8BAAA;ARwyLR;AQtyLQ;EACI,6BAAA;EACA,8BAAA;ARwyLZ;;AQ9yLI;EACI,6BAAA;EACA,8BAAA;ARizLR;AQ/yLQ;EACI,6BAAA;EACA,8BAAA;ARizLZ;;AQvzLI;EACI,6BAAA;EACA,8BAAA;AR0zLR;AQxzLQ;EACI,6BAAA;EACA,8BAAA;AR0zLZ;;AQh0LI;EACI,6BAAA;EACA,8BAAA;ARm0LR;AQj0LQ;EACI,6BAAA;EACA,8BAAA;ARm0LZ;;AQz0LI;EACI,6BAAA;EACA,8BAAA;AR40LR;AQ10LQ;EACI,6BAAA;EACA,8BAAA;AR40LZ;;AQl1LI;EACI,6BAAA;EACA,8BAAA;ARq1LR;AQn1LQ;EACI,6BAAA;EACA,8BAAA;ARq1LZ;;AQ31LI;EACI,6BAAA;EACA,8BAAA;AR81LR;AQ51LQ;EACI,6BAAA;EACA,8BAAA;AR81LZ;;AQp2LI;EACI,6BAAA;EACA,8BAAA;ARu2LR;AQr2LQ;EACI,6BAAA;EACA,8BAAA;ARu2LZ;;AQ72LI;EACI,6BAAA;EACA,8BAAA;ARg3LR;AQ92LQ;EACI,6BAAA;EACA,8BAAA;ARg3LZ;;AQt3LI;EACI,6BAAA;EACA,8BAAA;ARy3LR;AQv3LQ;EACI,6BAAA;EACA,8BAAA;ARy3LZ;;AQ/3LI;EACI,6BAAA;EACA,8BAAA;ARk4LR;AQh4LQ;EACI,6BAAA;EACA,8BAAA;ARk4LZ;;AQx4LI;EACI,6BAAA;EACA,8BAAA;AR24LR;AQz4LQ;EACI,6BAAA;EACA,8BAAA;AR24LZ;;AQj5LI;EACI,6BAAA;EACA,8BAAA;ARo5LR;AQl5LQ;EACI,6BAAA;EACA,8BAAA;ARo5LZ;;AQ15LI;EACI,6BAAA;EACA,8BAAA;AR65LR;AQ35LQ;EACI,6BAAA;EACA,8BAAA;AR65LZ;;AQn6LI;EACI,8BAAA;EACA,+BAAA;ARs6LR;AQp6LQ;EACI,8BAAA;EACA,+BAAA;ARs6LZ;;AS13MA;;2BAAA;AAIA,mBAAA;AACA;EAEI,0JAAA;EAIA,yJAAA;EACA,0BAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;AT43MJ;;ASx3MA;EACI,6BAAA;EACA,wIAAA;AT23MJ;;ASx3MA;EACI;IACI,6BAAA;IACA,2BAAA;ET23MN;AACF;ASx3MA,kBAAA;AACA;EACI,+BAAA;AT03MJ;;ASv3MA;EACI,+BAAA;AT03MJ;;ASv3MA;EACI,+BAAA;AT03MJ;;ASv3MA;EACI,+BAAA;AT03MJ;;ASv3MA;EACI,+BAAA;AT03MJ;;ASv3MA;EACI,+BAAA;AT03MJ;;ASr3MA,gBAAA;AAuHA;EACI,gCAAA;ATkwMJ;;AS/vMA;EACI,kCAAA;ATkwMJ;;AS/vMA;EACI,uCAAA;ATkwMJ;;AS/vMA;EACI,iDAAA;ATkwMJ;;AS/vMA;EACI,uDAAA;ATkwMJ;;AS/vMA;EACI,qDAAA;ATkwMJ;;AS/vMA;EACI,mDAAA;ATkwMJ;;AS/vMA;EACI,kDAAA;ATkwMJ;;AS/vMA;EACI,sDAAA;ATkwMJ;;AS/vMA;EACI,qDAAA;ATkwMJ;;AS/vMA;EACI,8CAAA;ATkwMJ;;AS/vMA;EACI,wDAAA;ATkwMJ;;AS/vMA;EACI,0DAAA;ATkwMJ;;AS/vMA;EACI,4DAAA;ATkwMJ;;AS/vMA;EACI,qDAAA;ATkwMJ;;AS/vMA;EACI,iDAAA;ATkwMJ;;AS/vMA;EACI,8CAAA;ATkwMJ;;AS/vMA;EACI,8CAAA;ATkwMJ;;AS/vMA;EACI,gDAAA;ATkwMJ;;AS/vMA;EACI,iDAAA;ATkwMJ;;AS/vMA;EACI,+CAAA;ATkwMJ;;AS/vMA;EACI,iDAAA;ATkwMJ;;AS/vMA;EACI,kDAAA;ATkwMJ;;AS/vMA;EACI,gDAAA;ATkwMJ;;AS/vMA;EACI,8CAAA;ATkwMJ;;AS/vMA;EACI,iDAAA;ATkwMJ;;AS/vMA;EACI,+CAAA;ATkwMJ;;AS/vMA;EACI,iDAAA;ATkwMJ;;AS/vMA;EACI,kDAAA;ATkwMJ;;AS/vMA;EACI,+CAAA;ATkwMJ;;AS5vMA,WAAA;AAcA,gBAAA;AAgCA,YAAA;AAgBA,YAAA;AACA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;ATosMJ;;AS7rMA;EACI,uCAAA;ATgsMJ;;ASxrMA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AT2rMJ;AS1rMI;EACI,aAAA;EACA,mBAAA;EACA,cAAA;AT4rMR;AS3rMQ;EAJJ;IAKQ,eAAA;ET8rMV;AACF;AS7rMQ;EACI,WAAA;EACA,uCAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AT+rMZ;AS9rMY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;ATgsMhB;;AS1rMA;EACI,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,uCAAA;EACA,iCAAA;AT6rMJ;;AUtmNA,qCAAA;AACA;;;;EAII,0BAAA;AVymNJ;;AUtmNA;;;EAGI,WAAA;EACA,gBAAA;AVymNJ;;AUtmNA;EACI,YAAA;EACA,eAAA;AVymNJ;;AUtmNA;EACI,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,wBAAA;EAGA,gBAAA;EACA,qDAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AVymNJ;;AUtmNA;;;;;;EAMI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EAEA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,qDAAA;EACA,4BAAA;EACA,wBAAA;EAEA,sBAAA;AVwmNJ;AUvmNI;;;;;;EACI,wBAAA;EACA,YAAA;EACA,UAAA;AV8mNR;AU3mNI;;;;;;EACI,4BAAA;EACA,wBAAA;EACA,UAAA;AVknNR;AU/mNI;;;;;;EACI,mBAAA;EACA,wBAAA;EACA,UAAA;AVsnNR;AUnnNI;;;;;;;;;;;;;;;EACI,kCAAA;EAEA,sBAAA;AVkoNR;AUjoNQ;;;;;;;;;;;;;;;EACI,2BAAA;EACA,YAAA;EACA,UAAA;AVipNZ;AU9oNQ;;;;;;;;;;;;;;;EACI,4BAAA;EACA,2BAAA;AV8pNZ;AU3pNQ;;;;;;;;;;;;;;;EACI,mBAAA;EACA,2BAAA;AV2qNZ;AUvqNI;;;;;;;;;;;;;;;EACI,qBAAA;EAEA,sBAAA;AVsrNR;AUrrNQ;;;;;;;;;;;;;;;EACI,cAAA;EACA,YAAA;EACA,UAAA;AVqsNZ;AUlsNQ;;;;;;;;;;;;;;;EACI,4BAAA;EACA,cAAA;AVktNZ;AU/sNQ;;;;;;;;;;;;;;;EACI,mBAAA;EACA,cAAA;AV+tNZ;AU5tNQ;;;;;;;;;;;;;;;EACI,qBAAA;AV4uNZ;AUxuNI;;;;;;EACI,kCAAA;AV+uNR;;AU1tNA;;EAEI,UAAA;EACA,kBAAA;AV6tNJ;AU3tNI;;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AV8tNR;AU5tNQ;;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yDAAA;EACA,kBAAA;EACA,oBAAA;AV+tNZ;AU5tNQ;;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,6CAAA;EACA,2CAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;AV+tNZ;AUztNY;;EACI,sCAAA;EACA,kCAAA;AV4tNhB;AUztNY;;EACI,UAAA;AV4tNhB;;AUptNQ;EACI,kBAAA;AVutNZ;AUptNQ;EACI,UAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AVstNZ;;AUjtNA;EACI,mBAAA;AVotNJ;AUltNI;EACI,qDAAA;EACA,4BAAA;EACA,YAAA;EACA,eAAA;EAEA,eAAA;AVmtNR;AUjtNQ;EACI,kCAAA;AVmtNZ;AU/sNI;EACI,iBAAA;EACA,qDAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AVitNR;AU9sNQ;EACI,kCAAA;AVgtNZ;;AU1sNA;EACI,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sDAAA;EACA,gCAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AV6sNJ;AU3sNI;EACI,cAAA;EAEA,+CAAA;EAGA,2BAAA;AV6sNR;;AUvsNA;;EAEI,wBAAA;EACA,mCAAA;AV0sNJ;;AUvsNA;;EAEI,gBAAA;EACA,mCAAA;AV0sNJ;;AUvsNA;;EAEI,WAAA;EACA,mCAAA;AV0sNJ;;AUvsNA;;EAEI,gBAAA;EACA,mCAAA;AV0sNJ;;AWr/NA,oBAAA;AAGA;EACI,eAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EAEA,aAAA;EAEA,mBAAA;AXq/NJ;AWn/NI;EACI,UAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,uFAAA;AXq/NR;;AWj/NA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;AXo/NJ;AWl/NI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,wFAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AXo/NR;AWj/NI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,uFAAA;AXm/NR;;AW5+NI;EACI,qBAAA;EACA,kBAAA;AX++NR;AW9+NQ;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;AXg/NZ;AW7+NY;EACI,WAAA;EACA,OAAA;EACA,WAAA;AX++NhB;;AYrkOA;;4BAAA;AAGA;EACE,aAAA;AZwkOF;;AYtkOA;EACE,eAAA;EACA,4CAAA;EACA,qCAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AZykOF;AYvkOI;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AZykON;AYxkOM;EACE,gBAAA;AZ0kOR;AYrkOE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AZukOJ;AYpkOE;EACE,kBAAA;AZskOJ;AYnkOE;EACE,aAAA;EACA,yBAAA;AZqkOJ;AYpkOI;EACE,iBAAA;AZskON;AYrkOM;EAFF;IAGI,cAAA;EZwkON;AACF;AYvkOM;EALF;IAMI,cAAA;EZ0kON;AACF;AYnkOM;EADF;;IAEI,YAAA;IACA,iBAAA;IACA,cAAA;IACA,eAAA;EZukON;AACF;AYrkOQ;EADF;;IAEI,YAAA;IACA,iBAAA;IACA,cAAA;IACA,eAAA;EZykOR;AACF;AYpkOE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,kCAAA;EACA,gCAAA;UAAA,wBAAA;AZskOJ;;AYlkOA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AZqkOF;AYnkOE;EAPF;IAQI,kBAAA;EZskOF;AACF;AYpkOE;EAXF;IAYI,kBAAA;EZukOF;AACF;AYrkOE;EACE,6BAAA;AZukOJ;AYrkOI;EAHF;IAII,qCAAA;EZwkOJ;AACF;AYtkOI;EAPF;IAQI,qCAAA;EZykOJ;AACF;AYtkOE;EACE,6BAAA;EACA,sBAAA;AZwkOJ;AYtkOI;EAJF;IAKI,qCAAA;EZykOJ;AACF;AYvkOI;EARF;IASI,qCAAA;EZ0kOJ;AACF;;AYtkOA;EACE,iCAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AZykOF;AYxkOE;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;AZ0kOJ;;AYrkOE;EACE,iBAAA;AZwkOJ;;AYpkOA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,8CAAA;EACA,WAAA;EACA,aAAA;EACA,2CAAA;EACA,UAAA;AZukOF;;AYpkOA;EACE;IACE,4BAAA;EZukOF;EYpkOA;IACE,wBAAA;EZskOF;AACF;Aa9uOA;;6BAAA;AAGA;EACI,sCAAA;AbgvOJ;;Aa9uOA;EACI,sCAAA;EACA,oBAAA;EACA,eAAA;AbivOJ;;Aa7uOI;EACI,aAAA;EACA,SAAA;EACA,UAAA;AbgvOR;Aa9uOY;EACI,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AbgvOhB;Aa/uOgB;EACI,2BAAA;AbivOpB;Aa7uOQ;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;Ab+uOZ;Aa5uOgB;EACI,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,uCAAA;EACA,iCAAA;Ab8uOpB;Aa5uOwB;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;Ab8uO5B;Aa5uO4B;EACI,2BAAA;EACA,+BAAA;Ab8uOhC;AavuOoB;EACI,UAAA;EACA,mBAAA;EACA,SAAA;AbyuOxB;AapuOY;EACI,gBAAA;AbsuOhB;AapuOgB;EACI,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AbsuOpB;AaruOoB;EACI,4BAAA;EACA,uCAAA;EACA,iCAAA;AbuuOxB;AaruOwB;EACI,kBAAA;EACA,4CAAA;EACA,YAAA;AbuuO5B;AapuOgC;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AbsuOpC;AapuOoC;EACI,iBAAA;AbsuOxC;AanuOoC;EACI,2BAAA;EACA,+BAAA;AbquOxC;Aa3tOwB;EACI,oBAAA;Ab6tO5B;AavtOoB;EACI,UAAA;EACA,mBAAA;EACA,SAAA;AbytOxB;;Acx2OA;;iCAAA;AAGA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,iCAAA;Ad22OF;Ac12OE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;Ad42OJ;Ac12OI;EACE,aAAA;EACA,4CAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;Ad42ON;Acz2OU;EACE,gBAAA;Ad22OZ;Act2OQ;EACE,+BAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;Adw2OV;Acv2OU;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;Ady2OZ;Acl2OE;EACE,mBAAA;EACA,UAAA;Ado2OJ;Acn2OI;EACE,UAAA;EACA,OAAA;EACA,gBAAA;Adq2ON;Acj2OE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;Adm2OJ;Acl2OI;EACE,SAAA;Ado2ON;Acn2OM;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;Adq2OR;Acn2OM;EACE,yCAAA;Adq2OR;Ach2OM;EACE,SAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;Adk2OR;Ach2OU;EACE,eAAA;Adk2OZ;Ac/1OQ;EACE,YAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;Adi2OV;Ac51OI;EACE,SAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;Ad81ON;Ac71OM;EACE,YAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;Ad+1OR;Ac31OI;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;Ad61ON;Ac31OQ;EACE,eAAA;Ad61OV;Ac31OQ;EACE,4CAAA;Ad61OV;Acp1OY;EACE,gCAAA;Ads1Od;;Aen/OA;;8BAAA;AAGA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;Afs/OJ;Aer/OI;EACI,aAAA;Afu/OR;Aer/OI;EACI,aAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;Afu/OR;Aet/OQ;EANJ;IAOQ,cAAA;IACA,kBAAA;IACA,eAAA;Efy/OV;AACF;Aev/OY;EACI,qBAAA;EACA,iBAAA;EACA,wBAAA;EACA,eAAA;Afy/OhB;Aex/OgB;EALJ;IAMQ,cAAA;IACA,gBAAA;IACA,cAAA;Ef2/OlB;AACF;Aex/OQ;EACI,iBAAA;Af0/OZ;Aez/OY;EAFJ;IAGQ,cAAA;Ef4/Od;AACF;Aez/OI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;Af2/OR;Ae1/OQ;EALJ;IAMQ,WAAA;IACA,SAAA;IACA,eAAA;Ef6/OV;AACF;Ae3/OI;EACI,uBAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;Af6/OR;Ae5/OQ;EACI,gCAAA;EACA,kCAAA;EACA,WAAA;Af8/OZ;;Aez/OA;;6BAAA;AAGA;EACI,eAAA;EACA,4CAAA;EACA,qCAAA;Af4/OJ;Ae1/OQ;EADJ;IAEQ,kBAAA;Ef6/OV;AACF;Ae5/OQ;EAJJ;IAKQ,kBAAA;Ef+/OV;AACF;Ae9/OQ;EACI,gBAAA;AfggPZ;Ae//OY;EACI,gBAAA;AfigPhB;Ae7/OI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;Af+/OR;Ae9/OQ;EALJ;IAMQ,uBAAA;IACA,eAAA;EfigPV;AACF;AehgPQ;EATJ;IAUQ,uBAAA;IACA,eAAA;EfmgPV;AACF;AejgPQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AfmgPZ;AelgPY;EACI,gBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AfogPhB;AelgPgB;EANJ;IAOQ,cAAA;EfqgPlB;AACF;AengPoB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,+BAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AfqgPxB;AejgPgB;EACI,gBAAA;AfmgPpB;AejgPgB;EACI,iBAAA;EACA,eAAA;AfmgPpB;Ae3/OY;EACI,WAAA;Af6/OhB;Ae5/OgB;EACI,wBAAA;EACA,eAAA;EACA,iBAAA;Af8/OpB;Aez/OI;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;Af2/OR;Ae1/OQ;EAJJ;IAKQ,cAAA;IACA,eAAA;IACA,gBAAA;Ef6/OV;AACF;Ae5/OQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,+BAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;Af8/OZ;Ae7/OY;EATJ;IAUQ,aAAA;EfggPd;AACF;;AgBnrPI;EACI,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,uCAAA;EACA,iCAAA;AhBsrPR;AgBrrPQ;EACI,oBAAA;AhBurPZ;AgB/qPY;EADJ;IAEQ,aAAA;EhBkrPd;AACF;AgB7qPQ;EACI,aAAA;AhB+qPZ;;AgBxqPI;EACI,wBAAA;EACA,cAAA;EACA,4CAAA;EACA,oBAAA;EACA,YAAA;AhB2qPR;;AiBptPA,mBAAA;AAEA;EACI,aAAA;AjBstPJ;AiBptPI;;EAEI,YAAA;AjBstPR;;AiB9sPI;;EACI,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;EACA,yJAAA;EACA,0BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gCAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;AjBktPR;AiB7sPY;;EACI,kBAAA;EACA,SAAA;EACA,iBAAA;AjBgtPhB;AiB/sPgB;;EACI,WAAA;EACA,YAAA;AjBktPpB;AiB9sPQ;;EACI,iCAAA;EAEA,wBAAA;EACA,yBAAA;EACA,qBAAA;AjBitPZ;AiB/sPQ;;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AjBktPZ;AiBhtPQ;;EACI,YAAA;EACA,iBAAA;EACA,eAAA;AjBmtPZ;AiBltPY;EAJJ;;IAKQ,eAAA;EjBstPd;AACF;AiBptPQ;;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AjButPZ;AiBttPY;EALJ;;IAMQ,eAAA;EjB0tPd;AACF;AiBxtPQ;;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AjB2tPZ;AiB1tPY;EALJ;;IAMQ,eAAA;EjB8tPd;AACF;AiB5tPQ;;EACI,yBAAA;EACA,iCAAA;EACA,iBAAA;EACA,mBAAA;AjB+tPZ;AiB9tPY;;EACI,wCAAA;EACA,oCAAA;AjBiuPhB;AiB9tPQ;;EACI,yBAAA;EACA,gCAAA;AjBiuPZ;AiBhuPY;;EACI,kBAAA;EACA,qBAAA;EACA,iBAAA;AjBmuPhB;AiBjuPgB;;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,8BAAA;EACA,+FAAA;EAEA,2BAAA;EACA,UAAA;EACA,WAAA;AjBouPpB;AiBhuPY;;EACI,gBAAA;AjBmuPhB;AiBhuPoB;;EACI,WAAA;AjBmuPxB;AiB7tPQ;;EACI,oBAAA;AjBguPZ;AiB7tPQ;;EACI,gBAAA;AjBguPZ;AiB7tPQ;;EACI,mBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AjBguPZ;AiB/tPY;EARJ;;IASQ,WAAA;IACA,YAAA;IACA,iBAAA;EjBmuPd;AACF;AiBjuPgB;;EACI,kBAAA;EACA,SAAA;EACA,SAAA;AjBouPpB;AiBhuPY;;EACI,yBAAA;EACA,gCAAA;AjBmuPhB;AiBhuPY;;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AjBmuPhB;;AiB3tPI;EACI,kBAAA;EACA,2BAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AjB8tPR;AiB5tPQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,qCAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;AjB8tPZ;AiB3tPQ;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,gCAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;AjB6tPZ;AiBxtPQ;EACI,2BAAA;AjB0tPZ;AiBztPY;EACI,WAAA;EACA,OAAA;EACA,WAAA;AjB2tPhB;;AiBptPA;EACI,qBAAA;EACA,sCAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;AjButPJ;;AiBptPA;EACI,6BAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,qBAAA;AjButPJ;AiBttPI;EACI,yJAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;AjBwtPR;;AiBptPA;;;EAGI,cAAA;EACA,WAAA;AjButPJ;;AkBh+PA;;uBAAA;AAGA;EACI,4CAAA;AlBm+PJ;;AkBh+PA;EACI,kBAAA;AlBm+PJ;AkB/9PY;EADJ;IAEQ,aAAA;ElBk+Pd;AACF;AkBj+PY;EAJJ;IAKQ,aAAA;ElBo+Pd;AACF;AkBh+PQ;EAEI,gBAAA;AlBi+PZ;AkBh+PY;EACI,qBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AlBk+PhB;AkBh+PgB;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AlBk+PpB;AkBh+PgB;EACI,wBAAA;EACA,gBAAA;AlBk+PpB;AkBj+PoB;EACI,2BAAA;AlBm+PxB;AkBh+PgB;EACI,gBAAA;AlBk+PpB;AkBj+PoB;EACI,2BAAA;EACD,gBAAA;AlBm+PvB;AkBl+PwB;EACI,aAAA;AlBo+P5B;;AmB7hQA;;4BAAA;AAKI;EACI,iCAAA;EACA,SAAA;EACA,uCAAA;AnB8hQR;AmB7hQQ;EACI,6BAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AnB+hQZ;AmB9hQY;EACI,2BAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AnBgiQhB;AmB7hQQ;EACI,cAAA;EACA,8BAAA;EACA,kCAAA;EACA,6BAAA;EACA,wBAAA;EACA,kBAAA;EACA,yCAAA;AnB+hQZ;AmB7hQQ;EACI,gBAAA;AnB+hQZ;AmB1hQQ;EACI,kCAAA;EACA,2BAAA;AnB4hQZ;AmB3hQY;EACI,4CAAA;EACA,wBAAA;AnB6hQhB;AmB3hQY;EACI,yBAAA;EACA,SAAA;AnB6hQhB;AmBthQQ;EACI,kCAAA;EACA,2BAAA;AnBwhQZ;AmBthQY;EACI,qCAAA;EACA,kBAAA;EACA,uCAAA;AnBwhQhB;AmBthQY;EACI,yBAAA;EACA,SAAA;AnBwhQhB;AmBlhQQ;EACI,qCAAA;EACA,kCAAA;EACA,uCAAA;AnBohQZ;AmBnhQY;EACI,kBAAA;EACA,uCAAA;AnBqhQhB;AmBnhQY;EACI,SAAA;EACA,yCAAA;AnBqhQhB;;AoBzmQA;;uBAAA;AAII;EACI,kBAAA;EACA,oBAAA;EACA,6GAAA;EACA,kBAAA;EACA,UAAA;ApB2mQR;AoB1mQQ;EANJ;IAOQ,kBAAA;EpB6mQV;AACF;AoB5mQQ;EATJ;IAUQ,kBAAA;EpB+mQV;AACF;AoB9mQQ;EAZJ;IAaQ,kBAAA;EpBinQV;AACF;AoB/mQQ;EAEI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;ApBgnQZ;AoB9mQY;EAXJ;IAYQ,mBAAA;EpBinQd;AACF;AoBhnQY;EACI,0BAAA;ApBknQhB;AoB7mQY;EACI,mBAAA;ApB+mQhB;AoB7mQgB;EAHJ;IAIQ,kBAAA;EpBgnQlB;AACF;AoB/mQgB;EACI,cAAA;ApBinQpB;AoB/mQoB;EACI,2BAAA;ApBinQxB;AoBxmQQ;EACI,2BAAA;ApB0mQZ;AoBvmQQ;EACI,qCAAA;ApBymQZ;AoBtmQQ;EACI,aAAA;ApBwmQZ;AoBvmQY;EAFJ;IAGQ,kBAAA;EpB0mQd;AACF;AoBzmQY;EALJ;IAMQ,kBAAA;EpB4mQd;AACF;AoB3mQY;EARJ;IASQ,kBAAA;EpB8mQd;AACF;AoB7mQY;EAXJ;IAYQ,kBAAA;EpBgnQd;AACF;AoB9mQY;EACI,qBAAA;ApBgnQhB;AoB5mQQ;EACI,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;ApB8mQZ;AoB5mQY;EANJ;IAOQ,iBAAA;EpB+mQd;AACF;AoB7mQY;EAVJ;IAWQ,iBAAA;EpBgnQd;AACF;AoB9mQY;EACI,eAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,6CAAA;EACA,iBAAA;EACA,mBAAA;ApBgnQhB;AoB5mQQ;EACI,kBAAA;ApB8mQZ;AoB7mQY;EAFJ;IAGQ,eAAA;EpBgnQd;AACF;AoB/mQY;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;ApBinQhB;AoB/mQY;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,qCAAA;ApBinQhB;AoBhnQgB;EARJ;IASQ,aAAA;EpBmnQlB;AACF;AoBlnQgB;EAXJ;IAYQ,aAAA;EpBqnQlB;AACF;AoBnnQY;EACI,eAAA;ApBqnQhB;AoB/mQI;EACI,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;ApBinQR;AoB9mQgB;EACI,kBAAA;ApBgnQpB;AoB7mQY;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EAEA,mBAAA;ApB8mQhB;AoB7mQgB;EACI,cAAA;ApB+mQpB;AoB7mQoB;EACI,2BAAA;ApB+mQxB;AoB3mQY;EAEI,wBAAA;EACA,mBAAA;ApB4mQhB;AoBtmQI;EACI,kBAAA;EACA,oBAAA;EACA,6GAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;ApBwmQR;AoBtmQQ;EATJ;IAUQ,kBAAA;EpBymQV;AACF;AoBvmQQ;EAbJ;IAcQ,kBAAA;EpB0mQV;AACF;AoBxmQQ;EAjBJ;IAkBQ,kBAAA;EpB2mQV;AACF;AoBzmQQ;EArBJ;IAsBQ,iBAAA;EpB4mQV;AACF;AoB3mQQ;EACI,mBAAA;ApB6mQZ;AoB5mQY;EACI,iBAAA;ApB8mQhB;AoBxmQgB;EACI,cAAA;ApB0mQpB;AoBxmQoB;EACI,2BAAA;ApB0mQxB;AoBtmQY;EAEI,aAAA;ApBumQhB;AoBpmQQ;EACI,2BAAA;EACA,4CAAA;ApBsmQZ;;AoBxlQoB;EACI,2BAAA;EACA,YAAA;ApB2lQxB;AoBnlQoB;EACI,2BAAA;EACA,YAAA;ApBqlQxB;AoB5kQoB;EACI,2BAAA;EACA,YAAA;ApB8kQxB;AoBrkQoB;EACI,2BAAA;EACA,YAAA;ApBukQxB;AoB3jQwB;EACI,yBAAA;ApB6jQ5B;AoBljQwB;EACI,yBAAA;ApBojQ5B;AoBxiQwB;EACI,yBAAA;ApB0iQ5B;AoB9hQwB;EACI,yBAAA;ApBgiQ5B;AoBrhQgB;EACI,aAAA;ApBuhQpB;;AqB/2QA;;CAAA;AAII;EACI,iCAAA;EACA,uCAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;ArBi3QR;AqB92QgB;EACI,kBAAA;ArBg3QpB;AqB72QY;EACI,iBAAA;ArB+2QhB;AqB92QgB;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;ArBg3QpB;AqB/2QoB;EACI,cAAA;ArBi3QxB;AqB/2QwB;EACI,2BAAA;ArBi3Q5B;AqB72QgB;EACI,gBAAA;ArB+2QpB;AqB72QgB;EACI,gBAAA;ArB+2QpB;;AsBj5QA;;wBAAA;AAII;EACI,gBAAA;AtBm5QR;;AsBh5QA;EACI,WAAA;EACA,gBAAA;EACA,uCAAA;EACA,mBAAA;AtBm5QJ;AsBl5QI;EACI,mBAAA;EACA,QAAA;EACA,YAAA;EACA,oCAAA;EACA,2BAAA;AtBo5QR;;AsBh5QA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AtBm5QJ;AsBl5QI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AtBo5QR;AsBj5QQ;EACI,eAAA;EACA,wBAAA;AtBm5QZ;;AsB74QI;EACI,gBAAA;AtBg5QR;AsB/4QQ;EACI,gBAAA;AtBi5QZ;;AsB54QI;EACI,YAAA;AtB+4QR;;AsB14QA;;sBAAA;AAII;EACI,iBAAA;AtB44QR;AsB34QQ;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AtB64QZ;AsB34QQ;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AtB64QZ;;AuBp9QA,uBAAA;AAGI;EAEI,eAAA;AvBo9QR;AuBn9QQ;EAHJ;IAIQ,eAAA;IACA,mBAAA;IACA,cAAA;EvBs9QV;AACF;AuBr9QQ;EARJ;IASQ,eAAA;IACA,mBAAA;IACA,cAAA;EvBw9QV;AACF;AuBt9QI;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AvBw9QR;;AuBl9QA;EACI,gBAAA;AvBq9QJ;AuBp9QI;EAFJ;IAGQ,6BAAA;EvBu9QN;AACF;AuBt9QI;EACI,eAAA;EACA,uCAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AvBw9QR;AuBr9QI;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AvBu9QR;AuBp9QI;EACI,gBAAA;EACA,kBAAA;EACA,SAAA;AvBs9QR;AuBr9QQ;EAJJ;IAKQ,gBAAA;EvBw9QV;AACF;AuBp9QQ;EACI,6CAAA;EACA,2BAAA;AvBs9QZ;AuBj9QQ;EACI,6BAAA;EACA,qCAAA;AvBm9QZ;AuB98QQ;EACI,cAAA;AvBg9QZ;;AuBv8QY;EACI,+CAAA;EACA,6BAAA;AvB08QhB;;AuBj8QY;EACI,iDAAA;EACA,+BAAA;AvBo8QhB;;AuB97QA;;gCAAA;AAGA;EACI,gBAAA;EACA,gBAAA;AvBi8QJ;AuBh8QI;EACI,eAAA;EACA,gBAAA;EACA,eAAA;AvBk8QR;AuBh8QI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,qBAAA;EACA,kBAAA;AvBk8QR;AuBj8QQ;EACI,YAAA;AvBm8QZ;AuBj8QQ;EACI,qBAAA;AvBm8QZ;;AwBtkRA;;wBAAA;AAIA;EACE,gBAAA;AxBwkRF;AwBtkRE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AxBwkRJ;AwBvkRI;EACE,kBAAA;AxBykRN;AwBvkRM;EACE,gBAAA;AxBykRR;AwBvkRQ;EACE,cAAA;EACA,gBAAA;AxBykRV;AwBrkRQ;EACE,gBAAA;AxBukRV;AwBjkRM;EACE,UAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,0DAAA;EAMA,0GAAA;EAKA,6BAAA;EACA,cAAA;AxB2jRR;AwBtjRI;EACE,iBAAA;AxBwjRN;AwB3iRE;EACE,2BAAA;AxB6iRJ;AwBxiRU;EACE,sBAAA;AxB0iRZ;;AwBliRA,gBAAA;AAKQ;EACE,aAAA;AxBiiRV;;AwB1hRA,qBAAA;AACA;EAGE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;AxB2hRF;;AwBzhRA;EACE,aAAA;EACA,uBAAA;AxB4hRF;;AwB1hRA;EACE,6BAAA;AxB6hRF;;AwB3hRA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,oDAAA;AxB8hRF;;AwB5hRA;EACE,eAAA;EACA,YAAA;EACA,UAAA;AxB+hRF;;AwB5hRE;EACE,kCAAA;EACA,uCAAA;AxB+hRJ;AwB3hRQ;EACE,kBAAA;AxB6hRV;AwB5hRU;EACE,0DAAA;AxB8hRZ;AwB5hRY;EACE,0DAAA;AxB8hRd;AwBxhRM;EACE,aAAA;AxB0hRR;AwBzhRQ;EACE,2BAAA;AxB2hRV;;AwBphRA;;gCAAA;AAIA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AxBshRF;AwBphRI;EACE,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,wBAAA;EAGA,aAAA;AxBohRN;AwBnhRM;EAEE,sCAAA;EACA,oCAAA;AxBohRR;;AwB9gRA,8BAAA;AAMQ;;EACE,SAAA;EACA,gBAAA;AxB6gRV;AwB3gRU;;EACE,WAAA;EACA,YAAA;AxB8gRZ;;AyBrtRA;;0BAAA;AAGA;EACI,aAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AzBwtRJ;AyBttRI;EACI,WAAA;AzBwtRR;AyBttRQ;EACI,WAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;AzBwtRZ;AyBttRY;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;AzBwtRhB;AyBrtRY;EACI,yBAAA;AzButRhB;AyBrtRgB;EACI,mBAAA;EACA,UAAA;AzButRpB;AyB/sRY;EACI,uCAAA;AzBitRhB;AyBxsRY;EACI,iBAAA;EACA,uBAAA;EACA,qCAAA;AzB0sRhB;AyBxsRgB;EACI,yBAAA;AzB0sRpB;AyBvsRgB;EACI,sCAAA;AzBysRpB;AyBhsRgB;EACI,yJAAA;AzBksRpB;AyB1rRY;EACI,iDAAA;EACA,sCAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AzB4rRhB;AyB1rRgB;EACI,aAAA;AzB4rRpB;AyBzrRgB;EACI,6BAAA;AzB2rRpB;AyBlrRY;EACI,kCAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AzBorRhB;AyBnrRgB;EACI,aAAA;AzBqrRpB;AyBnrRgB;EACI,sCAAA;AzBqrRpB;;A0BjzRA;;0BAAA;AAGA;;EAEI,gBAAA;A1BozRJ;A0BnzRI;;EACI,qFAAA;EACA,gDAAA;EACA,wCAAA;EACA,gCAAA;A1BszRR;A0BpzRQ;;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uCAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;A1BuzRZ;A0BtzRY;;EACI,mBAAA;A1ByzRhB;A0BrzRQ;;EACI,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;A1BwzRZ;A0BtzRY;;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;A1ByzRhB;A0BvzRY;;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;A1B0zRhB;A0BxzRY;;EACI,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;A1B2zRhB;A0BzzRgB;;EACI,mBAAA;EACA,gBAAA;A1B4zRpB;A0BzzRY;;EACI,gBAAA;EACA,aAAA;A1B4zRhB;A0BtzRgB;;EACI,wBAAA;A1ByzRpB;A0BlzRQ;;EACI,yJAAA;EACA,YAAA;EACA,cAAA;A1BqzRZ;A0BjzRI;;EACI,gBAAA;A1BozRR;A0BnzRQ;;EACI,iBAAA;A1BszRZ;A0BrzRY;;EACI,MAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;A1BwzRhB;A0BtzRY;;EACI,iBAAA;A1ByzRhB;;A0BnzRA;;wBAAA;AAMY;EACI,WAAA;EACA,4BAAA;A1BmzRhB;A0BhzRQ;EACI,iBAAA;A1BkzRZ;A0BjzRY;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;A1BmzRhB;A0BhzRY;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,2BAAA;EACA,wFAAA;EACA,uBAAA;A1BkzRhB;A0BhzRY;EACI,cAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;A1BkzRhB;A0BjzRgB;EACI,mBAAA;EACA,gBAAA;A1BmzRpB;A0BxyRgB;EACI,UAAA;EACA,eAAA;A1B0yRpB;;A0BlyRA;;wBAAA;AAKI;EACI,kBAAA;A1BmyRR;A0BjyRY;EACI,WAAA;EACA,4BAAA;A1BmyRhB;A0BhyRQ;EACI,kBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,oBAAA;EACA,UAAA;A1BkyRZ;A0BhyRY;EACI,aAAA;EACA,wCAAA;EACA,kCAAA;A1BkyRhB;A0B/xRY;EACI,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;A1BiyRhB;A0B/xRY;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;A1BiyRhB;A0B/xRY;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;A1BiyRhB;A0B1xRY;EACI,UAAA;A1B4xRhB;;A2Bj/RA;;2BAAA;AAGA;EACI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,oCAAA;A3Bo/RJ;A2Bl/RI;EAEI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;A3Bm/RR;A2Bh/RI;EACI,YAAA;EACA,SAAA;EACA,oFAAA;A3Bk/RR;A2B/+RI;EACI,aAAA;EACA,MAAA;EACA,oFAAA;A3Bi/RR;;A2B5+RA;EACI,kBAAA;EACA,QAAA;EACA,OAAA;A3B++RJ;A2B7+RI;EAEI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EAEA,gCAAA;A3B8+RR;A2B3+RI;EACI,UAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,qFAAA;EACA,2CAAA;A3B6+RR;A2B1+RI;EACI,4CAAA;EACA,yGAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;A3B4+RR;A2Bz+RI;EACI,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,0GAAA;EAEA,gCAAA;EACA,sBAAA;EAEA,0EAAA;A3B2+RR;;A2Bp+RA;;gCAAA;AAGA;EACI,kBAAA;EACA,mBAAA;A3Bu+RJ;A2Br+RI;EAJJ;IAKQ,kBAAA;E3Bw+RN;AACF;A2Bt+RI;EARJ;IASQ,kBAAA;E3By+RN;AACF;A2Bv+RI;EACI,qFAAA;EACA,gDAAA;EACA,wCAAA;EACA,gCAAA;A3By+RR;A2Bv+RQ;EACI,aAAA;A3By+RZ;A2Bx+RY;EAFJ;IAGQ,aAAA;E3B2+Rd;AACF;A2B1+RY;EALJ;IAMQ,aAAA;E3B6+Rd;AACF;A2B3+RgB;EACI,wBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;A3B6+RpB;A2B3+RoB;EARJ;IASQ,mBAAA;E3B8+RtB;AACF;A2B7+RoB;EAXJ;IAYQ,mBAAA;E3Bg/RtB;AACF;A2B9+RgB;EACI,gBAAA;A3Bg/RpB;A2B/+RoB;EAFJ;IAGQ,eAAA;E3Bk/RtB;AACF;A2Bh/RgB;EACI,gBAAA;A3Bk/RpB;A2Bj/RoB;EAFJ;IAGQ,gBAAA;E3Bo/RtB;AACF;A2Bn/RoB;EALJ;IAMQ,gBAAA;E3Bs/RtB;AACF;A2Bj/RY;EACI,4BAAA;A3Bm/RhB;A2B/9RA;EACI;IACI,UAAA;IAEA,gDAAA;E3B8+RN;E2B3+RE;IACI,UAAA;IAEA,8CAAA;E3B6+RN;AACF;A2B1+RA;;6BAAA;AAGA;EACI,kBAAA;EACA,4BAAA;EACA,gCAAA;A3B4+RJ;;A2Bz+RA;EACI,gBAAA;A3B4+RJ;A2B1+RI;EACI,kBAAA;A3B4+RR;A2B1+RQ;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;A3B4+RZ;A2Bz+RY;EACI,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gLAAA;EACA,4BAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;A3B2+RhB;A2B1+RgB;EAbJ;IAcQ,aAAA;E3B6+RlB;AACF;A2Bz+RQ;EACI,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;A3B2+RZ;A2Bz+RY;EACI,uDAAA;EACA,+GAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;A3B2+RhB;A2Bz+RgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sCAAA;A3B2+RpB;A2Bn+RY;EACI,UAAA;EACA,SAAA;A3Bq+RhB;A2B/9RY;EACI,UAAA;A3Bi+RhB;A2B79RI;EACI,mBAAA;EACA,eAAA;A3B+9RR;A2B79RI;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;A3B+9RR;A2B99RQ;EAJJ;IAKQ,eAAA;E3Bi+RV;AACF;A2Bh+RQ;EAPJ;IAQQ,eAAA;E3Bm+RV;AACF;A2B59RgB;EACI,yBAAA;EACA,gCAAA;A3B89RpB;A2Bz9RgB;EACI,yBAAA;EACA,gCAAA;A3B29RpB;A2Bj9RgB;EACI,yBAAA;EACA,iCAAA;A3Bm9RpB;A2B98RgB;EACI,yBAAA;EACA,iCAAA;A3Bg9RpB;A2B98RoB;EACI,sCAAA;A3Bg9RxB;;A4BxxSA;;2BAAA;AAOY;EACI,iBAAA;A5BuxShB;A4BtxSgB;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iCAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;A5BwxSpB;A4BpxSgB;EACI,mBAAA;A5BsxSpB;A4BpxSgB;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;A5BsxSpB;A4BpxSgB;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;A5BsxSpB;A4BhxSgB;EACI,kBAAA;A5BkxSpB;A4B/wSgB;EACI,mBAAA;EACA,gBAAA;A5BixSpB;;A4BxwSA;;gCAAA;AAKI;EACI,kBAAA;EACA,UAAA;A5BywSR;A4BxwSQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;A5B0wSZ;A4BvwSQ;EACI,cAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;A5BywSZ;A4BtwSQ;EACI,gBAAA;EACA,mBAAA;EACA,eAAA;A5BwwSZ;A4BtwSY;EALJ;IAMQ,mBAAA;IACA,eAAA;E5BywSd;AACF;A4BxwSY;EATJ;IAUQ,eAAA;E5B2wSd;AACF;A4BzwSY;EAbJ;IAcQ,eAAA;E5B4wSd;AACF;A4BzwSY;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;A5B2wShB;A4BzwSY;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;A5B2wShB;A4BvwSI;EACI,yJAAA;EACA,mBAAA;EACA,aAAA;A5BywSR;A4BxwSQ;EACI,mBAAA;A5B0wSZ;;A6Bz4SA;;6BAAA;AAGA;EACI,gBAAA;A7B44SJ;;A6Bz4SA;;yBAAA;AAII;EACI,aAAA;A7B24SR;A6B14SQ;EAFJ;IAGQ,aAAA;E7B64SV;AACF;A6B54SQ;EACI,WAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;A7B84SZ;A6B34SgB;EACI,aAAA;A7B64SpB;A6B34SgB;EACI,iCAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EAEA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,iDAAA;A7B44SpB;A6Bz4SY;EACI,UAAA;A7B24ShB;A6Bz4SoB;EAEI,mBAAA;EACA,gDAAA;EACA,6BAAA;EACA,wCAAA;A7B24SxB;A6Bh4SoB;EACI,mBAAA;EACA,mCAAA;A7Bk4SxB;A6B/3SgB;EACI,UAAA;A7Bi4SpB;A6B/3SwB;EAEI,mBAAA;EACA,gDAAA;EACA,6BAAA;EACA,wCAAA;A7Bi4S5B;;A6Bv3SA;;yBAAA;AAGA;EACI,kBAAA;A7B03SJ;A6Bx3SQ;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,mBAAA;EACA,0BAAA;A7B03SZ;A6Bx3SY;EAbJ;IAcQ,wBAAA;E7B23Sd;AACF;A6Bz3SY;EAjBJ;IAkBQ,wBAAA;E7B43Sd;AACF;A6B13SY;EArBJ;IAsBQ,wBAAA;E7B63Sd;AACF;A6B33SY;EACI,gCAAA;EACA,kCAAA;A7B63ShB;A6B13SY;EACI,cAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;A7B43ShB;A6Bz3SY;EACI,UAAA;A7B23ShB;A6B13SgB;EACI,gDAAA;A7B43SpB;A6B13SgB;EACI,UAAA;A7B43SpB;A6B33SoB;EACI,UAAA;A7B63SxB;A6Bz3SY;EACI,UAAA;EACA,WAAA;A7B23ShB;A6B13SgB;EACI,gDAAA;A7B43SpB;A6B13SgB;EACI,WAAA;A7B43SpB;A6B33SoB;EACI,UAAA;A7B63SxB;A6Bp3SY;EACI,UAAA;A7Bs3ShB;;A6B92SA,wBAAA;AACA;EACI,kBAAA;EACA,mBAAA;A7Bi3SJ;A6Bh3SI;EACI,kBAAA;EACA,mBAAA;A7Bk3SR;A6Bh3SI;EACI,cAAA;A7Bk3SR;;A6B72SI;EACI,aAAA;A7Bg3SR;;A8BviTA;;wBAAA;AAMI;EACI,UAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;A9BuiTR;A8BtiTQ;EACI,kBAAA;EACA,SAAA;A9BwiTZ;A8BtiTY;EAJJ;IAKQ,kBAAA;E9ByiTd;AACF;A8BviTY;EARJ;IASQ,kBAAA;E9B0iTd;AACF;A8BxiTY;EAZJ;IAaQ,kBAAA;E9B2iTd;AACF;A8BziTY;EACI,iCAAA;A9B2iThB;A8BviTY;EACI,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;A9ByiThB;A8BniTI;EACI,iCAAA;EACA,kBAAA;A9BqiTR;A8BpiTQ;EAHJ;IAIQ,aAAA;E9BuiTV;AACF;A8BriTY;EACI,gBAAA;A9BuiThB;A8BjiTQ;EACI,mBAAA;A9BmiTZ;A8BliTY;EACI,kCAAA;A9BoiThB;A8BjiTQ;EACI,kCAAA;A9BmiTZ;;A+BpmTA;EACI,gBAAA;A/BumTJ;A+BtmTI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,kBAAA;EACA,yDAAA;EACA,4BAAA;A/BwmTR;A+BvmTQ;EACI,WAAA;EACA,qBAAA;EACA,WAAA;EACA,yDAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uCAAA;A/BymTZ;A+BvmTQ;EACI,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,4CAAA;A/BymTZ;A+BxmTY;EACI,mBAAA;A/B0mThB;A+BxmTY;EACI,aAAA;EACA,uBAAA;A/B0mThB;A+BvmTgB;EACI,cAAA;A/BymTpB;A+BxmToB;EACI,eAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;A/B0mTxB;A+BxmToB;EACI,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;A/B0mTxB;A+BzmTwB;EANJ;IAOQ,eAAA;E/B4mT1B;AACF;A+B1mToB;EACI,eAAA;EACA,wBAAA;A/B4mTxB;A+BtmTQ;EACI,kBAAA;EACA,mBAAA;A/BwmTZ;A+BvmTY;EACI,gBAAA;EACA,UAAA;EACA,SAAA;A/BymThB;A+BrmTQ;EACI,kBAAA;A/BumTZ;A+BjmTQ;EACI,uCAAA;EACA,oCAAA;A/BmmTZ;A+B/lTI;EACI,iBAAA;EACA,kBAAA;A/BimTR;A+BhmTQ;EAHJ;IAIQ,iBAAA;IACA,kBAAA;E/BmmTV;AACF;A+BlmTQ;EAPJ;IAQQ,iBAAA;IACA,kBAAA;E/BqmTV;AACF;A+BjmTQ;EACI,oCAAA;A/BmmTZ;A+BjmTY;EACI,uBAAA;EACA,UAAA;A/BmmThB;A+BlmTgB;EAHJ;IAIQ,oBAAA;E/BqmTlB;AACF;A+BpmTgB;EANJ;IAOQ,oBAAA;E/BumTlB;AACF;A+BpmTY;EACI,4CAAA;A/BsmThB;A+BrmTgB;EACI,yBAAA;A/BumTpB;A+BpmToB;EACI,cAAA;A/BsmTxB;A+BrmTwB;EACI,yBAAA;EACA,UAAA;A/BumT5B;A+BpmTwB;EACI,yBAAA;A/BsmT5B;A+BpmTwB;EACI,yBAAA;A/BsmT5B;A+B7lTwB;EACI,yBAAA;A/B+lT5B;A+B9lT4B;EACI,yBAAA;A/BgmThC;A+BzlTY;EACI,kBAAA;A/B2lThB;A+BrlTQ;EACI,uCAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;A/BulTZ;A+BrlTY;EACI,aAAA;A/BulThB;A+BplTY;EACI,mBAAA;EACA,iBAAA;EACA,gCAAA;A/BslThB;A+BplTgB;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;A/BslTpB;A+BnlTgB;EACI,kBAAA;A/BqlTpB;A+BhlTwB;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;A/BklT5B;A+BhlTwB;EACI,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;A/BklT5B;A+BhlTwB;EACI,yBAAA;A/BklT5B;A+B7kTY;EACI,uCAAA;EACA,aAAA;A/B+kThB;;AgCvyTA;;6BAAA;AAGA;EACE,uBAAA;EACA,2DAAA;AhC0yTF;;AgCxyTA;EACE,mBAAA;AhC2yTF;;AgCtyTI;EACE,gBAAA;EACA,WAAA;AhCyyTN;AgCtyTM;EACE,4BAAA;AhCwyTR;AgCpyTE;EACE,mBAAA;AhCsyTJ;AgCpyTI;EAHF;IAII,kBAAA;EhCuyTJ;AACF;AgCtyTI;EANF;IAOI,kBAAA;EhCyyTJ;AACF;AgCxyTI;EATF;IAUI,kBAAA;EhC2yTJ;AACF;AgCzyTI;EACE,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,0BAAA;AhC2yTN;AgC1yTM;EALF;IAMI,eAAA;IACA,iBAAA;EhC6yTN;AACF;AgC1yTI;EACE,gBAAA;EACA,eAAA;EACA,SAAA;EAEA,gBAAA;AhC2yTN;AgC1yTM;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AhC4yTR;AgC1yTQ;EACE,kBAAA;AhC4yTV;;AgCryTA;EACE,gBAAA;AhCwyTF;;AiC32TA;;iCAAA;AAGA;EACI,gBAAA;AjC82TJ;AiC72TI;EAFJ;IAGQ,gBAAA;EjCg3TN;AACF;AiC/2TI;EALJ;IAMQ,gBAAA;EjCk3TN;AACF;AiCj3TI;EARJ;IASQ,gBAAA;EjCo3TN;AACF;AiCn3TI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AjCq3TR;AiCl3TQ;EACI,wBAAA;AjCo3TZ;AiCj3TI;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;AjCm3TR;AiCj3TI;EACI,gBAAA;AjCm3TR;AiC92TgB;EACI,OAAA;EACA,eAAA;AjCg3TpB;AiC72TY;EACI,kBAAA;AjC+2ThB;AiC12TI;EACI,gBAAA;AjC42TR;AiCz2TI;EACI,gBAAA;AjC22TR;AiCz2TQ;EACI,uCAAA;EACA,4BAAA;EACA,kBAAA;AjC22TZ;AiCv2TY;EACI,eAAA;EACA,mBAAA;EACA,oBAAA;AjCy2ThB;AiCt2TY;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;AjCw2ThB;AiCp2TQ;EACI,aAAA;AjCs2TZ;AiCr2TY;EAFJ;IAGQ,gBAAA;EjCw2Td;AACF;AiCv2TY;EALJ;IAMQ,gBAAA;EjC02Td;AACF;AiCt2TI;EACI,UAAA;AjCw2TR;AiCt2TQ;EACI,uCAAA;EACA,4BAAA;EACA,kBAAA;AjCw2TZ;AiCp2TY;EACI,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AjCs2ThB;AiCr2TgB;EALJ;IAMQ,kBAAA;EjCw2TlB;AACF;AiCv2TgB;EARJ;IASQ,eAAA;IACA,kBAAA;EjC02TlB;AACF;AiCv2TY;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;AjCy2ThB;AiCr2TQ;EACI,aAAA;AjCu2TZ;AiCt2TY;EAFJ;IAGQ,gBAAA;EjCy2Td;AACF;AiCx2TY;EALJ;IAMQ,gBAAA;EjC22Td;AACF;AiCt2TI;EACI,UAAA;AjCw2TR;AiCt2TQ;EACI,uCAAA;EACA,4BAAA;EACA,kBAAA;AjCw2TZ;AiCv2TY;EAJJ;IAKQ,kBAAA;EjC02Td;AACF;AiCz2TY;EAPJ;IAQQ,kBAAA;EjC42Td;AACF;AiCx2TY;EACI,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AjC02ThB;AiCz2TgB;EALJ;IAMQ,eAAA;EjC42TlB;AACF;AiC32TgB;EARJ;IASQ,eAAA;EjC82TlB;AACF;AiC72TgB;EAXJ;IAYQ,eAAA;EjCg3TlB;AACF;AiC/2TgB;EAdJ;IAeQ,eAAA;EjCk3TlB;AACF;AiCj3TgB;EACI,aAAA;AjCm3TpB;AiCh3TY;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;AjCk3ThB;AiC92TQ;EACI,gBAAA;AjCg3TZ;AiC52TI;EACI,eAAA;AjC82TR;AiC52TY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AjC82ThB;AiC52TgB;EACI,aAAA;AjC82TpB;AiC12TQ;EACI,aAAA;AjC42TZ;AiC32TY;EAFJ;IAGQ,gBAAA;EjC82Td;AACF;AiC72TY;EALJ;IAMQ,gBAAA;EjCg3Td;AACF;AiC52TI;EACI,UAAA;AjC82TR;AiC72TQ;EACI,eAAA;EACA,4CAAA;AjC+2TZ;AiC52TY;EACI,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AjC82ThB;AiC32TQ;EACI,aAAA;AjC62TZ;AiC52TY;EAFJ;IAGQ,gBAAA;EjC+2Td;AACF;AiC92TY;EALJ;IAMQ,gBAAA;EjCi3Td;AACF;;AiC12TI;EACI,gBAAA;EACA,iCAAA;AjC62TR;AiC52TQ;EACI,eAAA;EACA,4CAAA;AjC82TZ;AiC52TQ;EACI,yBAAA;AjC82TZ;AiC32TY;EACI,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;AjC62ThB;AiC12TQ;EACI,aAAA;AjC42TZ;;AiCr2TA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;AjCw2TJ;AiCt2TI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,wFAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AjCw2TR;AiCr2TI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,uFAAA;AjCu2TR;;AkClpUA;;+BAAA;AAGA;;EAEI,kBAAA;EACA,cAAA;AlCqpUJ;AkCnpUQ;;EACI,WAAA;AlCspUZ;AkCnpUI;;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;AlCspUR;;AkClpUI;EACI,UAAA;EACA,gBAAA;EACA,2CAAA;AlCqpUR;AkClpUQ;EACI,UAAA;EACA,aAAA;EACA,yCAAA;AlCopUZ;;AkC/oUA;EACI,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AlCkpUJ;AkChpUI;EANJ;IAOQ,oBAAA;IACA,kBAAA;ElCmpUN;AACF;AkCjpUI;EAXJ;IAYQ,oBAAA;IACA,kBAAA;ElCopUN;AACF;AkClpUI;EACI,eAAA;AlCopUR;AkClpUQ;EAHJ;IAIQ,eAAA;ElCqpUV;AACF;AkCppUQ;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;AlCspUZ;AkCrpUY;EAPJ;IAQQ,eAAA;ElCwpUd;AACF;;AmC5tUA;;6BAAA;AAMQ;EACI,YAAA;EACA,eAAA;AnC4tUZ;AmC1tUQ;EACI,iBAAA;EACA,kBAAA;AnC4tUZ;;AmCttUA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AnCytUJ;;AmCttUA;;qBAAA;AAGA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iCAAA;EACA,oBAAA;EACA,wCAAA;EACA,gBAAA;AnCytUJ;AmCvtUI;EAVJ;IAWQ,kBAAA;EnC0tUN;AACF;AmCztUI;EAbJ;IAcQ,kBAAA;EnC4tUN;AACF;AmC3tUI;EAhBJ;IAiBQ,kBAAA;EnC8tUN;AACF;AmC5tUI;EACI,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AnC8tUR;AmC1tUY;EACI,eAAA;EACA,gBAAA;AnC4tUhB;AmCztUQ;EACI,eAAA;EACA,gBAAA;AnC2tUZ;AmC1tUY;EAHJ;IAIQ,eAAA;EnC6tUd;AACF;AmC5tUY;EANJ;IAOQ,eAAA;EnC+tUd;AACF;AmC9tUY;EATJ;IAUQ,eAAA;EnCiuUd;AACF;AmC9tUgB;EAFJ;IAGQ,aAAA;EnCiuUlB;AACF;AmC/tUgB;EANJ;IAOQ,aAAA;EnCkuUlB;AACF;AmChuUgB;EAVJ;IAWQ,aAAA;EnCmuUlB;AACF;AmCjuUY;EACI,wBAAA;AnCmuUhB;AmCjuUgB;EACI,2BAAA;AnCmuUpB;AmC9tUI;EACI,2BAAA;AnCguUR;;AmC3tUA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AnC8tUJ;AmC7tUI;EACI,mBAAA;AnC+tUR;;AmC3tUA;EACI,YAAA;EACA,gBAAA;EACA,eAAA;AnC8tUJ;;AoC/0UA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;ApCk1UJ;AoCj1UI;EACI,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,yBAAA;EACA,iCAAA;EACA,sBAAA;EACA,kBAAA;ApCm1UR;AoCl1UQ;EARJ;IASQ,kBAAA;EpCq1UV;AACF;AoCp1UQ;EAXJ;IAYQ,eAAA;EpCu1UV;AACF;AoCt1UQ;EACI,cAAA;ApCw1UZ;AoCv1UY;EACI,YAAA;EACA,gBAAA;ApCy1UhB;AoCp1UgB;EACI,UAAA;ApCs1UpB;;AoC90UA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;ApCi1UJ;AoCh1UI;EACI,mBAAA;EACA,kBAAA;ApCk1UR;AoCh1UQ;EAJJ;IAKQ,eAAA;EpCm1UV;AACF;AoCj1UQ;EARJ;IASQ,eAAA;EpCo1UV;AACF;AoCl1UQ;EAZJ;IAaQ,kBAAA;EpCq1UV;AACF;AoCn1UQ;EAhBJ;IAiBQ,eAAA;EpCs1UV;AACF;AoCp1UQ;EACI,oBAAA;EACA,eAAA;EACA,cAAA;ApCs1UZ;AoCr1UY;EACI,UAAA;EACA,gBAAA;EACA,YAAA;ApCu1UhB;AoCl1UgB;EACI,YAAA;ApCo1UpB;AoC70UQ;EACI,eAAA;EACA,kBAAA;ApC+0UZ;AoC90UY;EAHJ;IAIQ,kBAAA;EpCi1Ud;AACF;AoCh1UY;EANJ;IAOQ,eAAA;EpCm1Ud;AACF;;AqCn7UA;;6BAAA;AAGA;EACI,yCAAA;EACA,4CAAA;ArCs7UJ;;AqCn7UI;EACI,yCAAA;EACA,4CAAA;ArCs7UR;;AqC/6UI;EACI,eAAA;ArCk7UR;AqC/6UQ;EACI,wBAAA;EACA,kBAAA;ArCi7UZ;AqC/6UQ;EACI,wBAAA;EACA,gBAAA;ArCi7UZ;AqC96UI;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ArCg7UR;AqC96UQ;EANJ;IAOO,cAAA;ErCi7UT;AACF;AqC/6UQ;EAVJ;IAWM,2BAAA;ErCk7UR;AACF;AqCh7UQ;EAdJ;IAeM,2BAAA;ErCm7UR;AACF;AqCj7UQ;EACI,gBAAA;EACA,cAAA;ArCm7UZ;AqCl7UY;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,cAAA;ArCo7UhB;AqCn7UgB;EANJ;IAOQ,gBAAA;ErCs7UlB;AACF;AqCr7UgB;EATJ;IAUQ,gBAAA;ErCw7UlB;AACF;AqCv7UgB;EAZJ;IAaQ,gBAAA;ErC07UlB;AACF;AqCz7UgB;EAfJ;IAgBQ,eAAA;IACA,mBAAA;ErC47UlB;AACF;AqC17UY;EACI,YAAA;ArC47UhB;;AsCjgVI;EACI,gBAAA;EACA,UAAA;EACA,eAAA;AtCogVR;AsClgVQ;EACI,cAAA;AtCogVZ;AsCjgVQ;EACI,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AtCmgVZ;AsCjgVY;EACI,kBAAA;EACA,WAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,gBAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;AtCmgVhB;AsC//UgB;EACI,UAAA;EACA,mBAAA;AtCigVpB;AsC5/UY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,6CAAA;EACA,kCAAA;EACA,qCAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;AtC8/UhB;AsC7/UgB;EAZJ;IAaQ,aAAA;EtCggVlB;AACF;AsC//UgB;EAfJ;IAgBQ,aAAA;EtCkgVlB;AACF;AsC//UY;EACI,wBAAA;EACA,eAAA;EACA,mBAAA;AtCigVhB;AsC9/UY;EACI,gBAAA;AtCggVhB;AsC1/UgB;EACI,yBAAA;AtC4/UpB;AsC1/UgB;EACI,UAAA;EACA,mBAAA;AtC4/UpB;AsCz/UgB;EACI,UAAA;EACA,mBAAA;AtC2/UpB;;AsCh/UQ;EACI,mBAAA;AtCm/UZ;;AsC5+UA;EACI,qCAAA;EACA,UAAA;EACA,WAAA;AtC++UJ;;AsC7+UA;EACI,mCAAA;AtCg/UJ;;AsC9+UA;EACI,SAAA;EACA,oDAAA;EACA,WAAA;EACA,SAAA;AtCi/UJ;;AsC/+UA;EACI,UAAA;EACA,mDAAA;AtCk/UJ;;AuC1mVA;;+BAAA;AAGA;EACI,iCAAA;EACA,mBAAA;AvC6mVJ;AuC5mVI;EACI,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,4BAAA;AvC8mVR;AuC7mVQ;EACI,mBAAA;AvC+mVZ;AuCzmVY;EACI,eAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AvC2mVhB;AuC1mVgB;EACI,eAAA;EACA,UAAA;AvC4mVpB;AuCxmVQ;EACI,WAAA;EACA,cAAA;AvC0mVZ;AuCxmVQ;EACI,kBAAA;EACA,eAAA;AvC0mVZ;AuCzmVY;EACI,gBAAA;EACA,cAAA;AvC2mVhB;AuC1mVgB;EACI,aAAA;AvC4mVpB;AuCxmVQ;EACI,cAAA;EACA,wBAAA;EACA,kBAAA;AvC0mVZ;AuCtmVI;EACI,kBAAA;AvCwmVR;AuCnmVQ;EACI,eAAA;EACA,mBAAA;AvCqmVZ;AuCpmVY;EACI,eAAA;EACA,aAAA;AvCsmVhB;;AwCrqVA;;4BAAA;AAKI;EACI,gBAAA;EACA,mBAAA;AxCsqVR;AwCrqVQ;EACI,2BAAA;AxCuqVZ;AwCnqVI;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AxCqqVR;AwCpqVQ;EACI,aAAA;AxCsqVZ;AwCrqVY;EACI,gCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AxCuqVhB;AwCrqVY;EACI,iBAAA;AxCuqVhB;AwCtqVgB;EACI,eAAA;EACA,SAAA;AxCwqVpB;AwCrqVgB;EACI,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AxCuqVpB;;AwC7pVA;EACI,kBAAA;EACA,UAAA;AxCgqVJ;AwC/pVI;EACI,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;AxCiqVR;AwChqVQ;EALJ;IAMQ,gBAAA;IACA,4BAAA;ExCmqVV;AACF;AwClqVQ;EATJ;IAUQ,gBAAA;IACA,4BAAA;ExCqqVV;AACF;AwCnqVY;EACI,mBAAA;AxCqqVhB;AwCjqVY;EACI,eAAA;AxCmqVhB;AwClqVgB;EAFJ;IAGQ,UAAA;ExCqqVlB;AACF;AwCpqVgB;EACI,eAAA;EACA,mBAAA;AxCsqVpB;AwCpqVgB;EACI,mBAAA;EACA,UAAA;AxCsqVpB;;AwC9pVA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AxCiqVJ;AwChqVI;EACI,eAAA;AxCkqVR;AwCjqVQ;EACI,2BAAA;EACA,kBAAA;AxCmqVZ;;AwC1pVI;;EAEI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AxC6pVR;AwC3pVI;EACI,aAAA;AxC6pVR;AwC5pVQ;EAFJ;IAGQ,aAAA;ExC+pVV;AACF;AwC9pVQ;EALJ;IAMQ,aAAA;ExCiqVV;AACF;AwChqVQ;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AxCkqVZ;AwC1pVQ;EACI,iBAAA;AxC4pVZ;AwCxpVI;EACI,eAAA;EACA,gBAAA;AxC0pVR;AwCxpVI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AxC0pVR;;AyCpzVA;;6BAAA;AAMQ;EACI,aAAA;AzCozVZ;;AyChzVA;EACI,aAAA;EACA,uBAAA;AzCmzVJ;;AyC9yVA;EACI,cAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AzCizVJ;;AyC/yVA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AzCkzVJ;AyCjzVI;EACI,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AzCmzVR;AyClzVQ;EACI,aAAA;EACA,gBAAA;AzCozVZ;AyCnzVY;EACI,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AzCqzVhB;AyCpzVgB;EACI,WAAA;AzCszVpB;AyCpzVgB;EACI,0BAAA;EACA,aAAA;AzCszVpB;AyCpzVgB;EACI,aAAA;AzCszVpB;AyCpzVgB;EACI,yBAAA;AzCszVpB;AyCpzVgB;EACI,cAAA;AzCszVpB;;A0C13VA;;8BAAA;AAGA;EACI,kBAAA;A1C63VJ;A0C53VI;EACI,gBAAA;EACA,cAAA;EACA,2BAAA;EACA,0BAAA;A1C83VR;A0C73VQ;EALJ;IAMQ,gBAAA;IACA,cAAA;E1Cg4VV;AACF;A0C73VI;EACI,iBAAA;EACA,0BAAA;A1C+3VR;A0C53VI;EACI,8BAAA;EACA,iBAAA;EACA,wBAAA;EACA,6BAAA;EACA,mBAAA;A1C83VR;A0C33VI;EACI,qBAAA;A1C63VR;A0C53VQ;EACI,gBAAA;A1C83VZ;A0C13VI;EACI,gBAAA;A1C43VR;;AAj2VA;;uCAAA;A2ChEA;;wBAAA;AAGA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,uCAAA;EACA,2BAAA;EACA,sCAAA;EACA,4BAAA;EACA,gBAAA;EACA,oBAAA;A3Cu6VJ;A2Cl6VgB;EACI,WAAA;A3Co6VpB;A2C/5VQ;EACI,aAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;A3Ci6VZ;A2C/5VY;EAPJ;IAQQ,kBAAA;E3Ck6Vd;AACF;A2Cj6VY;EACI,gBAAA;EACA,mBAAA;A3Cm6VhB;A2Cj6VY;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;A3Cm6VhB;A2C75VI;EACI,YAAA;A3C+5VR;A2C95VQ;EACI,aAAA;EACA,YAAA;A3Cg6VZ;A2C95VY;EACI,eAAA;A3Cg6VhB;A2C/5VgB;EACI,cAAA;EACA,YAAA;A3Ci6VpB;A2Ch6VoB;EACI,WAAA;EACA,iBAAA;EACA,YAAA;A3Ck6VxB;A2C95VY;EACI,eAAA;A3Cg6VhB;A2C/5VgB;EACI,mBAAA;A3Ci6VpB;A2C/5VgB;EACI,mBAAA;EACA,gBAAA;A3Ci6VpB;;A2Cz5VA;EAEI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;A3C25VJ;A2Cz5VI;EACI,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;A3C25VR;A2Cx5VQ;EACI,wBAAA;EACA,gBAAA;A3C05VZ;A2Cv5VQ;EACI,gBAAA;A3Cy5VZ;;A4CjgWA;EACI,kBAAA;A5CogWJ;A4CngWI;EACI,YAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;A5CqgWR;A4CngWI;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,sCAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;A5CqgWR;A4CpgWQ;EACI,yBAAA;EACA,gBAAA;A5CsgWZ;;A4ChgWA;EACI,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;A5CmgWJ;A4CjgWI;EACI,wBAAA;A5CmgWR;A4ChgWI;;EAEI,qDAAA;A5CkgWR;A4C9/VI;EACI,UAAA;EACA,cAAA;A5CggWR;A4C//VQ;EACI,SAAA;A5CigWZ;A4C7/VI;EACI,eAAA;EACA,iBAAA;EACA,cAAA;A5C+/VR;A4C5/VI;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,uCAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;A5C8/VR;A4C7/VQ;EACI,2BAAA;A5C+/VZ;A4C7/VgB;EACI,YAAA;EACA,iBAAA;A5C+/VpB;A4C3/VQ;EACI,mBAAA;A5C6/VZ;A4Cv/VI;EACI,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;A5Cy/VR;A4Cx/VQ;EACI,gBAAA;A5C0/VZ;A4Cx/VQ;EACI,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;A5C0/VZ;A4Cz/VY;EACI,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,gBAAA;A5C2/VhB;A4C1/VgB;EACI,2BAAA;A5C4/VpB;A4Cl/VgB;EACI,aAAA;EACA,8BAAA;A5Co/VpB;A4Cr+VY;EACI,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;A5Cu+VhB;A4Ct+VgB;EACI,wBAAA;A5Cw+VpB;A4Ct+VoB;EACI,2BAAA;A5Cw+VxB;A4Cr+VgB;EAEI,wBAAA;A5Cs+VpB;A4Cl+VwB;EACI,2BAAA;A5Co+V5B;A4Ch+VgB;EACI,yCAAA;A5Ck+VpB;A4Cr9VY;EACI,aAAA;EACA,gBAAA;A5Cu9VhB;A4Ct9VgB;EACI,aAAA;A5Cw9VpB;A4Ct9VgB;EACI,mBAAA;A5Cw9VpB;A4Ch9VY;EACI,yBAAA;EACA,kBAAA;A5Ck9VhB;A4Ch9VY;EACI,wBAAA;EACA,eAAA;EACA,qBAAA;A5Ck9VhB;;A4Ct8VA;EACI,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;A5Cy8VJ;A4Cx8VI;EALJ;IAMQ,cAAA;IACA,eAAA;E5C28VN;AACF;A4C18VI;EATJ;IAUQ,cAAA;IACA,eAAA;E5C68VN;AACF;A4C58VI;EAbJ;IAcQ,cAAA;IACA,eAAA;E5C+8VN;AACF;;A4C58VA;EACI,6BAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;A5C+8VJ;;A4C38VA;;EAEI,YAAA;EACA,eAAA;A5C88VJ;A4C78VI;;EACI,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,wBAAA;EACA,0BAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;EACA,qCAAA;EAEA,eAAA;EACA,kBAAA;A5C+8VR;A4C98VQ;;EACI,gCAAA;EACA,cAAA;EACA,kCAAA;A5Ci9VZ;;A6C9sWA;;mCAAA;AAMI;EACI,uBAAA;A7C8sWR;A6C7sWQ;EACI,wBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;A7C+sWZ;A6C9sWY;EALJ;IAMQ,eAAA;IACA,eAAA;E7CitWd;AACF;A6ChtWY;EATJ;IAUQ,eAAA;IACA,eAAA;E7CmtWd;AACF;A6CltWY;EACI,kBAAA;A7CotWhB;A6CltWY;EACI,wBAAA;EACA,gBAAA;A7CotWhB;A6CntWgB;EACI,2BAAA;A7CqtWpB;A6C/sWI;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;A7CitWR;A6ChtWQ;EACI,YAAA;EACA,kBAAA;A7CktWZ;A6CjtWY;EACI,kBAAA;EACA,YAAA;EACA,WAAA;A7CmtWhB;A6ChtWgB;EACI,aAAA;A7CktWpB;;A6CxsWI;EACI,aAAA;EACA,eAAA;EACA,yCAAA;EACA,4CAAA;EACA,eAAA;A7C2sWR;A6CzsWY;EACI,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;A7C2sWhB;;AA3sWA;;uCAAA;A8C1EA;;0BAAA;AAMQ;EACI,YAAA;A9CwxWZ;;A8CnxWA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;A9CsxWJ;A8CpxWI;EALJ;IAMQ,YAAA;IACA,gBAAA;E9CuxWN;AACF;A8CrxWI;EAVJ;IAWQ,YAAA;IACA,gBAAA;E9CwxWN;AACF;;A8CtxWA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;A9CyxWJ;A8CvxWI;EALJ;IAMQ,YAAA;IACA,gBAAA;E9C0xWN;AACF;A8CxxWI;EAVJ;IAWQ,YAAA;IACA,gBAAA;E9C2xWN;AACF;;A8CxxWA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;A9C2xWJ;A8CzxWI;EALJ;IAMQ,YAAA;IACA,gBAAA;E9C4xWN;AACF;A8C1xWI;EAVJ;IAWQ,YAAA;IACA,gBAAA;E9C6xWN;AACF;;A8CzxWA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;A9C4xWJ;A8C1xWI;EALJ;IAMQ,YAAA;IACA,gBAAA;E9C6xWN;AACF;A8C3xWI;EAVJ;IAWQ,YAAA;IACA,gBAAA;E9C8xWN;AACF;;A8C3xWA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;A9C8xWJ;A8C5xWI;EALJ;IAMQ,YAAA;IACA,gBAAA;E9C+xWN;AACF;A8C7xWI;EAVJ;IAWQ,YAAA;IACA,gBAAA;E9CgyWN;AACF;;A8C7xWA;EACI,eAAA;A9CgyWJ;A8C/xWI;EAFJ;IAGQ,eAAA;E9CkyWN;AACF;A8CjyWI;EALJ;IAMQ,eAAA;E9CoyWN;AACF;A8CnyWI;EARJ;IASQ,eAAA;E9CsyWN;AACF;A8CryWI;EAXJ;IAYQ,eAAA;E9CwyWN;AACF;;A8CryWA;EACI,eAAA;A9CwyWJ;A8CvyWI;EAFJ;IAGQ,eAAA;E9C0yWN;AACF;A8CzyWI;EALJ;IAMQ,eAAA;E9C4yWN;AACF;A8C1yWI;EATJ;IAUQ,eAAA;E9C6yWN;AACF;A8C3yWI;EAbJ;IAcQ,eAAA;E9C8yWN;AACF;;A8CzyWA;EACI,kBAAA;A9C4yWJ;A8C1yWI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,6BAAA;EACA,0EAAA;EACA,WAAA;A9C4yWR;;A8CtyWA;EACI,kBAAA;EACA,UAAA;A9CyyWJ;A8CvyWI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;A9CyyWR;A8CtyWI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uFAAA;EACA,WAAA;EACA,WAAA;A9CwyWR;;A8CnyWA;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;EACA,uCAAA;A9CsyWJ;A8CpyWI;EACI,WAAA;A9CsyWR;A8CnyWI;EACI,2BAAA;A9CqyWR;;A8C5xWgB;;EACI,iCAAA;EACA,yBAAA;A9CgyWpB;;A8CzxWA;;0BAAA;AAMQ;EACI,gCAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;A9CyxWZ;A8CvxWY;EARJ;IASQ,eAAA;IACA,mBAAA;E9C0xWd;AACF;A8CxxWY;EAbJ;IAcQ,eAAA;IACA,mBAAA;E9C2xWd;AACF;A8CzxWY;EAlBJ;IAmBQ,eAAA;E9C4xWd;AACF;A8CzxWQ;EACI,gCAAA;EACA,mBAAA;EACA,qBAAA;A9C2xWZ;A8CzxWY;EACI,qBAAA;A9C2xWhB;A8CzxWgB;EACI,gBAAA;A9C2xWpB;A8CtxWQ;EACI,gCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;A9CwxWZ;A8CtxWY;EARJ;IASQ,cAAA;IACA,eAAA;IACA,mBAAA;E9CyxWd;AACF;A8CvxWY;EAdJ;IAeQ,aAAA;IACA,eAAA;IACA,mBAAA;E9C0xWd;AACF;A8CxxWY;EApBJ;IAqBQ,aAAA;IACA,eAAA;IACA,mBAAA;E9C2xWd;AACF;A8CzxWY;EA1BJ;IA2BQ,eAAA;IACA,mBAAA;E9C4xWd;AACF;A8CtxWY;EACI,UAAA;A9CwxWhB;A8ChxWQ;EACI,iBAAA;A9CkxWZ;A8C9wWI;EACI,kBAAA;A9CgxWR;A8C9wWY;EACI,qBAAA;A9CgxWhB;;A8CvwWA;EACI,kBAAA;A9C0wWJ;A8CxwWI;EAHJ;IAIQ,kBAAA;E9C2wWN;AACF;A8CzwWI;EAPJ;IAQQ,kBAAA;E9C4wWN;AACF;A8C1wWQ;EACI,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,uCAAA;EACA,iCAAA;A9C4wWZ;A8CzwWQ;EACI,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;A9C2wWZ;A8CzwWgB;EADJ;IAEQ,eAAA;E9C4wWlB;AACF;A8CvwWY;EACI,wBAAA;A9CywWhB;A8CpwWI;EACI,iBAAA;A9CswWR;A8CrwWQ;EAFJ;IAGQ,kBAAA;E9CwwWV;AACF;A8CvwWQ;EALJ;IAMQ,kBAAA;E9C0wWV;AACF;A8CvwWY;EACI,gBAAA;EACA,eAAA;EACA,aAAA;A9CywWhB;A8CxwWgB;EAJJ;IAKQ,eAAA;E9C2wWlB;AACF;A8C1wWgB;EAPJ;IAQQ,eAAA;E9C6wWlB;AACF;A8C5wWgB;EAVJ;IAWQ,eAAA;E9C+wWlB;AACF;A8C5wWY;EACI,6BAAA;EACA,SAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;A9C8wWhB;A8C5wWgB;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,kCAAA;EACA,QAAA;EACA,2BAAA;A9C8wWpB;A8CxwWI;EACI,iBAAA;A9C0wWR;A8CzwWQ;EAFJ;IAGQ,kBAAA;E9C4wWV;AACF;A8C1wWQ;EANJ;IAOQ,kBAAA;E9C6wWV;AACF;A8C1wWY;EACI,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;A9C4wWhB;A8C3wWgB;EALJ;IAMQ,eAAA;E9C8wWlB;AACF;A8C7wWgB;EARJ;IASQ,eAAA;E9CgxWlB;E8C/wWkB;IACI,aAAA;E9CixWtB;AACF;A8C7wWY;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;A9C+wWhB;A8C9wWgB;EAJJ;IAKQ,eAAA;IACA,iBAAA;E9CixWlB;AACF;;A8CxwWI;EADJ;IAEQ,gBAAA;E9C4wWN;AACF;A8C1wWI;EALJ;IAMQ,gBAAA;E9C6wWN;AACF;A8C1wWQ;EACI,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;A9C4wWZ;A8C1wWY;EAPJ;IAQQ,gBAAA;E9C6wWd;AACF;A8C3wWY;EAXJ;IAYQ,eAAA;E9C8wWd;AACF;A8C5wWY;EAfJ;IAgBQ,mBAAA;IACA,eAAA;E9C+wWd;AACF;A8C5wWQ;EACI,eAAA;EACA,iBAAA;A9C8wWZ;A8C5wWY;EAJJ;IAKQ,eAAA;IACA,iBAAA;E9C+wWd;AACF;A8C7wWY;EATJ;IAUQ,eAAA;IACA,iBAAA;E9CgxWd;AACF;A8C5wWI;EACI,kBAAA;EACA,UAAA;A9C8wWR;A8C5wWQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EAGA,2BAAA;EACA,iCAAA;EACA,2BAAA;EACA,kBAAA;A9C8wWZ;;A8CtwWI;EACI,iBAAA;A9CywWR;A8CvwWQ;EAHJ;IAIQ,iBAAA;E9C0wWV;AACF;A8CzwWQ;EACI,yBAAA;EACA,yBAAA;EACA,sBAAA;A9C2wWZ;A8CzwWQ;EACI,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,yDAAA;EACA,yBAAA;A9C2wWZ;A8CzwWY;EATJ;IAUQ,gBAAA;E9C4wWd;AACF;A8C1wWY;EAbJ;IAcQ,gBAAA;E9C6wWd;AACF;A8C3wWY;EAjBJ;IAkBQ,eAAA;E9C8wWd;AACF;A8C5wWY;EArBJ;IAsBQ,eAAA;E9C+wWd;AACF;A8C5wWQ;EACI,eAAA;EACA,iBAAA;EACA,yDAAA;EACA,wBAAA;A9C8wWZ;A8C7wWY;EALJ;IAMQ,eAAA;IACA,iBAAA;E9CgxWd;AACF;A8C7wWQ;EACI,yDAAA;A9C+wWZ;A8C1wWY;EACI,eAAA;A9C4wWhB;A8C3wWgB;EAFJ;IAGQ,eAAA;E9C8wWlB;AACF;A8C1wWY;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;A9C4wWhB;A8CtwWY;EACI,eAAA;A9CwwWhB;A8CpwWY;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;A9CswWhB;;A8C7vWQ;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;A9CgwWZ;A8C9vWY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;A9CgwWhB;A8C5vWQ;EACI,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;A9C8vWZ;A8C5vWY;EARJ;IASQ,eAAA;E9C+vWd;AACF;;A8CvvWA;EACI,uCAAA;A9C0vWJ;A8CxvWI;EAHJ;IAIQ,gBAAA;IACA,gBAAA;IACA,kBAAA;E9C2vWN;AACF;A8CzvWI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;A9C2vWR;A8C1vWQ;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;A9C4vWZ;A8C3vWY;EANJ;IAOQ,aAAA;E9C8vWd;AACF;A8C7vWY;EATJ;IAUQ,aAAA;E9CgwWd;AACF;A8C5vWI;EACI,kBAAA;A9C8vWR;A8C7vWQ;EACI,kBAAA;EACA,UAAA;A9C+vWZ;A8C7vWQ;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;A9C+vWZ;A8C9vWY;EATJ;IAUQ,aAAA;E9CiwWd;AACF;A8C/vWY;EAbJ;IAcQ,aAAA;E9CkwWd;AACF;A8C7vWQ;EADJ;IAEQ,kBAAA;E9CgwWV;AACF;A8C5vWQ;EACI,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;A9C8vWZ;A8C5vWY;EAPJ;IAQQ,eAAA;E9C+vWd;AACF;A8C7vWY;EAXJ;IAYQ,eAAA;E9CgwWd;AACF;A8C9vWY;EAfJ;IAgBQ,eAAA;E9CiwWd;AACF;A8C/vWgB;EADJ;IAEQ,aAAA;E9CkwWlB;AACF;A8C9vWQ;EACI,eAAA;EACA,iBAAA;A9CgwWZ;A8C9vWY;EAJJ;IAKQ,eAAA;IACA,iBAAA;E9CiwWd;AACF;A8C/vWY;EATJ;IAUQ,eAAA;IACA,iBAAA;E9CkwWd;AACF;A8C7vWgB;EACI,iCAAA;EACA,yBAAA;A9C+vWpB;;A8CtvWQ;EADJ;IAEQ,kBAAA;E9C0vWV;AACF;A8CzvWQ;EAJJ;IAKQ,kBAAA;E9C4vWV;AACF;A8C1vWI;EACI,kBAAA;A9C4vWR;A8C3vWQ;EAFJ;IAGQ,aAAA;E9C8vWV;AACF;A8C7vWQ;EALJ;IAMQ,aAAA;E9CgwWV;AACF;A8C/vWQ;EACI,gBAAA;EACA,yBAAA;A9CiwWZ;A8ChwWY;EAHJ;IAIQ,eAAA;E9CmwWd;AACF;A8ClwWY;EANJ;IAOQ,eAAA;E9CqwWd;AACF;A8C/vWgB;;EACI,iCAAA;EACA,yBAAA;A9CkwWpB;;A8CxvWQ;EACI,gBAAA;A9C2vWZ;A8C1vWY;EAFJ;IAGQ,eAAA;E9C6vWd;AACF;A8C5vWY;EALJ;IAMQ,eAAA;E9C+vWd;AACF;A8C9vWY;EARJ;IAYQ,eAAA;E9C8vWd;E8CjwWc;IACI,aAAA;E9CmwWlB;AACF;;A8CtvWA;EACI,uBAAA;A9CyvWJ;A8CvvWQ;EACI,gBAAA;EACA,gBAAA;A9CyvWZ;A8CxvWY;EAHJ;IAIQ,eAAA;E9C2vWd;AACF;A8C1vWY;EANJ;IAOQ,eAAA;E9C6vWd;AACF;A8C3vWQ;EACI,eAAA;EACA,iBAAA;A9C6vWZ;A8C5vWY;EAHJ;IAIQ,eAAA;IACA,iBAAA;E9C+vWd;AACF;A8C7vWgB;EADJ;IAEQ,aAAA;E9CgwWlB;AACF;A8C/vWgB;EAJJ;IAKQ,aAAA;E9CkwWlB;AACF;;A8CzvWY;EACI,wBAAA;A9C4vWhB;A8CzvWY;EACI,qBAAA;A9C2vWhB;A8CxvWY;EACI,mBAAA;A9C0vWhB;A8CvvWY;EACI,qBAAA;A9CyvWhB;;A+CrmYA;;iCAAA;AAKQ;EACI,eAAA;EACA,mBAAA;A/CsmYZ;A+CrmYY;EAHJ;IAIQ,eAAA;IACA,mBAAA;E/CwmYd;AACF;A+CtmYQ;EACI,YAAA;A/CwmYZ;A+CvmYY;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;A/CymYhB;A+CxmYgB;EACI,yCAAA;A/C0mYpB;A+CxmYgB;EACI,eAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,SAAA;A/C0mYpB;A+CxmYgB;EACI,eAAA;A/C0mYpB;A+CpmYQ;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;A/CsmYZ;A+CnmYY;EACI,mBAAA;A/CqmYhB;;A+C7lYI;EACI,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;A/CgmYR;A+C/lYQ;EALJ;IAMQ,cAAA;IACA,eAAA;E/CkmYV;AACF;A+CjmYQ;EATJ;IAUQ,cAAA;IACA,eAAA;E/ComYV;AACF;A+CnmYQ;EAbJ;IAcQ,cAAA;IACA,eAAA;E/CsmYV;AACF;;AgD3qYA;;gCAAA;AAGA;EACI,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AhD8qYJ;AgD7qYI;EACI,cAAA;AhD+qYR;AgD5qYI;EACI,kBAAA;AhD8qYR;AgD7qYQ;EACI,mBAAA;EACA,WAAA;AhD+qYZ;AgD7qYQ;EACI,aAAA;AhD+qYZ;AgD7qYQ;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AhD+qYZ;AgD5qYI;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;AhD8qYR;AgD3qYI;EACI,2BAAA;AhD6qYR;;AgDzqYI;EACI,iBAAA;AhD4qYR;;AiDnuYA;EACI,aAAA;EACD,aAAA;EACH,uBAAA;AjDsuYA;;AiDluYA;EACI,aAAA;EACA,6BAAA;AjDquYJ;;AA7pYA;;uCAAA;AkDnFA;;yBAAA;AAKQ;EACI,gBAAA;AlDovYZ;;AkD/uYA;EACI,yCAAA;EACA,sCAAA;EAEA,iFAAA;AlDkvYJ;AkDjvYI;EACI,gBAAA;EACA,oBAAA;AlDmvYR;AkDjvYY;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;AlDmvYhB;AkDjvYgB;EATJ;IAUQ,eAAA;IACA,gBAAA;ElDovYlB;AACF;AkDnvYgB;EAbJ;IAcQ,eAAA;IACA,gBAAA;ElDsvYlB;AACF;AkDnvYY;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;AlDqvYhB;AkDlvYY;EACI,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AlDovYhB;AkDnvYgB;EAPJ;IAQQ,gBAAA;ElDsvYlB;AACF;AkDnvYY;EACI,gBAAA;AlDqvYhB;AkDlvYY;EACI,gBAAA;EACA,UAAA;AlDovYhB;AkDnvYgB;EACI,eAAA;EACA,kBAAA;AlDqvYpB;AkDpvYoB;EACI,eAAA;EACA,qBAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;AlDsvYxB;AkDrvYwB;EACI,2BAAA;AlDuvY5B;AkDtvY4B;EACI,WAAA;EACA,OAAA;EACA,WAAA;AlDwvYhC;AkD5uYY;EACI,gBAAA;AlD8uYhB;AkDzuYI;EACI,aAAA;AlD2uYR;AkDvuYI;EACI,aAAA;AlDyuYR;;AkDpuYI;EACI,uBAAA;AlDuuYR;;AkDluYA;EACI,aAAA;EACA,8BAAA;AlDquYJ;;AkDjuYA;EACI,aAAA;EACA,eAAA;AlDouYJ;AkDnuYI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AlDquYR;;AkD9tYY;EACI,iCAAA;AlDiuYhB;;AmD52YA;;4BAAA;AAGA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,uCAAA;AnD+2YJ;AmD92YI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;AnDg3YR;;AmD32YA;EACI,gCAAA;EACA,eAAA;EACA,yCAAA;AnD82YJ;AmD72YI;EACI,gBAAA;EACA,eAAA;AnD+2YR;AmD72YI;EACI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AnD+2YR;AmD92YQ;EAPJ;IAQQ,uBAAA;EnDi3YV;AACF;AmDh3YQ;EACI,SAAA;EACA,eAAA;EACA,kBAAA;AnDk3YZ;AmDh3YgB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,+BAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AnDk3YpB;AmD/2YY;EACI,eAAA;AnDi3YhB;AmD52YI;EACI,iCAAA;AnD82YR;AmD32YI;EACI,aAAA;AnD62YR;;AoDn7YA;;4BAAA;AAGA;EACE,gBAAA;ApDs7YF;;AoDp7YA;EACE,sCAAA;ApDu7YF;;AoDl7YE;EACE,oCAAA;EACA,cAAA;ApDq7YJ;AoDn7YI;EACE,cAAA;ApDq7YN;AoDl7YI;EACE,aAAA;ApDo7YN;AoDj7YI;;;;;;;;;;;;;;;;;;;;;;;;;EA6BE,cAAA;ApD+6YN;AoD56YI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAqCE,cAAA;ApD86YN;AoD36YI;;;;EAIE,cAAA;ApD66YN;AoD16YI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmCE,yCAAA;ApDu6YN;AoDp6YI;EACE,mBAAA;ApDs6YN;AoDn6YI;EAQE,mBAAA;EACA,2BAAA;ApD85YN;AoD35YI;EACE,uCAAA;ApD65YN;AoD15YI;;;;EAIE,2BAAA;ApD45YN;AoDz5YI;;;;EAIE,yBAAA;ApD25YN;AoDx5YI;;EAEE,kCAAA;ApD05YN;AoDv5YI;;EAEE,qBAAA;EACA,cAAA;ApDy5YN;AoDt5YI;;EAEE,eAAA;ApDw5YN;AoDr5YI;EACE,cAAA;ApDu5YN;AoDp5YI;EACE,aAAA;ApDs5YN;AoDn5YI;;;EAGE,gBAAA;ApDq5YN;AoDl5YI;EACE,mBAAA;ApDo5YN;AoDj5YI;;EAOE,2BAAA;ApD84YN;AoD34YI;;EAEE,uBAAA;ApD64YN;AoD14YI;EACE,yBAAA;ApD44YN;AoDz4YI;EACE,yBAAA;ApD24YN;AoDx4YI;EAIE,+CAAA;ApDu4YN;AoDp4YI;;EAEE,qBAAA;EACA,cAAA;ApDs4YN;AoDp4YI;;EAEE,WAAA;ApDs4YN;;AoDj4YA;EACE,iDAAA;EACA,2BAAA;ApDo4YF;;AoDj4YA;EAKE,iDAAA;EACA,2BAAA;ApDg4YF;;AoD93YA;EAKE,iDAAA;EACA,2BAAA;ApD63YF;;AoD13YA;EAKE,iDAAA;EACA,2BAAA;ApDy3YF;;AoDt3YA;EACE,sCAAA;ApDy3YF;;AoDv3YA;EAKE,sCAAA;ApDs3YF;;AoDp3YA;EAKE,sCAAA;ApDm3YF;;AoDh3YA;EAKE,sCAAA;ApD+2YF;;AoD52YA;EACE,6EAAA;ApD+2YF;;AoD52YA;EACE,oCAAA;ApD+2YF;;AoD52YA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAoCE,mBAAA;ApD42YF;;AoDz2YA;EACE,8BAAA;ApD42YF;;AoDz2YA;EACE,8BAAA;ApD42YF;;AoDz2YA;;EAEE,mBAAA;ApD42YF;;AoDz2YA;EACE,iCAAA;ApD42YF;;AoDz2YA;;;;;;;;EAYE,mBAAA;ApDw2YF;;AoDr2YA;EACE,mBAAA;ApDw2YF;;AoDt2YA;EACE,uBAAA;EACA,uBAAA;ApDy2YF;;AoDv2YA;EACI,gBAAA;EACA,eAAA;EACA,SAAA;EAEA,gBAAA;ApDy2YJ;AoDx2YI;EACE,uCAAA;EACA,aAAA;EACA,mBAAA;ApD02YN;AoDx2YM;EACE,kBAAA;ApD02YR;;AoDr2YA;;EAEE,qBAAA;ApDw2YF;;AoDr2YA;EACE,iDAAA;ApDw2YF;;AoDr2YA;EACE,qBAAA;ApDw2YF;;AoDr2YA;;EAEE,yCAAA;ApDw2YF;;AoDr2YA;EACE,+BAAA;EACA,kCAAA;EACA,qCAAA;ApDw2YF;;AoDr2YA;;EAEE,yCAAA;EACA,cAAA;ApDw2YF;;AoDr2YA;;EAEE,oCAAA;EACA,WAAA;ApDw2YF;;AoDr2YA;;EAEE,oCAAA;ApDw2YF;;AoDr2YA;;;;;;;;;;;;;;;;;;;;;EAwCE,cAAA;ApDq1YF;;AoDl1YA;EACE,yBAAA;ApDq1YF;;AoDl1YA;;;;;;;;;;;;;;;;;;;;;EA8CE,cAAA;ApD4zYF;;AoDzzYA;EACE,yBAAA;ApD4zYF;;AoDzzYA;EACE,yBAAA;ApD4zYF;;AoDzzYA;EACE,cAAA;ApD4zYF;;AoDzzYA;EACE,wBAAA;ApD4zYF;;AoDzzYA;EACE,2BAAA;ApD4zYF;;AoDzzYA;EAME,YAAA;ApDuzYF;;AoDpzYA;;EAEE,2BAAA;ApDuzYF;;AoDpzYA;EACE,wBAAA;ApDuzYF;;AoDpzYA;EACE,aAAA;ApDuzYF;;AoDpzYA;EACE,cAAA;ApDuzYF;;AoDpzYA;;EAEE,yCAAA;EACA,cAAA;ApDuzYF;;AoDpzYA;;EAKE,yBAAA;ApDozYF","sourcesContent":["/**************************************\r\n    Default Styles\r\n***************************************/\r\n\r\n@import url('../css/bootstrap.min.css');\r\n@import url('../css/slick.css');\r\n@import url('../css/slicktheme.css');\r\n@import url('../css/animation.css');\r\n\r\n\r\n\r\n@import 'default/variables';\r\n@import 'default/mixins';\r\n@import 'default/reset';\r\n@import 'default/typography';\r\n@import 'default/extend';\r\n@import 'default/animations';\r\n@import 'default/shortcode';\r\n@import 'default/spacing';\r\n@import 'default/common';\r\n@import 'default/forms';\r\n\r\n\r\n\r\n@import 'color/themebg';\r\n\r\n\r\n@import 'header/header';\r\n@import 'header/nav';\r\n@import 'header/mobilemenu';\r\n@import 'header/headertop';\r\n\r\n\r\n\r\n@import 'elements/sctiontitle';\r\n@import 'elements/button';\r\n@import 'elements/breadcrumb';\r\n@import 'elements/accordion';\r\n@import 'elements/service';\r\n@import 'elements/card';\r\n@import 'elements/progressbar';\r\n@import 'elements/counter';\r\n@import 'elements/portfolio';\r\n@import 'elements/social';\r\n@import 'elements/team';\r\n@import 'elements/timeline';\r\n@import 'elements/testimonial';\r\n@import 'elements/slickslide';\r\n@import 'elements/tab';\r\n@import 'elements/pricing';\r\n@import 'elements/split';\r\n@import 'elements/callto-action';\r\n@import 'elements/video';\r\n@import 'elements/contact';\r\n@import 'elements/brand';\r\n@import 'elements/newsletter';\r\n@import 'elements/advance-tab';\r\n@import 'elements/advancepricing';\r\n@import 'elements/about';\r\n@import 'elements/swicher';\r\n@import 'elements/404';\r\n\r\n\r\n\r\n/**************************************\r\n    Blog Styles\r\n***************************************/\r\n\r\n@import 'blog/blog';\r\n@import 'blog/sidebar';\r\n@import 'blog/blog-details';\r\n\r\n\r\n\r\n/**************************************\r\n    Footer Styles\r\n***************************************/\r\n@import 'template/banner';\r\n@import 'template/portfoliodetails';\r\n@import 'template/splash';\r\n@import 'template/manpage';\r\n\r\n\r\n/**************************************\r\n    Footer Styles\r\n***************************************/\r\n\r\n@import 'footer/footer';\r\n@import 'footer/copyright';\r\n@import 'footer/darkmode';\r\n\r\n","/*-- Variables --*/\r\n:root {\r\n    //Themes colors\r\n    --color-primary: #345085;\r\n    --color-primary-rgba: rgb(52, 80, 133);\r\n    --color-primary-alt: #345085;\r\n    --color-primary-light: #345085;\r\n    --color-primary-lightest: #345085;\r\n    --color-secondary: #6E8ECB;\r\n    --color-tertiary: #343944;\r\n    --color-tertiary-alt: #343944;\r\n    --color-pink: #0d4083;\r\n    --color-light-green: #07c1fa;\r\n    --color-primary-darker: #011827;\r\n    --color-tertiary-darker: #150b40;\r\n    --color-secondary-darker: #190301;\r\n    --color-light-green-darker: #001f27;\r\n    --color-pink-darker: #2f011d;\r\n    \r\n    // Typo Color \r\n    --color-heading: #ffffff;\r\n    --color-body: #acacac;\r\n\r\n    --color-dark: #060606;\r\n    --color-darker: rgba(6, 6, 6, 0.7);\r\n    --color-darkest: rgba(0, 0, 0, 0.3);\r\n\r\n    --color-black: #000000;\r\n    --color-blacker: rgba(15, 15, 17, 0);\r\n    --color-blackest: #0f0f11;\r\n    --color-border: hsla(0, 0%, 100%, 0.1);\r\n\r\n\r\n    --color-lessdark: #1e1e1e;\r\n\r\n\r\n\r\n\r\n    // Gery Colors \r\n    --color-gray: #65676B;\r\n    // --color-midgray: #9F9F9F;\r\n    --color-midgray: #878787;\r\n    --color-light: #E4E6EA;\r\n    --color-lighter: #CED0D4;\r\n    --color-lightest: #F0F2F5;\r\n\r\n    --color-white: #ffffff;\r\n    \r\n\r\n\r\n    // Notify Colors \r\n    --color-success: #3EB75E;\r\n    --color-danger: #FF0003;\r\n    --color-warning: #FF8F3C;\r\n    --color-info: #1BA2DB;\r\n\r\n\r\n    //Social icon colors\r\n    --color-facebook: #3B5997;\r\n    --color-twitter: #1BA1F2;\r\n    --color-youtube: #ED4141;\r\n    --color-linkedin: #0077B5;\r\n    --color-pinterest: #E60022;\r\n    --color-instagram: #C231A1;\r\n    --color-vimeo: #00ADEF;\r\n    --color-twitch: #6441A3;\r\n    --color-discord: #7289da;\r\n\r\n\r\n    // Extra Color \r\n    --color-extra01: #666666;\r\n    --color-extra02: #606770;\r\n    --color-extra03: #FBFBFD;\r\n    --color-extra04: #1A1A1A;\r\n    --color-extra05: #242424;\r\n    \r\n    //Border-radius\r\n    --border-width: 2px;\r\n    --radius-small: 6px;\r\n    --radius: 10px;\r\n    --radius-big: 16px;\r\n\r\n   \r\n\r\n    //Font weight\r\n    //primary font\r\n    --p-light: 300;\r\n    --p-regular: 400;\r\n    --p-medium: 500;\r\n    --p-semi-bold: 600;\r\n    --p-bold: 700;\r\n    --p-extra-bold: 800;\r\n    --p-black: 900;\r\n\r\n\r\n    //Shadows\r\n    --shadow-primary: 0 0 20px 5px rgba(251,83,67, 0.20);\r\n    --shadow-light: 1px 1px 6px rgba(0, 0, 0, 0.25);\r\n    --shadow-lighter: 4px 4px 20px 20px rgba(0, 0, 0, 0.01);\r\n\r\n\r\n    //transition easing\r\n    --transition: 0.3s;\r\n    --transition-transform: transform .65s cubic-bezier(.23,1,.32,1);\r\n\r\n    //Font Family\r\n    --font-primary: 'Inter', sans-serif;\r\n    --secondary-font: 'Inter', sans-serif;\r\n    --font-awesome: 'Font Awesome 5 Pro';\r\n\r\n\r\n    \r\n    //Fonts Size\r\n    --font-size-b1: 18px;\r\n    --font-size-b2: 16px;\r\n    --font-size-b3: 14px;\r\n    --font-size-b4: 12px;\r\n\r\n    //Line Height\r\n    --line-height-b1: 1.67; //28px\r\n    --line-height-b2: 1.7; //24px\r\n    --line-height-b3: 1.6; //22px\r\n    --line-height-b4: 1.3; //16px\r\n\r\n    // Heading Font \r\n    --h1: 56px; //52px 1.29\r\n    --h2: 44px; //44px 1.23\r\n    --h3: 36px; // 34px 1.14\r\n    --h4: 24px; //30px  1.25\r\n    --h5: 18px; //22px 1.24\r\n    --h6: 16px; //20px 1.25\r\n}\r\n\r\n// Layouts Variation\r\n$smlg-device: 'only screen and (max-width: 1199px)';\r\n$extra-device: 'only screen and (min-width: 1600px) and (max-width: 1919px)';\r\n$laptop-device: 'only screen and (min-width: 1200px) and (max-width: 1599px)';\r\n$lg-layout: 'only screen and (min-width: 992px) and (max-width: 1199px)';\r\n$md-layout:'only screen and (min-width: 768px) and (max-width: 991px)';\r\n$sm-layout:'only screen and (max-width: 767px)';\r\n$large-mobile: 'only screen and (max-width: 575px)';\r\n$small-mobile: 'only screen and (max-width: 479px)';\r\n\r\n","/**\n * Reset Styels\n */\n \n\n * {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n}\n\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nnav,\nsection,\nsummary {\n    display: block;\n}\n\naudio,\ncanvas,\nvideo {\n    display: inline-block;\n}\n\naudio:not([controls]) {\n    display: none;\n    height: 0;\n}\n\n[hidden] {\n    display: none;\n}\n\n\na {\n    color: var(--color-heading);\n    text-decoration: none;\n    outline: none;\n}\n\n\na:hover,\na:focus,\na:active {\n\ttext-decoration: none;\n\toutline: none;\n\tcolor: var(--color-primary);\n}\n\na:focus {\n    outline: none;\n}\naddress {\n    margin: 0 0 24px;\n}\n\nabbr[title] {\n    border-bottom: 1px dotted;\n}\n\nb,\nstrong {\n    font-weight: bold;\n}\nmark {\n    background: var(--color-primary);\n    color: #ffffff;\n}\ncode,\nkbd,\npre,\nsamp {\n    font-size: var(--font-size-b3);\n    -webkit-hyphens: none;\n    -moz-hyphens: none;\n    -ms-hyphens: none;\n    hyphens: none;\n    color: var(--color-primary);\n}\nkbd ,\nins{\n    color: #ffffff;\n}\n\n\n\n\npre, \npre.wp-block-code {\n    font-family: \"Courier 10 Pitch\", Courier, monospace !important;\n    font-size: 15px !important;\n    margin: 40px 0 !important;\n    overflow: auto;\n    padding: 20px !important;\n    white-space: pre !important;\n    white-space: pre-wrap !important;\n    word-wrap: break-word !important;\n    color: var(--color-body) !important;\n    background: var(--color-light);\n    border-radius: 4px;\n}\n\n\nsmall {\n    font-size: smaller;\n}\n\nsub,\nsup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n}\nsup {\n    top: -0.5em;\n}\nsub {\n    bottom: -0.25em;\n}\n\ndl {\n    margin-top: 0;\n    margin-bottom: 10px;\n}\n\ndd {\n    margin: 0 15px 15px;\n}\ndt {\n    font-weight: bold;\n    color: var(--color-heading);\n}\n\nmenu,\nol,\nul {\n    margin: 16px 0;\n    padding: 0 0 0 40px;\n}\n\nnav ul,\nnav ol {\n    list-style: none;\n    list-style-image: none;\n}\nli>ul,\nli>ol {\n    margin: 0;\n}\n\nol {\n    ul {\n        margin-bottom: 0;\n    }\n}\n\nimg {\n    -ms-interpolation-mode: bicubic;\n    border: 0;\n    vertical-align: middle;\n    max-width: 100%;\n    height: auto;\n}\n@media (max-width: 600px) {\n  .logo-dark {\n    height: auto;\n    max-height: 29px !important;\n    max-width: none;\n  }\n  .logo-light {\n    height: auto;\n    max-height: 29px !important;\n    max-width: none;\n  }\n}\nsvg:not(:root) {\n    overflow: hidden;\n}\nfigure {\n    margin: 0;\n}\nform {\n    margin: 0;\n}\nfieldset {\n    border: 1px solid var(--color-border);\n    margin: 0 2px;\n    min-width: inherit;\n    padding: 0.35em 0.625em 0.75em;\n}\nlegend {\n    border: 0;\n    padding: 0;\n    white-space: normal;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n    font-size: 100%;\n    margin: 0;\n    max-width: 100%;\n    vertical-align: baseline;\n}\n\nbutton,\ninput {\n    line-height: normal;\n}\n\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n    -webkit-appearance: button;\n    -moz-appearance: button;\n    appearance: button;\n    cursor: pointer;\n}\n\nbutton[disabled],\ninput[disabled] {\n    cursor: default;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n    padding: 0;\n}\n\ninput[type=\"search\"] {\n    -webkit-appearance: textfield;\n    -moz-appearance: textfield;\n    appearance: textfield;\n    appearance: textfield;\n    padding-right: 2px;\n    width: 270px;\n}\n\ninput[type=\"search\"]::-webkit-search-decoration {\n    -webkit-appearance: none;\n    appearance: none;\n}\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n}\ntextarea {\n    overflow: auto;\n    vertical-align: top;\n}\ncaption,\nth,\ntd {\n    font-weight: normal;\n}\ntable thead th {\n    font-weight: 700;\n}\n\ntd,\n.wp-block-calendar tfoot td {\n    border: 1px solid var(--color-border);\n    padding: 7px 10px;\n}\ndel {\n    color: #333;\n}\n\nins {\n    background: rgba(56, 88, 246, 0.6);\n    text-decoration: none;\n    padding: 0 5px;\n}\nhr {\n    background-size: 4px 4px;\n    border: 0;\n    height: 1px;\n    margin: 0 0 24px;\n    opacity: 0.25;\n}\ntable a,\ntable a:link, \ntable a:visited {\n    text-decoration: underline;\n}\n\ndt {\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\ndd {\n    margin: 0 15px 15px;\n}\n\ncaption {\n    caption-side: top;\n}\n\nkbd {\n    background: var(--heading-color);\n}\n\ndfn,\ncite,\nem {\n    font-style: italic;\n}\n\n\n/* BlockQuote  */\nblockquote,\nq {\n    -webkit-hyphens: none;\n    -moz-hyphens: none;\n    -ms-hyphens: none;\n    hyphens: none;\n    quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n    content: \"\";\n    content: none;\n}\n\nblockquote {\n    font-size: var(--font-size-b1);\n    font-style: italic;\n    font-weight: var(--p-light);\n    margin: 24px 40px;\n}\n\nblockquote blockquote {\n    margin-right: 0;\n}\n\nblockquote cite,\nblockquote small {\n    font-size: var(--font-size-b3);\n    font-weight: normal;\n}\n\nblockquote strong,\nblockquote b {\n    font-weight: 700;\n}\n\n\n\n\n\n\n\n\n\n\n","/**\r\n * Typography\r\n */\r\n @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');\r\n \r\n* {\r\n\tbox-sizing: border-box;\r\n}\r\n\r\nhtml {\r\n\toverflow: hidden;\r\n\toverflow-y: auto;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tfont-size: 10px;\r\n}\r\n\r\nbody {\r\n\toverflow: hidden;\r\n\tfont-size: var(--font-size-b2);;\r\n\tline-height: var(--line-height-b2);\r\n\t-webkit-font-smoothing: antialiased;\r\n\t-moz-osx-font-smoothing: grayscale;\r\n\tfont-family: var(--font-primary);\r\n\tcolor: var(--color-body);\r\n\tfont-weight: var(--p-regular);\r\n\tbackground-color: var(--color-dark);\r\n\tmargin: 0;\r\n    padding: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6,\r\naddress,\r\np,\r\npre,\r\nblockquote,\r\nmenu,\r\nol,\r\nul,\r\ntable,\r\nhr {\r\n\tmargin: 0;\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6 {\r\n\tword-break: break-word;\r\n\tfont-family: var(--secondary-font);\r\n\tline-height: 1.4074;\r\n\tcolor: var(--color-heading);\r\n}\r\n\r\nh1,\r\n.h1 {\r\n\tfont-size: var(--h1);\r\n\tline-height: 1.19;\r\n}\r\n\r\nh2,\r\n.h2 {\r\n\tfont-size: var(--h2);\r\n\tline-height: 1.23;\r\n}\r\n\r\nh3,\r\n.h3 {\r\n\tfont-size: var(--h3);\r\n\tline-height: 1.4;\r\n}\r\n\r\nh4,\r\n.h4 {\r\n\tfont-size: var(--h4);\r\n\tline-height: 1.25;\r\n}\r\n\r\nh5,\r\n.h5 {\r\n\tfont-size: var(--h5);\r\n\tline-height: 1.24;\r\n}\r\n\r\nh6,\r\n.h6 {\r\n\tfont-size: var(--h6);\r\n\tline-height: 1.25;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6 {\r\n\ta {\r\n\t\tcolor: inherit;\r\n\t\ttransition: 0.5s;\r\n\t}\r\n}\r\n\r\na {\r\n\tcolor: var(--color-body);\r\n}\r\n@media #{$md-layout} {\r\n\th1,\r\n\t.h1 {\r\n\t\tfont-size: 38px;\r\n\t}\r\n\th2,\r\n\t.h2 {\r\n\t\tfont-size: 32px;\r\n\t}\r\n\r\n\th3,\r\n\t.h3 {\r\n\t\tfont-size: 28px;\r\n\t}\r\n\r\n\th4,\r\n\t.h4 {\r\n\t\tfont-size: 24px;\r\n\t}\r\n\r\n\th5,\r\n\t.h5 {\r\n\t\tfont-size: 18px;\r\n\t}\r\n}\r\n\r\n\r\n@media #{$sm-layout} {\r\n\th1,\r\n\t.h1 {\r\n\t\tfont-size: 34px;\r\n\t}\r\n\r\n\th2,\r\n\t.h2 {\r\n\t\tfont-size: 28px;\r\n\t}\r\n\r\n\th3,\r\n\t.h3 {\r\n\t\tfont-size: 24px;\r\n\t}\r\n\r\n\th4,\r\n\t.h4 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\r\n\th5,\r\n\t.h5 {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\r\n}\r\n\r\n\r\nh1,\r\n.h1,\r\nh2,\r\n.h2,\r\nh3,\r\n.h3 {\r\n\tfont-weight: var(--p-bold);\r\n}\r\n\r\nh4,\r\n.h4,\r\nh5,\r\n.h5 {\r\n\tfont-weight: var(--p-bold);\r\n}\r\n\r\nh6,\r\n.h6 {\r\n\tfont-weight: var(--p-medium);\r\n}\r\n\r\np {\r\n\tfont-size: var(--font-size-b2);;\r\n\tline-height: var(--line-height-b2);\r\n\tfont-weight: var(--p-regular);\r\n\tcolor: var(--color-body);\r\n\tmargin: 0 0 30px;\r\n\r\n\t@media #{$sm-layout} {\r\n\t\tmargin: 0 0 20px;\r\n\t\tfont-size: var(--font-size-b2);\r\n\t\tline-height: var(--line-height-b2);\r\n\t}\r\n\r\n\t&.has-large-font-size {\r\n\t\tline-height: 1.5;\r\n\t\tfont-size: 36px;\r\n\t}\r\n\r\n\t&.has-medium-font-size {\r\n\t\tfont-size: 24px;\r\n\t\tline-height: 36px;\r\n\t}\r\n\r\n\t&.has-small-font-size {\r\n\t\tfont-size: 13px;\r\n\t}\r\n\r\n\t&.has-very-light-gray-color {\r\n\t\tcolor: var(--color-white);\r\n\t}\r\n\r\n\t&.has-background {\r\n\t\tpadding: 20px 30px;\r\n\t}\r\n\r\n\t&.b1 {\r\n\t\tfont-size: var(--font-size-b1);\r\n\t\tline-height: var(--line-height-b1);\r\n\t}\r\n\r\n\t&.b2 {\r\n\t\tfont-size: var(--font-size-b2);\r\n\t\tline-height: var(--line-height-b2);\r\n\t}\r\n\r\n\t&.b3 {\r\n\t\tfont-size: var(--font-size-b3);\r\n\t\tline-height: var(--line-height-b3);\r\n\t}\r\n\r\n\t&.b4 {\r\n\t\tfont-size: var(--font-size-b4);\r\n\t\tline-height: var(--line-height-b4);\r\n\t}\r\n\r\n\t\r\n}\r\n\r\n.b1 {\r\n\tfont-size: var(--font-size-b1);\r\n\tline-height: var(--line-height-b1);\r\n}\r\n\r\n.b2 {\r\n\tfont-size: var(--font-size-b2);\r\n\tline-height: var(--line-height-b2);\r\n}\r\n\r\n.b3 {\r\n\tfont-size: var(--font-size-b3);\r\n\tline-height: var(--line-height-b3);\r\n}\r\n\r\n.b4 {\r\n\tfont-size: var(--font-size-b4);\r\n\tline-height: var(--line-height-b4);\r\n}\r\n\r\n\r\ntable {\r\n\tborder-collapse: collapse;\r\n\tborder-spacing: 0;\r\n\tmargin: 0 0 40px;\r\n\twidth: 100%;\r\n}\r\n\r\ntable a,\r\ntable a:link,\r\ntable a:visited {\r\n\ttext-decoration: none;\r\n}\r\n\r\ncite,\r\n.wp-block-pullquote cite,\r\n.wp-block-pullquote.is-style-solid-color blockquote cite,\r\n.wp-block-quote cite {\r\n\tcolor: var(--color-heading);\r\n}\r\n\r\n\r\nvar {\r\n\tfont-family: \"Courier 10 Pitch\", Courier, monospace;\r\n}\r\n\r\n/*---------------------------\r\n\tList Style \r\n---------------------------*/\r\nul,\r\nol {\r\n\tpadding-left: 18px;\r\n}\r\n\r\nul {\r\n\tlist-style: square;\r\n\tmargin-bottom: 30px;\r\n\tpadding-left: 20px;\r\n\r\n\t&.liststyle {\r\n\t\t&.bullet {\r\n\t\t\tli {\r\n\t\t\t\tfont-size: 18px;\r\n\t\t\t\tline-height: 30px;\r\n\t\t\t\tcolor: var(--color-body);\r\n\t\t\t\tposition: relative;\r\n\t\t\t\tpadding-left: 30px;\r\n\r\n\t\t\t\t@media #{$sm-layout} {\r\n\t\t\t\t\tpadding-left: 19px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&::before {\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\tcontent: \"\";\r\n\t\t\t\t\twidth: 6px;\r\n\t\t\t\t\theight: 6px;\r\n\t\t\t\t\tborder-radius: 100%;\r\n\t\t\t\t\tbackground: var(--color-body);\r\n\t\t\t\t\tleft: 0;\r\n\t\t\t\t\ttop: 10px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&+li {\r\n\t\t\t\t\tmargin-top: 8px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\tli {\r\n\t\tfont-size: var(--font-size-b1);\r\n\t\tline-height: var(--line-height-b1);\r\n\t\tmargin-top: 10px;\r\n\t\tmargin-bottom: 10px;\r\n\t\tcolor: var(--color-body);\r\n\t\tfont-weight: 400;\r\n\r\n\t\ta {\r\n\t\t\ttext-decoration: none;\r\n\t\t\tcolor: var(--color-body);\r\n\t\t\t@extend %transition;\r\n\r\n\t\t\t&:hover {\r\n\t\t\t\tcolor: var(--color-primary);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\tul {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n}\r\n\r\nol {\r\n\tmargin-bottom: 30px;\r\n\tli {\r\n\t\tfont-size: var(--font-size-b1);\r\n\t\tline-height: var(--line-height-b1);\r\n\t\tcolor: var(--color-gray);\r\n\t\tmargin-top: 10px;\r\n\t\tmargin-bottom: 10px;\r\n\t\tfont-weight: 400;\r\n\t\ta {\r\n\t\t\tcolor: var(--heading-color);\r\n\t\t\t@extend %transition;\r\n\t\t\ttext-decoration: none;\r\n\t\t\t&:hover {\r\n\t\t\t\tcolor: var(--color-primary);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\tul {\r\n\t\tpadding-left: 30px;\r\n\t}\r\n}\r\nhr {\r\n    display: block;\r\n    height: 0;\r\n    margin: 15px 0 15px;\r\n    border-top: 1px solid var(--color-border);\r\n}\r\nkbd {\r\n    background: var(--color-primary);\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n","/*=====================\r\nAll Extend Here\r\n=======================*/\r\n%color-primary {\r\n    color: var(--color-primary) !important;\r\n}\r\n\r\n%color-primary-light {\r\n    color: var(--color-primary-light) !important;\r\n}\r\n\r\n%color-primary-alt {\r\n    color: var(--color-primary-alt) !important;\r\n}\r\n\r\n%color-secondary {\r\n    color: var(--color-secondary) !important;\r\n}\r\n%color-tertiary {\r\n    color: var(--color-tertiary) !important;\r\n}\r\n%color-tertiary-alt {\r\n    color: var(--color-tertiary-alt) !important;\r\n}\r\n%color-light-green {\r\n    color: var(--color-light-green) !important;\r\n}\r\n%color-pink {\r\n    color: var(--color-pink) !important;\r\n}\r\n%color-primary-darker {\r\n    color: var(--color-primary-darker) !important;\r\n}\r\n%color-secondary-darker {\r\n    color: var(--color-secondary-darker) !important;\r\n}\r\n%color-light-green-darker {\r\n    color: var(--color-light-green-darker) !important;\r\n}\r\n%color-pink-darker {\r\n    color: var(--color-pink-darker) !important;\r\n}\r\n%color-heading {\r\n    color: var(--color-heading) !important;\r\n}\r\n%color-body {\r\n    color: var(--color-body) !important;\r\n}\r\n%color-dark {\r\n    color: var(--color-dark) !important;\r\n}\r\n%color-darker {\r\n    color: var(--color-darker) !important;\r\n}\r\n%color-darkest {\r\n    color: var(--color-darkest) !important;\r\n}\r\n%color-black {\r\n    color: var(--color-black) !important;\r\n}\r\n%color-blacker {\r\n    color: var(--color-blacker) !important;\r\n}\r\n%color-blackest {\r\n    color: var(--color-blackest) !important;\r\n}\r\n%color-border {\r\n    color: var(--color-border) !important;\r\n}\r\n%color-gray {\r\n    color: var(--color-gray) !important;\r\n}\r\n%color-midgray {\r\n    color: var(--color-midgray) !important;\r\n}\r\n%color-light {\r\n    color: var(--color-light) !important;\r\n}\r\n\r\n%color-lighter {\r\n    color: var(--color-lighter) !important;\r\n}\r\n%color-lightest {\r\n    color: var(--color-lightest) !important;\r\n}\r\n%color-white {\r\n    color: var(--color-white) !important;\r\n}\r\n\r\n\r\n\r\n//===== BG Ncc Colors =====//\r\n\r\n%bg-primary-color {\r\n    background: var(--color-primary);\r\n}\r\n\r\n%bg-secondary-color {\r\n    background: var(--color-secondary)\r\n}\r\n\r\n%bg-tertiary-color {\r\n    background-color: var(--color-tertiary)\r\n}\r\n\r\n%bg-color-primary {\r\n    background-color: var(--color-primary) !important;\r\n}\r\n\r\n%bg-color-primary-light {\r\n    background-color: var(--color-primary-light) !important;\r\n}\r\n\r\n%bg-color-primary-alt {\r\n    background-color: var(--color-primary-alt) !important;\r\n}\r\n\r\n%bg-color-secondary {\r\n    background-color: var(--color-secondary) !important;\r\n}\r\n%bg-color-tertiary {\r\n    background-color: var(--color-tertiary) !important;\r\n}\r\n%bg-color-tertiary-alt {\r\n    background-color: var(--color-tertiary-alt) !important;\r\n}\r\n%bg-color-light-green {\r\n    background-color: var(--color-light-green) !important;\r\n}\r\n%bg-color-pink {\r\n    background-color: var(--color-pink) !important;\r\n}\r\n%bg-color-primary-darker {\r\n    background-color: var(--color-primary-darker) !important;\r\n}\r\n%bg-color-secondary-darker {\r\n    background-color: var(--color-secondary-darker) !important;\r\n}\r\n%bg-color-light-green-darker {\r\n    background-color: var(--color-light-green-darker) !important;\r\n}\r\n%bg-color-pink-darker {\r\n    background-color: var(--color-pink-darker) !important;\r\n}\r\n%bg-color-heading {\r\n    background-color: var(--color-heading) !important;\r\n}\r\n%bg-color-body {\r\n    background-color: var(--color-body) !important;\r\n}\r\n%bg-color-dark {\r\n    background-color: var(--color-dark) !important;\r\n}\r\n%bg-color-darker {\r\n    background-color: var(--color-darker) !important;\r\n}\r\n%bg-color-darkest {\r\n    background-color: var(--color-darkest) !important;\r\n}\r\n%bg-color-black {\r\n    background-color: var(--color-black) !important;\r\n}\r\n%bg-color-blacker {\r\n    background-color: var(--color-blacker) !important;\r\n}\r\n%bg-color-blackest {\r\n    background-color: var(--color-blackest) !important;\r\n}\r\n%bg-color-border {\r\n    background-color: var(--color-border) !important;\r\n}\r\n%bg-color-gray {\r\n    background-color: var(--color-gray) !important;\r\n}\r\n%bg-color-midgray {\r\n    background-color: var(--color-midgray) !important;\r\n}\r\n%bg-color-light {\r\n    background-color: var(--color-light) !important;\r\n}\r\n%bg-color-lighter {\r\n    background-color: var(--color-lighter) !important;\r\n}\r\n%bg-color-lightest {\r\n    background-color: var(--color-lightest) !important;\r\n}\r\n%bg-color-white {\r\n    background-color: var(--color-white) !important;\r\n}\r\n\r\n\r\n\r\n/* Radius */\r\n%radius-small {\r\n    border-radius: var(--radius-small);\r\n}\r\n\r\n%radius {\r\n    border-radius: var(--radius);\r\n}\r\n\r\n%radius-big {\r\n    border-radius: var(--radius-big);\r\n}\r\n\r\n/* Font Weight */\r\n\r\n%w-300 {\r\n    font-weight: 300 !important;\r\n}\r\n%w-400 {\r\n    font-weight: 400 !important;\r\n}\r\n%w-500 {\r\n    font-weight: 500 !important;\r\n}\r\n%w-600 {\r\n    font-weight: 600 !important;\r\n}\r\n%w-700 {\r\n    font-weight: 700 !important;\r\n}\r\n%w-800 {\r\n    font-weight: 800 !important;\r\n}\r\n%w-900 {\r\n    font-weight: 900 !important;\r\n}\r\n\r\n/* Shadows */\r\n\r\n%shadow-primary {\r\n    box-shadow: var(--shadow-primary);\r\n}\r\n%shadow-light {\r\n    box-shadow: var(--shadow-light);\r\n}\r\n%shadow-lighter {\r\n    box-shadow: var(--shadow-lighter);\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n// Others \r\n\r\n%box-shadow {\r\n    box-shadow: var(--shadow-primary);\r\n}\r\n\r\n\r\n\r\n\r\n/*=============== Style Css =============*/\r\n\r\n%liststyle {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n}\r\n\r\n%transition {\r\n    transition: var(--transition);\r\n}\r\n\r\n%bgImagePosition {\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    background-position: center center;\r\n}\r\n\r\n.bgImagePosition {\r\n    @extend %bgImagePosition;\r\n}","/*----------------------\r\n    Animation Css  \r\n-----------------------*/\r\n.post-scale {\r\n    overflow: hidden;\r\n    @extend %radius;\r\n    img {\r\n        transition: 0.5s;\r\n    }\r\n    &:hover {\r\n        img {\r\n            transform: scale(1.1);\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@keyframes customOne {\r\n    from {\r\n        transform: scale(1);\r\n    }\r\n\r\n    50% {\r\n        transform: scale(0.90);\r\n    }\r\n\r\n    to {\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n@keyframes customTwo {\r\n    0% {\r\n        transform: (translate(0.0px, 0.0px));\r\n    }\r\n\r\n    50% {\r\n        transform: (translate(100.0px, 0.0px));\r\n    }\r\n\r\n    100% {\r\n        transform: (translate(50.0px, 50.0px));\r\n    }\r\n}\r\n\r\n.customOne {\r\n    animation: customOne 2s infinite;\r\n}\r\n\r\n\r\n\r\n\r\n/* ------------------------\r\n    Custom Animation 01 \r\n----------------------------*/\r\n\r\n@-webkit-keyframes headerSlideDown {\r\n    0% {\r\n        margin-top: -100px\r\n    }\r\n\r\n    to {\r\n        margin-top: 0\r\n    }\r\n}\r\n\r\n@keyframes headerSlideDown {\r\n    0% {\r\n        margin-top: -100px\r\n    }\r\n\r\n    to {\r\n        margin-top: 0\r\n    }\r\n}\r\n\r\n\r\n/*------------------------\r\n\tslidefadeinup\r\n--------------------------*/\r\n\r\n@-webkit-keyframes slideFadeInUp {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 20%, 0);\r\n        transform: translate3d(0, 20%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: none;\r\n        transform: none;\r\n    }\r\n}\r\n\r\n@keyframes slideFadeInUp {\r\n    from {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(0, 20%, 0);\r\n        transform: translate3d(0, 20%, 0);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: none;\r\n        transform: none;\r\n    }\r\n}\r\n\r\n.slideFadeInUp {\r\n    -webkit-animation-name: slideFadeInUp;\r\n    animation-name: slideFadeInUp;\r\n}\r\n\r\n/* -----------------------------------\r\n    Custom Animation For All Page\r\n---------------------------------------*/\r\n\r\n@-webkit-keyframes moveVertical {\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translateY(0)\r\n    }\r\n}\r\n\r\n@keyframes moveVertical {\r\n    to {\r\n        opacity: 1;\r\n        -webkit-transform: translateY(0);\r\n        transform: translateY(0)\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/*--------------------------------\r\nScroll Down Button Animation  \r\n----------------------------------*/\r\n@keyframes scrollDown {\r\n    0% {\r\n        opacity: 0;\r\n    }\r\n\r\n    10% {\r\n        transform: translateY(0);\r\n        opacity: 1;\r\n    }\r\n\r\n    100% {\r\n        transform: translateY(10px);\r\n        opacity: 0;\r\n    }\r\n}\r\n","/*==============================\r\n *  Utilities\r\n=================================*/\r\n\r\n/* \r\nfont-family: 'Inter', sans-serif;\r\n*/\r\n\r\n\r\n.row {\r\n    margin-right: -15px;\r\n    margin-left: -15px;\r\n}\r\n\r\n.row > [class*=\"col\"] {\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n    .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\r\n        max-width: 1320px;\r\n    }\r\n}\r\n\r\n.clearfix:before,\r\n.clearfix:after {\r\n    content: \" \";\r\n    display: table;\r\n}\r\n.clearfix:after {\r\n    clear: both;\r\n}\r\n.fix {\r\n    overflow: hidden;\r\n}\r\n\r\n.slick-initialized .slick-slide {\r\n    margin-bottom: -10px;\r\n}\r\n\r\n\r\n/*===============================\r\n    Background Color \r\n=================================*/\r\n\r\n@include config-bg-colors('bg-color-',\r\n    'primary'var(--color-primary),\r\n    'secondary'var(--color-secondary),\r\n    'tertiary'var(--color-tertiary),\r\n    'grey'#F0F2F5,\r\n    'white'#FFFFFF,\r\n    'black'#1A1A1A,\r\n    'extra03'var(--color-extra03),\r\n    'lessdark'var(--color-lessdark),\r\n    'color-primary'var(--color-primary)\r\n\r\n);\r\n\r\n.bg-color-2 {\r\n    backdrop-filter: saturate(180%) blur(8px);\r\n    background-color: var(--color-darker);\r\n    background-image: linear-gradient(180deg, var(--color-black), transparent);\r\n}\r\n\r\n/*===========================\r\n    Background Image \r\n=============================*/\r\n\r\n.bg_image {\r\n    @extend %bgImagePosition;\r\n}\r\n.bg_image_fixed {\r\n    background-attachment: fixed !important;\r\n}\r\n/* Height and width */\r\n.fullscreen {\r\n    min-height: 100vh;\r\n    width: 100%;\r\n}\r\n\r\n\r\n/*===================\r\nCustom Row\r\n======================*/\r\n.row--0 {\r\n    margin-left: -0px;\r\n    margin-right: -0px;\r\n\r\n    &>[class*=\"col\"] {\r\n        padding-left: 0px;\r\n        padding-right: 0px;\r\n    }\r\n}\r\n\r\n.row--5 {\r\n    margin-left: -5px;\r\n    margin-right: -5px;\r\n\r\n    &>[class*=\"col\"] {\r\n        padding-left: 5px;\r\n        padding-right: 5px;\r\n    }\r\n}\r\n\r\n.row--10 {\r\n    margin-left: -10px;\r\n    margin-right: -10px;\r\n\r\n    &>[class*=\"col\"] {\r\n        padding-left: 10px;\r\n        padding-right: 10px;\r\n    }\r\n}\r\n\r\n.row--15 {\r\n    margin-left: -15px;\r\n    margin-right: -15px;\r\n\r\n    &>[class*=\"col\"] {\r\n        padding-left: 15px;\r\n        padding-right: 15px;\r\n    }\r\n}\r\n\r\n.row--20 {\r\n    margin-left: -20px;\r\n    margin-right: -20px;\r\n\r\n    // Responsive\r\n    @media #{$laptop-device} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$lg-layout} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$md-layout} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        margin-left: -15px !important;\r\n        margin-right: -15px !important;\r\n    }\r\n\r\n    &>[class*=\"col\"],\r\n    &>[class*=\"col-\"] {\r\n        padding-left: 20px;\r\n        padding-right: 20px;\r\n\r\n        // Responsive\r\n        @media #{$laptop-device} {\r\n            padding-left: 15px;\r\n            padding-right: 15px;\r\n        }\r\n\r\n        @media #{$lg-layout} {\r\n            padding-left: 15px;\r\n            padding-right: 15px;\r\n        }\r\n\r\n        @media #{$md-layout} {\r\n            padding-left: 15px !important;\r\n            padding-right: 15px !important;\r\n        }\r\n\r\n        @media #{$sm-layout} {\r\n            padding-left: 15px !important;\r\n            padding-right: 15px !important;\r\n        }\r\n    }\r\n}\r\n\r\n.row--25 {\r\n    margin-left: -25px;\r\n    margin-right: -25px;\r\n\r\n    // Responsive\r\n    @media #{$laptop-device} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$lg-layout} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$md-layout} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        margin-left: -15px !important;\r\n        margin-right: -15px !important;\r\n    }\r\n\r\n    &>[class*=\"col\"],\r\n    &>[class*=\"col-\"] {\r\n        padding-left: 25px;\r\n        padding-right: 25px;\r\n\r\n        // Responsive\r\n        @media #{$laptop-device} {\r\n            padding-left: 15px;\r\n            padding-right: 15px;\r\n        }\r\n\r\n        @media #{$lg-layout} {\r\n            padding-left: 15px;\r\n            padding-right: 15px;\r\n        }\r\n\r\n        @media #{$md-layout} {\r\n            padding-left: 15px !important;\r\n            padding-right: 15px !important;\r\n        }\r\n\r\n        @media #{$sm-layout} {\r\n            padding-left: 15px !important;\r\n            padding-right: 15px !important;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.row--30 {\r\n    margin-left: -30px;\r\n    margin-right: -30px;\r\n\r\n    // Responsive\r\n    @media #{$laptop-device} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$lg-layout} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$md-layout} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        margin-left: -15px !important;\r\n        margin-right: -15px !important;\r\n    }\r\n\r\n    &>[class*=\"col\"],\r\n    &>[class*=\"col-\"] {\r\n        padding-left: 30px;\r\n        padding-right: 30px;\r\n\r\n        // Responsive\r\n        @media #{$laptop-device} {\r\n            padding-left: 15px;\r\n            padding-right: 15px;\r\n        }\r\n\r\n        @media #{$lg-layout} {\r\n            padding-left: 15px;\r\n            padding-right: 15px;\r\n        }\r\n\r\n        @media #{$md-layout} {\r\n            padding-left: 15px !important;\r\n            padding-right: 15px !important;\r\n        }\r\n\r\n        @media #{$sm-layout} {\r\n            padding-left: 15px !important;\r\n            padding-right: 15px !important;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.row--45 {\r\n    margin-left: -45px;\r\n    margin-right: -45px;\r\n\r\n    // Responsive\r\n    @media #{$laptop-device} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$lg-layout} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$md-layout} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        margin-left: -15px !important;\r\n        margin-right: -15px !important;\r\n    }\r\n\r\n    &>[class*=\"col\"],\r\n    &>[class*=\"col-\"] {\r\n        padding-left: 45px;\r\n        padding-right: 45px;\r\n\r\n        // Responsive\r\n        @media #{$laptop-device} {\r\n            padding-left: 15px;\r\n            padding-right: 15px;\r\n        }\r\n\r\n        @media #{$lg-layout} {\r\n            padding-left: 15px;\r\n            padding-right: 15px;\r\n        }\r\n\r\n        @media #{$md-layout} {\r\n            padding-left: 15px !important;\r\n            padding-right: 15px !important;\r\n        }\r\n        @media #{$sm-layout} {\r\n            padding-left: 15px !important;\r\n            padding-right: 15px !important;\r\n        }\r\n    }\r\n}\r\n\r\n.row--40 {\r\n    margin-left: -40px;\r\n    margin-right: -40px;\r\n\r\n    // Responsive\r\n    @media #{$laptop-device} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$lg-layout} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$md-layout} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        margin-left: -15px !important;\r\n        margin-right: -15px !important;\r\n    }\r\n\r\n    &>[class*=\"col\"],\r\n    &>[class*=\"col-\"] {\r\n        padding-left: 40px;\r\n        padding-right: 40px;\r\n\r\n        // Responsive\r\n        @media #{$laptop-device} {\r\n            padding-left: 15px;\r\n            padding-right: 15px;\r\n        }\r\n\r\n        @media #{$lg-layout} {\r\n            padding-left: 15px;\r\n            padding-right: 15px;\r\n        }\r\n\r\n        @media #{$md-layout} {\r\n            padding-left: 15px !important;\r\n            padding-right: 15px !important;\r\n        }\r\n        @media #{$sm-layout} {\r\n            padding-left: 15px !important;\r\n            padding-right: 15px !important;\r\n        }\r\n    }\r\n}\r\n\r\n.row--60 {\r\n    margin-left: -60px;\r\n    margin-right: -60px;\r\n    // Responsive\r\n    @media #{$laptop-device} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$lg-layout} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$md-layout} {\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        margin-left: -15px !important;\r\n        margin-right: -15px !important;\r\n    }\r\n\r\n    &>[class*=\"col\"],\r\n    &>[class*=\"col-\"] {\r\n        padding-left: 60px;\r\n        padding-right: 60px;\r\n\r\n        // Responsive\r\n        @media #{$laptop-device} {\r\n            padding-left: 15px;\r\n            padding-right: 15px;\r\n        }\r\n\r\n        @media #{$lg-layout} {\r\n            padding-left: 15px;\r\n            padding-right: 15px;\r\n        }\r\n\r\n        @media #{$md-layout} {\r\n            padding-left: 15px !important;\r\n            padding-right: 15px !important;\r\n        }\r\n\r\n        @media #{$sm-layout} {\r\n            padding-left: 15px !important;\r\n            padding-right: 15px !important;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/*===========================\r\n    Input Placeholder\r\n=============================*/\r\ninput:-moz-placeholder,\r\ntextarea:-moz-placeholder {\r\n    opacity: 1;\r\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\r\n}\r\n\r\ninput::-webkit-input-placeholder,\r\ntextarea::-webkit-input-placeholder {\r\n    opacity: 1;\r\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\r\n}\r\n\r\ninput::-moz-placeholder,\r\ntextarea::-moz-placeholder {\r\n    opacity: 1;\r\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\r\n}\r\n\r\ninput:-ms-input-placeholder,\r\ntextarea:-ms-input-placeholder {\r\n    opacity: 1;\r\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\r\n}\r\n\r\n/*=============================\r\n\tOverlay styles \r\n==============================*/\r\n\r\n[data-overlay],\r\n[data-black-overlay],\r\n[data-white-overlay] {\r\n    position: relative;\r\n}\r\n\r\n[data-overlay]>div,\r\n[data-overlay]>*,\r\n[data-black-overlay]>div,\r\n[data-black-overlay]>*,\r\n[data-white-overlay]>div,\r\n[data-white-overlay]>* {\r\n    position: relative;\r\n    z-index: 2;\r\n}\r\n\r\n[data-overlay]:before,\r\n[data-black-overlay]:before,\r\n[data-white-overlay]:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 2;\r\n}\r\n\r\n[data-overlay]:before {\r\n    @extend %bg-primary-color;\r\n}\r\n\r\n[data-black-overlay]:before {\r\n    background-color: #000000;\r\n}\r\n\r\n[data-white-overlay]:before {\r\n    background-color: #ffffff;\r\n}\r\n\r\n@for $i from 1 through 10 {\r\n    [data-overlay=\"#{$i}\"]:before,\r\n    [data-black-overlay=\"#{$i}\"]:before,\r\n    [data-white-overlay=\"#{$i}\"]:before {\r\n        opacity: #{$i * 0.10};\r\n    }\r\n}\r\n\r\n/*------------------------------\r\n    Scroll Up \r\n--------------------------------*/\r\n\r\n#scrollUp {\r\n    width: 70px;\r\n    height: 80px;\r\n    right: 100px;\r\n    bottom: 60px;\r\n    text-align: center;\r\n    z-index: 9811 !important;\r\n    text-decoration: none;\r\n    background: #fff;\r\n    line-height: 80px;\r\n    color: #757589;\r\n    font-size: 15px;\r\n    font-weight: 400;\r\n    @extend %transition;\r\n    display: inline-block;\r\n    background: #ffffff;\r\n    @media #{$md-layout} {\r\n        right: 20px;\r\n        bottom: 40px;\r\n    }\r\n    @media #{$sm-layout} {\r\n        right: 20px;\r\n        bottom: 40px;\r\n    }\r\n    &::before {\r\n        width: 100%;\r\n        height: 100%;\r\n        left: 0;\r\n        bottom: 0;\r\n        background: rgba(0, 2, 72, 0.1);\r\n        content: \"\";\r\n        position: absolute;\r\n        z-index: -1;\r\n        transform-style: preserve-3d;\r\n        transform: rotateY(-10deg);\r\n        filter: blur(50px);\r\n    }\r\n    &::after {\r\n        background: #ffffff;\r\n        position: absolute;\r\n        content: \"\";\r\n        top: 0;\r\n        bottom: 0;\r\n        left: 0;\r\n        right: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        z-index: -1;\r\n        transform-style: preserve-3d;\r\n        transform: rotateY(-10deg);\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        right: 20px;\r\n        bottom: 30px;\r\n        width: 50px;\r\n        height: 60px;\r\n        line-height: 60px;\r\n    }\r\n    \r\n    span {\r\n        &.text {\r\n            position: relative;\r\n            display: inline-block;\r\n            margin-top: 7px;\r\n            @media #{$sm-layout} {\r\n                margin-top: 3px;\r\n            }\r\n            &::after {\r\n                width: 0;\r\n                height: 0;\r\n                border-style: solid;\r\n                border-width: 0 5px 7px 5px;\r\n                border-color: transparent transparent var(--color-primary) transparent;\r\n                position: absolute;\r\n                content: \"\";\r\n                left: 50%;\r\n                top: 21%;\r\n                transform: translateX(-50%);\r\n            }\r\n        }\r\n    }\r\n    &:hover {\r\n        span {\r\n            &.text {\r\n                color: var(--color-primary);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n/*--------------------\r\n    Contact Form \r\n----------------------*/\r\n.form-message {\r\n    margin-bottom: 0;\r\n    text-align: center;\r\n    &.error {\r\n        margin-top: 20px;\r\n        color: #f80707;\r\n    }\r\n    &.success {\r\n        margin-top: 20px;\r\n        color: #0d8d2d;\r\n    }\r\n}\r\n\r\n","@mixin clearfix() {\r\n\t&::after {\r\n\t\tcontent: \"\";\r\n\t\tclear: both;\r\n\t\tdisplay: table;\r\n\t}\r\n}\r\n\r\n@mixin config-bg-colors($prefix, $bg-color-...) {\r\n\t@each $i in $bg-color- {\r\n\t\t.#{$prefix}#{nth($i, 1)} {\r\n\t\t\tbackground: nth($i, 2);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@mixin placeholder {\r\n    &::-webkit-input-placeholder {\r\n        @content;\r\n    }\r\n    &:-moz-placeholder {\r\n        @content;\r\n    }\r\n    &::-moz-placeholder { \r\n        @content;\r\n    }\r\n    &:-ms-input-placeholder {\r\n        @content;\r\n    }\r\n}\r\n","/*=========================\r\n    Section Separation \r\n==========================*/\r\n\r\n.slick-dotted.slick-slider {\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n.mt_dec--30 {\r\n    margin-top: -30px;\r\n}\r\n\r\n.mt_dec--20 {\r\n    margin-top: -20px;\r\n}\r\n.ptb--120-mine{\r\n    padding: 60px 0 !important;\r\n}\r\n.rn-section-gap {\r\n    padding:120px 0 !important;\r\n    @media #{$md-layout} {\r\n        padding: 80px 0 !important;\r\n    }\r\n    @media #{$sm-layout} {\r\n        padding: 60px 0 !important;\r\n    }\r\n}\r\n.rn-section-gap-inside {\r\n    padding:20px 0 !important;\r\n    @media #{$md-layout} {\r\n        padding: 80px 0 !important;\r\n    }\r\n    @media #{$sm-layout} {\r\n        padding: 60px 0 !important;\r\n    }\r\n}\r\n.rn-section-gapBottom {\r\n    padding-bottom: 120px !important;\r\n    @media #{$md-layout} {\r\n        padding-bottom: 80px !important; \r\n    }\r\n    @media #{$sm-layout} {\r\n        padding-bottom: 60px  !important;\r\n    }\r\n}\r\n\r\n.pb--165,\r\n.pb--85 {\r\n    @media #{$md-layout} {\r\n        padding-bottom: 80px !important; \r\n    }\r\n    @media #{$sm-layout} {\r\n        padding-bottom: 60px  !important;\r\n    }\r\n}\r\n\r\n.rn-section-gapTop {\r\n    padding-top: 120px !important;\r\n    @media #{$md-layout} {\r\n        padding-top: 80px !important; \r\n    }\r\n    @media #{$sm-layout} {\r\n        padding-top: 60px  !important;\r\n    }\r\n}\r\n\r\n\r\n\r\n.ptb--120 {\r\n    @media #{$md-layout} {\r\n        padding: 80px 0 !important;\r\n    }\r\n    @media #{$sm-layout} {\r\n        padding: 60px 0 !important;\r\n    }\r\n}\r\n\r\n.pb--165 ,\r\n.pb--120 ,\r\n.pb--85 ,\r\n.pb--165 {\r\n    @media #{$md-layout} {\r\n        padding-bottom: 80px !important;\r\n    }\r\n    @media #{$sm-layout} {\r\n        padding-bottom: 60px !important;\r\n    }\r\n}\r\n\r\n.pb--70 {\r\n    @media #{$sm-layout} {\r\n        padding-bottom: 60px !important;\r\n    }\r\n}\r\n\r\n.pl--0 {\r\n    padding-left: 0 !important;\r\n}\r\n.pr--0 {\r\n    padding-right: 0 !important;\r\n}\r\n.pt--0 {\r\n    padding-top: 0 !important;\r\n}\r\n.pb--0 {\r\n    padding-bottom: 0 !important;\r\n}\r\n.mr--0 {\r\n    margin-right: 0 !important;\r\n}\r\n.ml--0 {\r\n    margin-left: 0 !important;\r\n}\r\n.mt--0 {\r\n    margin-top: 0 !important;\r\n}\r\n.mb--0 {\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n.pt--260{\r\n    padding-top: 260px !important;\r\n}\r\n\r\n.pt--250 {\r\n    padding-top: 250px !important;\r\n}\r\n\r\n.pb--240 {\r\n    padding-bottom: 240px !important;\r\n}\r\n\r\n.pb--220 {\r\n    padding-bottom: 220px !important;\r\n}\r\n\r\n.plr--270{\r\n    padding: 0 270px !important;\r\n}\r\n\r\n.plr--300{\r\n    padding: 0 300px !important;\r\n}\r\n\r\n.plr--340{\r\n    padding: 0 340px !important;\r\n}\r\n\r\n.ptb--300{\r\n    padding: 300px 0 !important;\r\n}\r\n\r\n.ptb--340{\r\n    padding: 340px 0 !important;\r\n}\r\n\r\n.ptb--450{\r\n    padding: 450px 0 !important;\r\n}\r\n\r\n.plr_dec--15{\r\n    margin: 0 -15px !important;\r\n}\r\n\r\n.pt--300{\r\n    padding-top: 300px !important;\r\n}\r\n\r\n@for $i from 1 through 40 {\r\n    .ptb--#{5 * $i} { padding: 5px *$i 0 !important; }\r\n    .plr--#{5 * $i} { padding: 0 5px *$i !important; }\r\n    .pt--#{5 * $i} { padding-top: 5px *$i !important; }\r\n    .pb--#{5 * $i} { padding-bottom: 5px *$i !important; }\r\n    .pl--#{5 * $i} { padding-left: 5px *$i !important;}\r\n    .pr--#{5 * $i} { padding-right: 5px *$i !important;}\r\n    .mt--#{5 * $i} {margin-top: 5px *$i !important;}\r\n    .mb--#{5 * $i} {margin-bottom: 5px *$i !important;}\r\n    .mr--#{5 * $i} {margin-right: 5px *$i !important;}\r\n    .ml--#{5 * $i} {margin-left: 5px *$i !important;}\r\n}\r\n\r\n\r\n@media #{$laptop-device} {\r\n    @for $i from 1 through 20 {\r\n        .ptb_lp--#{5 * $i} {\r\n            padding: 5px *$i 0 !important;\r\n        }\r\n\r\n        .plr_lp--#{5 * $i} {\r\n            padding: 0 5px *$i !important;\r\n        }\r\n\r\n        .pt_lp--#{5 * $i} {\r\n            padding-top: 5px *$i !important;\r\n        }\r\n\r\n        .pb_lp--#{5 * $i} {\r\n            padding-bottom: 5px *$i !important;\r\n        }\r\n\r\n        .pl_lp--#{5 * $i} {\r\n            padding-left: 5px *$i !important;\r\n        }\r\n\r\n        .pr_lp--#{5 * $i} {\r\n            padding-right: 5px *$i !important;\r\n        }\r\n\r\n        .mt_lp--#{5 * $i} {\r\n            margin-top: 5px *$i !important;\r\n        }\r\n\r\n        .mb_lp--#{5 * $i} {\r\n            margin-bottom: 5px *$i !important;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@media #{$lg-layout} {\r\n    @for $i from 1 through 20 {\r\n        .ptb_lg--#{5 * $i} {\r\n            padding: 5px *$i 0 !important;\r\n        }\r\n        .plr_lg--#{5 * $i} {\r\n            padding: 0 5px *$i !important;\r\n        }\r\n        .pt_lg--#{5 * $i} {\r\n            padding-top: 5px *$i !important;\r\n        }\r\n        .pb_lg--#{5 * $i} {\r\n            padding-bottom: 5px *$i !important;\r\n        }\r\n\r\n        .pl_lg--#{5 * $i} {\r\n            padding-left: 5px *$i !important;\r\n        }\r\n\r\n        .pr_lg--#{5 * $i} {\r\n            padding-right: 5px *$i !important;\r\n        }\r\n\r\n        .mt_lg--#{5 * $i} {\r\n            margin-top: 5px *$i !important;\r\n        }\r\n\r\n        .mb_lg--#{5 * $i} {\r\n            margin-bottom: 5px *$i !important;\r\n        }\r\n        .ml_lg--#{5 * $i} {\r\n            margin-left: 5px *$i !important;\r\n        }\r\n\r\n    }\r\n}\r\n\r\n@media #{$md-layout} {\r\n\r\n    .ptb_md--0{\r\n        padding: 0 !important;\r\n    }\r\n    .pl_md--0 {\r\n        padding-left: 0 !important;\r\n    }\r\n    .pr_md--0 {\r\n        padding-right: 0 !important;\r\n    }\r\n    .pt_md--0 {\r\n        padding-top: 0 !important;\r\n    }\r\n    .pb_md--0 {\r\n        padding-bottom: 0 !important;\r\n    }\r\n    .mr_md--0 {\r\n        margin-right: 0 !important;\r\n    }\r\n    .ml_md--0 {\r\n        margin-left: 0 !important;\r\n    }\r\n    .mt_md--0 {\r\n        margin-top: 0 !important;\r\n    }\r\n    .mb_md--0 {\r\n        margin-bottom: 0 !important;\r\n    }\r\n    .ptb_md--250{\r\n        padding: 250px 0 !important;\r\n    }\r\n\r\n    @for $i from 1 through 20 {\r\n        .ptb_md--#{5 * $i} {\r\n            padding: 5px *$i 0 !important;\r\n        }\r\n\r\n        .plr_md--#{5 * $i} {\r\n            padding: 0 5px *$i !important;\r\n        }\r\n\r\n        .pt_md--#{5 * $i} {\r\n            padding-top: 5px *$i !important;\r\n        }\r\n\r\n        .pb_md--#{5 * $i} {\r\n            padding-bottom: 5px *$i !important;\r\n        }\r\n\r\n        .pl_md--#{5 * $i} {\r\n            padding-left: 5px *$i !important;\r\n        }\r\n\r\n        .pr_md--#{5 * $i} {\r\n            padding-right: 5px *$i !important;\r\n        }\r\n\r\n        .mt_md--#{5 * $i} {\r\n            margin-top: 5px *$i !important;\r\n        }\r\n\r\n        .mb_md--#{5 * $i} {\r\n            margin-bottom: 5px *$i !important;\r\n        }\r\n        \r\n    }\r\n}\r\n\r\n@media #{$sm-layout} {\r\n    .ptb_sm--250{\r\n        padding: 250px 0 !important;\r\n    }\r\n    .ptb_sm--0{\r\n        padding: 0 !important;\r\n    }\r\n    .pl_sm--0 {\r\n        padding-left: 0 !important;\r\n    }\r\n    .pr_sm--0 {\r\n        padding-right: 0 !important;\r\n    }\r\n    .pt_sm--0 {\r\n        padding-top: 0 !important;\r\n    }\r\n    .pb_sm--0 {\r\n        padding-bottom: 0 !important;\r\n    }\r\n    .mr_sm--0 {\r\n        margin-right: 0 !important;\r\n    }\r\n    .ml_sm--0 {\r\n        margin-left: 0 !important;\r\n    }\r\n    .mt_sm--0 {\r\n        margin-top: 0 !important;\r\n    }\r\n    .mb_sm--0 {\r\n        margin-bottom: 0 !important;\r\n    }\r\n    .pt_sm--150 {\r\n        padding-top: 150px !important;\r\n    }\r\n    .pb_sm--110 {\r\n        padding-bottom: 110px !important;\r\n    }\r\n    @for $i from 1 through 20 {\r\n        .ptb_sm--#{5 * $i} {\r\n            padding: 5px *$i 0 !important;\r\n        }\r\n        .plr_sm--#{5 * $i} {\r\n            padding: 0 5px *$i !important;\r\n        }\r\n        .pt_sm--#{5 * $i} {\r\n            padding-top: 5px *$i !important;\r\n        }\r\n\r\n        .pb_sm--#{5 * $i} {\r\n            padding-bottom: 5px *$i !important;\r\n        }\r\n\r\n        .pl_sm--#{5 * $i} {\r\n            padding-left: 5px *$i !important;\r\n        }\r\n\r\n        .pr_sm--#{5 * $i} {\r\n            padding-right: 5px *$i !important;\r\n        }\r\n\r\n        .mt_sm--#{5 * $i} {\r\n            margin-top: 5px *$i !important;\r\n        }\r\n        \r\n        .ml_sm--#{5 * $i} {\r\n            margin-left: 5px *$i !important;\r\n        }\r\n\r\n        .mr_sm--#{5 * $i} {\r\n            margin-right: 5px *$i !important;\r\n        }\r\n\r\n        .mb_sm--#{5 * $i} {\r\n            margin-bottom: 5px *$i !important;\r\n        }\r\n    }\r\n\r\n    .pl_sm--0 {\r\n        padding-left: 0 !important;\r\n    }\r\n    .pr_sm--0 {\r\n        padding-right: 0 !important;\r\n    }\r\n    .pt_sm--0 {\r\n        padding-top: 0 !important;\r\n    }\r\n    .pb_sm--0 {\r\n        padding-bottom: 0 !important;\r\n    }\r\n    .mr_sm--0 {\r\n        margin-right: 0 !important;\r\n    }\r\n    .ml_sm--0 {\r\n        margin-left: 0 !important;\r\n    }\r\n    .mt_sm--0 {\r\n        margin-top: 0 !important;\r\n    }\r\n    .mb_sm--0 {\r\n        margin-bottom: 0 !important;\r\n    }\r\n    \r\n}\r\n\r\n\r\n@media #{$large-mobile}{\r\n    @for $i from 1 through 20 {\r\n        .ptb_mobile--#{5 * $i} {\r\n            padding: 5px *$i 0 !important;\r\n        }\r\n        .plr_mobile--#{5 * $i} {\r\n            padding: 0 5px *$i !important;\r\n        }\r\n        .pt_mobile--#{5 * $i} {\r\n            padding-top: 5px *$i !important;\r\n        }\r\n        .pb_mobile--#{5 * $i} {\r\n            padding-bottom: 5px *$i !important;\r\n        }\r\n        .pl_mobile--#{5 * $i} {\r\n            padding-left: 5px *$i !important;\r\n        }\r\n        .pr_mobile--#{5 * $i} {\r\n            padding-right: 5px *$i !important;\r\n        }\r\n        .mt_mobile--#{5 * $i} {\r\n            margin-top: 5px *$i !important;\r\n        }\r\n        .mb_mobile--#{5 * $i} {\r\n            margin-bottom: 5px *$i !important;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n@for $i from 1 through 20 {\r\n    .slick-gutter-#{$i * 5} {\r\n        margin-left: -#{$i * 5}px !important;\r\n        margin-right: -#{$i * 5}px !important;\r\n\r\n        .slick-slide {\r\n            padding-left: #{$i * 5}px !important;\r\n            padding-right: #{$i * 5}px !important;\r\n        }\r\n    }\r\n}\r\n\r\n","/*======================== \r\n    Common Style Css\r\n==========================*/\r\n\r\n/* Theme Gradient */\r\n.theme-gradient {\r\n    background: -moz-linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98% / 200% 100%;\r\n    background: -webkit-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98% / 200% 100%;\r\n    background: -webkit-linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98% / 200% 100%;\r\n    background: -o-linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98% / 200% 100%;\r\n    background: -ms-linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98% / 200% 100%;\r\n    background: linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98% / 200% 100%;\r\n    text-transform: capitalize;\r\n    -webkit-background-clip: text;\r\n    background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n}\r\n\r\n\r\n.bg-theme-gradient {\r\n    background-color: transparent;\r\n    background-image: linear-gradient(90deg, var(--color-primary-lightest) 10%, var(--color-primary-alt) 50%, var(--color-tertiary-alt) 90%);\r\n}\r\n\r\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\r\n    .theme-gradient {\r\n        color: var(--color-secondary);\r\n        background: none !important;\r\n    }\r\n}\r\n\r\n/* Heading Font  */\r\n.h1 {\r\n    font-size: var(--h1) !important\r\n}\r\n\r\n.h2 {\r\n    font-size: var(--h2) !important\r\n}\r\n\r\n.h3 {\r\n    font-size: var(--h3) !important\r\n}\r\n\r\n.h4 {\r\n    font-size: var(--h4) !important\r\n}\r\n\r\n.h5 {\r\n    font-size: var(--h5) !important\r\n}\r\n\r\n.h6 {\r\n    font-size: var(--h6) !important\r\n}\r\n\r\n\r\n\r\n/* Text Color  */\r\n\r\n.color-primary {\r\n    @extend %color-primary;\r\n}\r\n\r\n.color-primary {\r\n    @extend %color-primary;\r\n}\r\n\r\n.color-primary-light {\r\n    @extend %color-primary-light;\r\n}\r\n\r\n.color-primary-alt {\r\n    @extend %color-primary-alt;\r\n}\r\n\r\n.color-secondary {\r\n    @extend %color-secondary;\r\n}\r\n\r\n.color-tertiary {\r\n    @extend %color-tertiary;\r\n}\r\n\r\n.color-tertiary-alt {\r\n    @extend %color-tertiary-alt;\r\n}\r\n\r\n.color-light-green {\r\n    @extend %color-light-green;\r\n}\r\n\r\n.color-pink {\r\n    @extend %color-pink;\r\n}\r\n\r\n.color-primary-darker {\r\n    @extend %color-primary-darker;\r\n}\r\n\r\n.color-secondary-darker {\r\n    @extend %color-secondary-darker;\r\n}\r\n\r\n.color-light-green-darker {\r\n    @extend %color-light-green-darker;\r\n}\r\n\r\n.color-pink-darker {\r\n    @extend %color-pink-darker;\r\n}\r\n\r\n.color-heading {\r\n    @extend %color-heading;\r\n}\r\n\r\n.color-body {\r\n    @extend %color-body;\r\n}\r\n\r\n.color-dark {\r\n    @extend %color-dark;\r\n}\r\n\r\n.color-darker {\r\n    @extend %color-darker;\r\n}\r\n\r\n.color-darkest {\r\n    @extend %color-darkest;\r\n}\r\n\r\n.color-black {\r\n    @extend %color-black;\r\n}\r\n\r\n.color-blacker {\r\n    @extend %color-blacker;\r\n}\r\n\r\n.color-blackest {\r\n    @extend %color-blackest;\r\n}\r\n\r\n.color-border {\r\n    @extend %color-border;\r\n}\r\n\r\n.color-gray {\r\n    @extend %color-gray;\r\n}\r\n\r\n.color-midgray {\r\n    @extend %color-midgray;\r\n}\r\n\r\n.color-light {\r\n    @extend %color-light;\r\n}\r\n\r\n.color-lighter {\r\n    @extend %color-lighter;\r\n}\r\n\r\n.color-lightest {\r\n    @extend %color-lightest;\r\n}\r\n\r\n.color-white {\r\n    @extend %color-white;\r\n}\r\n\r\n\r\n\r\n\r\n//===== BG Ncc Colors =====//\r\n\r\n.bg-primary-color {\r\n    background: var(--color-primary);\r\n}\r\n\r\n.bg-secondary-color {\r\n    background: var(--color-secondary)\r\n}\r\n\r\n.bg-tertiary-color {\r\n    background-color: var(--color-tertiary)\r\n}\r\n\r\n.bg-color-primary {\r\n    background-color: var(--color-primary) !important;\r\n}\r\n\r\n.bg-color-primary-light {\r\n    background-color: var(--color-primary-light) !important;\r\n}\r\n\r\n.bg-color-primary-alt {\r\n    background-color: var(--color-primary-alt) !important;\r\n}\r\n\r\n.bg-color-secondary {\r\n    background-color: var(--color-secondary) !important;\r\n}\r\n\r\n.bg-color-tertiary {\r\n    background-color: var(--color-tertiary) !important;\r\n}\r\n\r\n.bg-color-tertiary-alt {\r\n    background-color: var(--color-tertiary-alt) !important;\r\n}\r\n\r\n.bg-color-light-green {\r\n    background-color: var(--color-light-green) !important;\r\n}\r\n\r\n.bg-color-pink {\r\n    background-color: var(--color-pink) !important;\r\n}\r\n\r\n.bg-color-primary-darker {\r\n    background-color: var(--color-primary-darker) !important;\r\n}\r\n\r\n.bg-color-secondary-darker {\r\n    background-color: var(--color-secondary-darker) !important;\r\n}\r\n\r\n.bg-color-light-green-darker {\r\n    background-color: var(--color-light-green-darker) !important;\r\n}\r\n\r\n.bg-color-pink-darker {\r\n    background-color: var(--color-pink-darker) !important;\r\n}\r\n\r\n.bg-color-heading {\r\n    background-color: var(--color-heading) !important;\r\n}\r\n\r\n.bg-color-body {\r\n    background-color: var(--color-body) !important;\r\n}\r\n\r\n.bg-color-dark {\r\n    background-color: var(--color-dark) !important;\r\n}\r\n\r\n.bg-color-darker {\r\n    background-color: var(--color-darker) !important;\r\n}\r\n\r\n.bg-color-darkest {\r\n    background-color: var(--color-darkest) !important;\r\n}\r\n\r\n.bg-color-black {\r\n    background-color: var(--color-black) !important;\r\n}\r\n\r\n.bg-color-blacker {\r\n    background-color: var(--color-blacker) !important;\r\n}\r\n\r\n.bg-color-blackest {\r\n    background-color: var(--color-blackest) !important;\r\n}\r\n\r\n.bg-color-border {\r\n    background-color: var(--color-border) !important;\r\n}\r\n\r\n.bg-color-gray {\r\n    background-color: var(--color-gray) !important;\r\n}\r\n\r\n.bg-color-midgray {\r\n    background-color: var(--color-midgray) !important;\r\n}\r\n\r\n.bg-color-light {\r\n    background-color: var(--color-light) !important;\r\n}\r\n\r\n.bg-color-lighter {\r\n    background-color: var(--color-lighter) !important;\r\n}\r\n\r\n.bg-color-lightest {\r\n    background-color: var(--color-lightest) !important;\r\n}\r\n\r\n.bg-color-white {\r\n    background-color: var(--color-white) !important;\r\n}\r\n\r\n\r\n\r\n\r\n/* Radius */\r\n.radius-small {\r\n    @extend %radius-small;\r\n}\r\n\r\n.radius {\r\n    @extend %radius;\r\n}\r\n\r\n.radius-big {\r\n    @extend %radius-big;\r\n}\r\n\r\n\r\n/* Font Weight */\r\n\r\n.w-300 {\r\n    @extend %w-300;\r\n}\r\n\r\n.w-400 {\r\n    @extend %w-400;\r\n}\r\n\r\n.w-500 {\r\n    @extend %w-500;\r\n}\r\n\r\n.w-600 {\r\n    @extend %w-600;\r\n}\r\n\r\n.w-700 {\r\n    @extend %w-700;\r\n}\r\n\r\n.w-800 {\r\n    @extend %w-800;\r\n}\r\n\r\n.w-900 {\r\n    @extend %w-900;\r\n}\r\n\r\n\r\n\r\n/* Shadows */\r\n\r\n.shadow-primary {\r\n    @extend %shadow-primary;\r\n}\r\n\r\n.shadow-light {\r\n    @extend %shadow-light;\r\n}\r\n\r\n.shadow-lighter {\r\n    @extend %shadow-lighter;\r\n}\r\n\r\n\r\n\r\n/* Others  */\r\n.liststyle {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n}\r\n\r\n.radius {\r\n    @extend %radius;\r\n}\r\n\r\n%transition-transform {\r\n    transition: var(--transition-transform);\r\n}\r\n\r\n.transition-transform {\r\n    @extend %transition-transform;\r\n}\r\n\r\n\r\n.list-icon {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    li {\r\n        display: flex;\r\n        align-items: center;\r\n        margin: 15px 0;\r\n        @media #{$sm-layout} {\r\n            font-size: 16px;\r\n        }\r\n        .icon {\r\n            width: 30px;\r\n            background-color: var(--color-blackest);\r\n            height: 30px;\r\n            border-radius: 100%;\r\n            display: inline-block;\r\n            position: relative;\r\n            margin-right: 9px;\r\n            min-width: 30px;\r\n            min-height: 30px;\r\n            svg {\r\n                width: 20px;\r\n                height: 20px;\r\n                position: absolute;\r\n                top: 50%;\r\n                left: 50%;\r\n                transform: translate(-50%, -50%);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.rn-sub-badge {\r\n    font-weight: 600;\r\n    letter-spacing: 0.5px;\r\n    line-height: 18px;\r\n    font-size: 16px;\r\n    border-radius: 4px;\r\n    margin-bottom: 12px;\r\n    display: inline-block;\r\n    padding: 7px 14px;\r\n    background-color: var(--color-blackest);\r\n    box-shadow: var(--shadow-lighter);\r\n}\r\n\r\n\r\n\r\n","/* ========= Forms Styles ========= */\r\nbutton,\r\n[type=\"button\"],\r\n[type=\"reset\"],\r\n[type=\"submit\"] {\r\n    -webkit-appearance: button;\r\n}\r\n\r\ninput,\r\nselect,\r\ntextarea {\r\n    width: 100%;\r\n    transition: 0.3s;\r\n}\r\n\r\ninput {\r\n    height: 40px;\r\n    padding: 0 15px;\r\n}\r\n\r\nselect {\r\n    transition: 0.3s;\r\n    height: 60px;\r\n    line-height: 28px;\r\n    padding: 10px 20px;\r\n    outline: none;\r\n    color: var(--color-body);\r\n    -moz-appearance: none;\r\n    -webkit-appearance: none;\r\n    appearance: none;\r\n    border: var(--border-width) solid var(--color-border);\r\n    border-radius: var(--radius);\r\n    font-size: 16px;\r\n    line-height: 28px;\r\n    font-weight: 400;\r\n    padding-right: 30px;\r\n}\r\n\r\ninput[type=\"text\"],\r\ninput[type=\"password\"],\r\ninput[type=\"email\"],\r\ninput[type=\"number\"],\r\ninput[type=\"tel\"],\r\ntextarea {\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    height: auto;\r\n    line-height: 28px;\r\n    background: transparent;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n    padding: 0 15px;\r\n    outline: none;\r\n    border: var(--border-width) solid var(--color-border);\r\n    border-radius: var(--radius);\r\n    color: var(--color-body);\r\n\r\n    /* -- Placeholder -- */\r\n    &::placeholder {\r\n        color: var(--body-color);\r\n        /* Firefox */\r\n        opacity: 1;\r\n    }\r\n\r\n    &:-ms-input-placeholder {\r\n        /* Internet Explorer 10-11 */\r\n        color: var(--body-color);\r\n        opacity: 1;\r\n    }\r\n\r\n    &::-ms-input-placeholder {\r\n        /* Microsoft Edge */\r\n        color: var(--body-color);\r\n        opacity: 1;\r\n    }\r\n\r\n    &.p-holder__active {\r\n        border-color: var(--color-primary);\r\n\r\n        /* -- Placeholder -- */\r\n        &::placeholder {\r\n            color: var(--color-primary);\r\n            /* Firefox */\r\n            opacity: 1;\r\n        }\r\n\r\n        &:-ms-input-placeholder {\r\n            /* Internet Explorer 10-11 */\r\n            color: var(--color-primary);\r\n        }\r\n\r\n        &::-ms-input-placeholder {\r\n            /* Microsoft Edge */\r\n            color: var(--color-primary);\r\n        }\r\n    }\r\n\r\n    &.p-holder__error {\r\n        border-color: #f4282d;\r\n\r\n        /* -- Placeholder -- */\r\n        &::placeholder {\r\n            color: #f4282d;\r\n            /* Firefox */\r\n            opacity: 1;\r\n        }\r\n\r\n        &:-ms-input-placeholder {\r\n            /* Internet Explorer 10-11 */\r\n            color: #f4282d;\r\n        }\r\n\r\n        &::-ms-input-placeholder {\r\n            /* Microsoft Edge */\r\n            color: #f4282d;\r\n        }\r\n\r\n        &:focus {\r\n            border-color: #f4282d;\r\n        }\r\n    }\r\n\r\n    &:focus {\r\n        border-color: var(--color-primary);\r\n    }\r\n}\r\n\r\n.input-active {\r\n    @extend .p-holder__active;\r\n\r\n    input {\r\n        @extend .p-holder__active;\r\n    }\r\n}\r\n\r\n.input-error {\r\n    @extend .p-holder__error;\r\n\r\n    input {\r\n        @extend .p-holder__error;\r\n    }\r\n}\r\n\r\n// Custom Checkbox and radio button \r\ninput[type=\"checkbox\"],\r\ninput[type=\"radio\"] {\r\n    opacity: 0;\r\n    position: absolute;\r\n\r\n    ~label {\r\n        position: relative;\r\n        font-size: 15px;\r\n        line-height: 25px;\r\n        color: var(--body-color);\r\n        font-weight: 400;\r\n        padding-left: 20px;\r\n        cursor: pointer;\r\n        margin-bottom: 0;\r\n\r\n        &::before {\r\n            content: \" \";\r\n            position: absolute;\r\n            top: 6px;\r\n            left: 0;\r\n            width: 14px;\r\n            height: 14px;\r\n            background-color: #fff;\r\n            border: var(--border-width) solid rgba(24, 152, 165, 0.2);\r\n            border-radius: 2px;\r\n            transition: all .3s;\r\n        }\r\n\r\n        &::after {\r\n            content: \" \";\r\n            position: absolute;\r\n            top: 9px;\r\n            left: 2px;\r\n            width: 10px;\r\n            height: 5px;\r\n            background-color: transparent;\r\n            border-bottom: var(--border-width) solid #fff;\r\n            border-left: var(--border-width) solid #fff;\r\n            border-radius: 2px;\r\n            transform: rotate(-45deg);\r\n            opacity: 0;\r\n            transition: all .3s;\r\n        }\r\n    }\r\n\r\n    &:checked {\r\n        ~label {\r\n            &::before {\r\n                background-color: var(--color-primary);\r\n                border-color: var(--color-primary);\r\n            }\r\n\r\n            &::after {\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\ninput[type=\"radio\"] {\r\n    ~label {\r\n        &::before {\r\n            border-radius: 50%;\r\n        }\r\n\r\n        &::after {\r\n            width: 8px;\r\n            height: 8px;\r\n            left: 3px;\r\n            background: #fff;\r\n            border-radius: 50%;\r\n        }\r\n    }\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 20px;\r\n\r\n    input {\r\n        border: var(--border-width) solid var(--color-border);\r\n        border-radius: var(--radius);\r\n        height: 50px;\r\n        font-size: 16px;\r\n        @extend %transition;\r\n        padding: 0 15px;\r\n\r\n        &:focus {\r\n            border-color: var(--color-primary);\r\n        }\r\n    }\r\n\r\n    textarea {\r\n        min-height: 193px;\r\n        border: var(--border-width) solid var(--color-border);\r\n        border-radius: var(--radius);\r\n        resize: none;\r\n        padding: 15px;\r\n        font-size: 16px;\r\n        @extend %transition;\r\n\r\n        &:focus {\r\n            border-color: var(--color-primary);\r\n        }\r\n    }\r\n}\r\n\r\n// Form Submit Styles \r\ninput[type=\"submit\"] {\r\n    width: auto;\r\n    font-size: 16px;\r\n    letter-spacing: 2px;\r\n    padding: 15px 20px;\r\n    border-radius: 6px;\r\n    display: block;\r\n    font-weight: 500;\r\n    transition: 0.3s;\r\n    border: var(--border-width) solid var(--color-primary);\r\n    background: var(--color-primary);\r\n    color: #ffffff;\r\n    height: 60px;\r\n    margin-top: 30px;\r\n\r\n    &:hover {\r\n        color: #ffffff;\r\n        -webkit-box-shadow: 0 10px 15px 0 rgba(249, 0, 77, 0.1);\r\n        box-shadow: 0 10px 15px 0 rgba(249, 0, 77, 0.1);\r\n        -webkit-transform: translateY(-5px);\r\n        -ms-transform: translateY(-5px);\r\n        transform: translateY(-5px);\r\n    }\r\n}\r\n\r\n\r\n\r\n.contact-form--1 form input::-webkit-input-placeholder,\r\n.contact-form--1 form textarea::-webkit-input-placeholder {\r\n    /* Chrome/Opera/Safari */\r\n    color: var(--color-body) !important;\r\n}\r\n\r\n.contact-form--1 form input::-moz-placeholder,\r\n.contact-form--1 form textarea::-moz-placeholder {\r\n    /* Firefox 19+ */\r\n    color: var(--color-body) !important;\r\n}\r\n\r\n.contact-form--1 form input:-ms-input-placeholder,\r\n.contact-form--1 form textarea:-ms-input-placeholder {\r\n    /* IE 10+ */\r\n    color: var(--color-body) !important;\r\n}\r\n\r\n.contact-form--1 form input:-moz-placeholder,\r\n.contact-form--1 form textarea:-moz-placeholder {\r\n    /* Firefox 18- */\r\n    color: var(--color-body) !important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n","/* Theme Bg Color  */\r\n\r\n\r\n.rn-gradient-circle {\r\n    position: fixed;\r\n    left: -250px;\r\n    top: 250px;\r\n    right: auto;\r\n    bottom: auto;\r\n    z-index: -1;\r\n    width: 500px;\r\n    height: 500px;\r\n    border-radius: 1000px;\r\n    //background-image: linear-gradient(45deg, var(--color-primary), var(--color-light-green)); //circle\r\n    opacity: 0.25;\r\n    -webkit-filter: blur(100px);\r\n    filter: blur(100px);\r\n\r\n    &.theme-pink {\r\n        left: auto;\r\n        top: -250px;\r\n        right: -250px;\r\n        bottom: auto;\r\n        background-image: linear-gradient(45deg, var(--color-secondary), var(--color-tertiary));\r\n    }\r\n}\r\n\r\n.theme-shape {\r\n    position: relative;\r\n    z-index: 2;\r\n    overflow: hidden;\r\n\r\n    &::before {\r\n        position: absolute;\r\n        left: -250px;\r\n        top: 250px;\r\n        right: auto;\r\n        bottom: auto;\r\n        z-index: -1;\r\n        width: 500px;\r\n        height: 500px;\r\n        border-radius: 1000px;\r\n        background-image: linear-gradient(45deg, var(--color-primary), var(--color-light-green));\r\n        opacity: 0.2;\r\n        filter: blur(100px);\r\n        content: \"\";\r\n    }\r\n\r\n    &::after {\r\n        position: absolute;\r\n        z-index: -1;\r\n        width: 500px;\r\n        height: 500px;\r\n        border-radius: 1000px;\r\n        opacity: 0.2;\r\n        filter: blur(100px);\r\n        content: \"\";\r\n        left: auto;\r\n        top: -250px;\r\n        right: -250px;\r\n        bottom: auto;\r\n        background-image: linear-gradient(45deg, var(--color-secondary), var(--color-tertiary));\r\n        \r\n    }\r\n}\r\n\r\n\r\n.link-hover {\r\n    a {\r\n        display: inline-block;\r\n        position: relative;\r\n        &::after {\r\n            position: absolute;\r\n            content: \"\";\r\n            left: auto;\r\n            bottom: 0;\r\n            background: currentColor;\r\n            width: 0;\r\n            height: 2px;\r\n            transition: 0.3s;\r\n            right: 0;\r\n        }\r\n        &:hover {\r\n            &::after {\r\n                width: 100%;\r\n                left: 0;\r\n                right: auto;\r\n            }\r\n        }\r\n    }\r\n    \r\n}","/*--------------------------\n    Header Styles  \n --------------------------*/\n.logo-dark {\n  display: none;\n}\n.header-default {\n  max-width: 100%;\n  border-bottom: 1px solid var(--color-border);\n  background-color: var(--color-darker);\n  color: #fff;\n  font-size: 12px;\n  z-index: 99;\n  position: relative;\n  height: 106px;\n  display: flex;\n  align-items: center;\n  .logo {\n    a {\n      display: flex;\n      height: 80px;\n      line-height: 80px;\n      align-items: center;\n      img {\n        max-height: 40px;\n      }\n    }\n  }\n\n  .header-right {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n  }\n\n  &.header-relative {\n    position: relative;\n  }\n\n  .header-right {\n    display: flex;\n    justify-content: flex-end;\n    .header-btn {\n      margin-left: 25px;\n      @media #{$md-layout} {\n        margin-left: 0;\n      }\n      @media #{$sm-layout} {\n        margin-left: 0;\n      }\n    }\n  }\n\n  a,\n  button {\n    &.btn-default {\n      @media #{$sm-layout} {\n        height: 33px;\n        line-height: 30px;\n        padding: 0 9px;\n        font-size: 12px;\n      }\n      &.btn-small {\n        @media #{$sm-layout} {\n          height: 33px;\n          line-height: 30px;\n          padding: 0 9px;\n          font-size: 12px;\n        }\n      }\n    }\n  }\n\n  &.header-transparent {\n    position: absolute;\n    left: 0;\n    right: 0;\n    width: auto;\n    background: transparent !important;\n    backdrop-filter: inherit;\n  }\n}\n\n.header-transparent-with-topbar {\n  position: absolute;\n  left: 0;\n  right: 0;\n  width: auto;\n  z-index: 99;\n\n  @media #{$md-layout} {\n    position: relative;\n  }\n\n  @media #{$sm-layout} {\n    position: relative;\n  }\n\n  .header-top-bar {\n    background-color: transparent;\n\n    @media #{$md-layout} {\n      background-color: var(--color-darker);\n    }\n\n    @media #{$sm-layout} {\n      background-color: var(--color-darker);\n    }\n  }\n\n  .header-default {\n    background-color: transparent;\n    background-image: none;\n\n    @media #{$md-layout} {\n      background-color: var(--color-darker);\n    }\n\n    @media #{$sm-layout} {\n      background-color: var(--color-darker);\n    }\n  }\n}\n\n.hamberger-button {\n  background: var(--color-blackest);\n  border: 0 none;\n  color: var(--color-white);\n  width: 40px;\n  height: 40px;\n  font-size: 21px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n  cursor: pointer;\n  svg {\n    position: relative;\n    z-index: 2;\n    stroke-width: 2px;\n    stroke: #fff;\n  }\n}\n\n.header-left-align {\n  .mainmenu-nav {\n    margin-left: 30px;\n  }\n}\n\n.rn-header.sticky {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: var(--color-dark) !important;\n  width: 100%;\n  height: 100px;\n  animation: headerSticky 0.95s ease forwards;\n  z-index: 9;\n}\n\n@keyframes headerSticky {\n  0% {\n    transform: translateY(-100%);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n","/*--------------------------\r\n    Navigation Styles \r\n----------------------------*/\r\n.active{\r\n    color: var(--color-primary) !important;\r\n}\r\n.activeInside{\r\n    color: var(--color-primary) !important;\r\n    pointer-events: none;\r\n    cursor: default;\r\n}\r\n.mainmenu-nav {\r\n \r\n    .mainmenu {\r\n        display: flex;\r\n        margin: 0;\r\n        padding: 0;\r\n        > li {\r\n            > a {\r\n                color: var(--color-body);\r\n                font-size: 18px;\r\n                font-weight: 500;\r\n                padding: 0 17px;\r\n                display: block;\r\n                height: 80px;\r\n                line-height: 80px;\r\n                transition: 0.3s;\r\n                cursor: pointer;\r\n                &:hover {\r\n                    color: var(--color-primary);\r\n                }\r\n            }\r\n        }\r\n        li {\r\n            margin-top: 0;\r\n            margin-bottom: 0;\r\n            position: relative;\r\n\r\n            &.has-droupdown {\r\n                .submenu {\r\n                    min-width: 240px;\r\n                    height: auto;\r\n                    position: absolute;\r\n                    top: 90%;\r\n                    left: 0;\r\n                    z-index: 90;\r\n                    opacity: 0;\r\n                    visibility: hidden;\r\n                    text-align: left;\r\n                    padding: 12px 0;\r\n                    transition: 0.3s;\r\n                    border-radius: 0 0 10px 10px;\r\n                    background-color: var(--color-blackest);\r\n                    box-shadow: var(--shadow-lighter);\r\n                    li {\r\n                        a {\r\n                            font-weight: 500;\r\n                            padding: 5px 20px;\r\n                            font-size: 14px;\r\n                            display: block;\r\n                            color: var(--color-body);\r\n                            margin: 0 10px;\r\n                            border-radius: 3px;\r\n                            @extend %transition;\r\n                            &:hover {\r\n                                color: var(--color-primary);\r\n                                background: var(--color-darker);\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n    \r\n                &:hover {\r\n                    .submenu {\r\n                        opacity: 1;\r\n                        visibility: visible;\r\n                        top: 100%;\r\n                    }\r\n                }\r\n            }\r\n\r\n            &.with-megamenu { \r\n                position: static;\r\n\r\n                .rn-megamenu {\r\n                    position: absolute;\r\n                    transition: 0.3s;\r\n                    top: 90%;\r\n                    width: 100%;\r\n                    left: 0;\r\n                    right: 0;\r\n                    padding: 0 15px;\r\n                    visibility: hidden;\r\n                    opacity: 0;\r\n                    .wrapper {\r\n                        border-radius: 0 0 10px 10px;\r\n                        background-color: var(--color-blackest);\r\n                        box-shadow: var(--shadow-lighter);\r\n\r\n                        .mega-menu-item {\r\n                            padding: 22px 10px;\r\n                            border-right: 1px solid var(--color-extra04);\r\n                            height: 100%;\r\n\r\n                            li {\r\n                                a {\r\n                                    font-weight: 500;\r\n                                    padding: 5px 14px;\r\n                                    font-size: 15px;\r\n                                    display: block;\r\n                                    color: var(--color-body);\r\n                                    margin: 0 10px;\r\n                                    border-radius: 4px;\r\n                                    transition: 0.3s;\r\n                                    display: flex;\r\n                                    align-items: center;\r\n\r\n                                    .rn-badge-card {\r\n                                        margin-left: 10px;\r\n                                    }\r\n\r\n                                    &:hover {\r\n                                        color: var(--color-primary);\r\n                                        background: var(--color-darker);\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .single-mega-item {\r\n                    &:last-child {\r\n                        .mega-menu-item {\r\n                            border-right: 0 none;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                &:hover {\r\n                    .rn-megamenu {\r\n                        opacity: 1;\r\n                        visibility: visible;\r\n                        top: 100%;\r\n                    }\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n}\r\n\r\n","/*------------------------------\r\n    Popup Menu Styles  \r\n--------------------------------*/\r\n.popup-mobile-menu {\r\n  z-index: 9999;\r\n  position: fixed;\r\n  content: \"\";\r\n  width: 100%;\r\n  height: 100%;\r\n  position: fixed;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background-color: rgba(0, 0, 0, 0.8);\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  transition: opacity 0.5s ease-out;\r\n  .inner {\r\n    width: 320px;\r\n    z-index: 999;\r\n    position: absolute;\r\n    background-color: var(--color-blackest);\r\n    height: 100%;\r\n    height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    opacity: 0;\r\n    left: -150px;\r\n    transition: all 0.5s ease-out;\r\n\r\n    .header-top {\r\n      display: flex;\r\n      border-bottom: 1px solid var(--color-border);\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      padding: 15px 20px;\r\n      .logo {\r\n        a {\r\n          img {\r\n            max-height: 45px;\r\n          }\r\n        }\r\n      }\r\n      .close-menu {\r\n        .close-button {\r\n          background: var(--color-darker);\r\n          border: 0 none;\r\n          color: var(--color-white);\r\n          width: 40px;\r\n          height: 40px;\r\n          font-size: 21px;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          border-radius: 100%;\r\n          cursor: pointer;\r\n          svg {\r\n            position: relative;\r\n            z-index: 2;\r\n            stroke-width: 2px;\r\n            stroke: #fff;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &.active {\r\n    visibility: visible;\r\n    opacity: 1;\r\n    .inner {\r\n      opacity: 1;\r\n      left: 0;\r\n      overflow-y: auto;\r\n    }\r\n  }\r\n\r\n  .mainmenu {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    padding: 15px 20px;\r\n    li {\r\n      margin: 0;\r\n      a {\r\n        padding: 8px 0;\r\n        display: block;\r\n        font-size: 18px;\r\n        font-weight: 500;\r\n      }\r\n      & + li {\r\n        border-top: 1px solid var(--color-border);\r\n      }\r\n    }\r\n\r\n    .has-droupdown {\r\n      .submenu {\r\n        height: 0;\r\n        transition: all 0.3s;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        padding: 0;\r\n        max-width: 100%;\r\n        list-style: none;\r\n        padding-left: 14px;\r\n        li {\r\n          a {\r\n            font-size: 15px;\r\n          }\r\n        }\r\n        &.active {\r\n          height: 100%;\r\n          opacity: 1;\r\n          visibility: visible;\r\n          padding-bottom: 12px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .rn-megamenu {\r\n      height: 0;\r\n      transition: all 0.3s;\r\n      opacity: 0;\r\n      visibility: hidden;\r\n      padding: 0;\r\n      max-width: 100%;\r\n      list-style: none;\r\n      padding-left: 14px;\r\n      &.active {\r\n        height: 100%;\r\n        opacity: 1;\r\n        visibility: visible;\r\n        padding-bottom: 12px;\r\n      }\r\n    }\r\n\r\n    .mega-menu-item {\r\n      list-style: none;\r\n      padding: 0;\r\n      margin: 0;\r\n      padding-left: 0;\r\n      li {\r\n        a {\r\n          font-size: 15px;\r\n        }\r\n        &:last-child {\r\n          border-bottom: 1px solid var(--color-border);\r\n        }\r\n      }\r\n    }\r\n\r\n    .single-mega-item {\r\n      &:last-child {\r\n        .mega-menu-item {\r\n          li {\r\n            &:last-child {\r\n              border-bottom-color: transparent;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","/*--------------------------\r\n    Header Top Styles  \r\n-----------------------------*/\r\n.header-top-news {\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    width: auto;\r\n    z-index: 99;\r\n    transition: 0.4s;\r\n    &.deactive {\r\n        display: none;\r\n    }\r\n    .inner {\r\n        display: flex;\r\n        justify-content: center;\r\n        padding: 8px 0;\r\n        align-items: center;\r\n        position: relative;\r\n        @media #{$sm-layout} {\r\n            display: block;\r\n            text-align: center;\r\n            padding: 15px 0;\r\n        }\r\n        .content {\r\n            .news-text {\r\n                display: inline-block;\r\n                margin-left: 15px;\r\n                color: var(--color-body);\r\n                font-size: 14px;\r\n                @media #{$large-mobile} {\r\n                    margin-left: 0;\r\n                    margin-top: 10px;\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n        .right-button {\r\n            margin-left: 30px;\r\n            @media #{$sm-layout} {\r\n                margin-left: 0;\r\n            }\r\n        }\r\n    }\r\n    .icon-close {\r\n        position: absolute;\r\n        right: 30px;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        @media #{$sm-layout} {\r\n            right: 10px;\r\n            top: 13px;\r\n            transform: none;\r\n        }\r\n    }\r\n    .close-button {\r\n        background: transparent;\r\n        color: #fff;\r\n        border: 2px solid var(--color-border);\r\n        width: 35px;\r\n        display: inline-block;\r\n        height: 35px;\r\n        border-radius: 100%;\r\n        padding: 0;\r\n        margin: 0;\r\n        line-height: 31px;\r\n        transition: 0.3s;\r\n        &:hover {\r\n            background: var(--color-primary);\r\n            border-color: var(--color-primary);\r\n            color: #fff;\r\n        }\r\n    }\r\n}\r\n\r\n/*----------------------------\r\n    Header Top Bar  \r\n----------------------------*/\r\n.header-top-bar {\r\n    padding: 10px 0;\r\n    border-bottom: 1px solid var(--color-border);\r\n    background-color: var(--color-darker);\r\n    .header-left {\r\n        @media #{$md-layout} {\r\n            text-align: center;\r\n        }\r\n        @media #{$sm-layout} {\r\n            text-align: center;\r\n        }\r\n        p {\r\n            margin-bottom: 0;\r\n            a {\r\n                transition: 0.3s;\r\n            }\r\n        }\r\n    }\r\n    .header-right {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-end;\r\n        flex-wrap: wrap;\r\n        @media #{$md-layout} {\r\n            justify-content: center;\r\n            margin-top: 6px;\r\n        }\r\n        @media #{$sm-layout} {\r\n            justify-content: center;\r\n            margin-top: 6px;\r\n        }\r\n\r\n        .address-content {\r\n            display: flex;\r\n            align-items: center;\r\n            margin: 0 -10px;\r\n            p {\r\n                margin-bottom: 0;\r\n                padding: 0 10px;\r\n                font-size: 14px;\r\n                position: relative;\r\n                \r\n                @media #{$large-mobile} {\r\n                    padding: 0 8px;\r\n                }\r\n                & + p {\r\n                    &::before {\r\n                        position: absolute;\r\n                        content: \"\";\r\n                        height: 20px;\r\n                        width: 2px;\r\n                        background: var(--color-border);\r\n                        top: 50%;\r\n                        transform: translateY(-50%);\r\n                        left: -1px;\r\n                    }\r\n                }\r\n               \r\n                a {\r\n                    transition: 0.3s;\r\n                }\r\n                svg {\r\n                    margin-right: 8px;\r\n                    font-size: 16px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .social-default {\r\n        &.icon-naked {\r\n            li {\r\n                margin: 1px;\r\n                a {\r\n                    color: var(--color-body);\r\n                    font-size: 15px;\r\n                    line-height: 26px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .social-icon-wrapper {\r\n        position: relative;\r\n        margin-left: 10px;\r\n        padding-left: 10px;\r\n        @media #{$large-mobile} {\r\n            margin-left: 0;\r\n            padding-left: 0;\r\n            flex-basis: 100%;\r\n        }\r\n        &::before {\r\n            position: absolute;\r\n            content: \"\";\r\n            height: 20px;\r\n            width: 2px;\r\n            background: var(--color-border);\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n            left: -1px;\r\n            @media #{$large-mobile} {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n",".section-title {\r\n    .subtitle {\r\n        font-weight: 600;\r\n        letter-spacing: 0.5px;\r\n        line-height: 18px;\r\n        font-size: 16px;\r\n        border-radius: 4px;\r\n        margin-bottom: 12px;\r\n        display: inline-block;\r\n        padding: 7px 14px;\r\n        background-color: var(--color-blackest);\r\n        box-shadow: var(--shadow-lighter);\r\n        &.radius-rounded {\r\n            border-radius: 100px;\r\n        }\r\n    }\r\n    .title {\r\n        \r\n    }\r\n    .description {\r\n        br {\r\n            @media #{$sm-layout} {\r\n                display: none;    \r\n            }\r\n        }\r\n    }\r\n\r\n    p {\r\n        &:empty {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.section-title-2 {\r\n    .title {\r\n        color: var(--color-body);\r\n        display: block;\r\n        border-bottom: 1px solid var(--color-border);\r\n        padding-bottom: 19px;\r\n        opacity: 0.6;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n","/* Button Styles  */\r\n\r\n.button-group {\r\n    margin: -10px;\r\n\r\n    a,\r\n    button {\r\n        margin: 10px;\r\n    }\r\n}\r\n\r\n\r\n\r\na,\r\nbutton {\r\n    &.btn-default {\r\n        padding: 0 28px;\r\n        border-style: solid;\r\n        border-width: 2px;\r\n        border-color: transparent;\r\n        border-radius: 8px;\r\n        background-color: transparent;\r\n        background: linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 95% / 200% 100%;\r\n        transition-duration: 300ms;\r\n        color: var(--color-white);\r\n        font-size: 16px;\r\n        font-weight: 400;\r\n        text-align: center;\r\n        text-decoration: none;\r\n        text-shadow: var(--shadow-light);\r\n        display: inline-block;\r\n        height: 50px;\r\n        line-height: 47px;\r\n        letter-spacing: 0.5px;\r\n        width: auto;\r\n\r\n        \r\n\r\n        &.btn-icon {\r\n            .icon {\r\n                position: relative;\r\n                top: -1px;\r\n                padding-left: 4px;\r\n                svg {\r\n                    width: 20px;\r\n                    height: 20px;\r\n                }\r\n            }\r\n        }\r\n        &:hover {\r\n            box-shadow: var(--shadow-primary);\r\n            -webkit-filter: brightness(125%);\r\n            filter: brightness(125%);\r\n            color: var(--color-white);\r\n            text-decoration: none;\r\n        }\r\n        &.btn-small {\r\n            height: 40px;\r\n            line-height: 36px;\r\n            padding: 0 20px;\r\n            font-size: 14px;\r\n            font-weight: 500;\r\n        }\r\n        &.btn-medium {\r\n            height: 65px;\r\n            line-height: 63px;\r\n            padding: 0 40px;\r\n            @media #{$sm-layout} {\r\n                padding: 0 30px;\r\n            }\r\n        }\r\n        &.btn-large {\r\n            height: 60px;\r\n            line-height: 56px;\r\n            padding: 0 37px;\r\n            font-size: 17px;\r\n            @media #{$sm-layout} {\r\n                padding: 0 30px;\r\n            }\r\n        }\r\n        &.btn-extra-large {\r\n            height: 90px;\r\n            line-height: 90px;\r\n            padding: 0 70px;\r\n            font-size: 20px;\r\n            @media #{$sm-layout} {\r\n                padding: 0 44px;\r\n            }\r\n        }\r\n        &.btn-border {\r\n            background-image: inherit;\r\n            border-color: var(--color-border);\r\n            border-width: 2px;\r\n            border-style: solid;\r\n            &:hover {\r\n                background-color: var(--color-secondary);\r\n                border-color: var(--color-secondary);\r\n            }\r\n        }\r\n        &.text-underline {\r\n            background-image: inherit;\r\n            border-color: var(--color-white);\r\n            span {\r\n                position: relative;\r\n                display: inline-block;\r\n                line-height: 30px;\r\n\r\n                &::after {\r\n                    content: '';\r\n                    position: absolute;\r\n                    bottom: 0;\r\n                    left: 0;\r\n                    height: 1px;\r\n                    background-color: currentColor;\r\n                    transition: background-color .25s ease-in-out, width .36s cubic-bezier(.51, .5, .07, .99);\r\n                    -webkit-backface-visibility: hidden;\r\n                    backface-visibility: hidden;\r\n                    width: 0px;\r\n                    bottom: 3px;\r\n                }\r\n            }\r\n\r\n            &:hover {\r\n                box-shadow: none;\r\n\r\n                span {\r\n                    &::after {\r\n                        width: 100%;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        &.round {\r\n            border-radius: 100px;\r\n        }\r\n\r\n        &.square {\r\n            border-radius: 0;\r\n        }\r\n\r\n        &.rounded-player {\r\n            border-radius: 100%;\r\n            width: 100px;\r\n            height: 100px;\r\n            padding: 0;\r\n            line-height: 100px;\r\n            font-size: 30px;\r\n            display: inline-block;\r\n            @media #{$sm-layout} {\r\n                width: 70px;\r\n                height: 70px;\r\n                line-height: 70px;\r\n            }\r\n            span {\r\n                svg {\r\n                    position: relative;\r\n                    top: -5px;\r\n                    left: 2px;\r\n                }\r\n            }\r\n\r\n            &.border {\r\n                background-image: inherit;\r\n                border-color: var(--color-white);\r\n            }\r\n\r\n            &.sm-size {\r\n                width: 70px;\r\n                height: 70px;\r\n                line-height: 70px;\r\n            }\r\n        }\r\n\r\n    }\r\n}\r\n\r\n.btn-read-more {\r\n    span {\r\n        position: relative;\r\n        color: var(--color-heading);\r\n        display: inline-block;\r\n        line-height: 35px;\r\n        transition: 0.3s;\r\n\r\n        &::after {\r\n            content: '';\r\n            position: absolute;\r\n            bottom: 0;\r\n            left: 0;\r\n            height: 2px;\r\n            background-color: var(--color-border);\r\n            transition: 0.3s;\r\n            width: 100%;\r\n            bottom: 3px;\r\n        }\r\n\r\n        &::before {\r\n            position: absolute;\r\n            content: \"\";\r\n            left: auto;\r\n            bottom: 2px;\r\n            background: var(--color-primary);\r\n            width: 0;\r\n            height: 2px;\r\n            transition: 0.3s;\r\n            right: 0;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        span {\r\n            color: var(--color-primary);\r\n            &::before {\r\n                width: 100%;\r\n                left: 0;\r\n                right: auto;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.rn-badge {\r\n    display: inline-block;\r\n    background-color: var(--color-primary);\r\n    padding: 0 16px;\r\n    height: 30px;\r\n    line-height: 30px;\r\n    border-radius: 100px;\r\n    color: #fff;\r\n    font-size: 12px;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n.rn-badge-card {\r\n    background-color: transparent;\r\n    background: transparent;\r\n    padding: 1px 10px;\r\n    border-radius: 100px;\r\n    color: #fff;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    display: inline-block;\r\n    position: relative;\r\n    z-index: 2;\r\n    letter-spacing: 0.5px;\r\n    &::before {\r\n        background: linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 95%/200% 100%;\r\n        content: \"\";\r\n        width: 100%;\r\n        height: 100%;\r\n        left: 0;\r\n        top: 0;\r\n        position: absolute;\r\n        z-index: -1;\r\n        border-radius: 100px;\r\n        opacity: 0.5;\r\n    }\r\n}\r\n\r\n.btn.disabled, \r\n.btn:disabled, \r\nfieldset:disabled .btn {\r\n    border: 0 none;\r\n    color: #fff;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n","/*====================\r\n    Breadcrump Area \r\n======================*/\r\n.breadcarumb-style-1 {\r\n    border-bottom: 1px solid var(--color-border);\r\n}\r\n\r\n.breadcrumb-inner {\r\n    text-align: center;\r\n    .title {\r\n\r\n        br {\r\n            @media #{md-layout} {\r\n                display: none;\r\n            }\r\n            @media #{sm-layout} {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n    ul {\r\n        &.page-list {\r\n            @extend %liststyle;\r\n            margin-top: 16px;\r\n            li {\r\n                display: inline-block;\r\n                color: var(--color-body);\r\n                padding: 0 12px;\r\n                position: relative;\r\n                font-size:20px;\r\n                margin: 0;\r\n\r\n                &::after {\r\n                    position: absolute;\r\n                    content: \"\";\r\n                    top: 50%;\r\n                    transform: translateY(-50%);\r\n                    background-color: var(--color-body);\r\n                    width: 5px;\r\n                    height: 5px;\r\n                    border-radius: 100%;\r\n                    opacity: 0.5;\r\n                    right: -3px;\r\n                }\r\n                a {\r\n                    color: var(--color-body);\r\n                    transition: 0.5s;\r\n                    &:hover {\r\n                        color: var(--color-primary);\r\n                    }\r\n                }\r\n                &.rn-breadcrumb-item {\r\n                    font-weight: 500;\r\n                    &.active {\r\n                        color: var(--color-primary);\r\n                       font-weight: 500;\r\n                        &::after {\r\n                            display: none;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","/*--------------------------\r\n    Accordion Styles  \r\n---------------------------*/\r\n\r\n.rn-accordion-style {\r\n    .card {\r\n        background: var(--color-lessdark);\r\n        border: 0;\r\n        border-radius: var(--radius) !important;\r\n        .card-header {\r\n            background-color: transparent;\r\n            border-bottom: 0 none;\r\n            box-shadow: none;\r\n            padding: 20px 30px;\r\n            margin-bottom: 0;\r\n            button {\r\n                color: var(--color-heading);\r\n                font-size: 18px;\r\n                outline: none;\r\n                text-decoration: none;\r\n                box-shadow: none;\r\n                width: 100%;\r\n                text-align: left;\r\n                padding: 0;\r\n            }\r\n        }\r\n        .card-body {\r\n            padding-top: 0;\r\n            font-size: var(--font-size-b2);\r\n            line-height: var(--line-height-b2);\r\n            font-weight: var(--p-regular);\r\n            color: var(--color-body);\r\n            padding: 30px 20px;\r\n            border-top: 1px solid var(--color-border);\r\n        }\r\n        & + .card {\r\n            margin-top: 20px;\r\n        }\r\n    }\r\n\r\n    &.rn-accordion-02 {\r\n        .card {\r\n            background: transparent !important;\r\n            border-radius: 0 !important;\r\n            .card-header {\r\n                border-bottom: 2px solid var(--color-border);\r\n                padding: 0px 20px 10px 0;\r\n            }\r\n            .card-body {\r\n                padding: 15px 20px 10px 0;\r\n                border: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    &.rn-accordion-03 {\r\n        .card {\r\n            background: transparent !important;\r\n            border-radius: 0 !important;\r\n\r\n            .card-header {\r\n                border: 2px solid var(--color-border);\r\n                padding: 15px 20px;\r\n                border-radius: var(--radius) !important;\r\n            }\r\n            .card-body {\r\n                padding: 15px 20px 10px 0;\r\n                border: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.rn-accordion-04 {\r\n        .card {\r\n            border: 2px solid var(--color-border);\r\n            background: transparent !important;\r\n            border-radius: var(--radius) !important;\r\n            .card-header {\r\n                padding: 15px 20px;\r\n                border-radius: var(--radius) !important;\r\n            }\r\n            .card-body {\r\n                border: 0;\r\n                border-top: 2px solid var(--color-border);\r\n            }\r\n        }\r\n    }\r\n}\r\n","/*--------------------\r\n    Service Styles  \r\n----------------------*/\r\n.service {\r\n    &.service__style--1 {\r\n        padding: 50px 35px;\r\n        padding-bottom: 55px;\r\n        transition: transform 0.65s cubic-bezier(0.05, 0.2, 0.1, 1),box-shadow 0.65s cubic-bezier(0.05, 0.2, 0.1, 1);\r\n        position: relative;\r\n        z-index: 2;\r\n        @media #{$laptop-device} {\r\n            padding: 30px 28px;\r\n        }\r\n        @media #{$md-layout} {\r\n            padding: 30px 25px;\r\n        }\r\n        @media #{$sm-layout} {\r\n            padding: 30px 14px;\r\n        }\r\n      \r\n        .icon {\r\n            @extend %transition;\r\n            font-size: 45px;\r\n            font-weight: 400;\r\n            margin-bottom: 23px;\r\n            color: var(--color-primary);\r\n            text-align: center;\r\n            border-radius: 100%;\r\n            display: flex;\r\n            justify-content: center;\r\n            \r\n            @media #{$md-layout} {\r\n                margin-bottom: 11px;\r\n            }\r\n            svg {\r\n                stroke-width: 1 !important;\r\n            }\r\n        }\r\n\r\n        .content {\r\n            .title {\r\n                margin-bottom: 19px;\r\n                @extend %transition;\r\n                @media #{$md-layout} {\r\n                    margin-bottom: 8px;\r\n                }\r\n                a {\r\n                    color: inherit;\r\n                    @extend %transition;\r\n                    &:hover {\r\n                        color: var(--color-primary);\r\n                    }\r\n                }\r\n            }\r\n            p {\r\n                @extend %transition;\r\n            }\r\n        }\r\n\r\n        &:hover{\r\n            transform: translateY(-5px);\r\n        }\r\n\r\n        &.rbt-border {\r\n            border: 1px solid var(--color-border);\r\n        }\r\n\r\n        &.text-start {\r\n            padding: 50px;\r\n            @media #{$laptop-device} {\r\n                padding: 40px 30px;\r\n            }\r\n            @media #{$lg-layout} {\r\n                padding: 40px 30px;\r\n            }\r\n            @media #{$md-layout} {\r\n                padding: 40px 30px;\r\n            }\r\n            @media #{$sm-layout} {\r\n                padding: 30px 20px;\r\n            }\r\n          \r\n            .icon {\r\n                justify-content: left;\r\n            }\r\n        }\r\n\r\n        &.icon-circle-style {\r\n            background-color: transparent;\r\n            box-shadow: none;\r\n            padding: 0px 35px;\r\n            margin-top: 25px;\r\n\r\n            @media #{$md-layout} {\r\n                padding: 0px 10px;\r\n            }\r\n\r\n            @media #{$sm-layout} {\r\n                padding: 0px 10px;\r\n            }\r\n\r\n            .icon {\r\n                font-size: 39px;\r\n                color: var(--color-primary);\r\n                display: flex;\r\n                justify-content: center;\r\n                width: 90px;\r\n                height: 90px;\r\n                margin: 0 auto;\r\n                margin-bottom: 23px;\r\n                background-color: var(--color-primary-darker);\r\n                line-height: 90px;\r\n                align-items: center;\r\n            }\r\n        }\r\n\r\n        &.with-working-process {\r\n            position: relative;\r\n            @media #{$lg-layout} {\r\n                padding: 20px 0;\r\n            }\r\n            .icon {\r\n                width: 180px;\r\n                height: 180px;\r\n                line-height: 180px;\r\n                font-size: 60px;\r\n                position: relative;\r\n            }\r\n            .line {\r\n                position: absolute;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n                height: 1px;\r\n                width: 100%;\r\n                left: 100%;\r\n                background-color: var(--color-border);\r\n                @media #{$md-layout} {\r\n                    display: none;\r\n                }\r\n                @media #{$sm-layout} {\r\n                    display: none;\r\n                }\r\n            }\r\n            &:hover {\r\n                transform: none;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    &.gallery-style {\r\n        padding: 40px 30px;\r\n        background: var(--color-blackest);\r\n        border-radius: 24px;\r\n        box-shadow: 0px 1px 1px rgba(255, 255, 255, 0.1);\r\n        margin-top: 30px;\r\n        .content {\r\n            .image {\r\n                img {\r\n                    border-radius: 5px;\r\n                }\r\n            }\r\n            .title {\r\n                margin-bottom: 19px;\r\n                font-weight: 600;\r\n                font-size: 20px;\r\n                @extend %transition;\r\n                margin-bottom: 10px;\r\n                a {\r\n                    color: inherit;\r\n                    @extend %transition;\r\n                    &:hover {\r\n                        color: var(--color-primary);\r\n                    }\r\n                }\r\n            }\r\n            p {\r\n                @extend %transition;\r\n                color: var(--color-body);\r\n                margin-bottom: 20px;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    &.service__style--2 {\r\n        padding: 50px 35px;\r\n        padding-bottom: 55px;\r\n        transition: transform 0.65s cubic-bezier(0.05, 0.2, 0.1, 1),box-shadow 0.65s cubic-bezier(0.05, 0.2, 0.1, 1);\r\n        position: relative;\r\n        z-index: 2;\r\n        border-radius: 10px;\r\n        margin-top: 30px;\r\n\r\n        @media #{$laptop-device} {\r\n            padding: 10px 28px;\r\n        }\r\n\r\n        @media #{$lg-layout} {\r\n            padding: 10px 15px;\r\n        }\r\n\r\n        @media #{$md-layout} {\r\n            padding: 10px 25px;\r\n        }\r\n\r\n        @media #{$sm-layout} {\r\n            padding: 0px 18px;\r\n        }\r\n        .image {\r\n            margin-bottom: 23px;\r\n            img {\r\n                max-height: 220px;\r\n            }\r\n        }\r\n        .content {\r\n            .title {\r\n                @extend %transition;\r\n                a {\r\n                    color: inherit;\r\n                    @extend %transition;\r\n                    &:hover {\r\n                        color: var(--color-primary);\r\n                    }\r\n                }\r\n            }\r\n            p {\r\n                @extend %transition;\r\n                padding: 0 5%;\r\n            }\r\n        }\r\n        &:hover{\r\n            transform: translateY(-5px);\r\n            box-shadow: 0 0 39px rgba(255, 101, 80, 0.1);\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.service-wrapper {\r\n    &>[class*=col] {\r\n        &:nth-child(1)  {\r\n            .service {\r\n                &.service__style--1 {\r\n                    .icon {\r\n                        color: var(--color-primary);\r\n                        color: white;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        &:nth-child(2)  {\r\n            .service {\r\n                &.service__style--1 {\r\n                    .icon {\r\n                        color: var(--color-primary);\r\n                        color: white;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        &:nth-child(3)  {\r\n            .service {\r\n                &.service__style--1 {\r\n                    .icon {\r\n                        color: var(--color-primary);\r\n                        color: white;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        &:nth-child(4)  {\r\n            .service {\r\n                &.service__style--1 {\r\n                    .icon {\r\n                        color: var(--color-primary);\r\n                        color: white;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &>[class*=col] {\r\n        &:nth-child(1)  {\r\n            .service {\r\n                &.service__style--1 {\r\n                    &.icon-circle-style {\r\n                        .icon {\r\n                            background-color: #1e3b71;\r\n                        }\r\n                    }\r\n                    \r\n                }\r\n            }\r\n        }\r\n        &:nth-child(2)  {\r\n            .service {\r\n                &.service__style--1 {\r\n                    &.icon-circle-style {\r\n                        .icon {\r\n                            background-color: #1e3b71;\r\n                        }\r\n                    }\r\n                    \r\n                }\r\n            }\r\n        }\r\n\r\n        &:nth-child(3)  {\r\n            .service {\r\n                &.service__style--1 {\r\n                    &.icon-circle-style {\r\n                        .icon {\r\n                            background-color: #1e3b71;\r\n                        }\r\n                    }\r\n                    \r\n                }\r\n            }\r\n        }\r\n\r\n        &:nth-child(4)  {\r\n            .service {\r\n                &.service__style--1 {\r\n                    &.icon-circle-style {\r\n                        .icon {\r\n                            background-color: #1e3b71;\r\n                        }\r\n                    }\r\n                    \r\n                }\r\n            }\r\n        }\r\n\r\n        &:last-child {\r\n            .with-working-process {\r\n                \r\n                .line {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n\r\n\r\n\r\n    }\r\n}\r\n\r\n\r\n","/*\r\n Card Styles  \r\n*/\r\n.card-box {\r\n    &.card-style-1 {\r\n        box-shadow: var(--shadow-lighter);\r\n        background-color: var(--color-blackest);\r\n        padding: 20px;\r\n        border-radius: 5px;\r\n        margin-top: 30px;\r\n        .inner {\r\n            .image {\r\n                img {\r\n                    border-radius: 5px;\r\n                }\r\n            }\r\n            .content {\r\n                padding-top: 20px;\r\n                .title {\r\n                    font-size: 18px;\r\n                    font-weight: 500;\r\n                    margin-bottom: 14px;\r\n                    a {\r\n                        color: inherit;\r\n                        @extend %transition;\r\n                        &:hover {\r\n                            color: var(--color-primary);\r\n                        }\r\n                    }\r\n                }\r\n                .description {\r\n                    margin-bottom: 0;\r\n                }\r\n                .btn-default {\r\n                    margin-top: 20px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n","/*-----------------------\r\n    Progress Bar \r\n-----------------------*/\r\n.single-progress  {\r\n    & + .single-progress {\r\n        margin-top: 40px;\r\n    }\r\n}\r\n.progress {\r\n    height: 6px;\r\n    overflow: hidden;\r\n    background-color: var(--color-blackest);\r\n    border-radius: 10px;\r\n    .progress-bar {\r\n        border-radius: 10px;\r\n        width: 0;\r\n        height: 100%;\r\n        background-color: var(--color-black);\r\n        transition: width .5s ease;\r\n    }\r\n}\r\n\r\n.progress-info {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-bottom: 18px;\r\n    .title {\r\n        font-size: 18px;\r\n        font-weight: 400;\r\n        margin-bottom: 0;\r\n        color: var(--color-body);\r\n        letter-spacing: 0.5px;\r\n    }\r\n    span {\r\n        &.progress-number {\r\n            font-size: 14px;\r\n            color: var(--color-body);\r\n        }\r\n    }\r\n}\r\n\r\n.no-radius {\r\n    .progress {\r\n        border-radius: 0;\r\n        .progress-bar {\r\n            border-radius: 0;\r\n        }\r\n    }\r\n}\r\n.large-size {\r\n    .progress {\r\n        height: 20px;\r\n       \r\n    }\r\n}\r\n\r\n/*--------------------\r\n    Rwt Circle \r\n---------------------*/\r\n.rwt-circle {\r\n    .circle-info {\r\n        padding-top: 20px;\r\n        .title {\r\n            font-size: 20px;\r\n            font-weight: 400;\r\n            margin-bottom: 4px;\r\n        }\r\n        .subtitle {\r\n            font-style: italic;\r\n            margin-bottom: 0;\r\n            font-size: 14px;\r\n            letter-spacing: 0.5px;\r\n        }\r\n    }\r\n}\r\n\r\n","/* Counter Style One  */\r\n\r\n.counter-style-1 {\r\n    .count-number {\r\n        @extend .theme-gradient;\r\n        font-size: 90px;\r\n        @media #{$md-layout} {\r\n            font-size: 60px;\r\n            margin-bottom: -5px;\r\n            display: block;\r\n        }\r\n        @media #{$sm-layout} {\r\n            font-size: 60px;\r\n            margin-bottom: -5px;\r\n            display: block;\r\n        }\r\n    }\r\n    .title {\r\n        font-size: 20px;\r\n        line-height: 1.3em;\r\n        font-weight: 500;\r\n        margin-top: 0;\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n\r\n\r\n\r\n.counter-style-2 {\r\n    margin-top: 30px;\r\n    @media #{$large-mobile} {\r\n        text-align: center !important;\r\n    }\r\n    .count-number {\r\n        font-size: 44px;\r\n        background-color: var(--color-blackest);\r\n        display: inline-block;\r\n        min-width: 150px;\r\n        height: 150px;\r\n        border-radius: 100%;\r\n        text-align: center;\r\n        line-height: 150px;\r\n        margin-bottom: 20px;\r\n        padding: 0 20px;\r\n        font-weight: 500;\r\n        color: var(--color-white);\r\n    }\r\n\r\n    .title {\r\n        font-size: 20px;\r\n        line-height: 1.3em;\r\n        font-weight: 500;\r\n        margin-top: 0;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .description {\r\n        line-height: 1.8;\r\n        padding-right: 16%;\r\n        margin: 0;\r\n        @media #{$large-mobile} {\r\n            padding-right: 0;\r\n        }\r\n    }\r\n\r\n    &.color-variation { \r\n        .count-number {\r\n            background-color: var(--color-primary-darker);\r\n            color: var(--color-primary);\r\n        }\r\n    }\r\n\r\n    &.border-style {\r\n        .count-number {\r\n            background-color: transparent;\r\n            border: 2px solid var(--color-border);\r\n        }\r\n    }\r\n    \r\n    &.text-center {\r\n        .description {\r\n            padding: 0 10%;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n[class*=col]:nth-child(2) {\r\n    .counter-style-2 {\r\n        &.color-variation { \r\n            .count-number {\r\n                background-color: var(--color-secondary-darker);\r\n                color: var(--color-secondary);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n[class*=col]:nth-child(3) {\r\n    .counter-style-2 {\r\n        &.color-variation { \r\n            .count-number {\r\n                background-color: var(--color-light-green-darker);\r\n                color: var(--color-light-green);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*------------------------------\r\n    Counterup Style Four  \r\n-------------------------------*/\r\n.counter-style-4 {\r\n    text-align: left;\r\n    margin-top: 30px;\r\n    .counter-title {\r\n        margin-top: 8px;\r\n        font-weight: 400;\r\n        font-size: 24px;\r\n    }\r\n    .count-number {\r\n        font-size: 35px;\r\n        line-height: 1.2;\r\n        font-weight: 700;\r\n        color: var(--color-primary);\r\n        display: inline-block;\r\n        position: relative;\r\n        &::after {\r\n            content: \"+\";\r\n        }\r\n        span {\r\n            display: inline-block;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n","/*---------------------\r\n    Portfolio Styles  \r\n-----------------------*/\r\n\r\n.rwt-card {\r\n  overflow: hidden;\r\n  @extend %transition;\r\n  .inner {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    .thumbnail {\r\n      position: relative;\r\n\r\n      .card-image {\r\n        overflow: hidden;\r\n\r\n        a {\r\n          display: block;\r\n          overflow: hidden;\r\n          @extend %radius-small;\r\n        }\r\n\r\n        img {\r\n          overflow: hidden;\r\n          @extend %transition;\r\n          @extend %radius-small;\r\n        }\r\n      }\r\n\r\n      .rwt-overlay {\r\n        opacity: 0;\r\n        position: absolute;\r\n        bottom: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        transition: opacity 0.65s, transform 0.65s;\r\n        transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\r\n        background: -webkit-linear-gradient(\r\n          0deg,\r\n          var(--color-primary-rgba) 0.3184713375796178%,\r\n          rgba(255, 255, 255, 0.36) 100%\r\n        );\r\n        background: linear-gradient(\r\n          0deg,\r\n          var(--color-primary-rgba) 0.3184713375796178%,\r\n          rgba(255, 255, 255, 0.36) 100%\r\n        );\r\n        color: rgba(255, 255, 255, 0);\r\n        display: block;\r\n        @extend %radius-small;\r\n      }\r\n    }\r\n\r\n    .content {\r\n      padding-top: 20px;\r\n\r\n      .title {\r\n        a {\r\n          @extend %transition;\r\n        }\r\n      }\r\n\r\n      .subtitle {\r\n      }\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    transform: translateY(-4px);\r\n\r\n    .inner {\r\n      .thumbnail {\r\n        .card-image {\r\n          img {\r\n            transform: scale(1.05);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* No Overlay  */\r\n.no-overlay {\r\n  .rwt-card {\r\n    .inner {\r\n      .thumbnail {\r\n        .rwt-overlay {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* Box Grid Layout  */\r\n.filterImage {\r\n // filter: sepia(100%) hue-rotate(190deg) saturate(500%);\r\n// filter: blur(3.5px);\r\n  display:flex ;\r\n  justify-content: center;\r\n  width: 290px;\r\n  height: 290px;\r\n}\r\n.serviceCard{\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.center{\r\n  text-align: center !important;\r\n}\r\n.title2 {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 1;\r\n  color: white !important;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  font-size: 28px;\r\n  text-shadow: 0.02em 0.02em 0 blue, 0 0 0.5em #345085;\r\n}\r\n.img-fluid {\r\n  max-width: 100%;\r\n  height: auto;\r\n  z-index: 0;\r\n}\r\n.box-grid-layout {\r\n  .rwt-card {\r\n    border-radius: var(--radius-small);\r\n    background-color: var(--color-blackest);\r\n\r\n    .inner {\r\n      .thumbnail {\r\n        .card-image {\r\n          position: relative;\r\n          a {\r\n            border-radius: var(--radius-small) var(--radius-small) 0 0;\r\n\r\n            img {\r\n              border-radius: var(--radius-small) var(--radius-small) 0 0;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .content {\r\n        padding: 25px;\r\n        .title {\r\n          color: var(--color-heading);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/*-----------------------------\r\n    Filter Button Style  \r\n-------------------------------*/\r\n\r\n.filter-button-default {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  li {\r\n    button {\r\n      border: 0 none;\r\n      padding: 10px 20px;\r\n      text-transform: capitalize;\r\n      background: transparent;\r\n      color: var(--color-body);\r\n      @extend %radius-small;\r\n      @extend %transition;\r\n      margin: 0 5px;\r\n      &.current,\r\n      &:hover {\r\n        background-color: var(--color-primary);\r\n        color: var(--color-white) !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* Portfolio Read More Icon  */\r\n.rwt-load-more {\r\n  a,\r\n  button {\r\n    &.btn-default {\r\n      &.btn-icon {\r\n        .icon {\r\n          top: -1px;\r\n          margin-left: 4px;\r\n\r\n          svg {\r\n            width: 14px;\r\n            height: 20px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","/*-----------------------\r\n    Social Icons \r\n-------------------------*/\r\n.social-default {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n    justify-content: center;\r\n    margin: -5px;\r\n\r\n    li {\r\n        margin: 5px;\r\n\r\n        a {\r\n            width: 48px;\r\n            background: var(--color-blackest);\r\n            height: 48px;\r\n            text-align: center;\r\n            line-height: 46px;\r\n            display: inline-block;\r\n            border-radius: 100%;\r\n            transition: 0.3s;\r\n            color: var(--color-white);\r\n            z-index: 2;\r\n            position: relative;\r\n\r\n            &::after {\r\n                position: absolute;\r\n                content: \"\";\r\n                left: 0;\r\n                top: 0;\r\n                width: 100%;\r\n                height: 100%;\r\n                z-index: -1;\r\n                background: var(--color-primary);\r\n                transform: scale(0.5);\r\n                opacity: 0;\r\n                transition: 0.3s;\r\n                border-radius: 100%;\r\n            }\r\n\r\n            &:hover {\r\n                color: var(--color-white);\r\n\r\n                &::after {\r\n                    transform: scale(1);\r\n                    opacity: 1;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.color-lessdark {\r\n        li {\r\n            a {\r\n                background-color: var(--color-lessdark);\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n\r\n    &.transparent-with-border {\r\n        li {\r\n            a {\r\n                line-height: 45px;\r\n                background: transparent;\r\n                border: 1px solid var(--color-border);\r\n\r\n                &:hover {\r\n                    border-color: transparent;\r\n                }\r\n\r\n                &::after {\r\n                    border: 1px solid var(--color-primary);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.with-gradient {\r\n        li {\r\n            a {\r\n                &::after {\r\n                    background: linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98%/200% 100%;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.with-bg-primary {\r\n        li {\r\n            a {\r\n                background-color: var(--color-primary) !important;\r\n                border: 2px solid var(--color-primary);\r\n                transition: 0.5s;\r\n                line-height: 44px;\r\n                color: #fff !important;\r\n\r\n                &::after {\r\n                    display: none;\r\n                }\r\n\r\n                &:hover {\r\n                    background-color: transparent;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    &.icon-naked {\r\n        li {\r\n            a {\r\n                background: transparent !important;\r\n                width: 30px;\r\n                height: 30px;\r\n                line-height: 36px;\r\n                &::after {\r\n                    display: none;\r\n                }\r\n                &:hover {\r\n                    color: var(--color-primary) !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","/*----------------------\r\n    Team Style  \r\n-------------------------*/\r\n.rn-box-card,\r\n.team-style-default {\r\n    margin-top: 75px;\r\n    .inner {\r\n        background: linear-gradient(180deg,var(--color-lessdark) 20%,rgba(19,19,19,.4));\r\n        -webkit-backdrop-filter: blur(4px) opacity(.95);\r\n        backdrop-filter: blur(4px) opacity(.95);\r\n        border-radius: var(--radius-big);\r\n\r\n        .thumbnail {\r\n            max-width: 150px;\r\n            max-height: 150px;\r\n            border-radius: 100%;\r\n            border: 6px solid var(--color-lessdark);\r\n            top: -75px;\r\n            position: absolute;\r\n            left: 50%;\r\n            transform: translateX(-50%);\r\n            min-width: 150px;\r\n            min-height: 150px;\r\n            overflow: hidden;\r\n            img {\r\n                border-radius: 100%;\r\n            }\r\n        }\r\n\r\n        .content {\r\n            text-align: center;\r\n            padding: 20px;\r\n            padding-top: 85px;\r\n            padding-bottom: 35px;\r\n\r\n            .title {\r\n                font-size: 34px;\r\n                line-height: 1.4;\r\n                font-weight: 700;\r\n                margin-bottom: 6px;\r\n            }\r\n            .subtitle {\r\n                font-size: 20px;\r\n                line-height: 1.4;\r\n                margin-bottom: 15px;\r\n                display: inline-block;\r\n            }\r\n            .team-form {\r\n                display: block;\r\n                font-size: 14px;\r\n                margin-bottom: 12px;\r\n                letter-spacing: 0.6px;\r\n                font-style: italic;\r\n\r\n                img {\r\n                    padding-right: 10px;\r\n                    max-height: 18px;\r\n                }\r\n            }\r\n            .description {\r\n                margin-bottom: 0;\r\n                padding: 0 5%;\r\n            }\r\n        }\r\n\r\n        .social-icon {\r\n            li {\r\n                a {\r\n                    color: var(--color-body);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.border-gradient {\r\n        .thumbnail {\r\n            background: linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98%/200% 100%;\r\n            padding: 5px;\r\n            border: 0 none;\r\n        }\r\n    }\r\n\r\n    &.style-two {\r\n        margin-top: 30px;\r\n        .inner {\r\n            padding-top: 35px;\r\n            .thumbnail {\r\n                top: 0;\r\n                position: static;\r\n                left: inherit;\r\n                transform: none;\r\n                min-width: 150px;\r\n                min-height: 150px;\r\n                margin: 0 auto;\r\n            }\r\n            .content {\r\n                padding-top: 10px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*---------------------\r\n    Team Style Two  \r\n-----------------------*/\r\n.team-style-two {\r\n    .inner {\r\n        .thumbnail {\r\n            img {\r\n                width: 100%;\r\n                border-radius: var(--radius);\r\n            }\r\n        }\r\n        .content {\r\n            padding-top: 20px;\r\n            .title {\r\n                font-size: 28px;\r\n                line-height: 1.4;\r\n                font-weight: 500;\r\n                margin-bottom: 0;\r\n\r\n            }\r\n            .subtitle {\r\n                font-size: 18px;\r\n                line-height: 1.4;\r\n                display: inline-block;\r\n                margin-top: 4px;\r\n                margin-bottom: 0;\r\n                opacity: 0;\r\n                transform: translateX(30px);\r\n                transition: transform .45s cubic-bezier(.16,.32,.26,.92),opacity .45s ease-out;\r\n                transition-delay: .15s;\r\n            }\r\n            .team-form {\r\n                display: block;\r\n                font-size: 14px;\r\n                letter-spacing: 0.6px;\r\n                font-style: italic;\r\n                margin-top: 11px;\r\n                img {\r\n                    padding-right: 10px;\r\n                    max-height: 18px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        .inner {\r\n            .content {\r\n                \r\n\r\n                .subtitle {\r\n                    opacity: 1;\r\n                    transform: none;\r\n                }\r\n\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*---------------------\r\n    Team Style Three  \r\n-----------------------*/\r\n\r\n.team-style-three {\r\n    .inner {\r\n        position: relative;\r\n        .thumbnail {\r\n            img {\r\n                width: 100%;\r\n                border-radius: var(--radius);\r\n            }\r\n        }\r\n        .content {\r\n            position: absolute;\r\n            bottom: 0;\r\n            padding: 20px;\r\n            width: 100%;\r\n            transition: all 0.3s;\r\n            opacity: 0;\r\n\r\n            .team-info {\r\n                padding: 20px;\r\n                background-color: rgba(58,58,58,0.85);\r\n                border-radius: var(--radius-small);\r\n            }\r\n\r\n            .title {\r\n                font-size: 17px;\r\n                line-height: 25px;\r\n                color: var(--color-heading);\r\n                margin-bottom: 4px;\r\n            }\r\n            .subtitle {\r\n                font-size: 16px;\r\n                line-height: 25px;\r\n                margin-bottom: 4px;\r\n            }\r\n            .team-form {\r\n                display: block;\r\n                font-style: italic;\r\n                font-size: 14px;\r\n                color: #ADADAD;\r\n                letter-spacing: 0.5px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        .inner {\r\n            .content {\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n","/* -----------------------\r\nTimeline Area  \r\n--------------------------*/\r\n.timeline-line {\r\n    position: absolute;\r\n    z-index: 0;\r\n    top: 0;\r\n    left: 0;\r\n    width: 4px;\r\n    height: 100%;\r\n    background: hsla(0, 0%, 76.9%, .22);\r\n\r\n    &::before,\r\n    &::after {\r\n        content: \"\";\r\n        display: block;\r\n        position: absolute;\r\n        width: 100%;\r\n    }\r\n\r\n    &::before {\r\n        height: 100%;\r\n        bottom: 0;\r\n        background: linear-gradient(180deg, var(var(--color-blackest)), rgba(19, 19, 19, 0));\r\n    }\r\n\r\n    &::after {\r\n        height: 200px;\r\n        top: 0;\r\n        background: linear-gradient(180deg, var(var(--color-blackest)), rgba(19, 19, 19, 0));\r\n    }\r\n}\r\n\r\n\r\n.timeline-dot {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 0;\r\n\r\n    &::before,\r\n    &::after {\r\n        content: \"\";\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        display: block;\r\n        border-radius: 50%;\r\n        -webkit-transform: translate(-50%, -50%);\r\n        transform: translate(-50%, -50%);\r\n    }\r\n\r\n    &::before {\r\n        z-index: 1;\r\n        width: 2.1rem;\r\n        height: 2.1rem;\r\n        border-radius: 50%;\r\n        background: linear-gradient(180deg, var(--color-primary-light), var(--color-primary));\r\n        box-shadow: 0 0 15px rgba(82, 56, 255, 0.50);\r\n    }\r\n\r\n    &::after {\r\n        border: 5px solid var(var(--color-blackest));\r\n        background: radial-gradient(50% 50% at 50% 50%, var(--color-lessdark) 48.96%, var(--color-lessdark) 100%);\r\n        z-index: 0;\r\n        width: 31px;\r\n        height: 31px;\r\n    }\r\n\r\n    .time-line-circle {\r\n        position: absolute;\r\n        top: 50%;\r\n        border-radius: 50%;\r\n        left: 50%;\r\n        width: 100px;\r\n        height: 100px;\r\n        background: radial-gradient(50% 50% at 50% 50%, rgba(242, 201, 76, 0) 40.62%, rgba(82, 56, 255, .5) 100%);\r\n        -webkit-transform: translate(-50%, -50%);\r\n        transform: translate(-50%, -50%);\r\n        will-change: transform;\r\n        -webkit-animation: radialanimation 2.2s cubic-bezier(.26, 1.04, .54, 1) infinite;\r\n        animation: radialanimation 2.2s cubic-bezier(.26, 1.04, .54, 1) infinite;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n/*------------------------------\r\n    Single Timeline Styles  \r\n-------------------------------*/\r\n.single-timeline {\r\n    position: relative;\r\n    padding-left: 100px;\r\n\r\n    @media #{$md-layout} {\r\n        padding-left: 50px;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        padding-left: 30px;\r\n    }\r\n\r\n    .single-content {\r\n        background: linear-gradient(180deg, var(--color-lessdark) 20%, rgba(19, 19, 19, 0.4));\r\n        -webkit-backdrop-filter: blur(4px) opacity(0.95);\r\n        backdrop-filter: blur(4px) opacity(0.95);\r\n        border-radius: var(--radius-big);\r\n\r\n        .inner {\r\n            padding: 50px;\r\n            @media #{$md-layout} {\r\n                padding: 30px;\r\n            }\r\n            @media #{$sm-layout} {\r\n                padding: 20px;\r\n            }\r\n            .content {\r\n                .date-of-timeline {\r\n                    color: var(--color-body);\r\n                    display: block;\r\n                    margin-bottom: 30px;\r\n                    letter-spacing: 0.5px;\r\n                    font-style: italic;\r\n                    font-size: 14px;\r\n\r\n                    @media #{$md-layout} {\r\n                        margin-bottom: 14px;\r\n                    }\r\n                    @media #{$sm-layout} {\r\n                        margin-bottom: 14px;\r\n                    }\r\n                }\r\n                .title {\r\n                    margin-bottom: 0;\r\n                    @media #{$lg-layout} {\r\n                        font-size: 32px;\r\n                    }\r\n                }\r\n                .description {\r\n                    margin-top: 30px;\r\n                    @media #{$md-layout} {\r\n                        margin-top: 20px;\r\n                    }\r\n                    @media #{$sm-layout} {\r\n                        margin-top: 15px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .thumbnail {\r\n            img {\r\n                border-radius: var(--radius);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@-webkit-keyframes radialanimation {\r\n    0% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(-50%, -50%, 0) scale(0.1);\r\n        transform: translate3d(-50%, -50%, 0) scale(0.1);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-50%, -50%, 0) scale(1);\r\n        transform: translate3d(-50%, -50%, 0) scale(1);\r\n    }\r\n}\r\n\r\n@keyframes radialanimation {\r\n    0% {\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(-50%, -50%, 0) scale(0.1);\r\n        transform: translate3d(-50%, -50%, 0) scale(0.1);\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n        -webkit-transform: translate3d(-50%, -50%, 0) scale(1);\r\n        transform: translate3d(-50%, -50%, 0) scale(1);\r\n    }\r\n}\r\n\r\n/*----------------------------\r\n    Timeline Style Two  \r\n----------------------------*/\r\n.timeline-style-two {\r\n    position: relative;\r\n    padding: 20px 50px 50px 50px;\r\n    border-radius: var(--radius-big);\r\n}\r\n\r\n.rn-timeline-single {\r\n    margin-top: 30px;\r\n\r\n    .rn-timeline {\r\n        text-align: center;\r\n\r\n        .progress-line {\r\n            position: relative;\r\n            border-radius: 0px;\r\n            height: 6px;\r\n            box-shadow: none;\r\n            margin: 20px 0;\r\n            width: 100%;\r\n           \r\n\r\n            .line-inner {\r\n                flex-direction: column;\r\n                justify-content: center;\r\n                overflow: hidden;\r\n                text-align: center;\r\n                white-space: nowrap;\r\n                transition: width .6s ease;\r\n                background-image: radial-gradient(circle farthest-corner at 0.0%, var(--color-pink) 25%, var(--color-secondary) 45%, var(--color-primary-light) 65%, var(--color-light-green) 85%);\r\n                background-attachment: fixed;\r\n                background-repeat: repeat-y;\r\n                width: 100%;\r\n                display: flex;\r\n                height: 100%;\r\n                @media #{$sm-layout} {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n\r\n        .progress-dot {\r\n            position: relative;\r\n            height: 30px;\r\n            display: block;\r\n            width: 100%;\r\n            margin-top: -39px;\r\n            margin-left: -15px;\r\n\r\n            .dot-level {\r\n                transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);\r\n                background: linear-gradient(to right, var(--color-primary), var(--color-secondary), var(--color-primary-light));\r\n                background-attachment: fixed;\r\n                background-repeat: repeat-y;\r\n                position: absolute;\r\n                width: 28px;\r\n                height: 28px;\r\n                display: block;\r\n                display: inline-block;\r\n                text-align: center;\r\n                border-radius: 50%;\r\n\r\n                .dot-inner {\r\n                    width: 12px;\r\n                    height: 12px;\r\n                    border-radius: 50px;\r\n                    position: absolute;\r\n                    top: 8px;\r\n                    left: 8px;\r\n                    background-color: var(--color-darkest);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &:first-child {\r\n        .rn-timeline {\r\n            .progress-line {\r\n                width: 50%;\r\n                left: 50%;\r\n            }\r\n        }\r\n    }\r\n    &:last-child {\r\n        .rn-timeline {\r\n            .progress-line {\r\n                width: 50%;\r\n            }\r\n        }\r\n    }\r\n    .title {\r\n        margin-bottom: 33px;\r\n        font-size: 20px;\r\n    }\r\n    .description {\r\n        padding: 0 10%;\r\n        margin-top: 15px;\r\n        margin-bottom: 0;\r\n        @media #{$md-layout} {\r\n            padding: 0 10px;\r\n        }\r\n        @media #{$sm-layout} {\r\n            padding: 0 10px;\r\n        }\r\n    }\r\n\r\n    &.no-gradient {\r\n        .rn-timeline {\r\n\r\n            .progress-line {\r\n                .line-inner {\r\n                    background-image: inherit;\r\n                    background: var(--color-primary);\r\n                }\r\n            }\r\n\r\n            .progress-dot {\r\n                .dot-level {\r\n                    background-image: inherit;\r\n                    background: var(--color-primary);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    &.dark-line {\r\n        .rn-timeline {\r\n            .progress-line {\r\n                .line-inner {\r\n                    background-image: inherit;\r\n                    background: var(--color-lessdark);\r\n                }\r\n            }\r\n\r\n            .progress-dot {\r\n                .dot-level {\r\n                    background-image: inherit;\r\n                    background: var(--color-lessdark);\r\n\r\n                    .dot-inner {\r\n                        background-color: var(--color-primary);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n\r\n}","/*-------------------------\r\n    Testimonial Styles  \r\n--------------------------*/\r\n\r\n.card-style-default {\r\n    &.testimonial-style-one {\r\n        .inner {\r\n            .thumbnail {\r\n                overflow: visible;\r\n                &::after {\r\n                    position: absolute;\r\n                    content: \"”\";\r\n                    width: 40px;\r\n                    height: 40px;\r\n                    border-radius: 100%;\r\n                    background: var(--color-blackest);\r\n                    right: 0;\r\n                    top: 0;\r\n                    color: #fff;\r\n                    z-index: 2;\r\n                    text-align: center;\r\n                    line-height: 58px;\r\n                    font-size: 39px;\r\n                }\r\n            }\r\n            .content {\r\n                .description {\r\n                    margin-bottom: 14px;\r\n                }\r\n                .title {\r\n                    font-size: 20px;\r\n                    font-weight: 500;\r\n                    margin-bottom: 2px;\r\n                    letter-spacing: 0.5px;\r\n                }\r\n                .subtitle {\r\n                    font-size: 16px;\r\n                    line-height: 1.2;\r\n                    margin-bottom: 0;\r\n                    letter-spacing: 0.5px;\r\n                }\r\n            }\r\n        } \r\n        &.style-two {\r\n            .inner {\r\n                .thumbnail {\r\n                    position: relative;\r\n                }\r\n\r\n                .description {\r\n                    margin-bottom: 19px;\r\n                    margin-top: 20px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n/*-----------------------------\r\n    Testimonial Style Two  \r\n-------------------------------*/\r\n\r\n.testimonial-style-two {\r\n    .content {\r\n        position: relative;\r\n        z-index: 2;\r\n        &::after {\r\n            position: absolute;\r\n            content: \"“\";\r\n            left: -20px;\r\n            color: var(--color-lessdark);\r\n            text-align: center;\r\n            font-size: 320px;\r\n            opacity: 0.7;\r\n            line-height: 50px;\r\n            top: 52px;\r\n            z-index: -1;\r\n        }\r\n      \r\n        .form {\r\n            display: block;\r\n            font-size: 18px;\r\n            text-transform: uppercase;\r\n            letter-spacing: 0.5px;\r\n            margin-bottom: 20px;\r\n        }\r\n\r\n        .description {\r\n            line-height: 1.5;\r\n            margin-bottom: 30px;\r\n            font-size: 32px;\r\n\r\n            @media #{$lg-layout} {\r\n                margin-bottom: 25px;\r\n                font-size: 24px;\r\n            }\r\n            @media #{$md-layout} {\r\n                font-size: 24px;\r\n            }\r\n\r\n            @media #{$sm-layout} {\r\n                font-size: 24px;\r\n            }\r\n        }\r\n        .client-info {\r\n            .title {\r\n                font-size: 22px;\r\n                font-weight: 500;\r\n                margin-bottom: 8px;\r\n            }\r\n            .subtitle {\r\n                font-size: 16px;\r\n                margin-bottom: 0;\r\n                font-weight: 400;\r\n                letter-spacing: 0.5px;\r\n                color: var(--color-body);\r\n                font-style: italic;\r\n            }\r\n        }\r\n    }\r\n    .thumbnail {\r\n        background: linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%) 98% / 200% 100%;\r\n        border-radius: 100%;\r\n        padding: 10px;\r\n        img {\r\n            border-radius: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n","/*--------------------------\r\n    Slick Slider Styles   \r\n----------------------------*/\r\n.slick-initialized .slick-slide {\r\n    margin-bottom: 0;\r\n}\r\n\r\n/*----------------------\r\n    Slick Dots  \r\n------------------------*/\r\n.rn-slick-dot {\r\n    .slick-dots {\r\n        bottom: -60px;\r\n        @media #{$large-mobile} {\r\n            bottom: -50px; \r\n        }\r\n        li{\r\n            width: 30px;\r\n            margin: 0;\r\n            opacity: 1;\r\n            position: relative;\r\n            \r\n            button{\r\n                &::before{\r\n                    display: none;\r\n                }\r\n                &::after{\r\n                    background: var(--color-lessdark);\r\n                    width: 100%;\r\n                    display: block;\r\n                    content: '';\r\n                    position: absolute;\r\n                    left: 0;\r\n                    width: 6px;\r\n                    height: 6px;\r\n                    @extend %transition;\r\n                    border-radius: 50%;\r\n                    margin-left: 11px;\r\n                    background-color: transparent;\r\n                    box-shadow: inset 0 0 0 5px var(--color-lessdark);\r\n                }\r\n            }\r\n            &.slick-active{\r\n                opacity: 1;\r\n                button{\r\n                    &::after{\r\n                        -webkit-transform: scale(2);\r\n                        transform: scale(2);\r\n                        box-shadow: inset 0 0 0 1px var(--color-primary);\r\n                        background-color: transparent;\r\n                        background-color: transparent!important;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    // Dot Light  \r\n    &.dot-light {\r\n        .slick-dots {\r\n            li{\r\n                button {\r\n                    &::after {\r\n                        background: #ffffff;\r\n                        box-shadow: inset 0 0 0 5px #ffffff;\r\n                    }\r\n                }\r\n                &.slick-active{\r\n                    opacity: 1;\r\n                    button{\r\n                        &::after{\r\n                            -webkit-transform: scale(2);\r\n                            transform: scale(2);\r\n                            box-shadow: inset 0 0 0 1px var(--color-primary);\r\n                            background-color: transparent;\r\n                            background-color: transparent!important;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/*----------------------\r\n    Slick Arrow  \r\n------------------------*/\r\n.rn-slick-arrow {\r\n    position: relative;\r\n    button {\r\n        &.slick-arrow {\r\n            position: absolute;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n            z-index: 2;\r\n            transition: 0.5s;\r\n            opacity: 0;\r\n            width: 68px;\r\n            height: 68px;\r\n            border: 2px solid var(--color-border);\r\n            border-radius: 100%;\r\n            color: var(--color-border);\r\n\r\n            @media #{$md-layout} {\r\n                display: none !important;\r\n            }\r\n\r\n            @media #{$lg-layout} {\r\n                display: none !important;\r\n            }\r\n\r\n            @media #{$sm-layout} {\r\n                display: none !important;\r\n            }\r\n\r\n            &:hover {\r\n                background: var(--color-primary);\r\n                border-color: var(--color-primary);\r\n            }\r\n\r\n            &::before {\r\n                line-height: 1;\r\n                opacity: 0.4;\r\n                position: relative;\r\n                top: -2px;\r\n                transition: 0.5s;\r\n                z-index: 2;\r\n            }\r\n\r\n            &.slick-prev {\r\n                left: 15px;\r\n                &::before{\r\n                    content: url(../../images/slick-arrow-left-small.png);\r\n                }\r\n                &:hover{\r\n                    left: 10px;\r\n                    &::before{\r\n                        opacity: 1;\r\n                    }\r\n                }\r\n            }\r\n            &.slick-next {\r\n                left: auto;\r\n                right: 15px;\r\n                &::before{\r\n                    content: url(../../images/slick-arrow-right-small.png);\r\n                }\r\n                &:hover {\r\n                    right:10px;\r\n                    &::before{\r\n                        opacity: 1;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        button {\r\n            &.slick-arrow {\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n/* Slick Gutter Space  */\r\n.slick-space-gutter--15 {\r\n    margin-left: -15px;\r\n    margin-right: -15px;\r\n    .slick-slide {\r\n        padding-left: 15px;\r\n        padding-right: 15px;\r\n    }\r\n    .testimonial-style-two  {\r\n        margin: 40px 0;\r\n    }\r\n}\r\n\r\n.slickdot--20 {\r\n    .slick-dots { \r\n        bottom: -20px;\r\n    }\r\n}\r\n\r\n\r\n\r\n","/*---------------------\r\n    Tab Styles  \r\n-----------------------*/\r\n\r\n.rn-default-tab {\r\n    // Tab Button \r\n    .tab-button {\r\n        padding: 0;\r\n        margin: 0;\r\n        list-style: none;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        cursor: pointer;\r\n        .react-tabs__tab {\r\n            padding: 20px 44px;\r\n            margin: 0;\r\n\r\n            @media #{$lg-layout} {\r\n                padding: 20px 24px;\r\n            }\r\n\r\n            @media #{$md-layout} {\r\n                padding: 20px 24px;\r\n            }\r\n\r\n            @media #{$sm-layout} {\r\n                padding: 20px 24px;\r\n            }\r\n\r\n            &.react-tabs__tab--selected {\r\n                background: var(--color-lessdark);\r\n            }\r\n        }\r\n        .rn-tab-button {\r\n            button {\r\n                padding: 0;\r\n                margin: 0;\r\n                background: transparent;\r\n                border: 0 none;\r\n                color: var(--color-white);\r\n            }\r\n        }\r\n    }\r\n\r\n    // Tab Content \r\n    .rn-tab-content {\r\n        background: var(--color-lessdark);\r\n        padding: 40px 40px;\r\n        @media #{$sm-layout} {\r\n            padding: 30px;\r\n        }\r\n        p {\r\n            &:last-child {\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.style-two {\r\n        .tab-button {\r\n            margin-bottom: 30px;\r\n            .react-tabs__tab {\r\n                border-radius: var(--radius-small);\r\n            }\r\n        }\r\n        .rn-tab-content {\r\n            border-radius: var(--radius-small);\r\n        }\r\n    }\r\n}","\r\n.rn-pricing {\r\n    margin-top: 40px;\r\n    .pricing-table-inner {\r\n        padding: 40px;\r\n        position: relative;\r\n        z-index: 2;\r\n        border: 2px solid var(--color-border);\r\n        border-radius: 5px;\r\n        transition: all 0.6s cubic-bezier(0.33, 0.84, 0.31, 0.98);\r\n        transform-style: preserve-3d;\r\n        &::before {\r\n            z-index: -1;\r\n            display: inline-block;\r\n            content: '';\r\n            transition: all 0.6s cubic-bezier(0.33, 0.84, 0.31, 0.98);\r\n            opacity: 0;\r\n            border-radius: 5px;\r\n            position: absolute;\r\n            top: -2px;\r\n            right: -2px;\r\n            bottom: -2px;\r\n            left: -2px;\r\n            background-color: var(--color-lessdark);\r\n        }\r\n        .pricing-header {\r\n            margin-bottom: 30px;\r\n            padding-bottom: 30px;\r\n            text-align: center;\r\n            border-bottom: 2px solid var(--color-border);\r\n            .title {\r\n                margin-bottom: 20px;\r\n            }\r\n            .price-wrapper {\r\n                display: flex;\r\n                justify-content: center;\r\n            }\r\n            .pricing {\r\n                span {\r\n                    display: block;\r\n                    &.currency {\r\n                        font-size: 28px;\r\n                        position: relative;\r\n                        top: -3px;\r\n                        left: -2px;\r\n                        opacity: 0.3;\r\n                    }\r\n                    &.price {\r\n                        font-size: 77px;\r\n                        color: var(--color-white);\r\n                        line-height: 1;\r\n                        font-weight: 700;\r\n                        margin-bottom: 10px;\r\n                        @media #{$sm-layout} {\r\n                            font-size: 54px;\r\n                        }\r\n                    }\r\n                    &.subtitle {\r\n                        font-size: 14px;\r\n                        color: var(--color-body);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .pricing-body {\r\n            text-align: center;\r\n            margin-bottom: 48px;\r\n            .list-style--1 {\r\n                list-style: none;\r\n                padding: 0;\r\n                margin: 0;\r\n            }\r\n        }\r\n\r\n        .pricing-footer {\r\n            text-align: center;\r\n        }\r\n    }\r\n\r\n\r\n    &.style-2 {\r\n        .pricing-table-inner {\r\n            background-color: var(--color-blackest);\r\n            border-color: transparent !important;\r\n        }\r\n    }\r\n\r\n    &.style-4 {\r\n        margin-left: -1px;\r\n        margin-right: -1px;\r\n        @media #{$md-layout} {\r\n            margin-left: 15px;\r\n            margin-right: 15px;\r\n        }\r\n        @media #{$sm-layout} {\r\n            margin-left: 15px;\r\n            margin-right: 15px;\r\n        }\r\n    }\r\n\r\n    &.active {\r\n        .pricing-table-inner {\r\n            border-color: transparent !important;\r\n\r\n            &::before {\r\n                transform: scaleY(1.12);\r\n                opacity: 1;\r\n                @media #{$md-layout} {\r\n                    transform: scaleY(1);\r\n                }\r\n                @media #{$sm-layout} {\r\n                    transform: scaleY(1);\r\n                }\r\n            }\r\n\r\n            .pricing-header {\r\n                border-bottom: 2px solid var(--color-border);\r\n                .title {\r\n                    color: var(--color-white);\r\n                }\r\n                .pricing {\r\n                    span {\r\n                        display: block;\r\n                        &.currency {\r\n                            color: var(--color-white);\r\n                            opacity: 1;\r\n                        }\r\n\r\n                        &.price {\r\n                            color: var(--color-white);\r\n                        }\r\n                        &.subtitle {\r\n                            color: var(--color-white);\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .pricing-body {\r\n                ul {\r\n                    &.list-style--1 {\r\n                        li {\r\n                            color: var(--color-white);\r\n                            svg {\r\n                                color: var(--color-white);\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .pricing-footer {\r\n                text-align: center;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.style-5 {\r\n        .pricing-table-inner {\r\n            background-color: var(--color-blackest);\r\n            border-color: transparent;\r\n            padding: 0;\r\n            padding-bottom: 40px;\r\n            border: 0 none;\r\n\r\n            &::before {\r\n                display: none;\r\n            }\r\n\r\n            .pricing-header {\r\n                margin-bottom: 30px;\r\n                padding-bottom: 0;\r\n                border-bottom: 0 none !important;\r\n\r\n                .title {\r\n                    padding: 30px 40px;\r\n                    margin-bottom: 0;\r\n                    font-size: 19px;\r\n                    font-weight: 500;\r\n                    letter-spacing: 0.5px;\r\n                }\r\n\r\n                .price-wrapper {\r\n                    margin-bottom: 5px;\r\n                }\r\n\r\n                .pricing {\r\n                    span {\r\n                        &.currency {\r\n                            font-size: 40px;\r\n                            position: relative;\r\n                            top: 0px;\r\n                            left: 0;\r\n                            opacity: 1;\r\n                            color: var(--color-white);\r\n                            font-weight: 700;\r\n                            line-height: 7px;\r\n                            display: flex;\r\n                            align-items: center;\r\n                        }\r\n                        &.price {\r\n                            font-size: 50px;\r\n                            color: var(--color-white);\r\n                            line-height: 1;\r\n                            font-weight: 700;\r\n                            margin-bottom: 0;\r\n                        }\r\n                        &.subtitle {\r\n                            color: var(--color-white);\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .pricing {\r\n                background-color: var(--color-lessdark);\r\n                padding: 30px;\r\n            }\r\n        }\r\n    }\r\n}\r\n","/*--------------------------\r\n    split Area Styles  \r\n----------------------------*/\r\n.slider_img {\r\n  width: 150px !important;\r\n  filter: brightness(0) invert(1) grayscale(100%) contrast(8);\r\n}\r\n.slider-container-logo{\r\n  margin-bottom: 90px;\r\n}\r\n\r\n.rn-splite-style {\r\n  .thumbnail {\r\n    img {\r\n      border-radius: 0;\r\n      width: 100%;\r\n    }\r\n    &.image-left-content {\r\n      img {\r\n        border-radius: 0 10px 10px 0;\r\n      }\r\n    }\r\n  }\r\n  .split-inner {\r\n    padding: 30px 115px;\r\n\r\n    @media #{$lg-layout} {\r\n      padding: 40px 80px;\r\n    }\r\n    @media #{$md-layout} {\r\n      padding: 40px 30px;\r\n    }\r\n    @media #{$sm-layout} {\r\n      padding: 40px 30px;\r\n    }\r\n\r\n    .title {\r\n      font-size: 36px;\r\n      line-height: 50px;\r\n      color: var(--color-heading);\r\n      font-weight: var(--p-bold);\r\n      @media #{$sm-layout} {\r\n        font-size: 24px;\r\n        line-height: 30px;\r\n      }\r\n    }\r\n\r\n    .split-list {\r\n      list-style: none;\r\n      padding-left: 0;\r\n      margin: 0;\r\n      //column-count: 2; /* You can adjust the number of columns as needed */\r\n      column-gap: 20px;\r\n      li {\r\n        color: white;\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        .split-icon {\r\n          margin-right: 20px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.no-radius .rn-splite-style .thumbnail.image-left-content img {\r\n  border-radius: 0;\r\n}\r\n","/*--------------------------------\r\n    Call To Action Style  \r\n--------------------------------*/\r\n.clltoaction-style-default {\r\n    padding: 250px 0;\r\n    @media #{$lg-layout} {\r\n        padding: 150px 0;\r\n    }\r\n    @media #{$md-layout} {\r\n        padding: 150px 0;\r\n    }\r\n    @media #{$sm-layout} {\r\n        padding: 150px 0;\r\n    }\r\n    .title {\r\n        font-size: 52px;\r\n        font-weight: 600;\r\n        position: relative;\r\n        margin-bottom: 30px;\r\n        padding-bottom: 0;\r\n        line-height: 1.4;\r\n        color: var(--color-white);\r\n    }\r\n    .inner {\r\n        p {\r\n            color: var(--color-body);\r\n        }\r\n    }\r\n    .subtitle {\r\n        color: #fff;\r\n        font-size: 24px;\r\n        line-height: 1.4;\r\n        margin: 0;\r\n        font-weight: 400;\r\n        letter-spacing: 0.5px;\r\n    }\r\n    .call-to-btn {\r\n        margin-top: 50px;\r\n    }\r\n    .content {\r\n        &.text-start {\r\n            .title {\r\n                &::before {\r\n                    left: 0;\r\n                    transform: none;\r\n                }\r\n            }\r\n            .subtitle {\r\n                padding: 0 16% 0 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.style-2 {\r\n        padding: 130px 0;\r\n    }\r\n\r\n    &.style-3 {\r\n        padding: 150px 0;\r\n\r\n        .content-wrapper {\r\n            background-color: var(--color-lessdark);\r\n            border-radius: var(--radius);\r\n            padding: 50px 40px;\r\n        }\r\n\r\n        .content {\r\n            .title {\r\n                font-size: 32px;\r\n                margin-bottom: 18px;\r\n                padding-bottom: 10px;\r\n            }\r\n\r\n            .subtitle {\r\n                font-size: 16px;\r\n                line-height: 1.4;\r\n                letter-spacing: 0.5px;\r\n            }\r\n        }\r\n\r\n        .call-to-btn {\r\n            margin-top: 0;\r\n            @media #{$md-layout} {\r\n                margin-top: 20px;\r\n            }\r\n            @media #{$sm-layout} {\r\n                margin-top: 20px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.style-4 {\r\n        padding: 0;\r\n\r\n        .content-wrapper {\r\n            background-color: var(--color-lessdark);\r\n            border-radius: var(--radius);\r\n            padding: 70px 50px;\r\n        }\r\n\r\n        .content {\r\n            .title {\r\n                font-size: 47px;\r\n                margin-bottom: 33px;\r\n                padding-bottom: 16px;\r\n                line-height: 1.4;\r\n                @media #{$md-layout} {\r\n                    margin-bottom: 0px;\r\n                }\r\n                @media #{$sm-layout} {\r\n                    font-size: 39px;\r\n                    margin-bottom: 1px;\r\n                }\r\n            }\r\n\r\n            .subtitle {\r\n                font-size: 16px;\r\n                line-height: 1.4;\r\n                letter-spacing: 0.5px;\r\n            }\r\n        }\r\n\r\n        .call-to-btn {\r\n            margin-top: 0;\r\n            @media #{$md-layout} {\r\n                margin-top: 20px;\r\n            }\r\n            @media #{$sm-layout} {\r\n                margin-top: 20px;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    &.style-5 {\r\n        padding: 0;\r\n\r\n        .content-wrapper {\r\n            background-color: var(--color-blackest);\r\n            border-radius: var(--radius);\r\n            padding: 70px 50px;\r\n            @media #{$md-layout} {\r\n                padding: 40px 20px;\r\n            }\r\n            @media #{$sm-layout} {\r\n                padding: 40px 20px;\r\n            }\r\n        }\r\n\r\n        .content {\r\n            .title {\r\n                font-size: 47px;\r\n                margin-bottom: 20px;\r\n                padding-bottom: 0;\r\n                line-height: 1.4;\r\n                @media #{$lg-layout} {\r\n                    font-size: 38px;\r\n                }\r\n                @media #{$md-layout} {\r\n                    font-size: 34px;\r\n                }\r\n                @media #{$sm-layout} {\r\n                    font-size: 34px;\r\n                }\r\n                @media #{$large-mobile} {\r\n                    font-size: 26px;\r\n                }\r\n                &::before {\r\n                    display: none;\r\n                }\r\n            }\r\n            .subtitle {\r\n                font-size: 16px;\r\n                line-height: 1.4;\r\n                letter-spacing: 0.5px;\r\n            }\r\n        }\r\n\r\n        .call-to-btn {\r\n            margin-top: 30px;\r\n        }\r\n    }\r\n\r\n    &.style-6 {\r\n        padding: 80px 0;\r\n        .content {\r\n            .title {\r\n                font-size: 36px;\r\n                margin-bottom: 0;\r\n                padding-bottom: 0;\r\n                line-height: 1.4;\r\n\r\n                &::before {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n        .call-to-btn {\r\n            margin-top: 0;\r\n            @media #{$md-layout} {\r\n                margin-top: 20px;\r\n            }\r\n            @media #{$sm-layout} {\r\n                margin-top: 20px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.style-7 {\r\n        padding: 0;\r\n        .content-wrapper {\r\n            padding: 40px 0;\r\n            border-bottom: 1px solid var(--color-border);\r\n        }\r\n        .content {\r\n            .subtitle {\r\n                font-size: 16px;\r\n                color: var(--color-body);\r\n                max-width: 450px;\r\n                line-height: 30px;\r\n                margin-bottom: 0;\r\n                margin-top: 13px;\r\n                padding: 0;\r\n            }\r\n        }\r\n        .call-to-btn {\r\n            margin-top: 0;\r\n            @media #{$md-layout} {\r\n                margin-top: 20px;\r\n            }\r\n            @media #{$sm-layout} {\r\n                margin-top: 20px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.rn-call-to-action {\r\n    &.style-8 {\r\n        padding: 100px 0;\r\n        background: var(--color-blackest);\r\n        .content-wrapper {\r\n            padding: 40px 0;\r\n            border-bottom: 1px solid var(--color-border);\r\n        }\r\n        .title {\r\n            color: var(--color-white);\r\n        }\r\n        .content {\r\n            .subtitle {\r\n                font-size: 20px;\r\n                color: var(--color-body);\r\n                line-height: 1.5;\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n        .call-to-btn {\r\n            margin-top: 0;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n.theme-shape {\r\n    position: relative;\r\n    z-index: 2;\r\n    overflow: hidden;\r\n\r\n    &::before {\r\n        position: absolute;\r\n        left: -250px;\r\n        top: 250px;\r\n        right: auto;\r\n        bottom: auto;\r\n        z-index: -1;\r\n        width: 500px;\r\n        height: 500px;\r\n        border-radius: 1000px;\r\n        background-image: linear-gradient(45deg, var(--color-primary), var(--color-light-green));\r\n        opacity: 0.2;\r\n        filter: blur(100px);\r\n        content: \"\";\r\n    }\r\n\r\n    &::after {\r\n        position: absolute;\r\n        z-index: -1;\r\n        width: 500px;\r\n        height: 500px;\r\n        border-radius: 1000px;\r\n        opacity: 0.2;\r\n        filter: blur(100px);\r\n        content: \"\";\r\n        left: auto;\r\n        top: -250px;\r\n        right: -250px;\r\n        bottom: auto;\r\n        background-image: linear-gradient(45deg, var(--color-secondary), var(--color-tertiary));\r\n        \r\n    }\r\n}","/*----------------------------\r\n    Video Popup Styles  \r\n------------------------------*/\r\n.video-popup ,\r\n.rn-gallery {\r\n    position: relative;\r\n    display: block;\r\n    .thumbnail {\r\n        img {\r\n            width: 100%;\r\n        }\r\n    }\r\n    .video-icon {\r\n        position: absolute;\r\n        content: \"\";\r\n        left: 50%;\r\n        top: 50%;\r\n        transform: translate(-50%, -50%);\r\n        margin-top: 10px;\r\n        transition: 0.4s;\r\n    }\r\n}\r\n.rn-gallery {\r\n    .video-icon {\r\n        opacity: 0;\r\n        transition: 0.4s;\r\n        transform: translate(-50%, -50%) scale(0.5);\r\n    }\r\n    &:hover {\r\n        .video-icon {\r\n            opacity: 1;\r\n            margin-top: 0;\r\n            transform: translate(-50%, -50%) scale(1);\r\n        }\r\n    }\r\n}\r\n\r\n.video-gallery-content {\r\n    border-radius: 10px;\r\n    padding-top: 300px;\r\n    padding-bottom: 60px;\r\n    overflow: hidden;\r\n\r\n    @media #{$md-layout} {\r\n        padding-bottom: 40px;\r\n        padding-top: 150px;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        padding-bottom: 40px;\r\n        padding-top: 150px;\r\n    }\r\n\r\n    .overlay-content {\r\n        padding: 0 60px;\r\n\r\n        @media #{$sm-layout} {\r\n            padding: 0 20px;\r\n        }\r\n        .title {\r\n            margin-top: 15px;\r\n            margin-bottom: 0;\r\n            font-size: 30px;\r\n            letter-spacing: 0.5px;\r\n            line-height: 1.4;\r\n            color: var(--color-white);\r\n            @media #{$sm-layout} {\r\n                font-size: 20px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n","/*==========================\r\n    Contact Address \r\n============================*/\r\n\r\n.contact-form-1 {\r\n    .form-group {\r\n        input {\r\n            height: 70px;\r\n            padding: 0 20px;\r\n        }\r\n        textarea {\r\n            padding-top: 20px;\r\n            padding-left: 20px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.contact-address-list {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n/*-------------------\r\n    Address Area  \r\n--------------------*/\r\n.rn-address {\r\n    margin-top: 30px;\r\n    padding: 40px;\r\n    border-radius: 10px;\r\n    padding-top: 40px;\r\n    background: var(--color-blackest);\r\n    padding-bottom: 50px;\r\n    box-shadow: 0 0 20px rgba(0,0,0,0.05);\r\n    transition: 0.3s;\r\n\r\n    @media #{$lg-layout} {\r\n        padding: 30px 20px;\r\n    }\r\n    @media #{$md-layout} {\r\n        padding: 30px 20px;\r\n    }\r\n    @media #{$sm-layout} {\r\n        padding: 30px 20px;\r\n    }\r\n    \r\n    .icon {\r\n        color: var(--color-primary);\r\n        border-radius: 100%;\r\n        font-size: 40px;\r\n        display: inline-block;\r\n        margin-bottom: 17px;\r\n        line-height: 6px;\r\n    }\r\n    .inner {\r\n        h4 {\r\n            &.title {\r\n                font-size: 18px;\r\n                font-weight: 700;\r\n            }\r\n        }\r\n        p {\r\n            font-size: 18px;\r\n            margin-bottom: 0;\r\n            @media #{$lg-layout} {\r\n                font-size: 16px;\r\n            }\r\n            @media #{$md-layout} {\r\n                font-size: 16px;\r\n            }\r\n            @media #{$sm-layout} {\r\n                font-size: 16px;\r\n            }\r\n            br {\r\n                \r\n                @media #{$lg-layout} {\r\n                    display: none;\r\n                }\r\n\r\n                @media #{$md-layout} {\r\n                    display: none;\r\n                }\r\n\r\n                @media #{$sm-layout} {\r\n                    display: none;\r\n                }\r\n            }\r\n            a {\r\n                color: var(--color-body);\r\n                @extend %transition;\r\n                &:hover {\r\n                    color: var(--color-primary);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &:hover {\r\n        transform: translateY(-5px)\r\n    }\r\n}\r\n\r\n\r\n.google-map-style-1 {\r\n    width: 100%;\r\n    height: 550px;\r\n    border-radius: 10px;\r\n    div {\r\n        border-radius: 10px;\r\n    }\r\n}\r\n\r\n.success-message {\r\n    color: green;\r\n    margin-top: 20px;\r\n    font-size: 16px;\r\n}\r\n\r\n\r\n","// Brand Style One \r\n\r\n.brand-style-1 {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n    li {\r\n        flex-basis: 25%;\r\n        border-width: 1px 1px 1px 1px;\r\n        border-style: solid;\r\n        margin: 0px 0px -2px -2px;\r\n        border-color: var(--color-border);\r\n        padding: 40px 0 40px 0;\r\n        text-align: center;\r\n        @media #{$large-mobile} {\r\n            flex-basis: 33.33%;\r\n        }\r\n        @media #{$small-mobile} {\r\n            flex-basis: 50%;\r\n        }\r\n        a {\r\n            display: block;\r\n            img {\r\n                opacity: 0.8;\r\n                transition: 0.3s;\r\n            }\r\n        }\r\n        &:hover {\r\n            a {\r\n                img {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Brand Style Two \r\n.brand-style-2 {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n    li {\r\n        flex-basis: 16.666%;\r\n        text-align: center;\r\n\r\n        @media #{$md-layout} {\r\n            flex-basis: 25%;\r\n        }\r\n        \r\n        @media #{$sm-layout} {\r\n            flex-basis: 25%;\r\n        }\r\n\r\n        @media #{$large-mobile} {\r\n            flex-basis: 33.33%;\r\n        }\r\n\r\n        @media #{$small-mobile} {\r\n            flex-basis: 50%;\r\n        }\r\n\r\n        a {\r\n            pointer-events: none;\r\n            cursor: default;\r\n            display: block;\r\n            img {\r\n                opacity: 1;\r\n                transition: 0.3s;\r\n                width: 145px;\r\n            }\r\n        }\r\n        &:hover {\r\n            a {\r\n                img {\r\n                    opacity: 0.8;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.variation-2 {\r\n        li {\r\n            flex-basis: 25%;\r\n            text-align: center;\r\n            @media #{$sm-layout} {\r\n                flex-basis: 33.33%;\r\n            }\r\n            @media #{$small-mobile} {\r\n                flex-basis: 50%;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n","/*---------------------------\r\n    Newsletter Styles  \r\n----------------------------*/\r\n.border-top-bottom {\r\n    border-top: 1px solid var(--color-border);\r\n    border-bottom: 1px solid var(--color-border);\r\n}\r\n.newsletter-area {\r\n    .border-top-bottom {\r\n        border-top: 1px solid var(--color-border);\r\n        border-bottom: 1px solid var(--color-border);\r\n    }\r\n}\r\n\r\n\r\n// Newsletter Style One \r\n.rn-newsletter-default {\r\n    .newsletter-wrapper {\r\n        padding: 40px 0;\r\n    }\r\n    .newsletter-section-title {\r\n        .title {\r\n            color: var(--color-body);\r\n            margin-bottom: 7px;\r\n        }\r\n        .description {\r\n            color: var(--color-body);\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n    .rn-newsletter {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        align-items: center;\r\n        margin: 0 -10px;\r\n\r\n        @media #{$large-mobile} {\r\n           display: block;\r\n        }\r\n\r\n        @media #{$md-layout} {\r\n          justify-content: flex-start;\r\n        }\r\n\r\n        @media #{$sm-layout} {\r\n          justify-content: flex-start;\r\n        }\r\n\r\n        .form-group {\r\n            margin-bottom: 0;\r\n            margin: 0 10px;\r\n            input {\r\n                height: 55px;\r\n                padding: 0 24px;\r\n                min-width: 500px;\r\n                background: var(--color-blackest);\r\n                border: 0 none;\r\n                @media #{$lg-layout} {\r\n                    min-width: 400px;\r\n                }\r\n                @media #{$md-layout} {\r\n                    min-width: 400px;\r\n                }\r\n                @media #{$sm-layout} {\r\n                    min-width: 350px;\r\n                }\r\n                @media #{$large-mobile} {\r\n                    min-width: 100%;\r\n                    margin-bottom: 20px;\r\n                }\r\n            }\r\n            .btn-default {\r\n                height: 55px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n","// Advance tab Styles \r\n\r\n.advance-tab-button-1 {\r\n    .tab-button-list {\r\n        list-style: none;\r\n        padding: 0;\r\n        margin: -10px 0;\r\n\r\n        li {\r\n            margin: 10px 0;\r\n        }\r\n\r\n        .tab-button {\r\n            cursor: pointer;\r\n            padding: 47px 27px;\r\n            border-radius: 10px;\r\n            position: relative;\r\n            z-index: 2;\r\n\r\n            &::before {\r\n                position: absolute;\r\n                content: \"\";\r\n                background: var(--color-blackest);\r\n                width: 100%;\r\n                height: 100%;\r\n                left: 0;\r\n                top: 0;\r\n                transition: 0.3s;\r\n                opacity: 0;\r\n                transform: scale(0.9);\r\n                z-index: -1;\r\n                border-radius: 10px;\r\n            }\r\n\r\n            &:hover {\r\n                &::before {\r\n                    opacity: 1;\r\n                    transform: scale(1);\r\n                }\r\n            }\r\n            \r\n\r\n            &::after {\r\n                content: '';\r\n                position: absolute;\r\n                top: 50%;\r\n                left: 100%;\r\n                border-left: 20px solid var(--color-blackest);\r\n                border-top: 20px solid transparent;\r\n                border-bottom: 20px solid transparent;\r\n                margin-top: -20px;\r\n                opacity: 0;\r\n                transition: 0.3s;\r\n                transform: scale(0.9);\r\n                @media #{$md-layout} {\r\n                    display: none;\r\n                }\r\n                @media #{$sm-layout} {\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n            .title {\r\n                color: var(--color-body);\r\n                font-size: 20px;\r\n                margin-bottom: 10px;\r\n            }\r\n\r\n            .description {\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n\r\n        .react-tabs__tab--selected {\r\n            .tab-button {\r\n                .title {\r\n                    color: var(--color-white);\r\n                }\r\n                &::before {\r\n                    opacity: 1;\r\n                    transform: scale(1);\r\n                }\r\n\r\n                &::after {\r\n                    opacity: 1;\r\n                    transform: scale(1);\r\n                }\r\n            }\r\n        }\r\n\r\n\r\n    }\r\n}\r\n\r\n.advance-tab-content-1 {\r\n    .thumbnail {\r\n        img {\r\n            border-radius: 10px;\r\n        }\r\n    }\r\n}\r\n\r\n// Right Align \r\n\r\n.advance-tab-button-1.right-align .tab-button-list .tab-button::after {\r\n    transform: scale(0.9) rotate(-180deg);\r\n    left: auto;\r\n    right: 100%;\r\n}\r\n.advance-tab-button-1.right-align .tab-button-list .react-tabs__tab--selected .tab-button::after {\r\n    transform: scale(1) rotate(-180deg);\r\n}\r\n.advance-tab-button-1.right-top .tab-button-list .tab-button::after {\r\n    left: 50%;\r\n    transform: scale(0.9) translateX(-50%) rotate(45deg);\r\n    bottom: 94%;\r\n    top: auto;\r\n}\r\n.advance-tab-button-1.right-top .tab-button-list .react-tabs__tab--selected .tab-button::after {\r\n    opacity: 1;\r\n    transform: scale(1) translateX(-50%) rotate(-90deg);\r\n}\r\n\r\n\r\n\r\n\r\n\r\n","/*----------------------------\r\n    Advance Pricing Table  \r\n------------------------------*/\r\n.advance-pricing {\r\n    background: var(--color-blackest);\r\n    border-radius: 10px;\r\n    .pricing-left {\r\n        height: 100%;\r\n        background: var(--color-lessdark);\r\n        padding: 60px 50px;\r\n        border-radius: 10px 0 0 10px;\r\n        .main-title {\r\n            margin-bottom: 10px;\r\n        }\r\n        .description {\r\n\r\n        }\r\n        .price-wrapper {\r\n            .price-amount {\r\n                font-size: 60px;\r\n                text-align: center;\r\n                display: block;\r\n                color: var(--color-white);\r\n                font-weight: 700;\r\n                sup {\r\n                    font-size: 16px;\r\n                    top: -34px;\r\n                }\r\n            }\r\n        }\r\n        .btn-default {\r\n            width: 100%;\r\n            margin: 10px 0;\r\n        }\r\n        .rating {\r\n            text-align: center;\r\n            margin-top: 5px;\r\n            a {\r\n                font-weight: 700;\r\n                color: #f1b304;\r\n                svg {\r\n                    fill: #f1b304;\r\n                }\r\n            }\r\n        }\r\n        .subtitle {\r\n            display: block;\r\n            color: var(--color-body);\r\n            text-align: center;\r\n        }\r\n    }\r\n\r\n    .pricing-right {\r\n        padding: 60px 30px;\r\n        .plan-offer-list {\r\n            @extend %liststyle;\r\n        }\r\n\r\n        .price-title {\r\n            font-size: 20px;\r\n            margin-bottom: 10px;\r\n            li {\r\n                font-size: 16px;\r\n                margin: 8px 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n","/*--------------------------\r\n    About Styles  \r\n---------------------------*/\r\n.about-style-4 {\r\n   \r\n    .title {\r\n        font-weight: 400;\r\n        margin-bottom: 35px;\r\n        strong {\r\n            color: var(--color-primary);\r\n        }\r\n    }\r\n\r\n    .feature-list {\r\n        padding: 0;\r\n        margin: 0;\r\n        list-style: none;\r\n        li {\r\n            display: flex;\r\n            .icon {\r\n                background: var(--color-primary);\r\n                width: 30px;\r\n                height: 30px;\r\n                border-radius: 100%;\r\n                color: var(--color-white);\r\n                text-align: center;\r\n                min-width: 30px;\r\n            }\r\n            .title-wrapper {\r\n                margin-left: 13px;\r\n                .title {\r\n                    font-size: 18px;\r\n                    margin: 0;\r\n                  \r\n                }\r\n                .text {\r\n                    font-size: 16px;\r\n                    margin-bottom: 20px;\r\n                    max-width: 80%;\r\n                    margin-top: 13px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// About Styles 5 \r\n\r\n.about-style-5 {\r\n    position: relative;\r\n    z-index: 2;\r\n    .about-wrapper {\r\n        margin-top: -150px;\r\n        background: var(--color-blackest);\r\n        border-radius: 10px;\r\n        padding: 15px;\r\n        @media #{$md-layout} {\r\n            margin-top: 80px;\r\n            padding: 15px 15px 30px 15px;\r\n        }\r\n        @media #{$sm-layout} {\r\n            margin-top: 80px;\r\n            padding: 15px 15px 30px 15px;\r\n        }\r\n        .thumbnail {\r\n            img {\r\n                border-radius: 10px;\r\n            }\r\n        }\r\n        .content {\r\n            .inner {\r\n                padding: 0 40px;\r\n                @media #{$sm-layout} {\r\n                    padding: 0;\r\n                }\r\n                .title {\r\n                    font-size: 30px;\r\n                    margin-bottom: 13px;\r\n                }\r\n                p {\r\n                    margin-bottom: 20px;\r\n                    width: 80%;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.contact-address {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n    li {\r\n        font-size: 16px;\r\n        svg {\r\n            color: var(--color-primary);\r\n            margin-right: 10px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// About Styles 6\r\n.about-style-6 {\r\n\r\n    .rbt-progress-style-1,\r\n    .wrapper {\r\n        position: relative;\r\n        z-index: 2;\r\n        max-width: 850px;\r\n        margin: 0 auto;\r\n        border-radius: 10px;\r\n    }\r\n    .wrapper {\r\n        padding: 50px;\r\n        @media #{$md-layout} {\r\n            padding: 20px;\r\n        }\r\n        @media #{$sm-layout} {\r\n            padding: 20px;\r\n        }\r\n        &::after {\r\n            position: absolute;\r\n            content: \"\";\r\n            left: 0;\r\n            top: 0;\r\n            background: var(--color-lessdark);\r\n            width: 100%;\r\n            height: 100%;\r\n            z-index: -1;\r\n            opacity: 0.6;\r\n            border-radius: 10px;\r\n        }\r\n\r\n    }\r\n\r\n    \r\n\r\n    .thumbnail {\r\n        img {\r\n            max-height: 200px;\r\n        }\r\n    }\r\n\r\n    .subtitle {\r\n        font-size: 18px;\r\n        font-weight: 500;\r\n    }\r\n    .maintitle {\r\n        font-size: 30px;\r\n        line-height: 1.3;\r\n        margin-top: 17px;\r\n        margin-bottom: 25px;\r\n    }\r\n}\r\n\r\n","/*--------------------------\r\n    Swicher Styles  \r\n----------------------------*/\r\n\r\nbody {\r\n    &.dark {\r\n        .dark-icon {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n.dark-icon {\r\n    display: none;\r\n    filter: brightness(100);\r\n}\r\n\r\n\r\n\r\n#darkmode {\r\n    border: 0 none;\r\n    padding: 0;\r\n    margin-left: 10px;\r\n    width: 40px;\r\n    background: var(--color-primary);\r\n    display: flex;\r\n    justify-content: center;\r\n    height: 40px;\r\n    align-items: center;\r\n    border-radius: 100%;\r\n}\r\n.my_switcher {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-left: 8px;\r\n    ul {\r\n        margin: 0;\r\n        padding: 0;\r\n        list-style: none;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        padding: 0;\r\n        width: auto;\r\n        height: auto;\r\n        li {\r\n            margin-top: 0;\r\n            margin-bottom: 0;\r\n            a {\r\n                position: relative;\r\n                text-decoration: none;\r\n                transition: .4s;\r\n                display: flex;\r\n                flex-direction: row-reverse;\r\n                align-items: center;\r\n                img {\r\n                    width: 15px;\r\n                }\r\n                span {\r\n                    transform: rotate(-180deg);\r\n                    display: none;\r\n                }\r\n                &.active {\r\n                    display: none;\r\n                }\r\n                &.light {\r\n                    color: var(--color-white);\r\n                }\r\n                &.dark {\r\n                    color: #18191A;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","/*---------------------------\r\n    Error Styles Area  \r\n-----------------------------*/\r\n.error-inner {\r\n    text-align: center;\r\n    h1 {\r\n        font-size: 200px;\r\n        line-height: 1;\r\n        color: var(--color-primary);\r\n        font-weight: var(--p-bold);\r\n        @media #{$sm-layout} {\r\n            font-size: 100px;\r\n            line-height: 1;\r\n        }\r\n    }\r\n\r\n    .title {\r\n        line-height: 45px;\r\n        font-weight: var(--p-bold);\r\n    }\r\n\r\n    .description {\r\n        font-size: var(--font-size-b2);\r\n        line-height: 28px;\r\n        color: var(--color-body);\r\n        font-weight: var(--p-regular);\r\n        margin-bottom: 30px;\r\n    }\r\n    \r\n    .blog-search {\r\n        display: inline-block;\r\n        input {\r\n            min-width: 500px;\r\n        }\r\n    }\r\n\r\n    .view-more-button {\r\n        margin-top: 30px;\r\n    }\r\n}\r\n\r\n","/*----------------------\r\n    Blog Styles  \r\n-----------------------*/\r\n.rn-card {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 0;\r\n    word-wrap: break-word;\r\n    background-color: var(--color-blackest);\r\n    background-clip: border-box;\r\n    border: 1px solid rgba(0, 0, 0, .125);\r\n    border-radius: var(--radius);\r\n    overflow: hidden;\r\n    transition: all .5s;\r\n\r\n    .inner {\r\n        .thumbnail {\r\n            a {\r\n                img {\r\n                    width: 100%;\r\n                }\r\n            }\r\n        }\r\n\r\n        .content {\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            height: 100%;\r\n            padding: 30px;\r\n            padding-top: 22px;\r\n            \r\n            @media #{$sm-layout} {\r\n                padding: 30px 20px;\r\n            }\r\n            .descriptiion {\r\n                margin-bottom: 0;\r\n                margin-bottom: 13px;\r\n            }\r\n            .title {\r\n                font-size: 20px;\r\n                line-height: 1.5;\r\n                transition: all .5s;\r\n                margin-bottom: 0;\r\n                margin-top: 15px;\r\n                flex-basis: 100%;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    &.card-list-view { \r\n        height: 100%;\r\n        .inner {\r\n            display: flex;\r\n            height: 100%;\r\n\r\n            .thumbnail {\r\n                flex-basis: 50%;\r\n                a {\r\n                    display: block;\r\n                    height: 100%;\r\n                    img {\r\n                        width: auto;\r\n                        object-fit: cover;\r\n                        height: 100%;\r\n                    }\r\n                }\r\n            }\r\n            .content {\r\n                flex-basis: 50%;\r\n                .title {\r\n                    margin-bottom: 10px;\r\n                }\r\n                .descriptiion {\r\n                    margin-bottom: 13px;\r\n                    margin-top: 12px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.rn-meta-list {\r\n    @extend %liststyle;\r\n    font-size: 1.4rem;\r\n    line-height: 2.2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n\r\n    li {\r\n        margin-top: 0;\r\n        margin-bottom: 0;\r\n        color: var(--color-gray);\r\n        font-size: 14px;\r\n        \r\n\r\n        a {\r\n            color: var(--color-gray);\r\n            transition: 0.5s;\r\n        }\r\n\r\n        &.separator {\r\n            margin: 0 .8rem;\r\n        }\r\n    }\r\n}","// Blog Search \r\n.blog-search {\r\n    position: relative;\r\n    input {\r\n        height: 60px;\r\n        padding: 0 20px;\r\n        color: var(--color-body);\r\n        padding-right: 80px;\r\n    }\r\n    .search-button {\r\n        position: absolute;\r\n        right: 6px;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        border: 0 none;\r\n        background: var(--color-primary-light);\r\n        height: 47px;\r\n        padding: 0 20px;\r\n        border-radius: 3px;\r\n        text-align: center;\r\n        font-size: 20px;\r\n        svg {\r\n            color: var(--color-white);\r\n            font-weight: 400;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.rbt-single-widget {\r\n    border-radius: 4px;\r\n    padding: 20px 20px;\r\n    border: 1px solid var(--color-border);\r\n    padding-top: 0;\r\n\r\n    &:first-child {\r\n        margin-top: 0 !important;\r\n    }\r\n\r\n    input,\r\n    select {\r\n        border: var(--border-width) solid var(--color-border);\r\n    }\r\n\r\n\r\n    &.widget_search {\r\n        padding: 0;\r\n        border: 0 none;\r\n        .title {\r\n            margin: 0;\r\n        }\r\n    }\r\n\r\n    p {\r\n        font-size: 16px;\r\n        line-height: 28px;\r\n        color: #717173;\r\n    }\r\n\r\n    .title {\r\n        line-height: 26px;\r\n        position: relative;\r\n        padding-bottom: 6px;\r\n        font-size: 18px;\r\n        font-weight: 500;\r\n        color: var(--color-white);\r\n        background-color: var(--color-blackest);\r\n        margin: -1px -22px 0;\r\n        padding: 14px 24px;\r\n        border-radius: 4px;\r\n        a {\r\n            color: var(--color-primary);\r\n            &.rsswidget {\r\n                img {\r\n                    height: 13px;\r\n                    margin-right: 3px;\r\n                }\r\n            }\r\n        }\r\n        img {\r\n            vertical-align: 0px;\r\n        }\r\n    }\r\n\r\n\r\n     // Blog List Style \r\n    ul {\r\n        padding-left: 0;\r\n        margin-bottom: -10px;\r\n        list-style: none;\r\n        padding-right: 0;\r\n        ul {\r\n            margin-bottom: 0;\r\n        }\r\n        li {\r\n            margin-top: 10px;\r\n            margin-bottom: 10px;\r\n            font-size: 16px;\r\n            line-height: 28px;\r\n            color: #717173;\r\n            a {\r\n                transition: all 0.3s ease 0s;\r\n                text-decoration: none;\r\n                color: var(--color-heading);\r\n                display: initial;\r\n                &:hover {\r\n                    color: var(--color-primary);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    \r\n    &.widget_categories {\r\n        ul {\r\n            li {\r\n                a {\r\n                    display: flex;\r\n                    justify-content: space-between;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    &.widget_recent_comments ,\r\n    &.widget_recent_entries ,\r\n    &.widget_archive ,\r\n    &.widget_categories,\r\n    &.widget_meta ,\r\n    &.widget_pages,\r\n    &.widget_nav_menu {\r\n        ul {\r\n            li {\r\n                position: relative;\r\n                padding-top: 15px;\r\n                padding-bottom: 15px;\r\n                margin-top: 0;\r\n                margin-bottom: 0;\r\n                color: var(--color-body);\r\n                a {\r\n                    color: var(--color-body);\r\n                    @extend %transition;\r\n                    &:hover {\r\n                        color: var(--color-primary);\r\n                    }\r\n                }\r\n                span {\r\n                    @extend %transition;\r\n                    color: var(--color-body);\r\n                }\r\n                &:hover {\r\n                    a {\r\n                        span {\r\n                            color: var(--color-primary);\r\n                        }\r\n                    }\r\n                }\r\n                & + li {\r\n                    border-top: 1px solid var(--color-border);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.widget_recent_comments ,\r\n    &.widget_recent_entries ,\r\n    &.widget_archive ,\r\n    &.widget_categories,\r\n    &.widget_meta ,\r\n    &.widget_pages {\r\n        > ul {\r\n            > li {\r\n                margin-top: 0;\r\n                margin-bottom: 0;\r\n                &:first-child {\r\n                    margin-top: 0;\r\n                }\r\n                &:last-child {\r\n                    margin-bottom: 10px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.widget_recent_entries {\r\n        .inner {\r\n            a {\r\n                color: var(--color-white);\r\n                margin-bottom: 4px;\r\n            }\r\n            span {\r\n                color: var(--color-body);\r\n                font-size: 14px;\r\n                letter-spacing: 0.5px;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n\r\n\r\n\r\n}\r\n\r\n\r\n.alignwide {\r\n    margin-left: -220px;\r\n    margin-right: -220px;\r\n    max-width: 1400px;\r\n    width: auto;\r\n    @media #{$lg-layout} {\r\n        margin-left: 0;\r\n        margin-right: 0;\r\n    }\r\n    @media #{$md-layout} {\r\n        margin-left: 0;\r\n        margin-right: 0;\r\n    }\r\n    @media #{$sm-layout} {\r\n        margin-left: 0;\r\n        margin-right: 0;\r\n    }\r\n}\r\n\r\n.alignfull {\r\n    margin-left: calc(50% - 50vw);\r\n    margin-right: calc(50% - 50vw);\r\n    max-width: 100vw;\r\n    width: 100vw;\r\n}\r\n\r\n// Tag Cloud Styles\r\n.tagcloud,\r\n.wp-block-tag-cloud {\r\n    margin: -3px;\r\n    padding-left: 0;\r\n    a {\r\n        background: transparent;\r\n        display: inline-block;\r\n        height: 40px;\r\n        color: var(--color-body);\r\n        font-size: 16px !important;\r\n        line-height: 35px;\r\n        text-decoration: none;\r\n        margin: 3px;\r\n        border: 2px solid var(--color-border);\r\n        @extend %transition;\r\n        padding: 0 20px;\r\n        border-radius: 3px;\r\n        &:hover {\r\n            background: var(--color-primary);\r\n            color: #ffffff;\r\n            border-color: var(--color-primary);\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n","/*------------------------------\r\n    Blog Details \r\n----------------------------------*/\r\n\r\n\r\n.post-page-banner {\r\n    .rn-meta-list {\r\n        justify-content: center;\r\n        li {\r\n            color: var(--color-body);\r\n            font-size: 20px;\r\n            margin: 0 15px;\r\n            margin-top: 38px;\r\n            @media #{$md-layout} {\r\n                font-size: 16px;\r\n                margin-top: 8px;\r\n            }\r\n            @media #{$sm-layout} {\r\n                font-size: 16px;\r\n                margin-top: 8px;\r\n            }\r\n            svg {\r\n                margin-right: 10px;\r\n            }\r\n            a {\r\n                color: var(--color-body);\r\n                transition: 0.3s;\r\n                &:hover {\r\n                    color: var(--color-primary);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .category-list {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        list-style: none;\r\n        justify-content: center;\r\n        margin: -10px;\r\n        padding: 0;\r\n        margin-top: 14px;\r\n        li {\r\n            margin: 10px;\r\n            position: relative;\r\n            &::after {\r\n                position: absolute;\r\n                content: \",\";\r\n                right: -9px;\r\n            }\r\n            &:last-child {\r\n                &::after {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n.blog-details-content {\r\n    .category-meta {\r\n        display: flex;\r\n        padding: 42px 0;\r\n        border-top: 1px solid var(--color-border);\r\n        border-bottom: 1px solid var(--color-border);\r\n        flex-wrap: wrap;\r\n        span {\r\n            &.text {\r\n                color: var(--color-white);\r\n                font-size: 22px;\r\n                display: inline-block;\r\n                margin: 10px 0;\r\n                margin-top: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n","/*------------------------\r\n    Banner Styles  \r\n-------------------------*/\r\n// Slider Dot \r\n.slider-dot {\r\n    &.rn-slick-dot {\r\n        .slick-dots {\r\n            bottom: 60px;\r\n        }\r\n    }\r\n}\r\n\r\n.height-850 {\r\n    height: 500px;\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    @media #{$md-layout} {\r\n        height: auto;\r\n        padding: 150px 0;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        height: auto;\r\n        padding: 100px 0;\r\n    }\r\n}\r\n.height-main {\r\n    height: 700px;\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    @media #{$md-layout} {\r\n        height: auto;\r\n        padding: 150px 0;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        height: auto;\r\n        padding: 100px 0;\r\n    }\r\n}\r\n\r\n.height-650 {\r\n    height: 650px;\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    @media #{$md-layout} {\r\n        height: auto;\r\n        padding: 150px 0;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        height: auto;\r\n        padding: 100px 0;\r\n    }\r\n}\r\n\r\n\r\n.height-750 {\r\n    height: 750px;\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    @media #{$md-layout} {\r\n        height: auto;\r\n        padding: 150px 0;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        height: auto;\r\n        padding: 100px 0;\r\n    }\r\n}\r\n\r\n.height-950 {\r\n    height: 950px;\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    @media #{$md-layout} {\r\n        height: auto;\r\n        padding: 150px 0;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        height: auto;\r\n        padding: 150px 0;\r\n    }\r\n}\r\n\r\n.display-one {\r\n    font-size: 75px;\r\n    @media #{$lg-layout} {\r\n        font-size: 70px;\r\n    }\r\n    @media #{$md-layout} {\r\n        font-size: 65px;\r\n    }\r\n    @media #{$sm-layout} {\r\n        font-size: 50px;\r\n    }\r\n    @media #{$large-mobile} {\r\n        font-size: 46px;\r\n    }\r\n}\r\n\r\n.display-two {\r\n    font-size: 85px;\r\n    @media #{$lg-layout} {\r\n        font-size: 70px;\r\n    }\r\n    @media #{$md-layout} {\r\n        font-size: 65px;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        font-size: 65px;\r\n    }\r\n\r\n    @media #{$large-mobile} {\r\n        font-size: 46px;\r\n    }\r\n}\r\n\r\n\r\n\r\n.bg-overlay {\r\n    position: relative;\r\n\r\n    &::before {\r\n        position: absolute;\r\n        height: 100%;\r\n        width: 100%;\r\n        opacity: 1;\r\n        top: 0;\r\n        left: 0;\r\n        background-color: transparent;\r\n        background-image: linear-gradient(90deg, #060606 0%, #06060600 90%);\r\n        content: \"\";\r\n    }\r\n}\r\n\r\n\r\n\r\n.bg-overlay-solid {\r\n    position: relative;\r\n    z-index: 1;\r\n\r\n    &::before {\r\n        position: absolute;\r\n        height: 100%;\r\n        width: 40%;\r\n        opacity: 1;\r\n        top: 0;\r\n        left: 0;\r\n        content: \"\";\r\n        background: var(--color-dark);\r\n        z-index: -1;\r\n    }\r\n\r\n    &::after {\r\n        position: absolute;\r\n        width: 500px;\r\n        height: 500px;\r\n        border-radius: 1000px;\r\n        opacity: 0.5;\r\n        filter: blur(100px);\r\n        left: auto;\r\n        top: -250px;\r\n        left: -250px;\r\n        bottom: auto;\r\n        background-image: linear-gradient(45deg, var(--color-secondary), var(--color-tertiary));\r\n        content: \"\";\r\n        z-index: -1;\r\n    }\r\n}\r\n\r\n\r\n.frame-image {\r\n    padding: 20px;\r\n    position: relative;\r\n    right: 0;\r\n    border-radius: 10px;\r\n    transition: var(--transition);\r\n    height: 100%;\r\n    background-color: var(--color-blackest);\r\n\r\n    img {\r\n        width: 100%;\r\n    }\r\n\r\n    &:hover {\r\n        transform: translateY(-5px);\r\n    }\r\n}\r\n\r\n.slider-area {\r\n    .inner {\r\n        a,\r\n        button {\r\n            &.btn-default {\r\n                &.btn-border {\r\n                    border-color: var(--color-border);\r\n                    color: var(--color-white);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*-----------------------\r\n    Slider Style One  \r\n-------------------------*/\r\n\r\n.slider-style-1 {\r\n    .inner {\r\n        .subtitle {\r\n            font-family: var(--font-primary);\r\n            font-size: 18px;\r\n            letter-spacing: 0.5px;\r\n            display: block;\r\n            margin-bottom: 18px;\r\n            color: var(--color-body);\r\n\r\n            @media #{$md-layout} {\r\n                font-size: 16px;\r\n                margin-bottom: 10px;\r\n            }\r\n\r\n            @media #{$sm-layout} {\r\n                font-size: 16px;\r\n                margin-bottom: 10px;\r\n            }\r\n\r\n            @media #{$large-mobile} {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n\r\n        .title {\r\n            font-family: var(--font-primary);\r\n            margin-bottom: 25px;\r\n            display: inline-block;\r\n\r\n            span {\r\n                display: inline-block;\r\n\r\n                label {\r\n                    margin-bottom: 0;\r\n                }\r\n            }\r\n        }\r\n\r\n        .description {\r\n            font-family: var(--font-primary);\r\n            padding: 0 22%;\r\n            font-size: 25px;\r\n            line-height: 1.7;\r\n            margin-bottom: 40px;\r\n            color: var(--color-body);\r\n\r\n            @media #{$lg-layout} {\r\n                padding: 0 14%;\r\n                font-size: 22px;\r\n                margin-bottom: 35px;\r\n            }\r\n\r\n            @media #{$md-layout} {\r\n                padding: 0 1%;\r\n                font-size: 20px;\r\n                margin-bottom: 30px;\r\n            }\r\n\r\n            @media #{$sm-layout} {\r\n                padding: 0 1%;\r\n                font-size: 20px;\r\n                margin-bottom: 30px;\r\n            }\r\n\r\n            @media #{$large-mobile} {\r\n                font-size: 18px;\r\n                margin-bottom: 25px;\r\n            }\r\n        }\r\n\r\n        .button-group {}\r\n\r\n        &.text-start {\r\n            .description {\r\n                padding: 0;\r\n            }\r\n        }\r\n\r\n\r\n    }\r\n\r\n    &.variation-default {\r\n        .inner {\r\n            padding-top: 80px;\r\n        }\r\n    }\r\n\r\n    &.variation-2 {\r\n        position: relative;\r\n        .thumbnail {\r\n            img {\r\n                transform: scale(1.1);\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n// Slider Style Two \r\n\r\n.slider-style-2 {\r\n    padding-top: 130px;\r\n\r\n    @media #{$md-layout} {\r\n        padding-top: 150px;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        padding-top: 150px;\r\n    }\r\n    .inner {\r\n        .subtitle {\r\n            font-weight: 700;\r\n            letter-spacing: 0.5px;\r\n            line-height: 18px;\r\n            font-size: 14px;\r\n            border-radius: 4px;\r\n            margin-bottom: 12px;\r\n            display: inline-block;\r\n            padding: 7px 14px;\r\n            background-color: var(--color-blackest);\r\n            box-shadow: var(--shadow-lighter);\r\n        }\r\n\r\n        .title {\r\n            font-family: var(--font-primary);\r\n            margin-bottom: 25px;\r\n            display: block;\r\n            color: var(--color-white);\r\n            &.display-one {\r\n                @media #{$sm-layout} {\r\n                    font-size: 40px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .list-icon {\r\n            li {\r\n                color: var(--color-body);\r\n            }\r\n        }\r\n    }\r\n\r\n    &.variation-2 {\r\n        padding-top: 79px;\r\n        @media #{$md-layout} {\r\n            padding-top: 170px;\r\n        }\r\n        @media #{$sm-layout} {\r\n            padding-top: 170px;\r\n        }\r\n\r\n        .inner {\r\n            .title {\r\n                font-weight: 500;\r\n                font-size: 75px;\r\n                margin-top: 0;\r\n                @media #{$md-layout} {\r\n                    font-size: 54px;\r\n                }\r\n                @media #{$sm-layout} {\r\n                    font-size: 54px;\r\n                }\r\n                @media #{$large-mobile} {\r\n                    font-size: 40px;\r\n                }\r\n            }\r\n\r\n            .tag-title {\r\n                color: var(--color-secondary);\r\n                margin: 0;\r\n                letter-spacing: 1.5px;\r\n                padding-left: 129px;\r\n                position: relative;\r\n                margin-top: 50px;\r\n\r\n                &::before {\r\n                    position: absolute;\r\n                    content: \"\";\r\n                    left: 0;\r\n                    width: 100px;\r\n                    height: 2px;\r\n                    background: var(--color-secondary);\r\n                    top: 50%;\r\n                    transform: translateY(-50%);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.variation-3 {\r\n        padding-top: 80px;\r\n        @media #{$md-layout} {\r\n            padding-top: 180px;\r\n        }\r\n\r\n        @media #{$sm-layout} {\r\n            padding-top: 180px;\r\n        }\r\n\r\n        .inner {\r\n            .title {\r\n                font-family: var(--font-primary);\r\n                margin-bottom: 25px;\r\n                display: block;\r\n                font-size: 80px;\r\n                @media #{$md-layout} {\r\n                    font-size: 60px;\r\n                }\r\n                @media #{$sm-layout} {\r\n                    font-size: 50px;\r\n                    br {\r\n                        display: none;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .description {\r\n                font-size: 20px;\r\n                line-height: 37px;\r\n                margin-bottom: 0;\r\n                @media #{$sm-layout} {\r\n                    font-size: 18px;\r\n                    line-height: 30px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Slider Style Three \r\n\r\n.slider-style-3 {\r\n    @media #{$md-layout} {\r\n        padding: 100px 0;\r\n    }\r\n\r\n    @media #{$sm-layout} {\r\n        padding: 100px 0;\r\n    }\r\n\r\n    .inner {\r\n        .title {\r\n            font-family: var(--font-primary);\r\n            margin-bottom: 25px;\r\n            display: block;\r\n            font-size: 130px;\r\n            line-height: 1.1;\r\n\r\n            @media #{$lg-layout} {\r\n                font-size: 100px;\r\n            }\r\n\r\n            @media #{$md-layout} {\r\n                font-size: 80px;\r\n            }\r\n\r\n            @media #{$sm-layout} {\r\n                margin-bottom: 20px;\r\n                font-size: 50px;\r\n            }\r\n        }\r\n\r\n        .description {\r\n            font-size: 22px;\r\n            line-height: 43px;\r\n\r\n            @media #{$md-layout} {\r\n                font-size: 20px;\r\n                line-height: 38px;\r\n            }\r\n\r\n            @media #{$sm-layout} {\r\n                font-size: 18px;\r\n                line-height: 30px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .thumbnail {\r\n        position: relative;\r\n        z-index: 2;\r\n\r\n        &::after {\r\n            position: absolute;\r\n            z-index: -1;\r\n            width: 100%;\r\n            height: calc(100% - 130px);\r\n            content: \"\";\r\n            left: 50%;\r\n            bottom: 0;\r\n            -webkit-transform: translateX(-50%);\r\n            -ms-transform: translateX(-50%);\r\n            transform: translateX(-50%);\r\n            background: var(--color-blackest);\r\n            box-shadow: var(--shadow-1);\r\n            border-radius: 6px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Slider Style 4 \r\n.slider-style-4 {\r\n    .inner {\r\n        padding-top: 80px;\r\n\r\n        @media #{$sm-layout} {\r\n            padding-top: 50px;\r\n        }\r\n        >* {\r\n            animation-name: fadeOutUp;\r\n            animation-fill-mode: both;\r\n            animation-duration: 1s;\r\n        }\r\n        .title {\r\n            font-family: var(--font-primary);\r\n            margin-bottom: 25px;\r\n            display: block;\r\n            font-size: 130px;\r\n            line-height: 1.1;\r\n            transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\r\n            color: var(--color-white);\r\n\r\n            @media #{$lg-layout} {\r\n                font-size: 100px;\r\n            }\r\n\r\n            @media #{$md-layout} {\r\n                font-size: 100px;\r\n            }\r\n\r\n            @media #{$sm-layout} {\r\n                font-size: 60px;\r\n            }\r\n\r\n            @media #{$large-mobile} {\r\n                font-size: 55px;\r\n            }\r\n        }\r\n\r\n        .description {\r\n            font-size: 22px;\r\n            line-height: 43px;\r\n            transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\r\n            color: var(--color-body);\r\n            @media #{$sm-layout} {\r\n                font-size: 20px;\r\n                line-height: 35px;\r\n            }\r\n        }\r\n\r\n        .button-group {\r\n            transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\r\n        }\r\n    }\r\n    &.variation-2 {\r\n        .inner {\r\n            .title {\r\n                font-size: 70px;\r\n                @media #{$sm-layout} {\r\n                    font-size: 42px;\r\n                }\r\n            }\r\n        }\r\n        .bg-overlay {\r\n            &::before {\r\n                background: #000000;\r\n                content: \"\";\r\n                opacity: 0.5;\r\n                background-image: none;\r\n            }\r\n        }\r\n    }\r\n    &.variation-3 {\r\n        .inner {\r\n            .title {\r\n                font-size: 70px;\r\n            }\r\n        }\r\n        .bg-overlay {\r\n            &::before {\r\n                background: #000000;\r\n                content: \"\";\r\n                opacity: 0.5;\r\n                background-image: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Slider Style 5\r\n.slider-style-5 {\r\n    .inner {\r\n        .subtitle {\r\n            font-weight: 400;\r\n            font-size: 16px;\r\n            letter-spacing: 0.5px;\r\n            position: relative;\r\n            padding-right: 20px;\r\n            display: inline-block;\r\n            color: var(--color-white);\r\n\r\n            &::after {\r\n                position: absolute;\r\n                content: \"\";\r\n                width: 120px;\r\n                height: 2px;\r\n                background: var(--color-pink);\r\n                left: 100%;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n            }\r\n        }\r\n\r\n        .title {\r\n            font-family: var(--font-primary);\r\n            margin-bottom: 25px;\r\n            display: block;\r\n            font-size: 64px;\r\n            line-height: 1.4;\r\n            color: var(--color-white);\r\n\r\n            @media #{$sm-layout} {\r\n                font-size: 40px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n// Slider Style 5\r\n.slider-style-6 {\r\n    background-color: var(--color-blackest);\r\n\r\n    @media #{$md-layout} {\r\n        overflow: hidden;\r\n        padding: 100px 0;\r\n        padding-top: 170px;\r\n    }\r\n\r\n    &.shape-right {\r\n        position: relative;\r\n        z-index: 2;\r\n        overflow: hidden;\r\n        .shape-image {\r\n            position: absolute;\r\n            right: 0;\r\n            top: 0;\r\n            opacity: 0.5;\r\n            width: auto;\r\n            @media #{$md-layout} {\r\n                display: none;\r\n            }\r\n            @media #{$sm-layout} {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.shape-left {\r\n        position: relative;\r\n        .inner {\r\n            position: relative;\r\n            z-index: 2;\r\n        }\r\n        .shape-image {\r\n            position: absolute;\r\n            left: 0;\r\n            top: 0;\r\n            opacity: 0.5;\r\n            transform: rotate(180deg);\r\n            height: 100%;\r\n            bottom: 0;\r\n            width: auto;\r\n            @media #{$md-layout} {\r\n                display: none;\r\n            }\r\n\r\n            @media #{$sm-layout} {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.inheader-not-transparent {\r\n        @media #{$md-layout} {\r\n            padding-top: 100px;\r\n        }\r\n    }\r\n\r\n    .inner {\r\n        .title {\r\n            font-family: var(--font-primary);\r\n            margin-bottom: 25px;\r\n            display: block;\r\n            font-size: 80px;\r\n            line-height: 1.1;\r\n            \r\n            @media #{$lg-layout} {\r\n                font-size: 62px;\r\n            }\r\n            \r\n            @media #{$md-layout} {\r\n                font-size: 60px;\r\n            }\r\n\r\n            @media #{$sm-layout} {\r\n                font-size: 45px;\r\n            }\r\n            br {\r\n                @media #{$sm-layout} {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n\r\n        .description {\r\n            font-size: 22px;\r\n            line-height: 43px;\r\n\r\n            @media #{$md-layout} {\r\n                font-size: 20px;\r\n                line-height: 38px;\r\n            }\r\n\r\n            @media #{$sm-layout} {\r\n                font-size: 18px;\r\n                line-height: 30px;\r\n            }\r\n        }\r\n\r\n        a {\r\n            &.btn-default {\r\n                &.btn-border {\r\n                    border-color: var(--color-border);\r\n                    color: var(--color-white);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.slider-perosonal-portfolio {\r\n    &.height-750 {\r\n        @media #{$md-layout} {\r\n            padding-top: 180px;\r\n        }\r\n        @media #{$sm-layout} {\r\n            padding-top: 180px;\r\n        }\r\n    }\r\n    .inner {\r\n        margin-top: -100px;\r\n        @media #{$md-layout} {\r\n            margin-top: 0;\r\n        }\r\n        @media #{$sm-layout} {\r\n            margin-top: 0;\r\n        }\r\n        .title {\r\n            font-size: 100px;\r\n            color: var(--color-white);\r\n            @media #{$md-layout} {\r\n                font-size: 58px;\r\n            }\r\n            @media #{$sm-layout} {\r\n                font-size: 46px;\r\n            }\r\n        }\r\n\r\n        a,\r\n        button {\r\n            &.btn-default {\r\n                &.btn-border {\r\n                    border-color: var(--color-border);\r\n                    color: var(--color-white);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Slider Style 7\r\n.slider-style-7 {\r\n    .inner {\r\n        .title {\r\n            font-size: 100px;\r\n            @media #{$lg-layout} {\r\n                font-size: 60px;\r\n            }\r\n            @media #{$md-layout} {\r\n                font-size: 50px;\r\n            }\r\n            @media #{$sm-layout} {\r\n                br {\r\n                    display: none;\r\n                }\r\n                font-size: 32px;\r\n            }\r\n        }\r\n        \r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n// Slider Style 8\r\n\r\n.slider-style-8 {\r\n    justify-content: center;\r\n    .inner {\r\n        .title {\r\n            font-size: 100px;\r\n            line-height: 1.1;\r\n            @media #{$md-layout} {\r\n                font-size: 60px;\r\n            }\r\n            @media #{$sm-layout} {\r\n                font-size: 46px;\r\n            }\r\n        }\r\n        .description {\r\n            font-size: 22px;\r\n            line-height: 43px;\r\n            @media #{$sm-layout} {\r\n                font-size: 20px;\r\n                line-height: 38px;\r\n            }\r\n            br {\r\n                @media #{$md-layout} {\r\n                    display: none;\r\n                }\r\n                @media #{$sm-layout} {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n// Slider Animation \r\n.slider-style-4 {\r\n    .slick-active {\r\n        .inner {\r\n            >* {\r\n                animation-name: fadeInUp;\r\n            }\r\n\r\n            .title {\r\n                animation-delay: 0.5s;\r\n            }\r\n\r\n            .description {\r\n                animation-delay: 1s;\r\n            }\r\n\r\n            .button-group {\r\n                animation-delay: 1.2s;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n// @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\r\n//     .theme-gradient {\r\n//         color:#f9004d;\r\n//         background: none !important;\r\n//     }\r\n// }\r\n\r\n\r\n\r\n","/*-----------------------------\r\n    Portfolio details  \r\n--------------------------------*/\r\n.rwt-portfolio-details {\r\n    .content-left {\r\n        .title {\r\n            font-size: 38px;\r\n            margin-bottom: 33px;\r\n            @media #{$sm-layout} {\r\n                font-size: 25px;\r\n                margin-bottom: 20px;\r\n            }\r\n        }\r\n        .single-list-wrapper {\r\n            margin: -5px;\r\n            .single-list {\r\n                margin: 5px;\r\n                display: flex;\r\n                justify-content: space-between;\r\n                align-items: center;\r\n                padding: 10px 0;\r\n                & + .single-list {\r\n                    border-top: 1px solid var(--color-border);\r\n                }\r\n                label {\r\n                    font-size: 20px;\r\n                    color: #fff;\r\n                    display: inline-block;\r\n                    padding-right: 16px;\r\n                    margin: 0;\r\n                }\r\n                span {\r\n                    font-size: 18px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .content-right {\r\n        .subtitle {\r\n            font-size: 25px;\r\n            letter-spacing: 0.5px;\r\n            font-weight: 500;\r\n        }\r\n        .description {\r\n            p {\r\n                margin-bottom: 10px;\r\n            }\r\n        }\r\n    }\r\n    \r\n}\r\n\r\n.rwt-portfolio-details {\r\n    .alignwide {\r\n        margin-left: -100px;\r\n        margin-right: -100px;\r\n        max-width: 1400px;\r\n        width: auto;\r\n        @media #{$lg-layout} {\r\n            margin-left: 0;\r\n            margin-right: 0;\r\n        }\r\n        @media #{$md-layout} {\r\n            margin-left: 0;\r\n            margin-right: 0;\r\n        }\r\n        @media #{$sm-layout} {\r\n            margin-left: 0;\r\n            margin-right: 0;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n","/*--------------------------------\r\n    Single Demo  \r\n-------------------------------*/\r\n.single-demo {\r\n    text-align: center;\r\n    background: var(--color-lessdark);\r\n    border-radius: 10px;\r\n    padding: 20px;\r\n    transition: 0.3s;\r\n    position: relative;\r\n    a {\r\n        display: block;\r\n    }\r\n\r\n    .thumbnail {\r\n        position: relative;\r\n        img {\r\n            border-radius: 10px;\r\n            width: 100%;\r\n        }\r\n        .image-light {\r\n            display: none;\r\n        }\r\n        .label-badge {\r\n            position: absolute;\r\n            right: 20px;\r\n            border-radius: 5px;\r\n            background-color: transparent;\r\n            background: #fff700;\r\n            padding: 0 12px;\r\n            color: #000;\r\n            font-size: 14px;\r\n            height: 29px;\r\n            line-height: 29px;\r\n            text-transform: uppercase;\r\n            letter-spacing: 0.5px;\r\n            font-weight: 500;\r\n            display: inline-block;\r\n            width: 60px;\r\n            bottom: 20px;\r\n        }\r\n    }\r\n    .title {\r\n        margin: 0;\r\n        margin-top: 20px;\r\n        font-size: 20px;\r\n        letter-spacing: 0.5px;\r\n        position: relative;\r\n        display: inline-block;\r\n        \r\n    }\r\n    &:hover {\r\n        transform: translateY(-5px);\r\n    }\r\n}\r\n.react-image {\r\n    img {\r\n        max-height: 150px;\r\n    }\r\n}","\r\n\r\n.seeMoreButton {\r\n    padding: 50px;\r\n   display: flex;\r\njustify-content: center;\r\n\r\n}\r\n\r\n.service-wrapper-box{\r\n    display: flex;\r\n    justify-content: space-around;\r\n    \r\n\r\n}","/*-----------------------\r\n    Footer Style Here  \r\n------------------------*/\r\n.logo {\r\n    a {\r\n        img {\r\n            max-height: 55px;\r\n        }\r\n    }\r\n}\r\n\r\n.footer-style-default {\r\n    border-top: 1px solid var(--color-border);\r\n    background-color: var(--color-darkest);\r\n    background-image: -webkit-gradient(linear, left bottom, left top, from(var(--color-black)), to(var(--color-blacker)));\r\n    background-image: linear-gradient(0deg, var(--color-black), var(--color-blacker));\r\n    .footer-top {\r\n        padding: 100px 0;\r\n        padding-bottom: 70px;\r\n        .rn-footer-widget {\r\n            .text-big {\r\n                font-size: 21px;\r\n                margin-top: 30px;\r\n                padding-right: 13%;\r\n                line-height: 1.7;\r\n                font-weight: 500;\r\n                color: var(--color-body);\r\n                margin-bottom: 30px;\r\n                \r\n                @media #{$md-layout} {\r\n                    font-size: 20px;\r\n                    padding-right: 0;\r\n                }\r\n                @media #{$sm-layout} {\r\n                    font-size: 20px;\r\n                    padding-right: 0;\r\n                }\r\n            }\r\n\r\n            .title {\r\n                font-size: 18px;\r\n                font-weight: 500;\r\n                letter-spacing: 1px;\r\n                margin-bottom: 10px;\r\n                color: var(--color-heading);\r\n            }\r\n\r\n            .subtitle {\r\n                font-weight: 400;\r\n                color: var(--color-body);\r\n                font-size: 16px;\r\n                padding-right: 31%;\r\n                line-height: 28px;\r\n                margin-bottom: 32px;\r\n                @media #{$sm-layout} {\r\n                    padding-right: 0;\r\n                }\r\n            }\r\n            \r\n            .inner {\r\n                margin-top: 13px;\r\n            }\r\n\r\n            .footer-link {\r\n                list-style: none;\r\n                padding: 0;\r\n                li {\r\n                    margin-top: 5px;\r\n                    margin-bottom: 5px;\r\n                    a {\r\n                        font-size: 14px;\r\n                        display: inline-block;\r\n                        color: var(--color-body);\r\n                        line-height: 25px;\r\n                        transition: 0.3s;\r\n                        &:hover {\r\n                            color: var(--color-primary);\r\n                            &::after {\r\n                                width: 100%;\r\n                                left: 0;\r\n                                right: auto;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n    \r\n    .logo {\r\n        a {\r\n            img {\r\n                max-height:80px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.variation-two{\r\n        border-top: 0;\r\n        \r\n    }\r\n\r\n    &.no-border {\r\n        border-top: 0;\r\n    }\r\n}\r\n\r\n.footer-style-2 {\r\n    .copyright-style-one {\r\n        background: transparent;\r\n    }\r\n}\r\n\r\n\r\n.flex{\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n// Newsletter Styles \r\n.newsletter-form {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    input {\r\n        flex-grow: 1;\r\n        width: auto;\r\n        margin-right: 10px;\r\n        height: 50px;\r\n        font-size: 14px;\r\n        font-weight: 400;\r\n        letter-spacing: 0.5px;\r\n    }\r\n}\r\n\r\n.footer-style-default {\r\n    .newsletter-form {\r\n        .form-group {\r\n            input {\r\n                border-color: var(--color-border);\r\n            }\r\n        }\r\n    }\r\n}","/*--------------------------\r\n    Copyright Area  \r\n---------------------------*/\r\n.rn-back-top {\r\n    position: fixed;\r\n    bottom: 30px;\r\n    right: 30px;\r\n    cursor: pointer;\r\n    z-index: 999;\r\n    width: 50px;\r\n    height: 50px;\r\n    line-height: 46px;\r\n    border-radius: 50%;\r\n    text-align: center;\r\n    z-index: 999 !important;\r\n    background-color: var(--color-blackest);\r\n    svg {\r\n        color: #fff;\r\n        width: 27px;\r\n        height: 27px;\r\n        font-size: 14px !important;\r\n    }\r\n}\r\n\r\n// Copyright Style One \r\n.copyright-style-one {\r\n    background: var(--color-darkest);\r\n    padding: 20px 0;\r\n    border-top: 1px solid var(--color-border);\r\n    .copyright-text {\r\n        margin-bottom: 0;\r\n        font-size: 14px;\r\n    }\r\n    .ft-menu {\r\n        padding: 0;\r\n        margin: 0 -10px;\r\n        list-style: none;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        align-items: center;\r\n        @media #{$sm-layout} {\r\n            justify-content: center;\r\n        }\r\n        li {\r\n            margin: 0;\r\n            padding: 0 10px;\r\n            position: relative;\r\n            & + li {\r\n                &::after {\r\n                    position: absolute;\r\n                    content: \"\";\r\n                    height: 14px;\r\n                    width: 1px;\r\n                    background: var(--color-border);\r\n                    left: -1px;\r\n                    top: 50%;\r\n                    transform: translateY(-50%);\r\n                }\r\n            }\r\n            a {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.variation-two{\r\n        background: var(--color-blackest);\r\n    }\r\n\r\n    &.no-border {\r\n        border-top: 0;\r\n    }\r\n}\r\n\r\n","/*-------------------------\r\n    Darkmode Styles  \r\n---------------------------*/\r\n.rn-back-top svg {\r\n  transition: 0.3s;\r\n}\r\n.rn-back-top:hover svg {\r\n  color: var(--color-primary) !important;\r\n}\r\n\r\n// Dark Style\r\nbody {\r\n  &.light {\r\n    background-color: var(--color-white);\r\n    color: #65676b;\r\n\r\n    .dark-icon {\r\n      display: block;\r\n    }\r\n\r\n    .light-icon {\r\n      display: none;\r\n    }\r\n\r\n    h1,\r\n    h2,\r\n    h3,\r\n    h4,\r\n    h5,\r\n    h6,\r\n    .h1,\r\n    .h2,\r\n    .h3,\r\n    .h4,\r\n    .h5,\r\n    .h6,\r\n    .social-default li a,\r\n    .rbt-single-widget .title,\r\n    .rbt-single-widget.widget_recent_entries .inner a,\r\n    .tagcloud a,\r\n    .wp-block-tag-cloud a,\r\n    .rwt-portfolio-details\r\n      .content-left\r\n      .single-list-wrapper\r\n      .single-list\r\n      label,\r\n    .blog-details-content .category-meta span.text,\r\n    .demo-slider-area.slider-style-1 .inner .title,\r\n    .rn-back-top svg,\r\n    .popup-mobile-menu .inner .header-top .close-menu .close-button,\r\n    .footer-style-default .footer-top .rn-footer-widget .title,\r\n    .rn-call-to-action.style-8 .title,\r\n    .rn-newsletter-default .newsletter-section-title .title {\r\n      color: #181818;\r\n    }\r\n\r\n    p,\r\n    input[type=\"text\"],\r\n    input[type=\"password\"],\r\n    input[type=\"email\"],\r\n    input[type=\"number\"],\r\n    input[type=\"tel\"],\r\n    textarea,\r\n    .breadcrumb-inner ul.page-list li a,\r\n    .rn-address .inner p a,\r\n    .error-inner .description,\r\n    .rbt-single-widget.widget_recent_comments ul li a,\r\n    .rbt-single-widget.widget_recent_entries ul li a,\r\n    .rbt-single-widget.widget_archive ul li a,\r\n    .rbt-single-widget.widget_categories ul li a,\r\n    .rbt-single-widget.widget_meta ul li a,\r\n    .rbt-single-widget.widget_pages ul li a,\r\n    .rbt-single-widget.widget_nav_menu ul li a,\r\n    .rbt-single-widget.widget_recent_entries .inner span,\r\n    .rbt-single-widget.widget_recent_comments ul li span,\r\n    .rbt-single-widget.widget_recent_entries ul li span,\r\n    .rbt-single-widget.widget_archive ul li span,\r\n    .rbt-single-widget.widget_categories ul li span,\r\n    .rbt-single-widget.widget_meta ul li span,\r\n    .rbt-single-widget.widget_pages ul li span,\r\n    .rbt-single-widget.widget_nav_menu ul li span,\r\n    .post-page-banner .rn-meta-list li a,\r\n    .post-page-banner .rn-meta-list li,\r\n    .breadcrumb-inner ul.page-list li.rn-breadcrumb-item.active,\r\n    .slider-style-1.bg-transparent .inner .subtitle,\r\n    .slider-style-1.bg-transparent .inner .description,\r\n    .popup-mobile-menu .mainmenu li a,\r\n    .footer-style-default .footer-top .rn-footer-widget .footer-link li a,\r\n    .footer-style-default .footer-top .rn-footer-widget .subtitle,\r\n    .rn-call-to-action.style-8 .content .subtitle,\r\n    .rn-newsletter-default .newsletter-section-title .description,\r\n    .slider-style-5 .inner .subtitle,\r\n    .slider-style-5 .inner .title {\r\n      color: #65676b;\r\n    }\r\n\r\n    .header-transparent.sticky .mainmenu-nav .mainmenu > li > a,\r\n    .clltoaction-style-default.style-7 .content .subtitle,\r\n    .copyright-style-one .ft-menu li a,\r\n    .footer-style-default .footer-top .rn-footer-widget .text-big {\r\n      color: #65676b;\r\n    }\r\n\r\n    .form-group input,\r\n    .form-group textarea,\r\n    .rn-accordion-style.rn-accordion-02 .card .card-header,\r\n    .mainmenu-nav\r\n      .mainmenu\r\n      li.with-megamenu\r\n      .rn-megamenu\r\n      .wrapper\r\n      .mega-menu-item,\r\n    .breadcarumb-style-1,\r\n    .rn-accordion-style.rn-accordion-03 .card .card-header,\r\n    .rn-accordion-style.rn-accordion-04 .card,\r\n    .rn-pricing .pricing-table-inner,\r\n    input[type=\"text\"],\r\n    input[type=\"password\"],\r\n    input[type=\"email\"],\r\n    input[type=\"number\"],\r\n    input[type=\"tel\"],\r\n    textarea,\r\n    .rbt-single-widget,\r\n    .rbt-single-widget.widget_recent_comments ul li + li,\r\n    .rbt-single-widget.widget_recent_entries ul li + li,\r\n    .rbt-single-widget.widget_archive ul li + li,\r\n    .rbt-single-widget.widget_categories ul li + li,\r\n    .rbt-single-widget.widget_meta ul li + li,\r\n    .rbt-single-widget.widget_pages ul li + li,\r\n    .rbt-single-widget.widget_nav_menu ul li + li,\r\n    .tagcloud a,\r\n    .wp-block-tag-cloud a,\r\n    .section-title-2 .title,\r\n    .popup-mobile-menu .mainmenu li + li,\r\n    .clltoaction-style-default.style-7 .content-wrapper,\r\n    .copyright-style-one,\r\n    .footer-style-default .newsletter-form .form-group input,\r\n    .newsletter-area .border-top-bottom {\r\n      border-color: #00000024;\r\n    }\r\n\r\n    .mainmenu-nav .mainmenu li.has-droupdown .submenu li a:hover {\r\n      background: #d8d8d8;\r\n    }\r\n\r\n    .mainmenu-nav\r\n      .mainmenu\r\n      li.with-megamenu\r\n      .rn-megamenu\r\n      .wrapper\r\n      .mega-menu-item\r\n      li\r\n      a:hover {\r\n      background: #d8d8d8;\r\n      color: var(--color-primary);\r\n    }\r\n\r\n    .btn-read-more span::after {\r\n      background: #00000024;\r\n    }\r\n\r\n    .breadcrumb-inner ul.page-list li a:hover,\r\n    .rn-address .inner p a:hover,\r\n    .post-page-banner .rn-meta-list li a:hover,\r\n    .header-top-bar .header-left p a:hover {\r\n      color: var(--color-primary);\r\n    }\r\n\r\n    .social-default li a:hover,\r\n    .tagcloud a:hover,\r\n    .wp-block-tag-cloud a:hover,\r\n    .header-top-news .btn-read-more span {\r\n      color: var(--color-white);\r\n    }\r\n\r\n    .tagcloud a:hover,\r\n    .wp-block-tag-cloud a:hover {\r\n      border-color: var(--color-primary);\r\n    }\r\n\r\n    a.btn-default.text-underline,\r\n    button.btn-default.text-underline {\r\n      border-color: #181818;\r\n      color: #181818;\r\n    }\r\n\r\n    .hamberger-button svg,\r\n    .popup-mobile-menu .inner .header-top .close-menu .close-button svg {\r\n      stroke: #181818;\r\n    }\r\n\r\n    .single-demo .thumbnail .image-light {\r\n      display: block;\r\n    }\r\n\r\n    .single-demo .thumbnail .image-dark {\r\n      display: none;\r\n    }\r\n\r\n    .footer-style-default .social-default li a,\r\n    .copyright-style-one .social-default.color-lessdark li a,\r\n    .rn-newsletter-default .rn-newsletter .form-group input {\r\n      background: #fff;\r\n    }\r\n\r\n    .copyright-style-one .ft-menu li + li::after {\r\n      background: #c5c1c1;\r\n    }\r\n\r\n    .copyright-style-one .ft-menu li a:hover,\r\n    .footer-style-default\r\n      .footer-top\r\n      .rn-footer-widget\r\n      .footer-link\r\n      li\r\n      a:hover {\r\n      color: var(--color-primary);\r\n    }\r\n\r\n    .header-transparent-with-topbar .header-top-bar,\r\n    .header-transparent-with-topbar .header-default {\r\n      background: transparent;\r\n    }\r\n\r\n    [class*=\"col\"]:nth-child(2) .counter-style-2.color-variation .count-number {\r\n      background-color: #f9f5f5;\r\n    }\r\n\r\n    [class*=\"col\"]:nth-child(3) .counter-style-2.color-variation .count-number {\r\n      background-color: #eef2f3;\r\n    }\r\n\r\n    .service-wrapper\r\n      > [class*=\"col\"]:nth-child(4)\r\n      .service.service__style--1.icon-circle-style\r\n      .icon {\r\n      background-color: #2f011d45;\r\n    }\r\n\r\n    .slider-style-8 .inner a.btn-default.btn-border,\r\n    .slider-style-8 .inner button.btn-default.btn-border {\r\n      border-color: #d8d8d8;\r\n      color: #65676b;\r\n    }\r\n    .slider-style-8 .inner a.btn-default.btn-border:hover,\r\n    .slider-style-8 .inner button.btn-default.btn-border:hover {\r\n      color: #fff;\r\n    }\r\n  }\r\n}\r\n\r\nbody.light .service.service__style--1.icon-circle-style .icon {\r\n  background-color: #059dff0f;\r\n  color: var(--color-primary);\r\n}\r\n\r\nbody.light\r\n  .service-wrapper\r\n  > [class*=\"col\"]:nth-child(1)\r\n  .service.service__style--1.icon-circle-style\r\n  .icon {\r\n  background-color: #059dff0f;\r\n  color: var(--color-primary);\r\n}\r\nbody.light\r\n  .service-wrapper\r\n  > [class*=\"col\"]:nth-child(2)\r\n  .service.service__style--1.icon-circle-style\r\n  .icon {\r\n  background-color: #059dff0f;\r\n  color: var(--color-primary);\r\n}\r\n\r\nbody.light\r\n  .service-wrapper\r\n  > [class*=\"col\"]:nth-child(3)\r\n  .service.service__style--1.icon-circle-style\r\n  .icon {\r\n  background-color: #059dff0f;\r\n  color: var(--color-primary);\r\n}\r\n\r\nbody.light .service.service__style--1.icon-circle-style .iconSolutions {\r\n  background-color: var(--color-primary);\r\n}\r\nbody.light\r\n  .service-wrapper\r\n  > [class*=\"col\"]:nth-child(1)\r\n  .service.service__style--1.icon-circle-style\r\n  .iconSolutions {\r\n  background-color: var(--color-primary);\r\n}\r\nbody.light\r\n  .service-wrapper\r\n  > [class*=\"col\"]:nth-child(2)\r\n  .service.service__style--1.icon-circle-style\r\n  .iconSolutions {\r\n  background-color: var(--color-primary);\r\n}\r\n\r\nbody.light\r\n  .service-wrapper\r\n  > [class*=\"col\"]:nth-child(3)\r\n  .service.service__style--1.icon-circle-style\r\n  .iconSolutions {\r\n  background-color: var(--color-primary);\r\n}\r\n\r\nbody.light .timeline-dot::after {\r\n  background: radial-gradient(50% 50% at 50% 50%, #f5f8fa 48.96%, #f5f8fa 100%);\r\n}\r\n\r\nbody.light .header-top-bar {\r\n  background-color: var(--color-white);\r\n}\r\n\r\nbody.light .single-timeline .single-content,\r\nbody.light .rn-card,\r\nbody.light .clltoaction-style-default.style-5 .content-wrapper,\r\nbody.light .header-default,\r\nbody.light .mainmenu-nav .mainmenu li.has-droupdown .submenu,\r\nbody.light .service.gallery-style,\r\nbody.light .rn-box-card .inner,\r\nbody.light .team-style-default .inner,\r\nbody.light .rn-accordion-style .card,\r\nbody.light .section-title .subtitle,\r\nbody.light .card-box.card-style-1,\r\nbody.light .list-icon li .icon,\r\nbody.light .counter-style-2 .count-number,\r\nbody.light .rn-pricing.style-2 .pricing-table-inner,\r\nbody.light .rn-default-tab .rn-tab-content,\r\nbody.light\r\n  .rn-default-tab\r\n  .tab-button\r\n  .react-tabs__tab.react-tabs__tab--selected,\r\nbody.light .advance-tab-button-1 .tab-button-list .tab-button::before,\r\nbody.light .advance-pricing .pricing-left,\r\nbody.light .rn-pricing.style-5 .pricing-table-inner,\r\nbody.light .about-style-5 .about-wrapper,\r\nbody.light .rn-sub-badge,\r\nbody.light .about-style-6 .wrapper::after,\r\nbody.light .box-grid-layout .rwt-card,\r\nbody.light .mainmenu-nav .mainmenu li.with-megamenu .rn-megamenu .wrapper,\r\nbody.light .social-default li a,\r\nbody.light .clltoaction-style-default.style-4 .content-wrapper,\r\nbody.light .rn-address,\r\nbody.light .rbt-single-widget .title,\r\nbody.light .frame-image,\r\nbody.light .rn-back-top,\r\nbody.light .popup-mobile-menu .inner,\r\nbody.light .rn-call-to-action.style-8,\r\nbody.light .bg-overlay-solid::before {\r\n  background: #f5f8fa;\r\n}\r\n\r\nbody.light .rn-header.sticky {\r\n  background: #f5f8fa !important;\r\n}\r\n\r\nbody.light .bg-color-blackest {\r\n  background: #f5f8fa !important;\r\n}\r\n\r\nbody.light .footer-style-default,\r\nbody.light .copyright-style-one {\r\n  background: #f5f8fa;\r\n}\r\n\r\nbody.light .slider-style-2 .list-icon li .icon {\r\n  background: var(--color-blackest);\r\n}\r\n\r\nbody.light .rn-pricing .pricing-table-inner::before,\r\nbody.light .rn-timeline-single.dark-line .rn-timeline .progress-dot .dot-level,\r\nbody.light\r\n  .rn-timeline-single.dark-line\r\n  .rn-timeline\r\n  .progress-line\r\n  .line-inner,\r\nbody.light .card-style-default.testimonial-style-one .inner .thumbnail::after,\r\nbody.light .advance-pricing,\r\nbody.light .rn-pricing.style-5 .pricing-table-inner .pricing,\r\nbody.light .popup-mobile-menu .inner .header-top .close-menu .close-button,\r\nbody.light .hamberger-button {\r\n  background: #d8d8d8;\r\n}\r\n\r\nbody.light .single-demo {\r\n  background: #e9f8fe;\r\n}\r\nbody.light .slider_img {\r\n  width: 150px !important;\r\n  filter: none !important;\r\n}\r\nbody.light .split-list {\r\n    list-style: none;\r\n    padding-left: 0;\r\n    margin: 0;\r\n    //column-count: 2; /* You can adjust the number of columns as needed */\r\n    column-gap: 20px;\r\n    li {\r\n      color: var(--color-dark-alt) !important;\r\n      display: flex;\r\n      align-items: center;\r\n\r\n      .split-icon {\r\n        margin-right: 20px;\r\n      }\r\n    }\r\n  }\r\n\r\nbody.light .rn-accordion-style .card .card-body,\r\nbody.light .brand-style-1 li {\r\n  border-color: #d8d8d8;\r\n}\r\n\r\nbody.light hr {\r\n  border-top: 1px solid #00000024;\r\n}\r\n\r\nbody.light .rn-card {\r\n  border-color: #f5f8fa;\r\n}\r\n\r\nbody.light .rn-pricing.active .pricing-table-inner .pricing-header,\r\nbody.light .rn-pricing .pricing-table-inner .pricing-header {\r\n  border-color: #0000000a;\r\n}\r\n\r\nbody.light .advance-tab-button-1 .tab-button-list .tab-button::after {\r\n  border-left: 20px solid #f5f8fa;\r\n  border-top: 20px solid transparent;\r\n  border-bottom: 20px solid transparent;\r\n}\r\n\r\nbody.light a.btn-default.btn-border,\r\nbody.light button.btn-default.btn-border {\r\n  border-color: #00000024;\r\n  color: #181818;\r\n}\r\n\r\nbody.light a.btn-default.btn-border:hover,\r\nbody.light button.btn-default.btn-border:hover {\r\n  border-color: var(--color-secondary);\r\n  color: #fff;\r\n}\r\n\r\nbody.light .rn-box-card .inner .thumbnail,\r\nbody.light .team-style-default .inner .thumbnail {\r\n  border: 6px solid var(--color-white);\r\n}\r\n\r\nbody.light .filter-button-default li button,\r\nbody.light .testimonial-style-two .content .client-info .subtitle,\r\nbody.light .single-timeline .single-content .inner .content .date-of-timeline,\r\nbody.light .service.gallery-style .content p,\r\nbody.light .rn-box-card .inner .social-icon li a,\r\nbody.light .team-style-default .inner .social-icon li a,\r\nbody.light .rn-accordion-style .card .card-body,\r\nbody.light .mainmenu-nav .mainmenu li.has-droupdown .submenu li a,\r\nbody.light .list-icon li,\r\nbody.light ul li,\r\nbody.light\r\n  .rn-pricing.active\r\n  .pricing-table-inner\r\n  .pricing-body\r\n  ul.list-style--1\r\n  li,\r\nbody.light\r\n  .rn-pricing.active\r\n  .pricing-table-inner\r\n  .pricing-body\r\n  ul.list-style--1\r\n  li\r\n  svg,\r\nbody.light .advance-tab-button-1 .tab-button-list .tab-button .title,\r\nbody.light .advance-pricing .pricing-left .subtitle,\r\nbody.light .header-top-bar .header-left p a,\r\nbody.light .header-top-bar .header-right .address-content p a,\r\nbody.light .header-top-bar .social-default.icon-naked li a,\r\nbody.light .progress-info .title,\r\nbody.light .progress-info span.progress-number,\r\nbody.light\r\n  .mainmenu-nav\r\n  .mainmenu\r\n  li.with-megamenu\r\n  .rn-megamenu\r\n  .wrapper\r\n  .mega-menu-item\r\n  li\r\n  a,\r\nbody.light .clltoaction-style-default.style-4 .content .subtitle {\r\n  color: #65676b;\r\n}\r\n\r\nbody.light .card-box.card-style-1 .inner .content .description {\r\n  color: #65676b !important;\r\n}\r\n\r\nbody.light .clltoaction-style-default.style-5 .content .subtitle,\r\nbody.light .rn-accordion-style .card .card-header button,\r\nbody.light .counter-style-2 .count-number,\r\nbody.light .rn-pricing .pricing-table-inner .pricing-header .pricing span.price,\r\nbody.light .rn-pricing.active .pricing-table-inner .pricing-header .title,\r\nbody.light\r\n  .rn-pricing.active\r\n  .pricing-table-inner\r\n  .pricing-header\r\n  .pricing\r\n  span.currency,\r\nbody.light\r\n  .rn-pricing.active\r\n  .pricing-table-inner\r\n  .pricing-header\r\n  .pricing\r\n  span.subtitle,\r\nbody.light\r\n  .rn-pricing\r\n  .pricing-table-inner\r\n  .pricing-header\r\n  .pricing\r\n  span.subtitle,\r\nbody.light .rn-default-tab .tab-button .rn-tab-button button,\r\nbody.light\r\n  .rn-pricing\r\n  .pricing-table-inner\r\n  .pricing-header\r\n  .pricing\r\n  span.currency,\r\nbody.light .card-style-default.testimonial-style-one .inner .thumbnail::after,\r\nbody.light .clltoaction-style-default.style-6 .content .title,\r\nbody.light .rn-splite-style .split-inner .title,\r\nbody.light\r\n  .advance-tab-button-1\r\n  .tab-button-list\r\n  .react-tabs__tab--selected\r\n  .tab-button\r\n  .title,\r\nbody.light .advance-pricing .pricing-left .price-wrapper .price-amount,\r\nbody.light .btn-read-more span,\r\nbody.light .section-title-2 .title,\r\nbody.light .box-grid-layout .rwt-card .inner .content .title,\r\nbody.light .clltoaction-style-default.style-5 .content .title,\r\nbody.light .clltoaction-style-default.style-4 .content .title,\r\nbody.light .hamberger-button {\r\n  color: #181818;\r\n}\r\n\r\nbody.light .about-style-6 .maintitle {\r\n  color: #181818 !important;\r\n}\r\n\r\nbody.light .slider-style-1 .inner .title {\r\n  color: var(--color-white);\r\n}\r\n\r\nbody.light .testimonial-style-two .content::after {\r\n  color: #f5f8fa;\r\n}\r\n\r\nbody.light .header-transparent .mainmenu-nav .mainmenu > li > a {\r\n  color: var(--color-body);\r\n}\r\n\r\nbody.light .header-top-bar .header-right .address-content p a:hover {\r\n  color: var(--color-primary);\r\n}\r\n\r\nbody.light\r\n  .rn-pricing\r\n  .pricing-table-inner\r\n  .pricing-header\r\n  .pricing\r\n  span.currency {\r\n  opacity: 0.8;\r\n}\r\n\r\nbody.light .mainmenu-nav .mainmenu li.has-droupdown .submenu li a:hover,\r\nbody.light .btn-read-more:hover span {\r\n  color: var(--color-primary);\r\n}\r\n\r\nbody.light .CircularProgressbar .CircularProgressbar-text {\r\n  fill: #181818 !important;\r\n}\r\n\r\nbody.light .logo-light {\r\n  display: none;\r\n}\r\n\r\nbody.light .logo-dark {\r\n  display: block;\r\n}\r\n\r\nbody.light .slider-area.bg-transparent .inner a.btn-default.btn-border,\r\nbody.light .slider-area.bg-transparent .inner button.btn-default.btn-border {\r\n  border-color: #00000024;\r\n  color: #181818;\r\n}\r\n\r\nbody.light .slider-area.bg-transparent .inner a.btn-default.btn-border:hover,\r\nbody.light\r\n  .slider-area.bg-transparent\r\n  .inner\r\n  button.btn-default.btn-border:hover {\r\n  color: var(--color-white);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
